
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("73TCo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");





var $jmjWc = parcelRequire("jmjWc");


var $bAyaS = parcelRequire("bAyaS");


const $60b070effa9833b5$var$CreateSpaceDrawerLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8t-EL",
    name: "CreateSpaceDrawerLoader",
    loader: async ()=>(await (parcelRequire("kjDYe"))).CreateSpaceDrawer
});
const $60b070effa9833b5$export$8b3b261467ad7423 = ()=>{
    const [shouldRenderDrawer] = (0, $bAyaS.useShouldRenderDrawer)();
    return shouldRenderDrawer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($60b070effa9833b5$var$CreateSpaceDrawerLoader, null) : null;
};


parcelRequire("h3wYQ");
var $cQbTj = parcelRequire("cQbTj");
var $f8AFM = parcelRequire("f8AFM");





var $dPJCf = parcelRequire("dPJCf");


var $7Sm4c = parcelRequire("7Sm4c");


var $b3j2Y = parcelRequire("b3j2Y");


var $1NBp8 = parcelRequire("1NBp8");


var $7Ndnw = parcelRequire("7Ndnw");


var $dizL5 = parcelRequire("dizL5");


var $8a9Dm = parcelRequire("8a9Dm");


var $4vC63 = parcelRequire("4vC63");

const $053fc94f5ddb8d12$export$d15e21537dfa6cb0 = /*#__PURE__*/ (0, $42omo.memo)(()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
        render: (forgeModules, loading, error)=>{
            if (loading) return null;
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
                return null;
            }
            return forgeModules.map((module)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
                    key: module.id,
                    module: module,
                    action: ()=>push((0, $1NBp8.GLOBAL_PAGE_FORGE).toUrl({
                            appId: (0, $8a9Dm.getAppId)(module),
                            envId: module.environmentId,
                            forgeManifestRoute: module.properties.route
                        }))
                }));
        }
    });
});












var $alLTz = parcelRequire("alLTz");


const $3729a951937314e9$var$StorageEnforcementFlagsLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_U9ss",
    name: "StorageEnforcementFlagsLoadable",
    loader: async ()=>(await (parcelRequire("fQP2E"))).StorageEnforcementFlags
});
const $3729a951937314e9$export$8df08a490eb32a33 = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3729a951937314e9$var$StorageEnforcementFlagsLoadable, null) : null;
};












const $372cb008daefafdd$var$GracePeriodModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "6zo21",
    name: "GracePeriodModalLoadable",
    loader: async ()=>(await (parcelRequire("aOp12"))).GracePeriodModalErrorBoundary
});
const $372cb008daefafdd$export$38134b9c38b2723c = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($372cb008daefafdd$var$GracePeriodModalLoadable, null) : null;
};












const $2c6a471f2dd5d9be$var$BlockCreateModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Mxabm",
    name: "BlockCreateModalLoadable",
    loader: async ()=>(await (parcelRequire("gsyUw"))).BlockCreateModal
});
const $2c6a471f2dd5d9be$export$4bd1fbb328f3ee8b = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c6a471f2dd5d9be$var$BlockCreateModalLoadable, null) : null;
};


const $7ac3d7089b8f08ca$export$5bf713f6291006b2 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3729a951937314e9$export$8df08a490eb32a33), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $372cb008daefafdd$export$38134b9c38b2723c), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2c6a471f2dd5d9be$export$4bd1fbb328f3ee8b), null));
};



var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");





var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $7W8i8 = parcelRequire("7W8i8");


var $4R3wx = parcelRequire("4R3wx");


var $17wUi = parcelRequire("17wUi");


var $5GjsS = parcelRequire("5GjsS");

const $051c39487bfe83be$var$flagId = 'loomAiMeetingNotesPostProvisionFlag';
const $051c39487bfe83be$var$logger = (0, $7W8i8.getLogger)('useLoomAiMeetingNotesPostProvisionFlag');
const $051c39487bfe83be$var$i18n = {
    title: {
        id: 'loom-utils.loom-ai-meeting-notes-post-provision-flag.title',
        defaultMessage: "You\u2019ve added Loom",
        description: 'Title of the flag that shows when Loom is provisioned via the Confluence AI meeting notes touchpoint'
    },
    description: {
        id: 'loom-utils.loom-ai-meeting-notes-post-provision-flag.description',
        defaultMessage: "You can now record and embed videos by typing \u2018/\u2019 followed by \u2018loom\u2019 whilst editing.",
        description: 'Description of the flag that shows when Loom is provisioned via the Confluence AI meeting notes touchpoint'
    },
    ctaText: {
        id: 'loom-utils.loom-ai-meeting-notes-post-provision-flag.ctaText',
        defaultMessage: 'Got it',
        description: 'Text for the call to action button on the Loom post-provision flag'
    }
};
const $051c39487bfe83be$export$8903cc30e91068ff = ({ flags: flags, enabled: enabled = true })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { entryPointVariant: entryPointVariant, loading: loading } = (0, $4R3wx.useLoomEntryPointVariant)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const previousVariantRef = (0, $42omo.useRef)();
    const handleCtaClick = (0, $42omo.useCallback)(async ()=>{
        await flags.hideFlag($051c39487bfe83be$var$flagId);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'gotIt',
                source: 'loomAiMeetingNotesPostProvisioningFlag'
            }
        }).fire();
    }, [
        flags,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        // Only show flag if the user has seen the touchpoint
        const hasClickedOnMeetingNotesTemplate = (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $5GjsS.USER_HAS_CLICKED_ON_MEETING_NOTES_TEMPLATE_KEY));
        // Only show flag if enabled and variant changed to CO_USE
        if (!enabled || entryPointVariant !== 'CO_USE' || !hasClickedOnMeetingNotesTemplate || loading) {
            if (!loading) previousVariantRef.current = entryPointVariant;
            $051c39487bfe83be$var$logger.info`Ineligible to show Loom post-provision flag, conditions not met (enabled: ${enabled}, entryPointVariant: ${entryPointVariant}, hasClickedOnMeetingNotesTemplate: ${hasClickedOnMeetingNotesTemplate}, loading: ${loading})`;
            return;
        }
        if (previousVariantRef.current !== undefined && previousVariantRef.current !== 'CO_USE' && previousVariantRef.current !== 'DISABLED') {
            flags.showSuccessCircleFlag({
                id: $051c39487bfe83be$var$flagId,
                title: formatMessage($051c39487bfe83be$var$i18n.title),
                description: formatMessage($051c39487bfe83be$var$i18n.description),
                actions: [
                    {
                        content: formatMessage($051c39487bfe83be$var$i18n.ctaText),
                        onClick: handleCtaClick
                    }
                ],
                isAutoDismiss: false,
                onClose: ()=>{
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'close',
                            source: 'loomAiMeetingNotesPostProvisioningFlag'
                        }
                    }).fire();
                }
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'rendered',
                    actionSubject: 'loomAiMeetingNotesPostProvisioningFlag'
                }
            }).fire();
            $051c39487bfe83be$var$logger.info`Showing Loom post-provision flag as entry point variant changed to CO_USE from ${previousVariantRef.current}`;
        }
        previousVariantRef.current = entryPointVariant;
    }, [
        entryPointVariant,
        enabled,
        flags,
        formatMessage,
        loading,
        createAnalyticsEvent,
        handleCtaClick
    ]);
    return {
        entryPointVariant: /**
     * Current touchpoint variant
     */ entryPointVariant,
        /**
     * Whether the flag would be shown for CO_USE state
     */ isEligibleForCoUse: entryPointVariant === 'CO_USE'
    };
};


const $a899a35998a2f0d5$export$6f8e8f84292a77d5 = ({ flags: flags })=>{
    (0, $051c39487bfe83be$export$8903cc30e91068ff)({
        flags: flags,
        enabled: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('loom_ai_meeting_notes_in_confluence_experiment', 'cohort', 'variation')
    });
    // This component doesn't render anything visible - it just monitors state changes
    return null;
};
const $a899a35998a2f0d5$export$65c1757b89fecfeb = (0, $7aRa9.withFlags)($a899a35998a2f0d5$export$6f8e8f84292a77d5);






var $aJv6Q = parcelRequire("aJv6Q");








const $f7a2cd2323bccfe9$var$TrialFlagsLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uEpNB",
    name: "TrialFlagsLoadable",
    loader: async ()=>(await (parcelRequire("j8xJB"))).TrialFlags
});
const $f7a2cd2323bccfe9$export$c108f21945b8b79 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).GROWTH_LUNA
})(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f7a2cd2323bccfe9$var$TrialFlagsLoadable, null));



var $hAnPj = parcelRequire("hAnPj");


var $i5Ioa = parcelRequire("i5Ioa");





var $9wGTI = parcelRequire("9wGTI");


var $cbc8g = parcelRequire("cbc8g");


var $2cEww = parcelRequire("2cEww");


var $gz8ZY = parcelRequire("gz8ZY");

const $560a905f50f30e05$export$209ba536680f5b50 = ()=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    // Adds the "custom:confluence:navType" property to UFO page load event to enable
    // Nav3/Nav4 split in the performance portal. Must be called on each route as it
    // only adds custom data to the existing interaction
    (0, $42omo.useEffect)(()=>{
        const navType = isNav4Enabled ? 'nav4' : 'nav3';
        if ((0, $9wGTI.fg)('platform_ufo_custom_cohort_data_migration')) (0, $2cEww.addUFOCustomCohortData)('confluence:navType', navType);
        else (0, $cbc8g.addUFOCustomData)({
            'confluence:navType': navType
        });
    });
};









var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");





var $1ytiN = parcelRequire("1ytiN");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");





var $1UApO = parcelRequire("1UApO");


var $deyhs = parcelRequire("deyhs");


var $dKIZZ = parcelRequire("dKIZZ");




const $d903e4dac8e596de$export$40ad526e6a3cd784 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const hasShownInfoFlag = (0, $17wUi.confluenceSessionStorageInstance).getItem((0, $1UApO.keys).NAV4_MISALIGNED_NAV_VERSIONS_FLAG);
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const { nav4AdminOptedIn: isSiteWideNav4Enabled } = (0, $dKIZZ.useGetNav4OptIn)();
    const isNav4DisplayedToUser = (0, $gz8ZY.useIsNav4Enabled)();
    const currentGAPhase = (0, $deyhs.getNav4GAPhase)();
    /**
   * The user is an admin capable of admin-only opt-out
   * We are in GA phase 1
   * Nav 4 is opted-in at the site level
   * The user is seeing nav 3 due to prior personal preference update
   */ const navVersionsAreMisaligned = (isSiteAdmin || isAdmin) && isSiteWideNav4Enabled && currentGAPhase === 1 && !isNav4DisplayedToUser;
    (0, $42omo.useEffect)(()=>{
        if (!hasShownInfoFlag && navVersionsAreMisaligned) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d903e4dac8e596de$export$a7357cdd1f0b0168.misalignedNavVersionsFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d903e4dac8e596de$export$a7357cdd1f0b0168.misalignedNavVersionsFlagDescription),
                actions: [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d903e4dac8e596de$export$a7357cdd1f0b0168.misalignedNavVersionsFlagLink),
                        href: '/wiki/admin/newfeatures'
                    }
                ],
                isAutoDismiss: false
            });
            (0, $17wUi.confluenceSessionStorageInstance).setItem((0, $1UApO.keys).NAV4_MISALIGNED_NAV_VERSIONS_FLAG, 'true');
        }
    }, [
        hasShownInfoFlag,
        navVersionsAreMisaligned,
        flags
    ]);
    return null;
});
const $d903e4dac8e596de$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    misalignedNavVersionsFlagTitle: {
        id: "nav-versions-misaligned.flag",
        defaultMessage: "New navigation is turned on for everyone"
    },
    misalignedNavVersionsFlagDescription: {
        id: "nav-versions-misaligned.flag.description",
        defaultMessage: "You are still on the old navigation because you previously opted out. You can update your navigation preferences in settings."
    },
    misalignedNavVersionsFlagLink: {
        id: "nav-versions-misaligned.flag.link",
        defaultMessage: "Go to settings"
    }
});









var $euL71 = parcelRequire("euL71");


var $fcF01 = parcelRequire("fcF01");


const $8e4a487f1ccf39b0$var$LazyExperimentPlanSelectionModal = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "z7feK",
    name: "LazyExperimentPlanSelectionModal",
    loader: async ()=>(await (parcelRequire("fQudG"))).ExperimentPlanSelectionModal
});
const $8e4a487f1ccf39b0$export$7699251dbf86d265 = ()=>{
    const { currentEdition: currentEdition } = (0, $42omo.useContext)((0, $fcF01.UpFlowContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, currentEdition === (0, $euL71.ConfluenceEdition).FREE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e4a487f1ccf39b0$var$LazyExperimentPlanSelectionModal, null));
};



var $c5zvz = parcelRequire("c5zvz");

// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 










const $0cafdf8f81e44cdc$var$ModernizeChangeboardingLoadable = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "HOLxR",
    name: "ModernizeChangeboardingLoadable",
    loader: async ()=>(await (parcelRequire("jZl47"))).ModernizeChangeboarding
});
const $0cafdf8f81e44cdc$export$51c4358102159001 = ()=>{
    return (0, $9wGTI.fg)('cc_modernize_ga_changeboarding') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0cafdf8f81e44cdc$var$ModernizeChangeboardingLoadable, null) : null;
};


// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 









const $63d46b1fc54f0401$var$NthUserOrientationLoadable = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pjDSS",
    name: "NthUserOrientationLoadable",
    loader: async ()=>(await (parcelRequire("2qwfL"))).NthUserOrientation
});
const $63d46b1fc54f0401$export$11a38f66cbb85629 = ()=>{
    return (0, $9wGTI.fg)('cc_nth_user_orientation_eligibility_checks') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($63d46b1fc54f0401$var$NthUserOrientationLoadable, null) : null;
};



var $7DERG = parcelRequire("7DERG");





var $ibzAc = parcelRequire("ibzAc");


var $l998X = parcelRequire("l998X");

/**
 * @generated SignedSource<<4412a0616c566d63806e5e00d935e8d4>>
 * @relayHash 106ffcdbdc9ff700e1f7193373d8211c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 21bcf8f16440b9445010d83b264fa7e47aeecee045ee1c72d7c44932b4fea62a
const $6623806f5bfc94bc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceAudioPreference",
            "kind": "LinkedField",
            "name": "confluence_getAudioPreference",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "tone"
                },
                {
                    "kind": "ScalarField",
                    "name": "length"
                },
                {
                    "kind": "ScalarField",
                    "name": "playbackSpeed"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AudioContainerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AudioContainerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "21bcf8f16440b9445010d83b264fa7e47aeecee045ee1c72d7c44932b4fea62a",
            "metadata": {},
            "name": "AudioContainerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6623806f5bfc94bc$var$node.hash = "8e9349dd0b657ff897c93848ef50d4f6";
var $6623806f5bfc94bc$export$2e2bcd8739ae039 = $6623806f5bfc94bc$var$node;











var $irOoi = parcelRequire("irOoi");


var $gdv5Z = parcelRequire("gdv5Z");


var $2Rith = parcelRequire("2Rith");

var $fYQcF = parcelRequire("fYQcF");


var $gWF6I = parcelRequire("gWF6I");

var $08e4a34c7045e030$export$f0c9015bb7804f57 = /*#__PURE__*/ function(AudioFormat) {
    AudioFormat["PCM"] = "pcm";
    AudioFormat["MP3"] = "mp3";
    AudioFormat["JSON"] = "json";
    return AudioFormat;
}({});
const $08e4a34c7045e030$export$d5bb0b43ead5f824 = async ({ mainResourceARI: mainResourceARI, supportingResourceARIs: supportingResourceARIs = [], locale: locale, type: type, instructions: instructions, format: format, activationId: activationId })=>{
    const resourceARIs = [
        mainResourceARI,
        ...supportingResourceARIs
    ];
    const resources = resourceARIs.map((resourceAri)=>({
            resource_ari: resourceAri
        }));
    const response = await fetch('/gateway/api/v2/audio', {
        method: 'POST',
        body: JSON.stringify({
            resources: resources,
            locale: locale,
            type: type,
            user_instruction: instructions,
            format: format
        }),
        headers: {
            'Content-Type': 'application/json',
            'ATL-ActivationId': activationId
        }
    });
    if (!response.ok) {
        const errorBody = await response.text();
        throw new Error(`Audio request failed with status ${response.status}: ${errorBody}`);
    }
    if (!response.body) throw new Error('Response body is null');
    return response.body;
};



var $61eRd = parcelRequire("61eRd");







const $b80bff0b244fbd50$export$e7688cf61a75f15f = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $b80bff0b244fbd50$export$6ec02d48b47f5f51 = ({ fetchAudio: fetchAudio, audioRef: audioRef, children: children })=>{
    const value = (0, $42omo.useMemo)(()=>({
            fetchAudio: fetchAudio,
            audioRef: audioRef
        }), [
        fetchAudio,
        audioRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($b80bff0b244fbd50$export$e7688cf61a75f15f.Provider, {
        value: value,
        children: children
    });
};
const $b80bff0b244fbd50$export$2ff13f0ef48683f2 = ()=>{
    const context = (0, $42omo.useContext)($b80bff0b244fbd50$export$e7688cf61a75f15f);
    if (!context) throw new Error('useAudioPlayerStreamingContext must be used within an AudioPlayerStreamingProvider');
    return context;
};





const $f43c45a1ab86a258$export$517a124efa5f6d1 = (0, $42omo.createContext)({
    emojiProvider: undefined
});
$f43c45a1ab86a258$export$517a124efa5f6d1.displayName = 'EmojiProviderContext';



var $3A9F3 = parcelRequire("3A9F3");


var $CAM5Y = parcelRequire("CAM5Y");

const $1726f70a3a8c123e$export$8842837476c9062b = (type)=>{
    switch(type){
        case (0, $CAM5Y.AudioFeatureType).BRIEFING:
            return 'aiAudioBriefing';
        case (0, $CAM5Y.AudioFeatureType).NARRATION:
            return 'aiAudioNarration';
    }
};











var $lqUMo = parcelRequire("lqUMo");

const $e8c5882c3211aac4$var$i18n = (0, $cgtv4.defineMessages)({
    errorLoadingAudioPreferences: {
        id: "ai-audio.audio-container.error-loading-audio-preferences",
        defaultMessage: "Playback speed error"
    },
    errorDescription: {
        id: "ai-audio.audio-container.error-loading-audio-preferences-description",
        defaultMessage: "Please try again later"
    }
});
const $e8c5882c3211aac4$export$682d7e508fc708d7 = ({ flags: flags, audioRef: audioRef, onBuffer: onBuffer })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        const audio = audioRef.current;
        if (!audio) return;
        const onPlay = ()=>{
            (0, $lqUMo.setIsPlaying)(true);
            (0, $lqUMo.setIsPaused)(false);
        };
        const onPause = ()=>{
            (0, $lqUMo.setIsPlaying)(false);
            if (audio.src && audio.src !== '') (0, $lqUMo.setIsPaused)(true);
        };
        const onEnded = ()=>{
            (0, $lqUMo.setIsPlaying)(false);
            (0, $lqUMo.setIsPaused)(false);
        };
        const onCanPlay = ()=>{
            if (audio.currentTime < audio.duration) {
                const customization = (0, $lqUMo.getCustomization)();
                if (customization.playbackSpeed && customization.playbackSpeed !== audio.playbackRate) try {
                    audio.playbackRate = customization.playbackSpeed;
                } catch  {
                    flags?.showFlag({
                        appearance: 'error',
                        title: formatMessage($e8c5882c3211aac4$var$i18n.errorLoadingAudioPreferences),
                        description: formatMessage($e8c5882c3211aac4$var$i18n.errorDescription),
                        close: 'auto'
                    });
                }
                audio.play();
            }
        };
        const handleBuffer = ()=>{
            onBuffer?.();
        };
        // Attach event listeners
        audio.addEventListener('play', onPlay);
        audio.addEventListener('pause', onPause);
        audio.addEventListener('canplay', onCanPlay);
        audio.addEventListener('ended', onEnded);
        audio.addEventListener('waiting', handleBuffer);
        return ()=>{
            // Cleanup event listeners
            audio.removeEventListener('play', onPlay);
            audio.removeEventListener('pause', onPause);
            audio.removeEventListener('canplay', onCanPlay);
            audio.removeEventListener('ended', onEnded);
            audio.removeEventListener('waiting', handleBuffer);
        };
    }, [
        audioRef,
        onBuffer,
        flags,
        formatMessage
    ]);
};



var $9s8in = parcelRequire("9s8in");








var $9NDUe = parcelRequire("9NDUe");

var $2Gu9D = parcelRequire("2Gu9D");



var $aU1TP = parcelRequire("aU1TP");

/**
 * A Promise-based wrapper for the SourceBuffer's `appendBuffer` method.
 * The MediaSource API is event-based. This utility hides that complexity by
 * resolving a promise when the 'updateend' event fires, allowing for
 * cleaner async/await syntax in the streaming loop.
 * @param sourceBuffer The MediaSource SourceBuffer to append to.
 * @param buffer The audio data chunk (BufferSource) to append.
 */ const $53e499115d6db86b$export$16cd91e6fd463653 = (sourceBuffer, buffer)=>{
    return new Promise((resolve, reject)=>{
        try {
            sourceBuffer.addEventListener('updateend', ()=>resolve(), {
                once: true
            });
            sourceBuffer.appendBuffer(buffer);
        } catch (e) {
            reject(e);
        }
    });
};
const $53e499115d6db86b$export$a54736a253e13047 = (audio)=>{
    try {
        const currentPlaybackTime = audio.currentTime;
        const ranges = audio.buffered;
        for(let i = 0; i < ranges.length; i++){
            const start = ranges.start(i);
            const end = ranges.end(i);
            if (start <= currentPlaybackTime && currentPlaybackTime <= end) return Math.max(0, end - currentPlaybackTime);
        }
        return 0;
    } catch  {
        return 0;
    }
};
const $53e499115d6db86b$export$a4a914e8c41c504d = async (audio, isReadyToConsumeStream, resumeThresholdSeconds)=>{
    return new Promise((resolve)=>{
        const evaluateResumeCondition = ()=>{
            if (!isReadyToConsumeStream) {
                cleanup();
                resolve();
                return;
            }
            const bufferAheadSeconds = $53e499115d6db86b$export$a54736a253e13047(audio);
            if (bufferAheadSeconds <= resumeThresholdSeconds || audio.ended) {
                cleanup();
                resolve();
            }
        };
        const onTimeUpdate = ()=>evaluateResumeCondition();
        const onSeeked = ()=>evaluateResumeCondition();
        audio.addEventListener('timeupdate', onTimeUpdate);
        audio.addEventListener('seeked', onSeeked);
        // run an immediate check in case we're already under the threshold
        evaluateResumeCondition();
        function cleanup() {
            audio.removeEventListener('timeupdate', onTimeUpdate);
            audio.removeEventListener('seeked', onSeeked);
        }
    });
};



var $6AYaN = parcelRequire("6AYaN");

class $1550dde86523a13d$export$c9f0b1c72f108cf3 {
    validateRequestParams() {
        const { locale: locale, contentId: contentId, contentType: contentType, type: type, format: format, activationId: activationId, cloudId: cloudId, instructions: instructions, supportingResourceARIs: supportingResourceARIs = [] } = this.unvalidatedRequestParams;
        const mainResourceARI = this.getAri(cloudId, contentId, contentType);
        if (!mainResourceARI) {
            this.onAudioStreamingChange({
                type: (0, $aU1TP.AudioStreamingState).ERROR,
                error: new Error('Invalid content ARI')
            });
            return;
        }
        this.validatedRequestParams = {
            mainResourceARI: mainResourceARI,
            supportingResourceARIs: supportingResourceARIs,
            locale: locale,
            type: type,
            format: format,
            activationId: activationId,
            instructions: instructions
        };
    }
    async fetchAudio() {
        if (!this.validatedRequestParams) return;
        this.onAudioStreamingChange({
            type: (0, $aU1TP.AudioStreamingState).LOADING
        });
        try {
            this.response = await this.fetchAudioQuery(this.validatedRequestParams);
            this.onAudioStreamingChange({
                type: (0, $aU1TP.AudioStreamingState).STREAM_STARTED,
                response: this.response
            });
        } catch (error) {
            this.onAudioStreamingChange({
                type: (0, $aU1TP.AudioStreamingState).ERROR,
                error: error
            });
        }
    }
    streamAudioToMediaSource(audioElement) {
        if (!audioElement || !this.response) return;
        this.mediaSource = new MediaSource();
        this.audioElement = audioElement;
        this.isReadyToConsumeStream = true;
        const url = URL.createObjectURL(this.mediaSource);
        this.audioElement.src = url;
        this.audioElement.load();
        this.mediaSource.addEventListener('sourceopen', ()=>this.onMediaSourceOpen(url), {
            once: true
        });
    }
    resetState() {
        this.onAudioStreamingChange({
            type: (0, $aU1TP.AudioStreamingState).UNINITIALIZED
        });
    }
    pauseAndResetPlayer() {
        if (this.audioElement) {
            this.audioElement.pause();
            this.audioElement.currentTime = 0;
            this.audioElement.src = '';
        }
    }
    disposeStream() {
        this.isReadyToConsumeStream = false;
        if (this.mediaSource?.readyState === 'open') try {
            this.mediaSource.endOfStream();
        } catch (e) {
        // Errors during cleanup can be safely ignored.
        }
        this.response = null;
        this.audioElement = null;
        this.onAudioStreamingChange({
            type: (0, $aU1TP.AudioStreamingState).STREAM_DISPOSED
        });
    }
    constructor(config){
        this.response = null;
        this.validatedRequestParams = null;
        this.unvalidatedRequestParams = void 0;
        this.audioElement = null;
        this.mediaSource = null;
        this.isReadyToConsumeStream = false;
        this.fetchAudioQuery = void 0;
        this.onAudioStreamingChange = void 0;
        this.getAri = void 0;
        this.audioMimeType = void 0;
        this.maxBufferAheadSeconds = void 0;
        this.resumeBufferAheadSeconds = void 0;
        this.onMediaSourceOpen = async (url)=>{
            if (!this.mediaSource || !this.response || !this.audioElement) return;
            try {
                URL.revokeObjectURL(url);
                const sourceBuffer = this.mediaSource.addSourceBuffer(this.audioMimeType);
                sourceBuffer.mode = 'sequence';
                const reader = this.response.getReader();
                while(this.isReadyToConsumeStream){
                    // Backpressure: if bufferAhead is at or above the cap, wait for it to drain
                    const bufferAheadSeconds = (0, $53e499115d6db86b$export$a54736a253e13047)(this.audioElement);
                    if (bufferAheadSeconds >= this.maxBufferAheadSeconds) {
                        await (0, $53e499115d6db86b$export$a4a914e8c41c504d)(this.audioElement, this.isReadyToConsumeStream, this.resumeBufferAheadSeconds);
                        if (!this.isReadyToConsumeStream) break;
                    }
                    const { done: done, value: value } = await reader.read();
                    if (done) break;
                    if (!this.isReadyToConsumeStream) break;
                    // Ensure we have a proper BufferSource by copying to a new ArrayBuffer
                    const buffer = new Uint8Array(value);
                    await (0, $53e499115d6db86b$export$16cd91e6fd463653)(sourceBuffer, buffer);
                }
                if (this.isReadyToConsumeStream) // done
                this.disposeStream();
            } catch (e) {
                this.onAudioStreamingChange({
                    type: (0, $aU1TP.AudioStreamingState).ERROR,
                    error: e
                });
            }
        };
        this.onAudioStreamingChange = config.onAudioStreamingChange;
        this.fetchAudioQuery = config.fetchAudioQuery ?? ((params)=>(0, $08e4a34c7045e030$export$d5bb0b43ead5f824)(params));
        this.getAri = config.getAri ?? (0, $6AYaN.getConfluenceContentAri);
        this.audioMimeType = config.audioMimeType ?? 'audio/mpeg';
        this.maxBufferAheadSeconds = config.maxBufferAheadSeconds ?? 360;
        this.resumeBufferAheadSeconds = config.resumeBufferAheadSeconds ?? 180;
        this.unvalidatedRequestParams = config.requestParams;
    }
}






function $71eb7df9f95f0ee6$export$c2d86f7b2e16f621({ activationId: activationId, product: product, cloudId: cloudId, locale: locale, format: format, supportingContent: supportingContent }) {
    const { activeContent: { contentId: contentId, contentType: contentType }, activeFeature: activeFeature, customization: customization } = (0, $lqUMo.audioPlayerState).get();
    const overrideSupportingContent = supportingContent.length > 0 ? supportingContent.map((resource)=>resource.ari) : undefined;
    return {
        activationId: activationId,
        product: product,
        cloudId: cloudId,
        locale: locale,
        contentId: contentId,
        contentType: contentType,
        type: activeFeature,
        format: format,
        instructions: customization,
        supportingResourceARIs: overrideSupportingContent || supportingContent.map((resource)=>resource.ari)
    };
}









var $4wsPv = parcelRequire("4wsPv");

function $eb746a322067b31d$export$ddeb68f842997797({ activationId: activationId, product: product, cloudId: cloudId, locale: locale, format: format }) {
    const audioRef = (0, $42omo.useRef)(null);
    const audioPlayerStreamingManager = (0, $42omo.useRef)(null);
    const featureOverrideRef = (0, $42omo.useRef)(null);
    const { state: state, updateAudioPlayerStreamingStore: updateAudioPlayerStreamingStore } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const { start: start, success: success, failure: failure } = (0, $2Gu9D.useUFOExperience)({
        id: 'audio-player-streaming',
        component: 'audio-player',
        type: (0, $9NDUe.ExperienceTypes).Experience,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult
    });
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, updateAIAttributes: updateAIAttributes } = (0, $fYQcF.useAIEventsInstrumentation)();
    const handleObservabilityAndAnalytics = (0, $42omo.useCallback)(async (action)=>{
        // NOTE: we need to get the latest store update which might be delayed due to the async nature of the react render loop
        const featureToUse = featureOverrideRef.current ?? (0, $lqUMo.audioPlayerState).get().activeFeature;
        switch(action.type){
            case (0, $aU1TP.AudioStreamingState).LOADING:
                const featureName = (0, $1726f70a3a8c123e$export$8842837476c9062b)(featureToUse);
                // Update AI analytics config
                updateAIAttributes({
                    aiFeatureName: featureName
                });
                trackAIInteractionInit();
                await start();
                break;
            case (0, $aU1TP.AudioStreamingState).STREAM_STARTED:
                trackAIResultView();
                break;
            case (0, $aU1TP.AudioStreamingState).STREAM_DISPOSED:
                await success();
                break;
            case (0, $aU1TP.AudioStreamingState).ERROR:
                trackAIResultError({
                    aiErrorMessage: action.error.message
                });
                await failure({
                    metadata: {
                        error: action.error.message
                    }
                });
                break;
        }
    }, [
        trackAIInteractionInit,
        start,
        trackAIResultView,
        success,
        trackAIResultError,
        failure,
        updateAIAttributes
    ]);
    const onAudioStreamingChange = (0, $42omo.useCallback)((action)=>{
        updateAudioPlayerStreamingStore(action);
        handleObservabilityAndAnalytics(action);
    }, [
        updateAudioPlayerStreamingStore,
        handleObservabilityAndAnalytics
    ]);
    const fetchAudio = (0, $42omo.useCallback)(async (featureOverride)=>{
        featureOverrideRef.current = featureOverride ?? null;
        // Dispose previous player and stream if exists
        audioPlayerStreamingManager.current?.pauseAndResetPlayer();
        audioPlayerStreamingManager.current?.disposeStream();
        const requestParams = (0, $71eb7df9f95f0ee6$export$c2d86f7b2e16f621)({
            activationId: activationId,
            product: product,
            cloudId: cloudId,
            locale: locale,
            format: format,
            supportingContent: (0, $lqUMo.getSupportingContent)()
        });
        audioPlayerStreamingManager.current = new (0, $1550dde86523a13d$export$c9f0b1c72f108cf3)({
            requestParams: requestParams,
            onAudioStreamingChange: onAudioStreamingChange
        });
        audioPlayerStreamingManager.current.validateRequestParams();
        await audioPlayerStreamingManager.current.fetchAudio();
        audioPlayerStreamingManager.current.streamAudioToMediaSource(audioRef.current);
    }, [
        activationId,
        product,
        cloudId,
        locale,
        format,
        onAudioStreamingChange
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            audioPlayerStreamingManager.current?.disposeStream();
            audioPlayerStreamingManager.current?.resetState();
        };
    }, []);
    return {
        state: state,
        fetchAudio: fetchAudio,
        audioRef: audioRef
    };
}





const $afa84e7a69fdc750$var$DEFAULT_DELAY = 3000;
const $afa84e7a69fdc750$export$ea0a8bb4d087b859 = ({ delay: delay = $afa84e7a69fdc750$var$DEFAULT_DELAY, initiallyHovered: initiallyHovered = false, resetKey: resetKey, isPinned: isPinned = false, onMouseOverChange: onMouseOverChange } = {})=>{
    const [isMouseOver, setIsMouseOver] = (0, $42omo.useState)(initiallyHovered);
    const hasInteractedRef = (0, $42omo.useRef)(false);
    const timerRef = (0, $42omo.useRef)(null);
    const onMouseOverChangeRef = (0, $42omo.useRef)(onMouseOverChange);
    onMouseOverChangeRef.current = onMouseOverChange;
    const handleMouseEnter = ()=>{
        if (isPinned) return;
        if (!hasInteractedRef.current) hasInteractedRef.current = true;
        if (timerRef.current) {
            window.clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        setIsMouseOver(true);
        onMouseOverChange?.(true);
    };
    const handleMouseLeave = ()=>{
        if (isPinned) return;
        if (!hasInteractedRef.current) return;
        if (timerRef.current) window.clearTimeout(timerRef.current);
        timerRef.current = window.setTimeout(()=>{
            setIsMouseOver(false);
            onMouseOverChange?.(false);
        }, delay);
    };
    (0, $42omo.useEffect)(()=>{
        if (isPinned) return;
        hasInteractedRef.current = false;
        setIsMouseOver(initiallyHovered);
        onMouseOverChangeRef.current?.(initiallyHovered);
        if (timerRef.current) {
            window.clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    }, [
        resetKey,
        initiallyHovered,
        isPinned
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (timerRef.current) window.clearTimeout(timerRef.current);
        };
    }, []);
    return {
        isMouseOver: isPinned || isMouseOver,
        handleMouseEnter: handleMouseEnter,
        handleMouseLeave: handleMouseLeave
    };
};


/**
 * @generated SignedSource<<730b467fdfa6e298cc9bb49367ced8f2>>
 * @relayHash b07a70410be438a389c31e421a9a90fe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 522e1b08de693669df0566f0c80b9d9bae87c2f003a0cb827b5bd32362037679
const $580930d537545341$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "mainSource"
    }, v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "base"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "ari"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AutoPlayManagerPlaylistQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluencePlaylist",
                    "kind": "LinkedField",
                    "name": "confluence_getPlaylist",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluencePaginatedTracks",
                            "kind": "LinkedField",
                            "name": "tracks",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceTrack",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "mainContent",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "supportingContent",
                                            "plural": true,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AutoPlayManagerPlaylistQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluencePlaylist",
                    "kind": "LinkedField",
                    "name": "confluence_getPlaylist",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluencePaginatedTracks",
                            "kind": "LinkedField",
                            "name": "tracks",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceTrack",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "mainContent",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "supportingContent",
                                            "plural": true,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "522e1b08de693669df0566f0c80b9d9bae87c2f003a0cb827b5bd32362037679",
            "metadata": {},
            "name": "AutoPlayManagerPlaylistQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$580930d537545341$var$node.hash = "8b4b9fd779a0ee63c9971623c5381440";
var $580930d537545341$export$2e2bcd8739ae039 = $580930d537545341$var$node;











/**
 * @generated SignedSource<<527b8a530123c95f500cd789ffea95d1>>
 * @relayHash f405f8b9c9b53f7ffdd1a1d819d71c76
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71e634583d9285c9be3b5a89bcb2d4c0305c76601778e083e286ef3f8ca2940a
const $ed30d22d32f3de34$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "mainSource"
    }, v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "base"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "ari"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePlaylistAutoPlayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluencePlaylist",
                    "kind": "LinkedField",
                    "name": "confluence_getPlaylist",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluencePaginatedTracks",
                            "kind": "LinkedField",
                            "name": "tracks",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceTrack",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "mainContent",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "supportingContent",
                                            "plural": true,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePlaylistAutoPlayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluencePlaylist",
                    "kind": "LinkedField",
                    "name": "confluence_getPlaylist",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluencePaginatedTracks",
                            "kind": "LinkedField",
                            "name": "tracks",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceTrack",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "mainContent",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "supportingContent",
                                            "plural": true,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "71e634583d9285c9be3b5a89bcb2d4c0305c76601778e083e286ef3f8ca2940a",
            "metadata": {},
            "name": "usePlaylistAutoPlayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ed30d22d32f3de34$var$node.hash = "c972bc9e4e39f23b51a59a4558bbe5e6";
var $ed30d22d32f3de34$export$2e2bcd8739ae039 = $ed30d22d32f3de34$var$node;









var $dxfEr = parcelRequire("dxfEr");









var $1WGfE = parcelRequire("1WGfE");

//this had to be duplicated in order to satisfy relay unused data in the same file requirements
const $beb41736e5209541$var$covertDataToPlaylist = (data)=>{
    const tracks = data.confluence_getPlaylist?.tracks?.nodes || [];
    return tracks.filter((track)=>{
        const mainContent = track.mainContent;
        const hasMainContent = !!mainContent;
        const hasValidStatus = mainContent?.status === 'current' || mainContent?.status === 'draft';
        return hasMainContent && hasValidStatus;
    }).map((track)=>{
        const mainContent = track.mainContent;
        const supportingContent = track.supportingContent;
        const creator = mainContent.history?.createdBy;
        const avatarUrl = creator?.profilePicture?.path || undefined;
        return {
            id: mainContent.id,
            title: mainContent.title || undefined,
            trackType: track.type,
            author: creator?.displayName || undefined,
            avatarUrl: avatarUrl,
            spaceKey: mainContent.space?.key || '',
            contentType: mainContent.type || '',
            contentId: mainContent.id,
            mainContent: {
                ari: track.mainSource,
                link: mainContent.links?.base + mainContent.links?.webui || ''
            },
            supportingContent: supportingContent.map((content)=>({
                    ari: content.ari,
                    link: content.links?.base + content.links?.webui || ''
                }))
        };
    });
};
const $beb41736e5209541$export$54d1743b5ece830b = ({ playlistItems: playlistItems, currentItemId: currentItemId })=>{
    const { fetchAudio: fetchAudio, audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const { cloudId: cloudId } = (0, $9s8in.useAudioPlayerStore)();
    const { removeTrack: removeTrack } = (0, $1WGfE.useContextMenuActions)(cloudId);
    const environment = (0, $irOoi.useRelayEnvironment)();
    const { sendTrackEvent: sendTrackEvent } = (0, $dxfEr.usePlatformInstrumentation)();
    const playNextTrack = (0, $42omo.useCallback)(async (data)=>{
        let playlistData = playlistItems;
        if (data?.confluence_getPlaylist?.tracks?.nodes) playlistData = $beb41736e5209541$var$covertDataToPlaylist(data);
        if (playlistData.length === 0) return;
        const currentIndex = playlistData.findIndex((item)=>item.contentId === currentItemId);
        // Get the current item to remove it
        const currentItem = currentIndex !== -1 ? playlistItems[currentIndex] : null;
        // Remove the finished track if we have the necessary data
        if (currentItem && currentItem.mainContent.ari) try {
            const mainSource = currentItem.mainContent.ari;
            const supportingSources = currentItem.supportingContent?.map((content)=>content.ari) || [];
            const trackType = currentItem.trackType;
            await removeTrack(mainSource, supportingSources, trackType);
        // eslint-disable-next-line no-unused-vars
        } catch (_error) {
        // Silently ignore errors - continue to next track even if removal fails
        // leaving this for analytics instrumentation
        }
        let nextTrack;
        let nextIndex = currentIndex + 1;
        if (currentIndex === -1 || currentIndex === playlistData.length - 1) {
            nextTrack = playlistItems[0];
            nextIndex = 0;
        } else if (playlistData.length === 0) {
            sendTrackEvent({
                eventType: 'track',
                action: 'ended',
                actionSubject: 'autoplay',
                actionSubjectId: 'playlist',
                source: 'playlist',
                attributes: {
                    reason: 'ended'
                }
            });
            return; //we're out of content to play
        } else nextTrack = playlistData[currentIndex + 1];
        (0, $lqUMo.setActiveContent)({
            contentId: nextTrack?.contentId,
            spaceKey: nextTrack?.spaceKey || '',
            contentType: nextTrack?.contentType || '',
            title: nextTrack?.title,
            author: nextTrack?.author || '',
            avatarUrl: nextTrack?.avatarUrl || '',
            supportingContent: nextTrack?.supportingContent || [],
            interimSupportingContent: [],
            mainContentLink: nextTrack?.mainContent?.link
        });
        await fetchAudio().catch((error)=>{
            sendTrackEvent({
                eventType: 'track',
                action: 'error',
                actionSubject: 'autoplay',
                actionSubjectId: 'playlist',
                source: 'playlist',
                attributes: {
                    error: error
                }
            });
        }).then(()=>{
            sendTrackEvent({
                eventType: 'track',
                action: 'success',
                actionSubject: 'autoplay',
                actionSubjectId: 'playlist',
                source: 'playlist',
                attributes: {
                    previousContentId: currentItem?.contentId,
                    nextContentId: nextTrack?.contentId,
                    previousPosition: currentIndex,
                    nextPosition: nextIndex,
                    totalPlaylistSize: playlistData.length,
                    cloudId: cloudId
                }
            });
        });
    }, [
        currentItemId,
        playlistItems,
        fetchAudio,
        removeTrack,
        cloudId,
        sendTrackEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        const audio = audioRef.current;
        if (!audio) return;
        const onEnded = ()=>{
            (0, $irOoi.fetchQuery)(environment, (0, $ed30d22d32f3de34$export$2e2bcd8739ae039), {
                cloudId: cloudId
            }, {
                fetchPolicy: 'network-only'
            }).subscribe({
                next: (data)=>{
                    playNextTrack(data);
                },
                error: ()=>{
                    playNextTrack();
                }
            });
        };
        audio.addEventListener('ended', onEnded);
        return ()=>{
            audio.removeEventListener('ended', onEnded);
        };
    }, [
        audioRef,
        playNextTrack,
        cloudId,
        environment
    ]);
};


const $bfdfc52c2649bf8b$export$180d4a3d7d834091 = ({ cloudId: cloudId })=>{
    const { activeContent: activeContent } = (0, $9s8in.useAudioPlayerStore)();
    //Atlassian rules are that fragment spreads can't be split between modules, however
    //these are currently only split between folders in the same module?
    //since modifyPlaylistButton may exist outside the module it may make sense to have a full copy
    // of this query inside that component as lint desires?
    const data = (0, $irOoi.useLazyLoadQuery)((0, $580930d537545341$export$2e2bcd8739ae039), {
        cloudId: cloudId
    }, {
        fetchPolicy: 'store-or-network'
    });
    const playlistItems = (0, $42omo.useMemo)(()=>{
        const tracks = data.confluence_getPlaylist?.tracks?.nodes || [];
        return tracks.filter((track)=>{
            const mainContent = track.mainContent;
            const hasMainContent = !!mainContent;
            const hasValidStatus = mainContent?.status === 'current' || mainContent?.status === 'draft';
            return hasMainContent && hasValidStatus;
        }).map((track)=>{
            const mainContent = track.mainContent;
            const supportingContent = track.supportingContent;
            const creator = mainContent.history?.createdBy;
            const avatarUrl = creator?.profilePicture?.path || undefined;
            return {
                id: mainContent.id,
                title: mainContent.title || undefined,
                trackType: track.type,
                author: creator?.displayName || undefined,
                avatarUrl: avatarUrl,
                spaceKey: mainContent.space?.key || '',
                contentType: mainContent.type || '',
                contentId: mainContent.id,
                mainContent: {
                    ari: track.mainSource,
                    link: mainContent.links?.base + mainContent.links?.webui || ''
                },
                supportingContent: supportingContent?.length > 0 ? supportingContent.map((content)=>({
                        ari: content.ari,
                        link: content.links?.base + content.links?.webui || ''
                    })) : []
            };
        });
    }, [
        data
    ]);
    // Enable auto-play of next track when current track ends
    (0, $beb41736e5209541$export$54d1743b5ece830b)({
        playlistItems: playlistItems,
        currentItemId: activeContent?.contentId
    });
    return null;
};


/* ExpandedAudioPlayer.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $1Whri = parcelRequire("1Whri");




var $1s5hv = parcelRequire("1s5hv");

var $eyWa4 = parcelRequire("eyWa4");




const $31283dfc19fed4c3$export$b4fa6866c714d7ab = (activeFeature, featureList)=>{
    const feature = featureList.find((feature)=>feature.name === activeFeature);
    return feature;
};


const $a9308afb81463823$var$UNAUTHORIZED_ACCESS_ERROR = 'User not authorized to view the content or content not found.';
const $a9308afb81463823$export$d48e99c253065d82 = (error)=>{
    return error.message.includes($a9308afb81463823$var$UNAUTHORIZED_ACCESS_ERROR);
};









const $541af32bf6a57dc8$export$1790dc7e7a551c53 = (audioRef)=>{
    if (audioRef.current) {
        const duration = audioRef.current.duration;
        if (isNaN(duration) || duration === Infinity) return 0;
        return Math.floor(duration * 1000);
    }
    return 0;
};
const $541af32bf6a57dc8$export$1c8d646a62473bef = (audioRef)=>{
    if (audioRef.current) return Math.floor(audioRef.current.currentTime * 1000);
    return 0;
};
const $541af32bf6a57dc8$export$7b4cb6af8950f6d9 = (audioRef)=>{
    if (audioRef.current) {
        const length = $541af32bf6a57dc8$export$1790dc7e7a551c53(audioRef);
        if (length === 0) return 0;
        return Math.floor($541af32bf6a57dc8$export$1c8d646a62473bef(audioRef) / length * 100);
    }
    return 0;
};
const $541af32bf6a57dc8$export$d7261be602ea5ad6 = (audioRef, reason)=>({
        audioLengthMs: $541af32bf6a57dc8$export$1790dc7e7a551c53(audioRef),
        audioCurrentTimeMs: $541af32bf6a57dc8$export$1c8d646a62473bef(audioRef),
        percentCompleted: $541af32bf6a57dc8$export$7b4cb6af8950f6d9(audioRef),
        reason: reason
    });

















/**
 * @generated SignedSource<<39c6856431a5aa618ec47b484c3ed846>>
 * @relayHash 98940543d2f890b3a01b1617a17d5841
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 920908dc8d7e000174dd1c8bea53bac6318c2842c8cba68d9bfdfaa39b4b5353
const $047d23adec45ec32$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "mainSource"
    }, v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v10 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v11 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "base"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\"])"
    }, v13 = {
        "kind": "ScalarField",
        "name": "supportingSources"
    }, v14 = {
        "kind": "ScalarField",
        "name": "ari"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PlaylistQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluencePlaylist",
                    "kind": "LinkedField",
                    "name": "confluence_getPlaylist",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluencePaginatedTracks",
                            "kind": "LinkedField",
                            "name": "tracks",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceTrack",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "mainContent",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "supportingContent",
                                            "plural": true,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PlaylistQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluencePlaylist",
                    "kind": "LinkedField",
                    "name": "confluence_getPlaylist",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluencePaginatedTracks",
                            "kind": "LinkedField",
                            "name": "tracks",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceTrack",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "mainContent",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v9 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "supportingContent",
                                            "plural": true,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "920908dc8d7e000174dd1c8bea53bac6318c2842c8cba68d9bfdfaa39b4b5353",
            "metadata": {},
            "name": "PlaylistQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$047d23adec45ec32$var$node.hash = "1fdea4bdca2adcebc6ecc998bdbf0d99";
var $047d23adec45ec32$export$2e2bcd8739ae039 = $047d23adec45ec32$var$node;






var $lAJUP = parcelRequire("lAJUP");











var $4Gau4 = parcelRequire("4Gau4");









const $a7e9ce4629cb2531$export$ed78826c06dd24e3 = 'atlaskit';


















/* MinifiedAudioPlayer.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $cO1el = parcelRequire("cO1el");


var $ebrpi = parcelRequire("ebrpi");






var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");



var $iXCQx = parcelRequire("iXCQx");


var $3gadb = parcelRequire("3gadb");

const $d63febb277db51bb$var$INSUFFICIENT_CONTEXT_ERROR = 'Grabbed context does not meet minimum context requirements';
const $d63febb277db51bb$export$a2e8de1b1229502e = (error)=>{
    return error.message.includes($d63febb277db51bb$var$INSUFFICIENT_CONTEXT_ERROR);
};














/* AudioIconStack.tsx generated by @compiled/babel-plugin v0.36.1 */ 




















/* PlaylistItemIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $etuMO = parcelRequire("etuMO");


var $e0ycV = parcelRequire("e0ycV");


var $e3TOY = parcelRequire("e3TOY");


var $8jHAi = parcelRequire("8jHAi");


var $9RVmI = parcelRequire("9RVmI");





const $dc3c01f94aef424c$var$styles = {
    nonDraggableWrapper: "_uiztglyw _lcxvglyw"
};
const $dc3c01f94aef424c$var$sanitizeEmojiValue = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $dc3c01f94aef424c$var$messages = (0, $cgtv4.defineMessages)({
    pageIcon: {
        id: "playlist.item.icon.page",
        defaultMessage: "Page"
    },
    liveDocIcon: {
        id: "playlist.item.icon.liveDoc",
        defaultMessage: "LiveDoc"
    },
    blogPostIcon: {
        id: "playlist.item.icon.blogPost",
        defaultMessage: "Blog Post"
    }
});
const $dc3c01f94aef424c$export$a13aa309f968c8c1 = ({ emojiId: emojiId, contentType: contentType, isLive: isLive })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { emojiProvider: emojiProvider } = (0, $42omo.useContext)((0, $f43c45a1ab86a258$export$517a124efa5f6d1));
    const sanitizedEmojiId = $dc3c01f94aef424c$var$sanitizeEmojiValue(emojiId);
    const isPage = contentType === 'page'; //will it always be page? will we support whiteboard or database?
    const isBlogPost = contentType === 'blogpost';
    const hasValidEmoji = sanitizedEmojiId !== 'null' && sanitizedEmojiId !== '';
    if (hasValidEmoji && emojiProvider) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "span",
        xcss: $dc3c01f94aef424c$var$styles.nonDraggableWrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $etuMO.default // @ts-ignore shortName is not required
        ), {
            emojiId: {
                id: sanitizedEmojiId
            },
            emojiProvider: emojiProvider,
            fitToHeight: 20,
            showTooltip: false
        })
    });
    if (isPage && isLive) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))), {
        size: "medium",
        label: formatMessage($dc3c01f94aef424c$var$messages.liveDocIcon)
    });
    if (isPage) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
        size: "medium",
        label: formatMessage($dc3c01f94aef424c$var$messages.pageIcon)
    });
    if (isBlogPost) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))), {
        size: "medium",
        label: formatMessage($dc3c01f94aef424c$var$messages.blogPostIcon)
    });
     //todo: remove this if content type will always be page
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e3TOY))), {
        size: "medium",
        label: "Contnet icon"
    });
};


const $a7a8bb5fd614ff8e$var$primaryTileKeyframes = null;
const $a7a8bb5fd614ff8e$var$secondaryTileKeyframes = null; // Opacity change is intentionally instant to align with tile switch animation
const $a7a8bb5fd614ff8e$var$hideKeyframes = null;
const $a7a8bb5fd614ff8e$var$styles = {
    stackContainer: "_1bsbh176 _4t3i88uy",
    centeredContainer: "_1e0c1txw _1bah1h6o",
    stackLayer: "_kqswstnw",
    iconTile: "_2rko1qi0 _1dqonqa1 _1h6d1l7x _189ee4h9 _4t3i1mcy _1bsb1mcy _1e0c1txw _4cvr1h6o _1bah1h6o _bfhkvuon",
    primaryIconTile: "_t9ec1sks",
    primaryIconTileSwapped: "_t9ecvluc",
    secondaryIconTile: "_t9ec8ge8",
    secondaryIconTileSwapped: "_t9eca3ps",
    transparentIconTile: "_tzy4idpf",
    scaledIcon: "_t9ec229g",
    iconContainer: "_kqswh2mm _1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o",
    stackedIcon: "_kqswstnw",
    primaryIconTileAnimation: "_y44v1gmc",
    primaryIconTileAnimationReversed: "_y44v1v38",
    secondaryIconTileAnimation: "_y44vhtj3",
    secondaryIconTileAnimationReversed: "_y44v1fxz",
    hideAnimation: "_y44v5c68",
    showAnimation: "_y44v1cxv"
}; //this export will only show the current playing item.
const $a7a8bb5fd614ff8e$export$859e827cf90667aa = ()=>{
    const { activeContent: activeContent } = (0, $9s8in.useAudioPlayerStore)();
    const emojiId = activeContent.emojiId;
    const contentType = activeContent.contentType;
    const subType = activeContent.subType;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dc3c01f94aef424c$export$a13aa309f968c8c1), {
        emojiId: emojiId ?? undefined,
        contentType: contentType,
        isLive: subType === 'live'
    });
}; //this export is for the title of the full size player where the emoji can be either
const $a7a8bb5fd614ff8e$export$a53176aa2e1373f0 = ()=>{
    const { activeContent: activeContent, pendingContent: pendingContent } = (0, $9s8in.useAudioPlayerStore)(); //unlike other pendingContent fields emojiId can be null So instead we make sure that
    // pendingContent isn't null. If it exists we use whatever its emoji is, even if it's empty
    const emojiId = (pendingContent !== null ? pendingContent?.emojiId : activeContent.emojiId) ?? undefined;
    const contentType = pendingContent?.contentType ?? activeContent.contentType;
    const subType = pendingContent?.subType ?? activeContent.subType;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dc3c01f94aef424c$export$a13aa309f968c8c1), {
        emojiId: emojiId,
        contentType: contentType,
        isLive: subType === 'live'
    });
};
const $a7a8bb5fd614ff8e$export$5e85faf560125ae5 = ({ featureList: featureList })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { activeFeature: activeFeature } = (0, $9s8in.useAudioPlayerStore)();
    const activeFeatureInfo = (0, $31283dfc19fed4c3$export$b4fa6866c714d7ab)(activeFeature, featureList);
    const primaryFeature = featureList[0];
    const secondaryFeature = featureList[1];
    const isPrimaryActive = activeFeatureInfo?.name === primaryFeature.name; // Track if we've ever changed features (to persist animation class)
    const prevFeature = (0, $42omo.useRef)(null);
    const hasAnimated = (0, $42omo.useRef)(false); // Prevent animation on mount. After the first feature switch,
    // keep animations enabled so reverse transitions still animate
    if (prevFeature.current === null) prevFeature.current = activeFeature;
    else if (prevFeature.current !== activeFeature) {
        hasAnimated.current = true;
        prevFeature.current = activeFeature;
    }
    const shouldShowAnimation = hasAnimated.current;
    const PrimaryFeatureIcon = primaryFeature.icon;
    const SecondaryFeatureIcon = secondaryFeature.icon;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $a7a8bb5fd614ff8e$var$styles.centeredContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $a7a8bb5fd614ff8e$var$styles.stackContainer,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                alignInline: "center",
                xcss: $a7a8bb5fd614ff8e$var$styles.stackLayer,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($a7a8bb5fd614ff8e$var$styles.iconTile, isPrimaryActive ? $a7a8bb5fd614ff8e$var$styles.primaryIconTile : $a7a8bb5fd614ff8e$var$styles.primaryIconTileSwapped, shouldShowAnimation && (isPrimaryActive ? $a7a8bb5fd614ff8e$var$styles.primaryIconTileAnimationReversed : $a7a8bb5fd614ff8e$var$styles.primaryIconTileAnimation)),
                        testId: "primary-audio-tile",
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                            xcss: $a7a8bb5fd614ff8e$var$styles.iconContainer,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: (0, $1Whri.cx)($a7a8bb5fd614ff8e$var$styles.scaledIcon, $a7a8bb5fd614ff8e$var$styles.stackedIcon, shouldShowAnimation && (isPrimaryActive ? $a7a8bb5fd614ff8e$var$styles.showAnimation : $a7a8bb5fd614ff8e$var$styles.hideAnimation), !isPrimaryActive && $a7a8bb5fd614ff8e$var$styles.transparentIconTile),
                                    testId: "primary-feature-icon",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)(PrimaryFeatureIcon, {
                                        label: isPrimaryActive ? formatMessage(primaryFeature.translationString) : '',
                                        "aria-hidden": !isPrimaryActive
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: (0, $1Whri.cx)($a7a8bb5fd614ff8e$var$styles.scaledIcon, $a7a8bb5fd614ff8e$var$styles.stackedIcon, shouldShowAnimation && (isPrimaryActive ? $a7a8bb5fd614ff8e$var$styles.hideAnimation : $a7a8bb5fd614ff8e$var$styles.showAnimation), isPrimaryActive && $a7a8bb5fd614ff8e$var$styles.transparentIconTile),
                                    testId: "secondary-feature-icon",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)(SecondaryFeatureIcon, {
                                        label: !isPrimaryActive ? formatMessage(secondaryFeature.translationString) : '',
                                        "aria-hidden": isPrimaryActive
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($a7a8bb5fd614ff8e$var$styles.iconTile, isPrimaryActive ? $a7a8bb5fd614ff8e$var$styles.secondaryIconTile : $a7a8bb5fd614ff8e$var$styles.secondaryIconTileSwapped, shouldShowAnimation && (isPrimaryActive ? $a7a8bb5fd614ff8e$var$styles.secondaryIconTileAnimationReversed : $a7a8bb5fd614ff8e$var$styles.secondaryIconTileAnimation)),
                        testId: "secondary-audio-tile",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $a7a8bb5fd614ff8e$var$styles.scaledIcon,
                            children: /*#__PURE__*/ (0, $l998X.jsx)($a7a8bb5fd614ff8e$export$a53176aa2e1373f0, {})
                        })
                    })
                ]
            })
        }, activeFeature)
    });
};


/* AudioTimeIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $d8SNb = parcelRequire("d8SNb");





const $ac90fb746780e8b1$var$GeneratingAnimation = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("CQuUR")).then((mod)=>({
            default: mod.GeneratingAnimation
        })));
const $ac90fb746780e8b1$var$DEFAULT_TIME_DISPLAY = '0:00';
const $ac90fb746780e8b1$var$styles = {
    grid: "_yv0e1ch2 _1bsb1ns9 _1tkegktf",
    codeStyledText: "_ect4zzfg _syaz1rpy"
};
const $ac90fb746780e8b1$var$formatTime = (timeInSeconds)=>{
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};
const $ac90fb746780e8b1$var$TextWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        size: "small",
        align: "center",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $ac90fb746780e8b1$var$styles.codeStyledText,
            children: children
        })
    });
};
const $ac90fb746780e8b1$export$1ce816177bf69471 = ()=>{
    const { audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const [currentTimeDisplay, setCurrentTimeDisplay] = (0, $42omo.useState)($ac90fb746780e8b1$var$DEFAULT_TIME_DISPLAY);
    const [totalTimeDisplay, setTotalTimeDisplay] = (0, $42omo.useState)($ac90fb746780e8b1$var$DEFAULT_TIME_DISPLAY);
    const isAudioDurationUnknown = totalTimeDisplay === $ac90fb746780e8b1$var$DEFAULT_TIME_DISPLAY;
    const handleTimeUpdate = (0, $42omo.useCallback)(()=>{
        const audioEl = audioRef.current;
        if (!audioEl) return;
        const currentTime = Math.floor(audioEl.currentTime ?? 0);
        setCurrentTimeDisplay($ac90fb746780e8b1$var$formatTime(currentTime));
    }, [
        audioRef
    ]);
    const handleDurationChange = (0, $42omo.useCallback)(()=>{
        const audioEl = audioRef.current;
        if (!audioEl) return;
        const duration = audioEl.duration;
        if (Number.isFinite(duration)) setTotalTimeDisplay($ac90fb746780e8b1$var$formatTime(duration));
        else setTotalTimeDisplay($ac90fb746780e8b1$var$DEFAULT_TIME_DISPLAY);
    }, [
        audioRef
    ]);
    // Reset displays when audio source is cleared (during fetch)
    (0, $42omo.useEffect)(()=>{
        const audioEl = audioRef.current;
        if (!audioEl) return;
        const handleEmptied = ()=>{
            setCurrentTimeDisplay($ac90fb746780e8b1$var$DEFAULT_TIME_DISPLAY);
            setTotalTimeDisplay($ac90fb746780e8b1$var$DEFAULT_TIME_DISPLAY);
        };
        audioEl.addEventListener('emptied', handleEmptied);
        return ()=>{
            audioEl.removeEventListener('emptied', handleEmptied);
        };
    }, [
        audioRef
    ]);
    (0, $42omo.useEffect)(()=>{
        const audioEl = audioRef.current;
        if (!audioEl) return;
        handleTimeUpdate();
        handleDurationChange();
        audioEl.addEventListener('timeupdate', handleTimeUpdate);
        audioEl.addEventListener('durationchange', handleDurationChange);
        return ()=>{
            audioEl.removeEventListener('timeupdate', handleTimeUpdate);
            audioEl.removeEventListener('durationchange', handleDurationChange);
        };
    }, [
        audioRef,
        handleTimeUpdate,
        handleDurationChange
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
        testId: "audio-time-indicator",
        columnGap: "space.050",
        alignItems: "center",
        xcss: $ac90fb746780e8b1$var$styles.grid,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($ac90fb746780e8b1$var$TextWrapper, {
                children: currentTimeDisplay
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($ac90fb746780e8b1$var$TextWrapper, {
                children: "/"
            }),
            isAudioDurationUnknown ? /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $l998X.jsx)($ac90fb746780e8b1$var$GeneratingAnimation, {})
            }) : /*#__PURE__*/ (0, $l998X.jsx)($ac90fb746780e8b1$var$TextWrapper, {
                children: totalTimeDisplay
            })
        ]
    });
};


/* MiniPauseButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");










var $hpDFj = parcelRequire("hpDFj");














const $7c4bb90d2d062860$export$43d4c61d5a1d26c1 = (onToggle)=>{
    (0, $42omo.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (e.altKey && e.code === 'KeyP') {
                e.preventDefault();
                onToggle();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return ()=>window.removeEventListener('keydown', handleKeyDown);
    }, [
        onToggle
    ]);
};


const $4db9674c8498775d$var$i18n = (0, $cgtv4.defineMessages)({
    pauseButtonLabel: {
        id: "audio.mini-pause-button.pause-button-label",
        defaultMessage: "Pause"
    }
});
const $4db9674c8498775d$var$styles = {
    pauseButton: "_2rko1rr0 _1e0c116y _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _bfhki8nm",
    pauseButtonHover: "_irr3plhp _1di61gdz",
    pauseIcon: "_1e0c1o8l _t9ec8j72"
};
const $4db9674c8498775d$export$b7363f9f61d4134c = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        trackAIResultAction('audioPause', {
            attributes: {
                source: 'minified-audio-player'
            }
        });
        audioRef.current?.pause();
    }, [
        audioRef,
        trackAIResultAction
    ]);
    (0, $7c4bb90d2d062860$export$43d4c61d5a1d26c1)(handleClick);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: formatMessage($4db9674c8498775d$var$i18n.pauseButtonLabel),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            onClick: handleClick,
            xcss: (0, $1Whri.cx)($4db9674c8498775d$var$styles.pauseButton, $4db9674c8498775d$var$styles.pauseButtonHover),
            testId: "miniplayer-mini-pause-button",
            children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    $4db9674c8498775d$var$styles.pauseIcon
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hpDFj))), {
                    label: formatMessage($4db9674c8498775d$var$i18n.pauseButtonLabel)
                })
            })
        })
    });
};


/* MiniPlayButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 

















var $hLeLq = parcelRequire("hLeLq");












const $28faf1ad2f237904$var$i18n = (0, $cgtv4.defineMessages)({
    playButtonLabel: {
        id: "audio.mini-play-button.play-button-label",
        defaultMessage: "Play"
    }
});
const $28faf1ad2f237904$var$styles = {
    playButton: "_2rko1rr0 _1e0c116y _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _bfhki8nm",
    playButtonHover: "_irr3plhp _1di61gdz",
    playIcon: "_1e0c1o8l _t9ec8j72"
};
const $28faf1ad2f237904$export$95f5ab28d88f6f3b = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        trackAIResultAction('audioPlay', {
            attributes: {
                source: 'minified-audio-player'
            }
        });
        audioRef.current?.play();
    }, [
        audioRef,
        trackAIResultAction
    ]);
    (0, $7c4bb90d2d062860$export$43d4c61d5a1d26c1)(handleClick);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: formatMessage($28faf1ad2f237904$var$i18n.playButtonLabel),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            onClick: handleClick,
            xcss: (0, $1Whri.cx)($28faf1ad2f237904$var$styles.playButton, $28faf1ad2f237904$var$styles.playButtonHover),
            testId: "miniplayer-mini-play-button",
            children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    $28faf1ad2f237904$var$styles.playIcon
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hLeLq))), {
                    label: formatMessage($28faf1ad2f237904$var$i18n.playButtonLabel)
                })
            })
        })
    });
};



const $8aca57df42a7cd81$var$WaveformAnimation = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bXYW5")).then((mod)=>({
            default: mod.WaveformAnimation
        })));
const $8aca57df42a7cd81$var$i18n = (0, $cgtv4.defineMessages)({
    errorHeading: {
        id: "audio.minified-audio-player.error-heading",
        defaultMessage: "Error loading audio"
    },
    insufficientContextErrorHeading: {
        id: "audio.minified-audio-player.insufficient-context-error-heading",
        defaultMessage: "Not enough info to create a briefing"
    }
});
const $8aca57df42a7cd81$var$styles = {
    container: "_1rjc12x7 _18zru2gc _kqswh2mm _1bsb1osq _bfhkvuon",
    elevated: "_2rko1mok _1bsb1osq _16qst7xp",
    overlayButton: "_1r04idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko1mok _kqswstnw _1bsb1osq _4t3i1osq _1pbyidpf _bfhkvuon",
    content: "_kqswh2mm _1pbykb7n",
    warningIconContainer: "_1rjc1b66 _18zr1b66",
    contentArea: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    emojiIconContainer: "_t9ec1ov8 _19bvu2gc _u5f3u2gc"
};
const $8aca57df42a7cd81$var$dynamicStyles = {
    minWidth: `${(0, $61eRd.AUDIO_CONTAINER_MODES).MINIFIED.width}px`
};
const $8aca57df42a7cd81$export$fd7786f444ea3be1 = ({ title: title, byline: byline, elevated: elevated, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { state: state } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const { isPaused: isPaused, isPlaying: isPlaying } = (0, $9s8in.useAudioPlayerStore)();
    const hasFetched = state.state !== (0, $aU1TP.AudioStreamingState).UNINITIALIZED;
    const isErrorState = state.state === (0, $aU1TP.AudioStreamingState).ERROR;
    if (isErrorState) {
        const hasInsufficientContext = (0, $d63febb277db51bb$export$a2e8de1b1229502e)(state.error);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            style: $8aca57df42a7cd81$var$dynamicStyles,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($8aca57df42a7cd81$var$styles.container, elevated && $8aca57df42a7cd81$var$styles.elevated),
                children: [
                    onClick && /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                        onClick: onClick,
                        xcss: $8aca57df42a7cd81$var$styles.overlayButton,
                        testId: "minified-audio-player-pressable"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        space: "space.100",
                        xcss: $8aca57df42a7cd81$var$styles.content,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $8aca57df42a7cd81$var$styles.warningIconContainer,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
                                    color: "var(--ds-icon-warning, #E06C00)",
                                    label: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                size: "xsmall",
                                children: formatMessage(hasInsufficientContext ? $8aca57df42a7cd81$var$i18n.insufficientContextErrorHeading : $8aca57df42a7cd81$var$i18n.errorHeading)
                            })
                        ]
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        style: $8aca57df42a7cd81$var$dynamicStyles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            gap: "space.100",
            direction: "row",
            alignItems: "center",
            justifyContent: "space-between",
            xcss: (0, $1Whri.cx)($8aca57df42a7cd81$var$styles.container, elevated && $8aca57df42a7cd81$var$styles.elevated),
            children: [
                onClick && /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                    onClick: onClick,
                    xcss: $8aca57df42a7cd81$var$styles.overlayButton,
                    testId: "minified-audio-player-pressable"
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    gap: "space.100",
                    direction: "row",
                    alignItems: "center",
                    justifyContent: "start",
                    xcss: $8aca57df42a7cd81$var$styles.content,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $8aca57df42a7cd81$var$styles.emojiIconContainer,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7a8bb5fd614ff8e$export$859e827cf90667aa), {})
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                            content: title,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $8aca57df42a7cd81$var$styles.contentArea,
                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                    space: "space.025",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            maxLines: 1,
                                            align: "start",
                                            weight: "semibold",
                                            size: "small",
                                            children: title
                                        }),
                                        hasFetched ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ac90fb746780e8b1$export$1ce816177bf69471), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            size: "small",
                                            color: "color.text.subtlest",
                                            maxLines: 1,
                                            align: "start",
                                            children: byline
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                hasFetched && (isPlaying || isPaused) && /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    space: "space.100",
                    alignBlock: "center",
                    xcss: $8aca57df42a7cd81$var$styles.content,
                    children: isPaused ? /*#__PURE__*/ (0, $l998X.jsx)((0, $28faf1ad2f237904$export$95f5ab28d88f6f3b), {}) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                                fallback: null,
                                children: /*#__PURE__*/ (0, $l998X.jsx)($8aca57df42a7cd81$var$WaveformAnimation, {})
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $4db9674c8498775d$export$b7363f9f61d4134c), {})
                        ]
                    })
                })
            ]
        })
    });
};


/* FooterMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");









var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $a3fRD = parcelRequire("a3fRD");








const $a4f01eca3bc8d64c$var$styles = {
    footer: "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvpxbi _16qs1nax _bfhkvuon _kqsw1if8 _94n5idpf _1bsb1osq _y3gn1e5h _1pbykb7n",
    content: "_16jlkb7n _1o9zkb7n _i0dlf1ug"
};
const $a4f01eca3bc8d64c$var$messages = (0, $cgtv4.defineMessages)({
    footerMessage: {
        id: "ai-audio.playlist.footer-message",
        defaultMessage: "Some items are no longer available due to permissions or deletion."
    },
    closeLabel: {
        id: "ai-audio.playlist.footer-close",
        defaultMessage: "Close"
    }
});
const $a4f01eca3bc8d64c$export$b5402b48e8cc96c3 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $a4f01eca3bc8d64c$var$styles.footer,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            gap: "space.200",
            alignItems: "center",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                    color: "var(--ds-icon-subtle, #505258)",
                    label: "Warning"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $a4f01eca3bc8d64c$var$styles.content,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "small",
                        color: "color.text.subtle",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...$a4f01eca3bc8d64c$var$messages.footerMessage
                        })
                    })
                }),
                onClose && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                    label: formatMessage($a4f01eca3bc8d64c$var$messages.closeLabel),
                    onClick: onClose,
                    appearance: "subtle",
                    shape: "circle"
                })
            ]
        })
    });
};


/* PlaylistEmptyView.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $afBrg = parcelRequire("afBrg");


var $3DMri = parcelRequire("3DMri");












parcelRequire("42omo");

const $3d679f5218c04b0e$export$32bae604890efcac = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "playlist-empty-illustration",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M70.558 37.5128C69.0656 29.2045 63.294 24.0845 55.2009 22.7696C53.8191 22.5456 52.3733 22.4292 50.8664 22.4292C49.3595 22.4292 47.7886 22.5543 46.3515 22.7928C38.2526 24.1456 32.4926 29.251 30.9973 37.5128C30.7442 38.9092 30.6133 40.3928 30.6133 41.9667C30.6133 43.5405 30.7413 44.9834 30.9915 46.3623C32.4751 54.6125 38.2409 59.7296 46.3515 61.0823C47.7856 61.3208 49.2926 61.4459 50.8664 61.4459C52.4402 61.4459 53.8191 61.3296 55.2009 61.1056C63.3056 59.7877 69.0831 54.659 70.5638 46.3623C70.8111 44.9834 70.9391 43.5172 70.9391 41.9667C70.9391 40.4161 70.8082 38.9092 70.558 37.5128Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.375 67.7471H55.0106L35.383 49.6118L16.375 67.7471Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M10.1646 12.5093C10.1646 12.5093 7.49983 28.9864 10.2867 37.4664H38.0307C38.0307 37.4664 35.718 24.326 38.2722 12.5093C38.2722 12.5093 9.98129 12.6896 10.1646 12.5093Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M31.0117 37.4664H38.0314C38.0314 37.4664 37.2343 32.9282 37.0946 26.7842C33.9819 29.3151 31.8466 32.9078 31.0117 37.4664Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M35.3857 49.5942L32.8984 51.9651C35.5312 56.9281 40.2846 60.0495 46.353 61.0619C46.8999 61.1521 47.4643 61.2219 48.0315 61.2801L35.3828 49.5942H35.3857Z",
                fill: "#164B35"
            })
        ]
    });
};


const $b28c8be0834a93be$var$messages = (0, $cgtv4.defineMessages)({
    emptyPlaylistHeading: {
        id: "ai-audio.playlist.empty.heading",
        defaultMessage: "Queue up some work"
    },
    emptyPlaylistDescription: {
        id: "ai-audio.playlist.empty.description",
        defaultMessage: "Tap {audioIcon} on Pages and Live Docs, then click {addToPlaylistIcon} to add to your list"
    },
    audioIconLabel: {
        id: "ai-audio.playlist.empty.audio-icon-label",
        defaultMessage: "Audio briefing icon"
    },
    addToPlaylistIconLabel: {
        id: "ai-audio.playlist.empty.addToPlaylist-icon-label",
        defaultMessage: "Add to playlist icon"
    }
});
const $b28c8be0834a93be$var$styles = {
    container: "_16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _1bah1h6o _y3gn1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    content: "_1bsb12aa _y3gn1h6o _19bvxy5q _u5f3xy5q"
};
const $b28c8be0834a93be$export$5412f1eb9298d3ef = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { sendUIEvent: sendUIEvent } = (0, $dxfEr.usePlatformInstrumentation)();
    (0, $42omo.useEffect)(()=>{
        sendUIEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: 'playlistEmpty',
            actionSubjectId: 'playlist',
            source: 'playlist'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: $b28c8be0834a93be$var$styles.container,
        justifyContent: "center",
        alignItems: "center",
        rowGap: "space.200",
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3d679f5218c04b0e$export$32bae604890efcac), {}),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                xcss: $b28c8be0834a93be$var$styles.content,
                alignItems: "center",
                rowGap: "space.150",
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                        size: "small",
                        as: "h3",
                        children: formatMessage($b28c8be0834a93be$var$messages.emptyPlaylistHeading)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "medium",
                        color: "color.text.subtlest",
                        children: formatMessage($b28c8be0834a93be$var$messages.emptyPlaylistDescription, {
                            audioIcon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($afBrg))), {
                                label: formatMessage($b28c8be0834a93be$var$messages.audioIconLabel)
                            }),
                            addToPlaylistIcon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3DMri))), {
                                label: formatMessage($b28c8be0834a93be$var$messages.addToPlaylistIconLabel)
                            })
                        })
                    })
                ]
            })
        ]
    });
};


/* PlaylistErrorView.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $ccHMk = parcelRequire("ccHMk");















parcelRequire("42omo");

const $40f5c70c499fb79a$export$444f767f9ea88cb4 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M35.6598 20.7648C35.7761 20.8841 36.0496 20.7066 35.9885 20.5524C35.9041 20.3313 35.7907 20.1132 35.6249 19.8513C35.4183 19.5633 35.3136 19.5255 35.1914 19.319C34.9703 18.9786 34.6736 18.3561 34.6038 18.2048C34.5921 18.1815 34.5805 18.1612 34.566 18.1408C34.4612 18.0012 34.0016 17.3844 33.6612 16.8172C33.4081 16.4273 33.2481 16.1859 33.1667 16.0579C32.9718 15.7612 32.7972 15.5546 32.6052 15.3713C32.4976 15.2695 32.262 15.4237 32.3114 15.5604C32.4016 15.8135 32.518 16.055 32.71 16.3546C32.7856 16.471 32.8758 16.7561 33.0852 17.1022C33.1201 17.1604 33.1609 17.2128 33.2074 17.2593C33.606 17.6783 33.9812 18.3124 33.9812 18.3124C33.9812 18.3124 34.5776 19.2346 34.8307 19.6244C35.0227 19.9183 35.1129 20.0579 35.1711 20.1452C35.3427 20.407 35.4969 20.5961 35.6627 20.7648H35.6598Z",
                fill: "#1E1F21"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M36.0877 28.2473C36.2564 28.291 36.3989 28.0001 36.2622 27.8953C36.0673 27.7441 35.8491 27.6102 35.5582 27.4648C35.2207 27.3164 35.1073 27.3339 34.8862 27.2175C34.5051 27.0313 33.9029 26.6357 33.7604 26.5368C33.74 26.5222 33.7167 26.5106 33.6935 26.5019C33.5247 26.4321 32.7829 26.1237 32.1749 25.7979C31.7386 25.5826 31.468 25.4517 31.3255 25.3819C30.9909 25.219 30.7262 25.1259 30.4557 25.0619C30.3073 25.027 30.1822 25.2801 30.3015 25.3761C30.5197 25.5506 30.7524 25.7048 31.0869 25.8706C31.2178 25.9346 31.4535 26.1382 31.8287 26.3361C31.8898 26.3681 31.9538 26.3942 32.0207 26.4146C32.5997 26.5804 33.2746 26.947 33.2746 26.947C33.2746 26.947 34.3044 27.4531 34.7378 27.6684C35.0666 27.8284 35.2237 27.907 35.3197 27.9535C35.6135 28.0961 35.852 28.1833 36.0906 28.2473H36.0877Z",
                fill: "#1E1F21"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M42.7548 24.2241C42.9759 24.7652 43.2814 24.6604 43.1272 24.099C42.9061 23.299 42.6501 22.467 42.2923 21.4052C41.8705 20.2095 41.7046 19.9332 41.4341 19.1157C41.309 18.7521 41.1694 18.3186 41.0297 17.8735C40.9599 17.6495 40.8901 17.4255 40.8203 17.2044C40.7737 17.0561 40.7854 17.0822 40.7766 17.0473L40.7679 16.9921C40.7883 16.9979 40.8086 17.0066 40.829 17.0124L40.8523 17.0212H40.8639L40.8697 17.027L40.9017 17.0328C41.085 17.0677 41.2566 17.1026 41.4079 17.1317C41.7134 17.1928 41.949 17.2422 42.0857 17.2684C42.1701 17.2859 42.2574 17.3004 42.3446 17.3121C42.5686 17.3441 43.069 17.4197 43.7759 17.5244C44.1279 17.5797 44.5352 17.6408 44.9832 17.7106C45.5708 17.8037 46.2166 17.9084 46.909 18.019C46.8217 17.7106 46.5861 16.8641 46.3592 16.0553C45.9054 14.4495 45.6232 13.4575 45.4748 12.9397C45.1257 11.715 44.8348 10.8073 44.5206 9.92588C44.349 9.44006 44.0756 9.51861 44.1832 10.0219C44.3781 10.9382 44.605 11.8633 44.9483 13.0881C45.0821 13.5652 45.2886 14.5775 45.6726 15.9826C45.7337 16.2124 45.8036 16.4393 45.8792 16.6604C45.9374 16.8321 45.9956 17.0066 46.0537 17.187L46.0654 17.2219C46.0654 17.2219 46.0654 17.2277 46.0683 17.2306L46.0741 17.2393L46.0857 17.2597L46.109 17.3121H46.0537H46.0217H46.013L45.9723 17.3062L45.8908 17.2946C45.6756 17.2626 45.4661 17.2335 45.2596 17.2015C44.8494 17.1375 44.4683 17.0764 44.1396 17.027C43.485 16.9164 43.0428 16.8437 43.0428 16.8437L39.9883 16.3433L41.0559 19.4881C41.4603 20.6721 41.6523 21.2393 41.7716 21.5884C42.1352 22.6473 42.4377 23.4619 42.7519 24.2328L42.7548 24.2241Z",
                fill: "#1E1F21"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M46.1112 28.582C46.0472 28.7361 46.3178 28.9194 46.437 28.8001C46.6087 28.6343 46.7658 28.4452 46.9432 28.1834C47.1294 27.878 47.1236 27.7674 47.2661 27.5696C47.493 27.2292 47.9556 26.7085 48.0661 26.5834C48.0836 26.566 48.0981 26.5456 48.1098 26.5223C48.197 26.3681 48.5898 25.702 48.9796 25.1638C49.2414 24.774 49.4043 24.5325 49.4887 24.4074C49.6865 24.1078 49.8087 23.8692 49.9047 23.6161C49.957 23.4765 49.7243 23.3194 49.6138 23.4212C49.4159 23.6045 49.2385 23.8081 49.0349 24.1049C48.9563 24.2212 48.7294 24.419 48.4909 24.7507C48.453 24.806 48.4181 24.8641 48.3919 24.9252C48.1592 25.4576 47.7199 26.0569 47.7199 26.0569C47.7199 26.0569 47.1003 26.9732 46.8385 27.363C46.6436 27.654 46.5476 27.7965 46.4894 27.8838C46.3149 28.1456 46.1985 28.3638 46.1083 28.5849L46.1112 28.582Z",
                fill: "#1E1F21"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.293 70.1609L16.3192 70.2104H63.6879L63.717 70.1609L40.005 26.3384L16.293 70.1609Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M40.082 42.0303V58.0332",
                stroke: "white",
                strokeWidth: "2.66545",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M41.2052 63.0195C41.2197 62.9439 41.2255 62.8624 41.2255 62.7781C41.2255 62.6937 41.2197 62.6093 41.2052 62.5337C41.1237 62.077 40.8066 61.7977 40.3615 61.725C40.2859 61.7133 40.2074 61.7075 40.123 61.7075C40.0386 61.7075 39.9543 61.7133 39.8757 61.7279C39.4306 61.8006 39.1164 62.0828 39.0321 62.5366C39.0175 62.6122 39.0117 62.6937 39.0117 62.781C39.0117 62.8682 39.0175 62.9468 39.0321 63.0224C39.1135 63.4762 39.4306 63.7555 39.8757 63.8312C39.9543 63.8457 40.0386 63.8515 40.123 63.8515C40.2074 63.8515 40.2859 63.8457 40.3615 63.8341C40.8066 63.7613 41.1237 63.4792 41.2052 63.0253V63.0195Z",
                stroke: "white",
                strokeWidth: "2.66545",
                strokeMiterlimit: "10"
            })
        ]
    });
};


const $72825c5b62874300$var$messages = (0, $cgtv4.defineMessages)({
    errorPlaylistHeading: {
        id: "ai-audio.playlist.error.heading",
        defaultMessage: "Hmm, something went wrong"
    },
    errorPlaylistMessage: {
        id: "ai-audio.playlist.error.message",
        defaultMessage: "Failed to load playlist"
    },
    tryAgainButton: {
        id: "ai-audio.playlist.error.try-again",
        defaultMessage: "Try again"
    }
});
const $72825c5b62874300$var$styles = {
    container: "_16jlkb7n _1o9zkb7n _i0dlf1ug _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    content: "_1bsb12aa _y3gn1h6o"
};
const $72825c5b62874300$export$babe4b87e2205167 = ({ error: error, onRetry: onRetry })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { sendTrackEvent: sendTrackEvent } = (0, $dxfEr.usePlatformInstrumentation)();
    (0, $42omo.useEffect)(()=>{
        sendTrackEvent({
            eventType: 'track',
            action: 'viewed',
            actionSubject: 'playlistError',
            actionSubjectId: 'playlist',
            source: 'playlist',
            attributes: {
                message: error?.message
            }
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: $72825c5b62874300$var$styles.container,
        justifyContent: "center",
        alignItems: "center",
        rowGap: "space.200",
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $40f5c70c499fb79a$export$444f767f9ea88cb4), {}),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                xcss: $72825c5b62874300$var$styles.content,
                alignItems: "center",
                rowGap: "space.150",
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                        size: "small",
                        as: "h3",
                        children: formatMessage($72825c5b62874300$var$messages.errorPlaylistHeading)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "medium",
                        color: "color.text.subtlest",
                        children: error?.message || formatMessage($72825c5b62874300$var$messages.errorPlaylistMessage)
                    })
                ]
            }),
            onRetry && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                appearance: "default",
                onClick: onRetry,
                children: formatMessage($72825c5b62874300$var$messages.tryAgainButton)
            })
        ]
    });
};


/* PlaylistHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");













var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");











parcelRequire("42omo");

const $198caac5591e8787$export$edce85b1447597ec = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M13.458 5L13.0625 3.1416C12.901 2.38205 12.1541 1.89719 11.3945 2.05859L3.1416 3.8125C2.38201 3.97396 1.89728 4.72088 2.05859 5.48047L3.8125 13.7334C3.93937 14.3303 4.42811 14.7556 5 14.833V8.28125C5.0001 6.46919 6.46919 5.00006 8.28125 5H13.458ZM8.28125 6.875C7.50472 6.87506 6.8751 7.50473 6.875 8.28125V16.7188C6.875 17.4954 7.50465 18.1249 8.28125 18.125H16.7188C17.4954 18.125 18.125 17.4954 18.125 16.7188V8.28125C18.1249 7.50469 17.4953 6.875 16.7188 6.875H8.28125ZM10.1543 9.18945C10.4433 9.02174 10.7997 9.02081 11.0898 9.18652L15.4648 11.6865C15.7569 11.8534 15.9374 12.1636 15.9375 12.5C15.9375 12.8364 15.7569 13.1475 15.4648 13.3145L11.0898 15.8145C10.7998 15.98 10.4432 15.9782 10.1543 15.8105C9.86549 15.6428 9.6875 15.334 9.6875 15V10C9.68756 9.66597 9.86545 9.3572 10.1543 9.18945ZM16.7188 5C18.5309 5 19.9999 6.46916 20 8.28125V16.7188C20 18.5309 18.5309 20 16.7188 20H8.28125C6.46912 19.9999 5 18.5309 5 16.7188V16.7168C3.55933 16.6348 2.29313 15.6034 1.97852 14.124L0.224609 5.87012C-0.151891 4.09768 0.979513 2.35526 2.75195 1.97852L11.0049 0.224609C12.7774 -0.152104 14.5197 0.979448 14.8965 2.75195L15.374 5H16.7188Z",
            fill: "#505258"
        })
    });
};


const $11331ad580bc04dc$var$messages = (0, $cgtv4.defineMessages)({
    playlistHeader: {
        id: "ai-audio.playlist.header",
        defaultMessage: "Playlist"
    },
    collapsePlaylistLabel: {
        id: "ai-audio.playlist.header.collapse-label",
        defaultMessage: "Collapse playlist"
    },
    expandPlaylistLabel: {
        id: "ai-audio.playlist.header.expand-label",
        defaultMessage: "Expand playlist"
    }
});
const $11331ad580bc04dc$var$styles = {
    container: "_ca0q1b66 _n3td1b66 _19bv1b66 _u5f31b66 _kqsw1if8 _154iidpf _1pbykb7n _4t3i1ylp _bfhkvuon _t9ec161g _9x1o15vq",
    containerExpanded: "_n3td12x7 _19bv12x7 _u5f312x7 _ca0q12x7",
    headerButton: "_2rko1qi0 _4t3izwfg _80omtlke _1bsb1osq _bfhkvuon _1ah3ze3t _irr31dpa",
    minifiedAudioPlayerContainer: "_ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc"
};
const $11331ad580bc04dc$export$4a2fa2c22decc531 = ({ isExpanded: isExpanded, onToggle: onToggle })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($11331ad580bc04dc$var$styles.container, isExpanded && $11331ad580bc04dc$var$styles.containerExpanded),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                onClick: onToggle,
                xcss: $11331ad580bc04dc$var$styles.headerButton,
                "aria-label": formatMessage(isExpanded ? $11331ad580bc04dc$var$messages.collapsePlaylistLabel : $11331ad580bc04dc$var$messages.expandPlaylistLabel),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            gap: "space.100",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $198caac5591e8787$export$edce85b1447597ec), {}),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                    as: "h3",
                                    size: "xsmall",
                                    children: formatMessage($11331ad580bc04dc$var$messages.playlistHeader)
                                })
                            ]
                        }),
                        isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            label: "",
                            size: "medium",
                            LEGACY_margin: "-4px"
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                            label: "",
                            size: "medium",
                            LEGACY_margin: "-4px"
                        })
                    ]
                })
            })
        })
    });
};


/* PlaylistLoadingView.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $9hlns = parcelRequire("9hlns");

const $fa33749b641c5e6f$var$styles = {
    container: "_4t3i1qnl _19pkpxbi"
};
const $fa33749b641c5e6f$export$2477093f98b7771d = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        xcss: $fa33749b641c5e6f$var$styles.container,
        justifyContent: "center",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: "medium"
        })
    });
};


/* PlaylistView.tsx generated by @compiled/babel-plugin v0.36.1 */ 

















var $bl9WW = parcelRequire("bl9WW");













/* PlaylistItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
















































var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $22Iw9 = parcelRequire("22Iw9");


var $euUgw = parcelRequire("euUgw");


var $iV0NL = parcelRequire("iV0NL");





var $9VJDA = parcelRequire("9VJDA");










// Product agnostic
var $40d88dbb76c26f6b$export$c2fc6e4ded3e0219 = /*#__PURE__*/ function(TrackType) {
    TrackType["BRIEFING"] = "BRIEFING";
    TrackType["NARRATION"] = "NARRATION";
    return TrackType;
}({});














var $eq3pJ = parcelRequire("eq3pJ");




const $d1a0d49ce70050e9$var$messages = (0, $cgtv4.defineMessages)({
    copyLinkSuccess: {
        id: "ai-audio.audio-share-link.copy-success-title",
        defaultMessage: "Link copied"
    },
    copyLinkSuccessDescription: {
        id: "ai-audio.audio-share-link.copy-success-description",
        defaultMessage: "People with access to the content can open the audio."
    },
    copyLinkError: {
        id: "ai-audio.audio-share-link.copy-error",
        defaultMessage: "Failed to copy link"
    }
});
const $d1a0d49ce70050e9$export$7dffd02bd56a4e49 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const flags = (0, $3A9F3.useFlags)();
    const copyAudioShareLinkToClipboard = (0, $42omo.useCallback)(async (mainSourceUrl, feature, supportingContent)=>{
        try {
            const link = (0, $eq3pJ.generateAudioShareLink)(mainSourceUrl, feature, supportingContent);
            await navigator.clipboard.writeText(link);
            if (flags) flags.showFlag({
                type: 'success-circle',
                title: formatMessage($d1a0d49ce70050e9$var$messages.copyLinkSuccess),
                description: formatMessage($d1a0d49ce70050e9$var$messages.copyLinkSuccessDescription),
                close: 'auto'
            });
        } catch  {
            if (flags) flags.showFlag({
                type: 'error',
                title: formatMessage($d1a0d49ce70050e9$var$messages.copyLinkError),
                close: 'auto'
            });
        }
    }, [
        flags,
        formatMessage
    ]);
    return {
        copyAudioShareLinkToClipboard: copyAudioShareLinkToClipboard
    };
};





const $80deb67c02e7e7fc$var$messages = (0, $cgtv4.defineMessages)({
    moreOptions: {
        id: "ai-audio.playlist.more-options",
        defaultMessage: "More options"
    },
    moveUp: {
        id: "ai-audio.playlist.move-up",
        defaultMessage: "Move up"
    },
    moveDown: {
        id: "ai-audio.playlist.move-down",
        defaultMessage: "Move down"
    },
    copyLink: {
        id: "ai-audio.playlist.copy-link",
        defaultMessage: "Copy link to audio"
    },
    removeFromPlaylist: {
        id: "ai-audio.playlist.remove-from-playlist",
        defaultMessage: "Remove from playlist"
    }
});
const $80deb67c02e7e7fc$export$67438c15ecb70167 = ({ onMenuOpenChange: onMenuOpenChange, isFirstItem: isFirstItem, isLastItem: isLastItem, data: data, currentIndex: currentIndex, allItems: allItems })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { cloudId: cloudId, setHasOpenDropdownMenu: setHasOpenDropdownMenu } = (0, $9s8in.useAudioPlayerStore)();
    const { removeTrack: removeTrack, reorderTrack: reorderTrack } = (0, $1WGfE.useContextMenuActions)(cloudId);
    const { copyAudioShareLinkToClipboard: copyAudioShareLinkToClipboard } = (0, $d1a0d49ce70050e9$export$7dffd02bd56a4e49)();
    const { mainContent: mainContent, supportingContent: supportingContent, trackType: trackType } = data;
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { sendTrackEvent: sendTrackEvent, sendUIEvent: sendUIEvent } = (0, $dxfEr.usePlatformInstrumentation)();
    const handleOpenChange = (args)=>{
        setIsOpen(args.isOpen);
        onMenuOpenChange?.(args.isOpen);
        // Track menu open/close in global state
        setHasOpenDropdownMenu(args.isOpen);
        if (args.isOpen) sendUIEvent({
            eventType: 'ui',
            action: 'opened',
            actionSubject: 'menu',
            actionSubjectId: 'playlist',
            source: 'playlist',
            attributes: {
                contentType: data.contentType,
                trackType: trackType,
                itemPosition: currentIndex
            }
        });
    };
    const handleMoveUp = async ()=>{
        if (isFirstItem || currentIndex <= 0) return;
        const targetTrack = {
            mainSource: mainContent.ari,
            supportingSources: supportingContent.map((content)=>content.ari),
            trackType: trackType
        };
        const newReferenceIndex = currentIndex - 2;
        const referenceItem = newReferenceIndex >= 0 ? allItems[newReferenceIndex] : null;
        const referenceTrack = referenceItem ? {
            mainSource: referenceItem.mainContent.ari,
            supportingSources: referenceItem.supportingContent.map((content)=>content.ari),
            trackType: referenceItem.trackType
        } : undefined; // undefined means move to beginning
        await reorderTrack(targetTrack, referenceTrack, data.title);
        sendUIEvent({
            eventType: 'ui',
            action: 'reordered',
            actionSubject: 'playlistItem',
            actionSubjectId: 'playlist',
            source: 'playlist',
            attributes: {
                contentType: data.contentType,
                trackType: trackType,
                oldPosition: currentIndex,
                newPosition: currentIndex - 1,
                totalPlaylistSize: allItems?.length
            }
        });
    };
    const handleMoveDown = async ()=>{
        if (isLastItem || currentIndex >= allItems.length - 1) return;
        const targetTrack = {
            mainSource: mainContent.ari,
            supportingSources: supportingContent.map((content)=>content.ari),
            trackType: trackType
        };
        // When moving down, we want to place our item after the item that's currently below us
        const referenceItem = allItems[currentIndex + 1];
        const referenceTrack = {
            mainSource: referenceItem.mainContent.ari,
            supportingSources: referenceItem.supportingContent.map((content)=>content.ari),
            trackType: referenceItem.trackType
        };
        await reorderTrack(targetTrack, referenceTrack, data.title);
        sendUIEvent({
            eventType: 'ui',
            action: 'reordered',
            actionSubject: 'playlistItem',
            actionSubjectId: 'playlist',
            source: 'playlist',
            attributes: {
                contentType: data.contentType,
                trackType: trackType,
                oldPosition: currentIndex,
                newPosition: currentIndex + 1,
                totalPlaylistSize: allItems?.length
            }
        });
    };
    const handleCopyLink = ()=>{
        copyAudioShareLinkToClipboard(data.mainContent.link, data.trackType === (0, $40d88dbb76c26f6b$export$c2fc6e4ded3e0219).BRIEFING ? (0, $CAM5Y.AudioFeatureType).BRIEFING : (0, $CAM5Y.AudioFeatureType).NARRATION, data.supportingContent);
        sendUIEvent({
            eventType: 'ui',
            action: 'copied',
            actionSubject: 'playlistItem',
            actionSubjectId: 'playlist',
            source: 'playlist',
            attributes: {
                contentType: data.contentType,
                trackType: trackType,
                itemPosition: currentIndex
            }
        });
    };
    const handleRemove = async ()=>{
        const mainSourceAri = mainContent.ari;
        const supportingSourcesAris = supportingContent.map((content)=>content.ari);
        await removeTrack(mainSourceAri, supportingSourcesAris, trackType, data.title).catch((error)=>{
            sendTrackEvent({
                eventType: 'track',
                action: 'error',
                actionSubject: 'playlistItemRemove',
                actionSubjectId: 'playlist',
                source: 'playlist',
                attributes: {
                    error: error,
                    contentType: data.contentType,
                    trackType: trackType,
                    itemPosition: currentIndex,
                    totalPlaylistSize: allItems?.length
                }
            });
        }).then(()=>{
            sendUIEvent({
                eventType: 'ui',
                action: 'removed',
                actionSubject: 'playlistItem',
                actionSubjectId: 'playlist',
                source: 'playlist',
                attributes: {
                    contentType: data.contentType,
                    trackType: trackType,
                    itemPosition: currentIndex,
                    totalPlaylistSize: allItems?.length
                }
            });
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: formatMessage($80deb67c02e7e7fc$var$messages.moreOptions),
        canAppear: ()=>!isOpen,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
            onOpenChange: handleOpenChange,
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    ...triggerProps,
                    ref: triggerRef,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                    label: formatMessage($80deb67c02e7e7fc$var$messages.moreOptions),
                    appearance: "subtle",
                    shape: "circle"
                }),
            shouldRenderToParent: true,
            strategy: "absolute",
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $ahaN7.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                        onClick: handleMoveUp,
                        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
                            label: ""
                        }),
                        isDisabled: isFirstItem,
                        children: formatMessage($80deb67c02e7e7fc$var$messages.moveUp)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                        onClick: handleMoveDown,
                        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($22Iw9))), {
                            label: ""
                        }),
                        isDisabled: isLastItem,
                        children: formatMessage($80deb67c02e7e7fc$var$messages.moveDown)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                        onClick: handleCopyLink,
                        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iV0NL))), {
                            label: ""
                        }),
                        children: formatMessage($80deb67c02e7e7fc$var$messages.copyLink)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                        onClick: handleRemove,
                        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                            label: ""
                        }),
                        children: formatMessage($80deb67c02e7e7fc$var$messages.removeFromPlaylist)
                    })
                ]
            })
        })
    });
};



const $138d2535002035dc$var$messages = (0, $cgtv4.defineMessages)({
    unknownAuthor: {
        id: "playlist.item.unknown-author",
        defaultMessage: "Unknown author"
    },
    typeBriefing: {
        id: "playlist.item.type.briefing",
        defaultMessage: "Briefing"
    },
    typeNarration: {
        id: "playlist.item.type.narration",
        defaultMessage: "Narration"
    }
});
const $138d2535002035dc$var$styles = {
    gridContainer: "_2rko1qi0 _1e0c11p5 _kqswh2mm _bfhkvuon _irr3116u",
    container: "_2rko1qi0 _yyhyjvu9 _1ii7kb7n _1bsb1osq _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc _bfhk1j28",
    content: "_16jlkb7n _1o9zkb7n _i0dlf1ug _y3gn1e5h",
    contentWithMenu: "_u5f31jfw",
    iconWrapper: "_1e0c1txw _1wpz1y6m _ca0q1b66 _1o9zidpf _1bsb1tcg _1bah1h6o",
    title: "_4t3igktf",
    subtitle: "_zulp1b66 _1e0c1txw _4cvr1h6o _4t3igktf",
    authorName: "_1o9zkb7n _1ul9idpf",
    separator: "_1o9zidpf",
    type: "_1o9zidpf",
    contextualMenuOverlay: "_yyhyjvu9 _1ii7kb7n _1e0c1txw _4cvr1h6o _1bahesu3 _u5f3u2gc _lcxvglyw",
    contextualMenuButton: "_v5641hrg _tzy4idpf _lcxv1wug",
    contextualMenuButtonVisible: "_tzy4kb7n"
};
const $138d2535002035dc$export$e1eaa64b8ea94aef = ({ data: data, onItemClick: onItemClick, isFirstItem: isFirstItem, isLastItem: isLastItem, currentIndex: currentIndex, allItems: allItems })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { title: title, trackType: trackType, author: author } = data;
    const { sendUIEvent: sendUIEvent } = (0, $dxfEr.usePlatformInstrumentation)();
    const displayTitle = title || '';
    const displayAuthor = author || formatMessage($138d2535002035dc$var$messages.unknownAuthor);
    const audioType = trackType === 'BRIEFING' ? formatMessage($138d2535002035dc$var$messages.typeBriefing) : formatMessage($138d2535002035dc$var$messages.typeNarration);
    const titleRef = (0, $42omo.useRef)(null);
    const authorRef = (0, $42omo.useRef)(null);
    const [isTitleTruncated, setIsTitleTruncated] = (0, $42omo.useState)(false);
    const [isAuthorTruncated, setIsAuthorTruncated] = (0, $42omo.useState)(false);
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false); // isMenuOpen is needed to still show the menu trigger button when the user is interacting with the menu
    const [isMenuOpen, setIsMenuOpen] = (0, $42omo.useState)(false);
    const shouldShowMenuTrigger = isHovered || isMenuOpen;
    const handleClick = (0, $42omo.useCallback)(()=>{
        sendUIEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'playlistItem',
            actionSubjectId: 'playlist',
            source: 'playlist',
            attributes: {
                contentType: data.contentType,
                trackType: trackType,
                itemPosition: currentIndex,
                totalPlaylistSize: allItems?.length
            }
        });
        onItemClick?.(data);
    }, [
        onItemClick,
        data,
        allItems?.length,
        currentIndex,
        sendUIEvent,
        trackType
    ]);
    (0, $42omo.useEffect)(()=>{
        if (titleRef.current) {
            const element = titleRef.current;
            const isTruncated = element.scrollHeight > element.clientHeight;
            setIsTitleTruncated(isTruncated);
        }
    }, [
        title,
        isHovered
    ]);
    (0, $42omo.useEffect)(()=>{
        if (authorRef.current) {
            const element = authorRef.current;
            const isTruncated = element.scrollHeight > element.clientHeight;
            setIsAuthorTruncated(isTruncated);
        }
    }, [
        author,
        isHovered
    ]);
    const shouldShowTooltip = isTitleTruncated || isAuthorTruncated;
    const tooltipContent = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                children: displayTitle
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                children: [
                    displayAuthor,
                    " \u2022 ",
                    audioType
                ]
            })
        ]
    });
    const playlistItem = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: ()=>setIsHovered(true),
        onBlur: ()=>setIsHovered(false),
        xcss: (0, $1Whri.cx)($138d2535002035dc$var$styles.gridContainer),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                onClick: handleClick,
                xcss: $138d2535002035dc$var$styles.container,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    gap: "space.150",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $138d2535002035dc$var$styles.iconWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dc3c01f94aef424c$export$a13aa309f968c8c1), {
                                emojiId: data.emojiId,
                                contentType: data.contentType,
                                isLive: data.isLive
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            xcss: (0, $1Whri.cx)($138d2535002035dc$var$styles.content, shouldShowMenuTrigger && $138d2535002035dc$var$styles.contentWithMenu),
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $138d2535002035dc$var$styles.title,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        maxLines: 1,
                                        ref: titleRef,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                            as: "h5",
                                            size: "xsmall",
                                            children: displayTitle
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                    xcss: $138d2535002035dc$var$styles.subtitle,
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $138d2535002035dc$var$styles.authorName,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                size: "small",
                                                color: "color.text.subtle",
                                                maxLines: 1,
                                                ref: authorRef,
                                                children: displayAuthor
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $138d2535002035dc$var$styles.separator,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                size: "small",
                                                color: "color.text.subtle",
                                                children: "\u2022"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $138d2535002035dc$var$styles.type,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                size: "small",
                                                color: "color.text.subtle",
                                                children: audioType
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $138d2535002035dc$var$styles.contextualMenuOverlay,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($138d2535002035dc$var$styles.contextualMenuButton, shouldShowMenuTrigger && $138d2535002035dc$var$styles.contextualMenuButtonVisible),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $80deb67c02e7e7fc$export$67438c15ecb70167), {
                        onMenuOpenChange: setIsMenuOpen,
                        isFirstItem: isFirstItem,
                        isLastItem: isLastItem,
                        data: data,
                        currentIndex: currentIndex,
                        allItems: allItems
                    })
                })
            })
        ]
    });
    return shouldShowTooltip ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: tooltipContent,
        children: playlistItem
    }) : playlistItem;
};


const $0d7b77dc727e4033$var$messages = (0, $cgtv4.defineMessages)({
    nowPlaying: {
        id: "ai-audio.playlist.now-playing",
        defaultMessage: "Now playing"
    },
    upNext: {
        id: "ai-audio.playlist.up-next",
        defaultMessage: "Up next"
    }
});
const $0d7b77dc727e4033$var$styles = {
    playlist: "_16jlkb7n _1o9zkb7n _i0dlf1ug _ca0qu2gc _u5f3utpp _n3tdutpp _19bvutpp",
    sectionHeader: "_y3gn1e5h _19bvu2gc _ca0q1b66 _n3tdu2gc _u5f31b66 _syazazsu",
    sectionList: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw",
    upNextSection: "_ca0qutpp",
    player: "_18u01b66 _2hwx1b66",
    emptySection: "_ca0qpxbi"
};
const $0d7b77dc727e4033$export$2273374c83a237b1 = ({ items: items, hasUnavailableItems: hasUnavailableItems = false, currentItem: currentItem, currentItemTrackType: currentItemTrackType, onItemClick: onItemClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { sendUIEvent: sendUIEvent } = (0, $dxfEr.usePlatformInstrumentation)();
    (0, $42omo.useEffect)(()=>{
        sendUIEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: 'playlist',
            actionSubjectId: 'playlist',
            source: 'playlist',
            attributes: {
                playlistSize: items.length,
                hasUnavailableItems: hasUnavailableItems
            }
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Separate currently playing item from the rest (only if it's in the playlist)
    const remainingItems = currentItem && currentItemTrackType ? items.filter((item)=>item.contentId !== currentItem.contentId || item.trackType !== currentItemTrackType) : items;
    const renderPlaylistItem = (0, $42omo.useCallback)((item, index, totalCount)=>/*#__PURE__*/ (0, $l998X.jsx)("li", {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $138d2535002035dc$export$e1eaa64b8ea94aef), {
                data: item,
                onItemClick: onItemClick,
                isFirstItem: currentItem ? index === 1 : index === 0,
                isLastItem: index === totalCount - 1,
                currentIndex: index,
                allItems: items
            })
        }, item.id), [
        onItemClick,
        currentItem,
        items
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bl9WW.default), {
        columns: 1,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
            xcss: $0d7b77dc727e4033$var$styles.playlist,
            direction: "column",
            children: currentItem ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $0d7b77dc727e4033$var$styles.sectionHeader,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            as: "h4",
                            size: "xxsmall",
                            children: formatMessage($0d7b77dc727e4033$var$messages.nowPlaying)
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                        as: "ul",
                        space: "space.100",
                        xcss: $0d7b77dc727e4033$var$styles.sectionList,
                        children: /*#__PURE__*/ (0, $l998X.jsx)("li", {
                            className: (0, $gMc0m.default)([
                                $0d7b77dc727e4033$var$styles.player
                            ]),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8aca57df42a7cd81$export$fd7786f444ea3be1), {
                                title: currentItem.title || '',
                                byline: "",
                                elevated: true
                            })
                        }, currentItem.contentId)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        xcss: $0d7b77dc727e4033$var$styles.upNextSection,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $0d7b77dc727e4033$var$styles.sectionHeader,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                    as: "h4",
                                    size: "xxsmall",
                                    children: formatMessage($0d7b77dc727e4033$var$messages.upNext)
                                })
                            }),
                            remainingItems.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                                as: "ul",
                                space: "space.100",
                                xcss: $0d7b77dc727e4033$var$styles.sectionList,
                                children: remainingItems.map((item, index)=>{
                                    return renderPlaylistItem(item, index + 1, items.length);
                                })
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                                xcss: $0d7b77dc727e4033$var$styles.emptySection,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b28c8be0834a93be$export$5412f1eb9298d3ef), {})
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                as: "ul",
                space: "space.100",
                xcss: $0d7b77dc727e4033$var$styles.sectionList,
                children: items.map((item, index)=>renderPlaylistItem(item, index, items.length))
            })
        })
    });
};


const $f8afa1f53c3baeb9$var$styles = {
    wrapper: "_2rko1mok _1reo15vq _18m915vq _bfhkvuon _16qs1nax _kqswstnw _94n5u2gc _1ltvu2gc _1xi2u2gc _1e0c1txw _2lx21bp4",
    contentContainer: "_4t3ic1vo _kqswh2mm _18m91wug",
    contentContainerWithPendingContent: "_4t3i1x4w",
    fullHeightWrapper: "_16jlkb7n _kqswh2mm",
    playlistInnerContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf _kqswh2mm _4t3i1osq _ca0q1b66",
    coverBorder: "_kqswstnw _1bsb1osq _154iidpf _bfhkvuon _1pby1kze _4t3i1crf _t9ec161g _9x1o15vq",
    stickyShadow: "_kqsw1if8 _154ir5cr _1pbykb7n _16qs1nax _bfhkvuon _4t3i14y2",
    minifiedAudioPlayer: "_18u0u2gc _2hwxu2gc _19pku2gc _otyru2gc"
};
const $f8afa1f53c3baeb9$var$PlaylistWrapper = ({ children: children, defaultExpanded: defaultExpanded = false, hasOtherActivePlayback: hasOtherActivePlayback = false })=>{
    const resizingHeightProps = (0, $4Gau4.useResizingHeight)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(defaultExpanded);
    const { activeContent: activeContent, clearPendingContent: clearPendingContent } = (0, $9s8in.useAudioPlayerStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        setIsExpanded(defaultExpanded);
    }, [
        defaultExpanded
    ]);
    const handleToggle = ()=>{
        setIsExpanded((prev)=>{
            // Reset the unavailable content flag
            (0, $lqUMo.setPlaylistHasUnavailableContent)(false);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: !prev ? 'expanded' : 'collapsed',
                    actionSubject: 'playlist',
                    actionSubjectId: 'playlist',
                    eventType: 'track'
                }
            }).fire((0, $a7e9ce4629cb2531$export$ed78826c06dd24e3));
            return !prev;
        });
        (0, $lqUMo.resetPlaylistDefaultExpanded)();
    };
    const handleMinifiedPlayerClick = ()=>{
        clearPendingContent();
    };
    const shouldShowMinifiedPlayer = !isExpanded && hasOtherActivePlayback;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        direction: "column",
        xcss: $f8afa1f53c3baeb9$var$styles.wrapper,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $11331ad580bc04dc$export$4a2fa2c22decc531), {
                isExpanded: isExpanded,
                onToggle: handleToggle
            }),
            shouldShowMinifiedPlayer && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $f8afa1f53c3baeb9$var$styles.minifiedAudioPlayer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8aca57df42a7cd81$export$fd7786f444ea3be1), {
                    title: activeContent.title || '',
                    byline: "",
                    elevated: true,
                    onClick: handleMinifiedPlayerClick
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ...resizingHeightProps,
                children: isExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    xcss: (0, $1Whri.cx)($f8afa1f53c3baeb9$var$styles.contentContainer, hasOtherActivePlayback && $f8afa1f53c3baeb9$var$styles.contentContainerWithPendingContent),
                    direction: "column",
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                        direction: "column",
                        xcss: $f8afa1f53c3baeb9$var$styles.fullHeightWrapper,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $f8afa1f53c3baeb9$var$styles.coverBorder
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $f8afa1f53c3baeb9$var$styles.stickyShadow
                            }),
                            children
                        ]
                    })
                })
            })
        ]
    });
};
const $f8afa1f53c3baeb9$var$PlaylistInner = ({ cloudId: cloudId, fetchKey: fetchKey })=>{
    const { fetchAudio: fetchAudio } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const { activeContent: activeContent, playlistHasUnavailableContent: playlistHasUnavailableContent } = (0, $9s8in.useAudioPlayerStore)();
    const { removeTrack: removeTrack, addTrack: addTrack } = (0, $1WGfE.useContextMenuActions)(cloudId);
    const { sendTrackEvent: sendTrackEvent } = (0, $dxfEr.usePlatformInstrumentation)();
    const data = (0, $irOoi.useLazyLoadQuery)((0, $047d23adec45ec32$export$2e2bcd8739ae039), {
        cloudId: cloudId
    }, {
        fetchPolicy: 'network-only',
        fetchKey: fetchKey
    });
    const { playlistItems: serverPlaylistItems, unavailableItems: unavailableItems } = (0, $42omo.useMemo)(()=>{
        const tracks = data.confluence_getPlaylist?.tracks?.nodes || [];
        const filtered = [];
        const unavailable = [];
        tracks.forEach((track)=>{
            const mainContent = track.mainContent;
            const supportingContent = track.supportingContent;
            const hasMainContent = !!mainContent;
            const hasValidStatus = mainContent?.status === 'current' || mainContent?.status === 'draft';
            if (hasMainContent && hasValidStatus) {
                const creator = mainContent.history?.createdBy;
                const avatarUrl = creator?.profilePicture?.path || undefined;
                const item = {
                    id: track.id,
                    title: mainContent.title || undefined,
                    trackType: track.type,
                    author: creator?.displayName || undefined,
                    avatarUrl: avatarUrl,
                    spaceKey: mainContent.space?.key || '',
                    contentType: mainContent.type || '',
                    isLive: !!(mainContent.subType === 'live'),
                    emojiId: mainContent.properties?.nodes?.[0]?.value || undefined,
                    contentId: mainContent.id,
                    mainContent: {
                        ari: track.mainSource,
                        link: mainContent.links?.base + mainContent.links?.webui || ''
                    },
                    supportingContent: supportingContent.map((content)=>({
                            ari: content.ari,
                            link: content.links?.base + content.links?.webui || ''
                        }))
                };
                filtered.push(item);
            } else {
                const unavailableItem = {
                    mainSource: track.mainSource,
                    supportingSources: track.supportingSources || [],
                    trackType: track.type
                };
                unavailable.push(unavailableItem);
            }
        });
        return {
            playlistItems: filtered,
            unavailableItems: unavailable
        };
    }, [
        data
    ]); // Remove unavailable items from the playlist and show unavailable content notification
    (0, $42omo.useEffect)(()=>{
        if (unavailableItems.length === 0) return;
        (0, $lqUMo.setPlaylistHasUnavailableContent)(true);
        sendTrackEvent({
            eventType: 'track',
            action: 'detected',
            actionSubject: 'unavailableItems',
            actionSubjectId: 'playlist',
            source: 'playlist',
            attributes: {
                unavailableItemsCount: unavailableItems.length,
                totalPlaylistSize: serverPlaylistItems.length
            }
        });
        Promise.allSettled(unavailableItems.map((item)=>removeTrack(item.mainSource, item.supportingSources, item.trackType)));
    }, [
        unavailableItems,
        removeTrack,
        serverPlaylistItems,
        sendTrackEvent
    ]);
    const shouldShowFooterMessage = playlistHasUnavailableContent;
    const currentPlaylistItems = serverPlaylistItems;
    const { state: streamingState } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const isUninitialized = streamingState.state === (0, $aU1TP.AudioStreamingState).UNINITIALIZED;
    const { activeFeature: activeFeature, setActiveFeature: setActiveFeature } = (0, $9s8in.useAudioPlayerStore)();
    const currentItem = (0, $42omo.useMemo)(()=>{
        if (!activeContent?.contentId || isUninitialized) return null;
        return activeContent;
    }, [
        activeContent,
        isUninitialized
    ]);
    const currentItemTrackType = (0, $42omo.useMemo)(()=>{
        if (!activeFeature || isUninitialized) return null;
         // Convert AudioFeatureType (lowercase) to TrackType (uppercase)
        return activeFeature.toString().toUpperCase();
    }, [
        activeFeature,
        isUninitialized
    ]);
    const handleItemClick = (0, $42omo.useCallback)((item)=>{
        const supportingSources = item.supportingContent.map((content)=>content.ari); // Add the track to the top of the playlist
        addTrack(item.mainContent.ari, supportingSources, item.trackType, {
            top: true,
            showFlags: false
        }).catch(()=>{
        // TODO: analytics
        });
        (0, $lqUMo.setActiveContent)({
            contentId: item.contentId,
            spaceKey: item.spaceKey || '',
            contentType: item.contentType || '',
            title: item.title,
            author: item.author,
            avatarUrl: item.avatarUrl || '',
            supportingContent: item.supportingContent,
            mainContentLink: item.mainContent.link,
            interimSupportingContent: [],
            emojiId: item?.emojiId || undefined
        });
        setActiveFeature(item.trackType.toLowerCase());
        fetchAudio();
    }, [
        addTrack,
        fetchAudio,
        setActiveFeature
    ]);
    const dismissFooter = (0, $42omo.useCallback)(()=>{
        (0, $lqUMo.setPlaylistHasUnavailableContent)(false);
        sendTrackEvent({
            eventType: 'track',
            action: 'dismissed',
            actionSubject: 'footerMessage',
            actionSubjectId: 'playlist',
            source: 'playlist',
            attributes: {
                unavailableItemsCount: unavailableItems.length,
                totalPlaylistSize: serverPlaylistItems.length
            }
        });
    }, [
        sendTrackEvent,
        unavailableItems.length,
        serverPlaylistItems.length
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        direction: "column",
        xcss: $f8afa1f53c3baeb9$var$styles.playlistInnerContainer,
        children: [
            currentPlaylistItems.length === 0 && !currentItem ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b28c8be0834a93be$export$5412f1eb9298d3ef), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $0d7b77dc727e4033$export$2273374c83a237b1), {
                items: currentPlaylistItems,
                hasUnavailableItems: unavailableItems.length > 0,
                currentItem: currentItem,
                currentItemTrackType: currentItemTrackType,
                onItemClick: handleItemClick
            }),
            shouldShowFooterMessage && /*#__PURE__*/ (0, $l998X.jsx)((0, $a4f01eca3bc8d64c$export$b5402b48e8cc96c3), {
                onClose: dismissFooter
            })
        ]
    });
};
const $f8afa1f53c3baeb9$export$a10c242a3195e585 = ({ cloudId: cloudId, defaultExpanded: defaultExpanded })=>{
    const { pendingContent: pendingContent } = (0, $9s8in.useAudioPlayerStore)();
    const { state: streamingState } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const isUninitialized = streamingState.state === (0, $aU1TP.AudioStreamingState).UNINITIALIZED;
    const [fetchKey, setFetchKey] = (0, $42omo.useState)(0);
    const handleIncrementFetchKey = (0, $42omo.useCallback)(()=>{
        setFetchKey((prev)=>prev + 1);
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)($f8afa1f53c3baeb9$var$PlaylistWrapper, {
        defaultExpanded: defaultExpanded,
        hasOtherActivePlayback: pendingContent !== null && !isUninitialized,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
            fallbackRender: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $72825c5b62874300$export$babe4b87e2205167), {
                    ...props,
                    onRetry: handleIncrementFetchKey
                }),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $fa33749b641c5e6f$export$2477093f98b7771d), {}),
                children: /*#__PURE__*/ (0, $l998X.jsx)($f8afa1f53c3baeb9$var$PlaylistInner, {
                    cloudId: cloudId,
                    fetchKey: fetchKey
                })
            })
        }, fetchKey)
    });
};


/* AudioFeedbackFooter.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $dpPtd = parcelRequire("dpPtd");










var $iuafG = parcelRequire("iuafG");

var $aXh2V = parcelRequire("aXh2V");

var $9Rf00 = parcelRequire("9Rf00");




const $64432bd829583b79$var$AUDIO_FEEDBACK_ENTRYPOINT_ID = 'ffb1f355-3d3c-45c7-a0d1-1f13eb13baa3';
const $64432bd829583b79$var$styles = {
    footerWrapper: "_18zru2gc _1q51v77o _85i512x7",
    footerContainer: "_kqswstnw _1ltvutpp _1xi2utpp _94n51jfw _85i51b66"
};
const $64432bd829583b79$export$a62c3d0b73e04446 = ({ userId: userId, displayName: displayName })=>{
    const { activeContent: activeContent, activeFeature: activeFeature } = (0, $9s8in.useAudioPlayerStore)();
    const { trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const handleLikeClicked = (0, $42omo.useCallback)(()=>{
        trackAIFeedbackSubmit('up');
    }, [
        trackAIFeedbackSubmit
    ]);
    const handleDislikeClicked = (0, $42omo.useCallback)(()=>{
        trackAIFeedbackSubmit('down');
    }, [
        trackAIFeedbackSubmit
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9Rf00.AIFeedbackPropertiesProvider), {
            entrypointId: $64432bd829583b79$var$AUDIO_FEEDBACK_ENTRYPOINT_ID,
            userId: userId ?? undefined,
            displayName: displayName ?? undefined,
            feedbackContext: {
                feature: activeFeature,
                isTeamEUVersion: true
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $64432bd829583b79$var$styles.footerContainer,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    spread: "space-between",
                    grow: "fill",
                    alignBlock: "start",
                    alignInline: "center",
                    xcss: $64432bd829583b79$var$styles.footerWrapper,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iuafG.AIDisclaimer), {}),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $aXh2V.AIFeedbackComponent), {
                            contentId: activeContent.contentId,
                            onLikeClicked: handleLikeClicked,
                            onDislikeClicked: handleDislikeClicked
                        })
                    ]
                })
            })
        })
    });
};





parcelRequire("42omo");












var $f4Buk = parcelRequire("f4Buk");

/* AudioFeatureToggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");










var $jY68A = parcelRequire("jY68A");














const $b67f95736b88fa09$var$i18n = (0, $cgtv4.defineMessages)({
    switchToFeatureLabel: {
        id: "ai-audio.player.feature-toggle.switch-to-feature-label",
        defaultMessage: "Switch to"
    }
});
const $b67f95736b88fa09$var$styles = {
    toggleButton: "_2rko1rr0 _1h6d1l7x _189ee4h9 _1dqonqa1 _4t3izwfg _ca0q12x7 _n3td12x7 _u5f3utpp _19bvutpp _syazi7uo",
    toggleButtonInteractive: "_bfhksm61 _irr31dpa _1di6fcek"
};
const $b67f95736b88fa09$export$e019b538b718d4b = ({ featureList: featureList, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { activeFeature: activeFeature, activeContent: activeContent } = (0, $9s8in.useAudioPlayerStore)();
    const activeFeatureInfo = (0, $31283dfc19fed4c3$export$b4fa6866c714d7ab)(activeFeature, featureList);
    const getNextFeature = ()=>{
        const currentIndex = featureList.findIndex((feature)=>feature.name === activeFeatureInfo?.name);
        const nextIndex = (currentIndex + 1) % featureList.length;
        return featureList[nextIndex];
    };
    const nextFeature = getNextFeature();
    const isDisabled = !activeContent?.contentId;
    const accessibleLabel = nextFeature.accessibleLabel ? `${formatMessage($b67f95736b88fa09$var$i18n.switchToFeatureLabel)} ${formatMessage(nextFeature.accessibleLabel)}` : `${formatMessage($b67f95736b88fa09$var$i18n.switchToFeatureLabel)} ${formatMessage(nextFeature.translationString)}`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($b67f95736b88fa09$var$styles.toggleButton, !isDisabled && $b67f95736b88fa09$var$styles.toggleButtonInteractive),
        onClick: onClick,
        isDisabled: isDisabled,
        "aria-label": accessibleLabel,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
            gap: "space.150",
            alignItems: "center",
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.075",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jY68A))), {
                        label: "",
                        color: "var(--ds-text-subtle, #505258)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                        size: "medium",
                        color: "color.text.subtle",
                        children: [
                            formatMessage($b67f95736b88fa09$var$i18n.switchToFeatureLabel),
                            ' ',
                            formatMessage(nextFeature.translationString)
                        ]
                    })
                ]
            })
        })
    });
};


/* AudioHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $esRft = parcelRequire("esRft");




















const $6f913394e3b1cf0a$var$styles = {
    iconTileContainer: "_6rthpxbi",
    headingContainer: "_18zru2gc"
};
const $6f913394e3b1cf0a$export$c4e332ee639ec438 = ({ featureList: featureList })=>{
    const { activeContent: activeContent, pendingContent: pendingContent } = (0, $9s8in.useAudioPlayerStore)();
    const contentTitle = pendingContent?.title || activeContent.title || 'Untitled';
    const contentAuthor = pendingContent?.author ?? activeContent.author ?? '';
    const contentAvatarUrl = pendingContent?.avatarUrl ?? activeContent.avatarUrl ?? '';
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $6f913394e3b1cf0a$var$styles.iconTileContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7a8bb5fd614ff8e$export$5e85faf560125ae5), {
                    featureList: featureList
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                alignInline: "center",
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $6f913394e3b1cf0a$var$styles.headingContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                            content: contentTitle,
                            position: "top",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                maxLines: 2,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                    size: "medium",
                                    as: "h2",
                                    children: contentTitle
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.075",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                                src: contentAvatarUrl,
                                size: "xsmall"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text.subtlest",
                                maxLines: 1,
                                children: contentAuthor
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

















var $1bY7o = parcelRequire("1bY7o");











const $4766e177ec4a9341$var$messages = (0, $cgtv4.defineMessages)({
    tooltip: {
        id: "audio.audio-player.audio-share-link-button.link",
        defaultMessage: "Link to audio"
    },
    label: {
        id: "audio.audio-player.audio-share-link-button.label",
        defaultMessage: "Copy link to audio"
    },
    copied: {
        id: "audio.audio-player.audio-share-link-button.copied",
        defaultMessage: "Copied!"
    }
});
const $4766e177ec4a9341$export$71bb0386751911cc = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { activeContent: activeContent, activeFeature: activeFeature } = (0, $9s8in.useAudioPlayerStore)();
    const { copyAudioShareLinkToClipboard: copyAudioShareLinkToClipboard } = (0, $d1a0d49ce70050e9$export$7dffd02bd56a4e49)();
    const { sendUIEvent: sendUIEvent } = (0, $dxfEr.usePlatformInstrumentation)();
    const defaultTooltip = formatMessage($4766e177ec4a9341$var$messages.tooltip);
    const [tooltipContent, setTooltipContent] = (0, $42omo.useState)(defaultTooltip);
    const timeoutRef = (0, $42omo.useRef)(null);
    const updateTooltip = (0, $42omo.useRef)();
    (0, $42omo.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        tooltipContent
    ]);
    const handleCopyLink = (0, $42omo.useCallback)(()=>{
        copyAudioShareLinkToClipboard(activeContent.mainContentLink, activeFeature, activeContent.supportingContent);
        sendUIEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'aiAudioCopyLink',
            attributes: {
                contentType: activeContent.contentType,
                trackType: activeFeature
            }
        });
        setTooltipContent(formatMessage($4766e177ec4a9341$var$messages.copied));
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            setTooltipContent(formatMessage($4766e177ec4a9341$var$messages.tooltip));
        }, 2000);
    }, [
        activeContent,
        activeFeature,
        copyAudioShareLinkToClipboard,
        sendUIEvent,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipContent;
        },
        position: "bottom",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            label: formatMessage($4766e177ec4a9341$var$messages.label),
            onClick: handleCopyLink,
            isDisabled: activeContent.mainContentLink === '',
            shape: "circle"
        })
    });
};


const $be08e60fcd7984c2$export$be8fd49269d8e703 = ({ featureList: featureList })=>{
    const { activeFeature: activeFeature, setActiveFeature: setActiveFeature, cloudId: cloudId } = (0, $9s8in.useAudioPlayerStore)();
    const { fetchAudio: fetchAudio } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const activeFeatureInfo = (0, $31283dfc19fed4c3$export$b4fa6866c714d7ab)(activeFeature, featureList);
    const getNextFeature = ()=>{
        const currentIndex = featureList.findIndex((feature)=>feature.name === activeFeatureInfo?.name);
        const nextIndex = (currentIndex + 1) % featureList.length;
        return featureList[nextIndex];
    };
    const { pendingContent: pendingContent, activeContent: activeContent } = (0, $9s8in.useAudioPlayerStore)();
    const handleFeatureToggle = ()=>{
        const nextFeature = getNextFeature().name;
        setActiveFeature(nextFeature);
        fetchAudio(nextFeature);
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.250",
        alignInline: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f913394e3b1cf0a$export$c4e332ee639ec438), {
                featureList: featureList
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                gap: "space.050",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $f4Buk.ModifyPlaylistButton), {
                        round: true,
                        cloudId: cloudId,
                        contentId: pendingContent?.contentId || activeContent.contentId,
                        contentType: pendingContent?.contentType || activeContent.contentType,
                        title: pendingContent?.title || activeContent.title,
                        // @ts-ignore breifing and narration are tricky to type across the app
                        trackType: activeFeature?.toUpperCase()
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $b67f95736b88fa09$export$e019b538b718d4b), {
                        featureList: featureList,
                        onClick: handleFeatureToggle
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4766e177ec4a9341$export$71bb0386751911cc), {})
                ]
            })
        ]
    });
};


/* AudioPlayerError.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");













var $9pS9R = parcelRequire("9pS9R");















parcelRequire("42omo");

const $9c0c8867a08efbcf$export$7b7bac8a8cbace8a = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "29",
        height: "37",
        viewBox: "0 0 29 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.6224 6.69921C11.6923 6.77077 11.8563 6.6643 11.8197 6.57179C11.7691 6.43914 11.701 6.30823 11.6015 6.15114C11.4776 5.97834 11.4147 5.95565 11.3414 5.83172C11.2088 5.6275 11.0307 5.25397 10.9888 5.16321C10.9819 5.14925 10.9749 5.13703 10.9661 5.12481C10.9033 5.04103 10.6275 4.67099 10.4233 4.33063C10.2715 4.09674 10.1755 3.95186 10.1266 3.87506C10.0096 3.69703 9.90491 3.5731 9.78971 3.46314C9.72512 3.40205 9.58374 3.49456 9.61341 3.57659C9.66752 3.72845 9.73734 3.87332 9.85254 4.0531C9.89792 4.12292 9.95203 4.29397 10.0777 4.50168C10.0987 4.53659 10.1231 4.56801 10.151 4.59594C10.3901 4.84728 10.6153 5.22779 10.6153 5.22779C10.6153 5.22779 10.9731 5.7811 11.125 6.01499C11.2402 6.19128 11.2943 6.27506 11.3292 6.32743C11.4322 6.48452 11.5247 6.59797 11.6242 6.69921H11.6224Z",
                fill: "#1E1F21"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.8811 11.1886C11.9823 11.2148 12.0679 11.0403 11.9858 10.9774C11.8689 10.8867 11.738 10.8064 11.5634 10.7191C11.361 10.6301 11.2929 10.6406 11.1602 10.5707C10.9316 10.459 10.5703 10.2216 10.4847 10.1623C10.4725 10.1536 10.4586 10.1466 10.4446 10.1414C10.3434 10.0995 9.89827 9.91445 9.53347 9.71896C9.27166 9.5898 9.10933 9.51125 9.0238 9.46936C8.82307 9.37161 8.66424 9.31576 8.50191 9.27736C8.41289 9.25641 8.33784 9.40827 8.4094 9.46587C8.54031 9.5706 8.67995 9.66311 8.88067 9.7626C8.95922 9.801 9.1006 9.92318 9.32576 10.0419C9.36242 10.0611 9.40082 10.0768 9.44096 10.089C9.78831 10.1885 10.1933 10.4084 10.1933 10.4084C10.1933 10.4084 10.8111 10.7121 11.0712 10.8413C11.2685 10.9373 11.3627 10.9844 11.4203 11.0123C11.5966 11.0979 11.7397 11.1502 11.8829 11.1886H11.8811Z",
                fill: "#1E1F21"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.8806 8.77438C16.0133 9.09903 16.1966 9.0362 16.1041 8.69933C15.9714 8.21933 15.8178 7.72013 15.6031 7.08303C15.35 6.36565 15.2505 6.19983 15.0882 5.70936C15.0131 5.49118 14.9294 5.23111 14.8456 4.96405C14.8037 4.82965 14.7618 4.69525 14.7199 4.5626C14.692 4.47358 14.699 4.48929 14.6937 4.46834L14.6885 4.43518C14.7007 4.43867 14.7129 4.44391 14.7251 4.4474L14.7391 4.45263H14.7461L14.7496 4.45613L14.7688 4.45962C14.8787 4.48056 14.9817 4.50151 15.0725 4.51896C15.2558 4.55562 15.3971 4.58529 15.4792 4.601C15.5298 4.61147 15.5822 4.6202 15.6345 4.62718C15.7689 4.64638 16.0691 4.69176 16.4933 4.7546C16.7045 4.78776 16.9488 4.82442 17.2176 4.86631C17.5702 4.92216 17.9577 4.985 18.3731 5.05133C18.3208 4.86631 18.1794 4.35838 18.0433 3.87314C17.771 2.90965 17.6016 2.31445 17.5126 2.00376C17.3032 1.26893 17.1286 0.724344 16.9401 0.195471C16.8371 -0.0960201 16.6731 -0.0488925 16.7376 0.253071C16.8546 0.802889 16.9907 1.35794 17.1967 2.09278C17.277 2.37903 17.4009 2.98645 17.6313 3.82951C17.668 3.9674 17.7099 4.10354 17.7552 4.2362C17.7902 4.33918 17.8251 4.44391 17.86 4.55212L17.867 4.57307C17.867 4.57307 17.867 4.57656 17.8687 4.57831L17.8722 4.58354L17.8792 4.59576L17.8931 4.62718H17.86H17.8408H17.8355L17.8111 4.62369L17.7622 4.61671C17.6331 4.59751 17.5074 4.58005 17.3835 4.56085C17.1374 4.52245 16.9087 4.4858 16.7115 4.45613C16.3187 4.3898 16.0534 4.34616 16.0534 4.34616L14.2207 4.04594L14.8613 5.93278C15.1039 6.64318 15.2191 6.98354 15.2907 7.193C15.5088 7.82834 15.6904 8.31707 15.8789 8.77962L15.8806 8.77438Z",
                fill: "#1E1F21"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.8925 11.3894C17.8541 11.4819 18.0164 11.5919 18.088 11.5203C18.191 11.4208 18.2852 11.3074 18.3917 11.1503C18.5034 10.967 18.4999 10.9007 18.5855 10.782C18.7216 10.5778 18.9991 10.2653 19.0655 10.1903C19.0759 10.1798 19.0847 10.1676 19.0916 10.1536C19.144 10.0611 19.3796 9.66141 19.6135 9.3385C19.7706 9.10461 19.8684 8.95973 19.919 8.88468C20.0377 8.7049 20.111 8.56177 20.1686 8.40992C20.2 8.32614 20.0604 8.23188 19.994 8.29297C19.8754 8.40293 19.7689 8.52512 19.6467 8.70315C19.5996 8.77297 19.4634 8.89166 19.3203 9.09064C19.2976 9.12381 19.2767 9.15872 19.261 9.19537C19.1213 9.51479 18.8578 9.87435 18.8578 9.87435C18.8578 9.87435 18.486 10.4242 18.3289 10.6581C18.2119 10.8326 18.1543 10.9181 18.1194 10.9705C18.0147 11.1276 17.9449 11.2585 17.8908 11.3912L17.8925 11.3894Z",
                fill: "#1E1F21"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 36.3375L0.0157091 36.3671H28.4369L28.4544 36.3375L14.2272 10.0439L0 36.3375Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.2773 19.458V29.0598",
                stroke: "white",
                strokeWidth: "2.66545",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.9489 32.0518C14.9576 32.0065 14.9611 31.9576 14.9611 31.907C14.9611 31.8564 14.9576 31.8057 14.9489 31.7604C14.9 31.4863 14.7098 31.3188 14.4427 31.2751C14.3973 31.2681 14.3502 31.2646 14.2996 31.2646C14.249 31.2646 14.1983 31.2681 14.1512 31.2769C13.8842 31.3205 13.6957 31.4898 13.645 31.7621C13.6363 31.8075 13.6328 31.8564 13.6328 31.9087C13.6328 31.9611 13.6363 32.0082 13.645 32.0536C13.6939 32.3259 13.8842 32.4934 14.1512 32.5388C14.1983 32.5476 14.249 32.551 14.2996 32.551C14.3502 32.551 14.3973 32.5476 14.4427 32.5406C14.7098 32.4969 14.9 32.3276 14.9489 32.0553V32.0518Z",
                stroke: "white",
                strokeWidth: "2.66545",
                strokeMiterlimit: "10"
            })
        ]
    });
};


const $7a58e3138507e5bf$var$i18n = (0, $cgtv4.defineMessages)({
    errorHeading: {
        id: "ai-audio.player.error-heading",
        defaultMessage: "Audio player isn't working"
    },
    insufficientContextErrorHeading: {
        id: "ai-audio.player.insufficient-context-error-heading",
        defaultMessage: "Not enough info to create a briefing"
    },
    errorMessage: {
        id: "ai-audio.player.error-message",
        defaultMessage: "Try again"
    },
    refetchAudioButtonLabel: {
        id: "ai-audio.player.refetch-audio-button-label",
        defaultMessage: "Load audio again"
    }
});
const $7a58e3138507e5bf$var$styles = {
    container: "_2rkopb1k _4t3icae7 _1bsbp59q _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _16qs1nax",
    grid: "_16jlkb7n _1o9zkb7n _i0dlf1ug _yv0emer8 _1bsb1osq",
    errorIllustration: "_18zru2gc _1rjc1b66"
};
const $7a58e3138507e5bf$export$3c7826ce7b343605 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { fetchAudio: fetchAudio } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const hasInsufficientContext = (0, $d63febb277db51bb$export$a2e8de1b1229502e)(error);
    const handleRetry = ()=>{
        fetchAudio();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        justifyContent: "center",
        alignItems: "center",
        gap: "space.050",
        xcss: $7a58e3138507e5bf$var$styles.container,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
            columnGap: "space.100",
            xcss: $7a58e3138507e5bf$var$styles.grid,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    alignItems: "center",
                    justifyContent: "center",
                    xcss: $7a58e3138507e5bf$var$styles.errorIllustration,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9c0c8867a08efbcf$export$7b7bac8a8cbace8a), {})
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    alignBlock: "center",
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "xsmall",
                            children: formatMessage(hasInsufficientContext ? $7a58e3138507e5bf$var$i18n.insufficientContextErrorHeading : $7a58e3138507e5bf$var$i18n.errorHeading)
                        }),
                        !hasInsufficientContext && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            color: "color.text.subtlest",
                            children: formatMessage($7a58e3138507e5bf$var$i18n.errorMessage)
                        })
                    ]
                }),
                !hasInsufficientContext && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9pS9R))),
                    appearance: "subtle",
                    label: formatMessage($7a58e3138507e5bf$var$i18n.refetchAudioButtonLabel),
                    onClick: handleRetry
                })
            ]
        })
    });
};



/* MiniplayerControls.tsx generated by @compiled/babel-plugin v0.36.1 */ 
















































/**
 * @generated SignedSource<<5fea28a622debb1175a7f8409f0f362d>>
 * @relayHash 044d266abdac3b8465cb51ea5db11fb8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a3949ed12b6ced04d34d02559d4db8de81e4d4cca0d32e35e9563ea54bb23de5
const $c6152ee27f8e0985$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceUpdateAudioPreferencePayload",
            "kind": "LinkedField",
            "name": "confluence_updateAudioPreference",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "ConfluenceUpdateAudioPreferencePayloadError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        },
                        {
                            "concreteType": "ConfluenceUpdateAudioPreferencePayloadErrorExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "statusCode"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useUpdateAudioPreferencesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useUpdateAudioPreferencesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a3949ed12b6ced04d34d02559d4db8de81e4d4cca0d32e35e9563ea54bb23de5",
            "metadata": {},
            "name": "useUpdateAudioPreferencesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c6152ee27f8e0985$var$node.hash = "b7870368cf8ebdcd82ca2559b27f7470";
var $c6152ee27f8e0985$export$2e2bcd8739ae039 = $c6152ee27f8e0985$var$node;



















const $4c66a4ba64b0743a$var$messages = (0, $cgtv4.defineMessages)({
    errorTitle: {
        id: "ai-audio.set-audio-preferences.error",
        defaultMessage: "Something went wrong"
    },
    errorDescription: {
        id: "ai-audio.set-audio-preferences.description",
        defaultMessage: "Failed to update audio preferences"
    }
});
const $4c66a4ba64b0743a$export$9cb9fb4a6a3e4e05 = ()=>{
    const { cloudId: cloudId } = (0, $9s8in.useAudioPlayerStore)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const flags = (0, $3A9F3.useFlags)();
    const [updateAudioPreferencesMutation, isUpdateAudioPreferencesInFlight] = (0, $irOoi.useMutation)((0, $c6152ee27f8e0985$export$2e2bcd8739ae039));
    const updateAudioPreferences = (0, $42omo.useCallback)((input)=>{
        return new Promise((resolve, reject)=>{
            updateAudioPreferencesMutation({
                variables: {
                    cloudId: cloudId,
                    input: input
                },
                onCompleted: (response)=>{
                    const success = response.confluence_updateAudioPreference?.success;
                    const errors = response.confluence_updateAudioPreference?.errors;
                    if (success) resolve(true);
                    else {
                        const errorMessage = errors?.[0]?.message || 'Failed to update audio preferences';
                        reject(new Error(errorMessage));
                        if (flags) flags.showFlag({
                            title: formatMessage($4c66a4ba64b0743a$var$messages.errorTitle),
                            description: formatMessage($4c66a4ba64b0743a$var$messages.errorDescription),
                            type: 'error',
                            close: 'auto'
                        });
                    }
                },
                onError: (error)=>{
                    reject(error);
                    if (flags) flags.showFlag({
                        title: formatMessage($4c66a4ba64b0743a$var$messages.errorTitle),
                        description: formatMessage($4c66a4ba64b0743a$var$messages.errorDescription),
                        type: 'error',
                        close: 'auto'
                    });
                }
            });
        });
    }, [
        updateAudioPreferencesMutation,
        cloudId,
        flags,
        formatMessage
    ]);
    return {
        updateAudioPreferences: updateAudioPreferences,
        isUpdateAudioPreferencesInFlight: isUpdateAudioPreferencesInFlight
    };
};









/* AudioControlButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $1bHXt = parcelRequire("1bHXt");


var $2W0qg = parcelRequire("2W0qg");




const $6f31bb62c20136f1$var$styles = {
    base: "_2rko12b0 _11c8fhey _v5649dqc _189eidpf _1e0c116y _vchhusvi _1bsb66rk _p12f1osq _kqswh2mm _4cvr1h6o _1bah1h6o _gy1p1b66 _1o9zidpf _4t3i8vuz _k48p1wq8 _y3gn1h6o _s7n4nkob",
    iconButton: "_1rjcu2gc _18zru2gc",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx",
    subtle: "_bfhksm61 _irr31dpa _1di6fcek",
    iconScaleStyles: "_t9ec3swd"
};
const $6f31bb62c20136f1$export$675494d687f3e478 = ({ onClick: onClick = ()=>{}, Icon: Icon, tooltip: tooltip, label: label, testId: testId, isDisabled: isDisabled })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: !isDisabled && tooltip,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
            onClick: onClick,
            isDisabled: isDisabled,
            xcss: (0, $1bHXt.cx)($6f31bb62c20136f1$var$styles.base, $6f31bb62c20136f1$var$styles.iconButton, isDisabled ? $6f31bb62c20136f1$var$styles.disabled : $6f31bb62c20136f1$var$styles.subtle),
            testId: testId,
            "aria-label": label,
            children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    $6f31bb62c20136f1$var$styles.iconScaleStyles
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                    label: label,
                    color: isDisabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)"
                })
            })
        })
    });
};
const $6f31bb62c20136f1$export$4f20c53aa5d7da55 = ({ onClick: onClick = ()=>{}, testId: testId, label: label, isDisabled: isDisabled, children: children, triggerRef: triggerRef, triggerProps: triggerProps })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        onClick: onClick,
        isDisabled: isDisabled,
        xcss: (0, $1bHXt.cx)($6f31bb62c20136f1$var$styles.base, isDisabled ? $6f31bb62c20136f1$var$styles.disabled : $6f31bb62c20136f1$var$styles.subtle),
        testId: testId,
        ref: triggerRef,
        "aria-label": label,
        ...triggerProps,
        children: children
    });
};


const $cacda57932742ea2$var$i18n = (0, $cgtv4.defineMessages)({
    playbackSpeedLabel: {
        id: "audio.miniplayer-playback-speed-control.playback-speed-label",
        defaultMessage: "Playback speed"
    },
    speedLabel08x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-08x",
        defaultMessage: "0.8x"
    },
    speedLabel10x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-10x",
        defaultMessage: "1x"
    },
    speedLabel12x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-12x",
        defaultMessage: "1.2x"
    },
    speedLabel15x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-15x",
        defaultMessage: "1.5x"
    },
    speedLabel18x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-18x",
        defaultMessage: "1.8x"
    },
    speedLabel20x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-20x",
        defaultMessage: "2x"
    },
    errorTitle: {
        id: "audio.miniplayer-playback-speed-control.error-title",
        defaultMessage: "Playback speed error"
    },
    errorDescription: {
        id: "audio.miniplayer-playback-speed-control.error-description",
        defaultMessage: "Unable to save speed preferences. Please try again."
    }
});
const $cacda57932742ea2$export$94e3bad7a674d259 = ({ onClick: onClick })=>{
    const intl = (0, $8C5kA.default)();
    const { getCustomization: getCustomization, setPlaybackSpeed: setPlaybackSpeed } = (0, $9s8in.useAudioPlayerStore)();
    const { updateAudioPreferences: updateAudioPreferences } = (0, $4c66a4ba64b0743a$export$9cb9fb4a6a3e4e05)();
    const { audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const flags = (0, $3A9F3.useFlags)();
    const PLAYBACK_RATES = (0, $42omo.useMemo)(()=>new Map([
            [
                0.8,
                intl.formatMessage($cacda57932742ea2$var$i18n.speedLabel08x)
            ],
            [
                1.0,
                intl.formatMessage($cacda57932742ea2$var$i18n.speedLabel10x)
            ],
            [
                1.2,
                intl.formatMessage($cacda57932742ea2$var$i18n.speedLabel12x)
            ],
            [
                1.5,
                intl.formatMessage($cacda57932742ea2$var$i18n.speedLabel15x)
            ],
            [
                1.8,
                intl.formatMessage($cacda57932742ea2$var$i18n.speedLabel18x)
            ],
            [
                2.0,
                intl.formatMessage($cacda57932742ea2$var$i18n.speedLabel20x)
            ]
        ]), [
        intl
    ]);
    const handleClick = (0, $42omo.useCallback)((speed)=>{
        if (audioRef.current) try {
            audioRef.current.playbackRate = speed;
            setPlaybackSpeed(speed);
            onClick?.(speed);
            updateAudioPreferences({
                ...getCustomization(),
                playbackSpeed: speed
            });
        } catch  {
            // Some browsers or conditions may make playbackRate read-only
            flags?.showFlag({
                appearance: 'error',
                title: intl.formatMessage($cacda57932742ea2$var$i18n.errorTitle),
                description: intl.formatMessage($cacda57932742ea2$var$i18n.errorDescription),
                close: 'auto'
            });
        }
    }, [
        audioRef,
        getCustomization,
        setPlaybackSpeed,
        updateAudioPreferences,
        onClick,
        flags,
        intl
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        placement: "top-start",
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                justifyContent: "center",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: intl.formatMessage($cacda57932742ea2$var$i18n.playbackSpeedLabel),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f31bb62c20136f1$export$4f20c53aa5d7da55), {
                        triggerProps: triggerProps,
                        triggerRef: triggerRef,
                        label: intl.formatMessage($cacda57932742ea2$var$i18n.playbackSpeedLabel),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            color: 'color.text.subtle',
                            weight: "medium",
                            children: PLAYBACK_RATES.get(getCustomization().playbackSpeed)
                        })
                    })
                })
            }),
        shouldRenderToParent: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
            children: Array.from(PLAYBACK_RATES.entries()).map(([value, label])=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                    onClick: ()=>handleClick(value),
                    children: label
                }, value))
        })
    });
};





parcelRequire("42omo");







var $bqp2a = parcelRequire("bqp2a");



const $fc49ea589983bc20$var$START_SECONDS = 0;
const $fc49ea589983bc20$var$ZERO_EPSILON_SECONDS = 0.25;
const $fc49ea589983bc20$var$i18n = (0, $cgtv4.defineMessages)({
    playFromBeginningLabel: {
        id: "audio.miniplayer-controls.play-from-beginning-label",
        defaultMessage: "Play from beginning"
    }
});
const $fc49ea589983bc20$export$8c6adc17175bd77e = ({ isDisabled: isDisabled = false, onClick: onClick = ()=>{} })=>{
    const intl = (0, $8C5kA.default)();
    const { fetchAudio: fetchAudio, audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const hasBufferedAtZero = (audio)=>{
        try {
            const ranges = audio.buffered;
            for(let i = 0; i < ranges.length; i++){
                const start = ranges.start(i);
                const end = ranges.end(i);
                if (start <= $fc49ea589983bc20$var$ZERO_EPSILON_SECONDS && end > $fc49ea589983bc20$var$ZERO_EPSILON_SECONDS) return true;
            }
        } catch  {}
        return false;
    };
    const handlePlayFromBeginning = async ()=>{
        const audio = audioRef.current;
        if (audio) {
            if (hasBufferedAtZero(audio)) {
                audio.currentTime = $fc49ea589983bc20$var$START_SECONDS;
                if (audio.paused) await audio.play();
            } else fetchAudio();
        }
    };
    const handleClick = ()=>{
        onClick?.();
        handlePlayFromBeginning();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f31bb62c20136f1$export$675494d687f3e478), {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bqp2a))),
        label: intl.formatMessage($fc49ea589983bc20$var$i18n.playFromBeginningLabel),
        tooltip: intl.formatMessage($fc49ea589983bc20$var$i18n.playFromBeginningLabel),
        onClick: handleClick,
        isDisabled: isDisabled,
        testId: "miniplayer-play-from-beginning"
    });
};


/* PlayPauseButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 












































const $97371f537d6b0675$var$i18n = (0, $cgtv4.defineMessages)({
    pauseButtonLabel: {
        id: "audio.play-pause-button.pause-label",
        defaultMessage: "Pause"
    },
    playButtonLabel: {
        id: "audio.play-pause-button.play-label",
        defaultMessage: "Play"
    },
    loadingButtonLabel: {
        id: "audio.play-pause-button.loading-label",
        defaultMessage: "Loading"
    },
    loadingAnnouncement: {
        id: "audio.play-pause-button.loading-announcement",
        defaultMessage: "Loading audio, please wait."
    }
});
const $97371f537d6b0675$var$styles = {
    button: "_2rko1rr0 _1e0c116y _4cvr1h6o _1bah1h6o _1bsbvbgk _4t3ivbgk _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _bfhki8nm",
    hover: "_irr3plhp _1di61gdz",
    icon: "_1e0c1o8l _t9echc6n"
};
const $97371f537d6b0675$export$e0201548afaa4886 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const buttonRef = (0, $42omo.useRef)(null);
    const shouldRestoreFocusRef = (0, $42omo.useRef)(false);
    const updateTooltip = (0, $42omo.useRef)();
    const { state: streamingState } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const { isPlaying: isPlaying, pendingContent: pendingContent, activatePendingContent: activatePendingContent, activeContent: activeContent } = (0, $9s8in.useAudioPlayerStore)();
    const { fetchAudio: fetchAudio, audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const isLoading = streamingState.state === (0, $aU1TP.AudioStreamingState).LOADING; // Restore focus after state updates complete (when isPlaying or isLoading changes)
    (0, $42omo.useEffect)(()=>{
        if (shouldRestoreFocusRef.current && buttonRef.current && !isLoading) requestAnimationFrame(()=>{
            if (buttonRef.current && !isLoading) buttonRef.current.focus();
            shouldRestoreFocusRef.current = false;
        });
    }, [
        isPlaying,
        isLoading
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        isLoading,
        isPlaying,
        pendingContent
    ]);
    const { buttonContent: buttonContent, testId: testId, tooltipLabel: tooltipLabel } = (0, $42omo.useMemo)(()=>{
        let buttonContent;
        let testId = 'miniplayer-play';
        let tooltipLabel;
        if (isLoading) {
            testId = 'miniplayer-loading';
            tooltipLabel = formatMessage($97371f537d6b0675$var$i18n.loadingButtonLabel);
            buttonContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                label: tooltipLabel
            });
        } else if (isPlaying && !pendingContent) {
            tooltipLabel = formatMessage($97371f537d6b0675$var$i18n.pauseButtonLabel);
            buttonContent = /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hpDFj))), {
                label: tooltipLabel
            });
            testId = 'miniplayer-pause';
        } else {
            tooltipLabel = formatMessage($97371f537d6b0675$var$i18n.playButtonLabel);
            buttonContent = /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hLeLq))), {
                label: tooltipLabel
            });
        }
        return {
            buttonContent: buttonContent,
            testId: testId,
            tooltipLabel: tooltipLabel
        };
    }, [
        isLoading,
        isPlaying,
        pendingContent,
        formatMessage
    ]);
    const handlePause = (0, $42omo.useCallback)(()=>{
        if (audioRef.current) audioRef.current.pause();
    }, [
        audioRef
    ]);
    const handlePlay = (0, $42omo.useCallback)(async ()=>{
        if (audioRef.current) await audioRef.current.play();
    }, [
        audioRef
    ]);
    const handleClick = (0, $42omo.useCallback)(async ()=>{
        // Mark that we should restore focus after state updates
        shouldRestoreFocusRef.current = true;
        if (isPlaying && !pendingContent) {
            trackAIResultAction('audioPause', {
                attributes: {
                    source: 'expanded-audio-player'
                }
            });
            handlePause();
        } else if (streamingState.state === (0, $aU1TP.AudioStreamingState).UNINITIALIZED || pendingContent) {
            trackAIResultAction('audioPlay', {
                attributes: {
                    source: 'expanded-audio-player',
                    action: 'fetch'
                }
            });
            if (pendingContent) {
                handlePause();
                activatePendingContent();
            }
            fetchAudio();
        } else {
            trackAIResultAction('audioPlay', {
                attributes: {
                    source: 'expanded-audio-player',
                    action: 'resume'
                }
            });
            await handlePlay();
        }
    }, [
        isPlaying,
        pendingContent,
        streamingState.state,
        handlePause,
        handlePlay,
        activatePendingContent,
        fetchAudio,
        trackAIResultAction
    ]);
    // Global keyboard shortcut: Alt/Option + P to toggle play/pause
    (0, $7c4bb90d2d062860$export$43d4c61d5a1d26c1)(handleClick);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipLabel;
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            ref: buttonRef,
            onClick: handleClick,
            xcss: (0, $1bHXt.cx)($97371f537d6b0675$var$styles.button, !isLoading && $97371f537d6b0675$var$styles.hover),
            testId: testId,
            isDisabled: isLoading || !activeContent?.contentId,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "span",
                xcss: $97371f537d6b0675$var$styles.icon,
                children: buttonContent
            })
        })
    });
};





parcelRequire("42omo");







var $aolCq = parcelRequire("aolCq");



const $c4e6c85f0c5d74a4$var$SKIP_SECONDS = 15;
const $c4e6c85f0c5d74a4$var$START_SECONDS = 0;
const $c4e6c85f0c5d74a4$var$i18n = (0, $cgtv4.defineMessages)({
    skipBackButtonLabel: {
        id: "audio.miniplayer-controls.skip-back-label",
        defaultMessage: "Skip 15 seconds backward"
    },
    skipBackButtonTooltip: {
        id: "audio.miniplayer-controls.skip-back-label",
        defaultMessage: "Skip backward"
    }
});
const $c4e6c85f0c5d74a4$export$70885cced56339a = ({ onClick: onClick = ()=>{}, isDisabled: isDisabled = false })=>{
    const intl = (0, $8C5kA.default)();
    const { audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const handleSkipBack = ()=>{
        const audio = audioRef.current;
        if (audio) {
            if (audio.currentTime <= $c4e6c85f0c5d74a4$var$SKIP_SECONDS) audio.currentTime = $c4e6c85f0c5d74a4$var$START_SECONDS;
            else audio.currentTime -= $c4e6c85f0c5d74a4$var$SKIP_SECONDS;
        }
    };
    const handleClick = ()=>{
        onClick?.();
        handleSkipBack();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f31bb62c20136f1$export$675494d687f3e478), {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aolCq))),
        label: intl.formatMessage($c4e6c85f0c5d74a4$var$i18n.skipBackButtonLabel),
        tooltip: intl.formatMessage($c4e6c85f0c5d74a4$var$i18n.skipBackButtonTooltip),
        onClick: handleClick,
        isDisabled: isDisabled,
        testId: "miniplayer-skip-back"
    });
};





parcelRequire("42omo");







var $7xRSp = parcelRequire("7xRSp");



const $fb87cf9b598349ca$var$SKIP_SECONDS = 15;
const $fb87cf9b598349ca$var$i18n = (0, $cgtv4.defineMessages)({
    skipForwardButtonTooltip: {
        id: "audio.miniplayer-controls.skip-forward-label",
        defaultMessage: "Skip forward"
    },
    skipForwardButtonLabel: {
        id: "audio.miniplayer-controls.skip-forward-label",
        defaultMessage: "Skip 15 seconds forward"
    }
});
const $fb87cf9b598349ca$export$28c69814f23535ab = ({ onClick: onClick = ()=>{}, isDisabled: isDisabled = false })=>{
    const intl = (0, $8C5kA.default)();
    const { audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const handleSkipForward = ()=>{
        const audio = audioRef.current;
        if (audio && audio.duration) {
            const remaining = audio.duration - audio.currentTime;
            if (remaining <= $fb87cf9b598349ca$var$SKIP_SECONDS) audio.currentTime = audio.duration;
            else audio.currentTime += $fb87cf9b598349ca$var$SKIP_SECONDS;
        }
    };
    const handleClick = ()=>{
        onClick?.();
        handleSkipForward();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f31bb62c20136f1$export$675494d687f3e478), {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7xRSp))),
        label: intl.formatMessage($fb87cf9b598349ca$var$i18n.skipForwardButtonLabel),
        tooltip: intl.formatMessage($fb87cf9b598349ca$var$i18n.skipForwardButtonTooltip),
        onClick: handleClick,
        isDisabled: isDisabled,
        testId: "miniplayer-skip-forward"
    });
};


const $2ebbeb88b9a023f1$var$gridStyles = {
    root: "_yv0e1n6q _ca0q1b66 _u5f3utpp _n3td1b66 _19bvutpp"
};
const $2ebbeb88b9a023f1$export$94d452cfe99f9aa = ()=>{
    const { state: streamingState } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const isLoading = streamingState.state === (0, $aU1TP.AudioStreamingState).LOADING;
    const isUninitialized = streamingState.state === (0, $aU1TP.AudioStreamingState).UNINITIALIZED;
    const { pendingContent: pendingContent } = (0, $9s8in.useAudioPlayerStore)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const handlePlayFromBeginningButtonClick = (0, $42omo.useCallback)(()=>{
        trackAIResultAction('audioPlayFromBeginning');
    }, [
        trackAIResultAction
    ]);
    const handleSkipBackButtonClick = (0, $42omo.useCallback)(()=>{
        trackAIResultAction('audioSkipBackward');
    }, [
        trackAIResultAction
    ]);
    const handleSkipForwardButtonClick = (0, $42omo.useCallback)(()=>{
        trackAIResultAction('audioSkipForward');
    }, [
        trackAIResultAction
    ]);
    const handlePlaybackSpeedControlClick = (0, $42omo.useCallback)((speed)=>{
        trackAIResultAction('audioPlaybackSpeed', {
            attributes: {
                playbackSpeed: speed
            }
        });
    }, [
        trackAIResultAction
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
        testId: "miniplayer-controls",
        gap: "space.300",
        xcss: $2ebbeb88b9a023f1$var$gridStyles.root,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                justifyContent: "end",
                direction: "row",
                gap: "space.200",
                children: !pendingContent && !isUninitialized && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fc49ea589983bc20$export$8c6adc17175bd77e), {
                            isDisabled: isLoading,
                            onClick: handlePlayFromBeginningButtonClick
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $c4e6c85f0c5d74a4$export$70885cced56339a), {
                            isDisabled: isLoading,
                            onClick: handleSkipBackButtonClick
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $97371f537d6b0675$export$e0201548afaa4886), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                direction: "row",
                gap: "space.200",
                children: !pendingContent && !isUninitialized && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fb87cf9b598349ca$export$28c69814f23535ab), {
                            isDisabled: isLoading,
                            onClick: handleSkipForwardButtonClick
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cacda57932742ea2$export$94e3bad7a674d259), {
                            onClick: handlePlaybackSpeedControlClick
                        })
                    ]
                })
            })
        ]
    });
};































parcelRequire("42omo");















const $293483a054ae7a18$export$f29386f55261023 = ({ items: items })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { setActiveMenu: setActiveMenu } = (0, $9s8in.useAudioPlayerStore)();
    const { sendUIEvent: sendUIEvent } = (0, $dxfEr.usePlatformInstrumentation)();
    const handleClick = (item)=>{
        sendUIEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'audioMenu',
            source: 'audioPlayer',
            attributes: {
                version: 'v3',
                menuItem: item.id
            }
        });
        item.onClick();
        if (item.renderPanel) setActiveMenu(item);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
        testId: "audio-object-menu-group",
        children: items.map((item)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                elemBefore: item.icon,
                onClick: ()=>handleClick(item),
                isDisabled: item.isDisabled,
                testId: item.testId,
                description: item.description,
                children: formatMessage(item.title)
            }, item.id))
    });
};


const $bd1b3d11dfca322d$var$mergeRefs = (...refs)=>{
    return (node)=>{
        refs.forEach((ref)=>{
            if (!ref) return;
            if (typeof ref === 'function') ref(node);
            else ref.current = node;
        });
    };
};
const $bd1b3d11dfca322d$var$messages = (0, $cgtv4.defineMessages)({
    moreOptionsLabel: {
        id: "ai-audio.audio-player.overflow-menu.more-options-label",
        defaultMessage: "More options"
    }
});
const $bd1b3d11dfca322d$export$f62801e1786d0b09 = ({ items: items, buttonRef: buttonRef })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { setHasOpenDropdownMenu: setHasOpenDropdownMenu } = (0, $9s8in.useAudioPlayerStore)();
    const handleOpenChange = ({ isOpen: newIsOpen })=>{
        setIsOpen(newIsOpen);
        // Track menu open/close in global state
        setHasOpenDropdownMenu(newIsOpen);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        position: "bottom",
        canAppear: ()=>!isOpen,
        content: formatMessage($bd1b3d11dfca322d$var$messages.moreOptionsLabel),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
            onOpenChange: handleOpenChange,
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    ...triggerProps,
                    ref: $bd1b3d11dfca322d$var$mergeRefs(triggerRef, buttonRef),
                    appearance: "subtle",
                    spacing: "compact",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                    label: formatMessage($bd1b3d11dfca322d$var$messages.moreOptionsLabel)
                }),
            shouldRenderToParent: true,
            strategy: "absolute",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $293483a054ae7a18$export$f29386f55261023), {
                items: items
            })
        })
    });
};

















var $laHi9 = parcelRequire("laHi9");












/* ModalHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");























const $b7ab42c5e87f53a1$var$i18n = (0, $cgtv4.defineMessages)({
    defaultCloseButtonLabel: {
        id: "ai-audio.modal-header.close-button-label",
        defaultMessage: "Close audio player"
    }
});
const $b7ab42c5e87f53a1$var$styles = {
    headerSection: "_1rjc1b66",
    headerContent: "_1e0c1txw _4cvr1h6o _1bah1yb4 _1bsb1osq",
    leftSection: "_1e0c1txw _4cvr1h6o",
    heading: "_19bvu2gc"
};
const $b7ab42c5e87f53a1$export$f50a68e3694789ee = ({ leftElement: leftElement, heading: heading, onClose: onClose, closeButtonRef: closeButtonRef })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b7ab42c5e87f53a1$var$styles.headerSection,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between",
            xcss: $b7ab42c5e87f53a1$var$styles.headerContent,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $b7ab42c5e87f53a1$var$styles.leftSection,
                            children: leftElement
                        }),
                        heading && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $b7ab42c5e87f53a1$var$styles.heading,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                size: "xsmall",
                                as: "h2",
                                children: formatMessage(heading)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: formatMessage($b7ab42c5e87f53a1$var$i18n.defaultCloseButtonLabel),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        ref: closeButtonRef,
                        appearance: "subtle",
                        spacing: "compact",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                        label: formatMessage($b7ab42c5e87f53a1$var$i18n.defaultCloseButtonLabel),
                        onClick: onClose,
                        testId: 'modal-header-close-button'
                    })
                })
            ]
        })
    });
};


const $b0b498e317860144$var$i18n = (0, $cgtv4.defineMessages)({
    backButtonLabel: {
        id: "ai-audio.audio-player.overflow-menu.back-button-label",
        defaultMessage: "Back"
    },
    backButtonAriaLabel: {
        id: "ai-audio.audio-player.overflow-menu.back-button-aria-label",
        defaultMessage: "Back to audio player"
    }
});
const $b0b498e317860144$export$f537a9b13aef4d02 = ({ header: header, onBack: onBack, children: children, closeButtonRef: closeButtonRef })=>{
    const { closeAudioPlayer: closeAudioPlayer } = (0, $9s8in.useAudioPlayerStore)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const backButtonRef = (0, $42omo.useRef)(null);
    const { audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    (0, $42omo.useEffect)(()=>{
        // Focus the back button when the panel is rendered
        if (backButtonRef.current) backButtonRef.current.focus();
    }, []);
    const handleClose = ()=>{
        trackAIResultAction('audioClosed', {
            attributes: {
                ...(0, $541af32bf6a57dc8$export$d7261be602ea5ad6)(audioRef, 'closed from overflow menu panel')
            }
        });
        closeAudioPlayer();
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $b7ab42c5e87f53a1$export$f50a68e3694789ee), {
                leftElement: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    ref: backButtonRef,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($laHi9))),
                    appearance: "subtle",
                    label: formatMessage($b0b498e317860144$var$i18n.backButtonAriaLabel),
                    spacing: "compact",
                    onClick: onBack,
                    testId: "overflow-menu-panel-back-button"
                }),
                heading: header,
                onClose: handleClose,
                closeButtonRef: closeButtonRef
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: children
            })
        ]
    });
};



/* UnauthorizedAccessError.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





















parcelRequire("42omo");

const $bd5092ca8caefbf6$export$6fc0ee428466ba6f = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M60.465 53.682c0.253 -1.425 0.387 -2.938 0.387 -4.541s-0.134 -3.159 -0.393 -4.602c-1.542 -8.582 -7.505 -13.873 -15.863 -15.232 -1.425 -0.233 -2.921 -0.352 -4.477 -0.352s-3.18 0.128 -4.663 0.375c-8.367 1.396 -14.316 6.673 -15.86 15.206 -0.262 1.443 -0.396 2.976 -0.396 4.602s0.134 3.116 0.39 4.541c1.533 8.524 7.488 13.809 15.869 15.206 1.484 0.247 3.04 0.375 4.663 0.375s3.052 -0.119 4.477 -0.352c8.375 -1.361 14.342 -6.662 15.872 -15.232z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M45.649 47.029c0.07 -0.393 0.108 -0.809 0.108 -1.251s-0.038 -0.87 -0.108 -1.265c-0.425 -2.362 -2.065 -3.817 -4.367 -4.192a7.651 7.651 0 0 0 -1.233 -0.096c-0.431 0 -0.876 0.035 -1.283 0.105 -2.304 0.384 -3.942 1.836 -4.367 4.186 -0.073 0.396 -0.111 0.82 -0.111 1.265s0.038 0.858 0.108 1.251c0.422 2.345 2.063 3.802 4.367 4.186 0.407 0.067 0.838 0.105 1.283 0.105s0.841 -0.032 1.233 -0.096c2.304 -0.375 3.948 -1.833 4.369 -4.192z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M55.162 23.779H24.881v13.175h30.281z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M43.668 48.463h-7.293v9.664h7.293z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M40.07 36.649c-0.951 0 -1.891 -0.076 -2.787 -0.227 -5.536 -0.922 -9.265 -4.521 -10.225 -9.868 -0.157 -0.879 -0.239 -1.809 -0.239 -2.761s0.081 -1.905 0.241 -2.796c0.969 -5.347 4.692 -8.943 10.223 -9.865 1.766 -0.294 3.706 -0.3 5.469 -0.015 5.539 0.902 9.271 4.503 10.237 9.885 0.16 0.89 0.241 1.83 0.241 2.79q0 1.44 -0.236 2.758c-0.96 5.382 -4.692 8.986 -10.24 9.888 -0.861 0.14 -1.763 0.212 -2.682 0.212zm0 -23.043c-0.797 0 -1.597 0.061 -2.342 0.186 -4.404 0.736 -7.249 3.465 -8.015 7.686 -0.134 0.73 -0.201 1.51 -0.201 2.316s0.067 1.562 0.195 2.284c0.759 4.221 3.607 6.953 8.017 7.689 1.475 0.247 3.13 0.25 4.593 0.012 4.413 -0.719 7.261 -3.453 8.02 -7.7 0.128 -0.724 0.195 -1.492 0.195 -2.284s-0.067 -1.583 -0.198 -2.316c-0.762 -4.247 -3.61 -6.982 -8.017 -7.7 -0.716 -0.116 -1.484 -0.175 -2.252 -0.175z",
                fill: "#BF63F3"
            })
        ]
    });
};


const $421bfc6ee1d77404$var$i18n = (0, $cgtv4.defineMessages)({
    unauthorizedAccessMessage: {
        id: "ai-audio.player.unauthorized-access-message",
        defaultMessage: "You do not have permission to play this audio."
    },
    closeButtonLabel: {
        id: "ai-audio.player.unauthorized-access-close-button-label",
        defaultMessage: "Close"
    }
});
const $421bfc6ee1d77404$var$styles = {
    container: "_16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _1bah1h6o _y3gn1h6o _ca0qxncg _u5f3xy5q _n3td1epz _19bvxy5q"
};
const $421bfc6ee1d77404$export$fe19aab1a5fc230f = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleClose = ()=>{
        (0, $aU1TP.setAudioPlayerStreamingStore)({
            type: (0, $aU1TP.AudioStreamingState).UNINITIALIZED
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: $421bfc6ee1d77404$var$styles.container,
        justifyContent: "center",
        alignItems: "center",
        rowGap: "space.200",
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $bd5092ca8caefbf6$export$6fc0ee428466ba6f), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "small",
                as: "h3",
                children: formatMessage($421bfc6ee1d77404$var$i18n.unauthorizedAccessMessage)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                appearance: "default",
                onClick: handleClose,
                children: formatMessage($421bfc6ee1d77404$var$i18n.closeButtonLabel)
            })
        ]
    });
};


const $302b202115679cb3$export$9df972a8b9862020 = 'audio.audio-features.manage-sources-menu-item-label';
const $302b202115679cb3$var$styles = {
    expandedAudioPlayerContainer: "_kqswh2mm _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
    audioPlayerMinHeight: "_1tke1784",
    audioPlayerWithPendingContent: "_4t3i1fez",
    controlsContainer: "_4t3i1j6c"
};
const $302b202115679cb3$var$dynamicStyles = {
    background: `linear-gradient(180deg, ${"var(--ds-surface, #FFFFFF)"} 50%, ${"var(--ds-surface-sunken, #F8F8F8)"} 100%)`,
    width: `${(0, $61eRd.AUDIO_CONTAINER_MODES).EXPANDED.width}px`
};
const $302b202115679cb3$var$messages = (0, $cgtv4.defineMessages)({
    infoFlagTitle: {
        id: "ai-audio.audio-player.remove-info-title",
        defaultMessage: "Sources will not be added."
    },
    infoFlagDescription: {
        id: "ai-audio.audio-player.remove-info-description",
        defaultMessage: "Select Re-start briefing to add."
    }
});
const $302b202115679cb3$export$9547b0db2c4a4264 = ({ audioFeatures: audioFeatures, userId: userId, displayName: displayName })=>{
    const { activeContent: activeContent, activeFeature: activeFeature, cloudId: cloudId, activeMenu: activeMenu, closeAudioPlayer: closeAudioPlayer, pendingContent: pendingContent, setActiveMenu: setActiveMenu, playlistDefaultExpanded: playlistDefaultExpanded } = (0, $9s8in.useAudioPlayerStore)();
    const { state: streamingState } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const { audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const closeButtonRef = (0, $42omo.useRef)(null);
    const menuButtonRef = (0, $42omo.useRef)(null);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const flags = (0, $3A9F3.useFlags)();
    const activeFeatureInfo = (0, $31283dfc19fed4c3$export$b4fa6866c714d7ab)(activeFeature, audioFeatures);
    const hasOverflowMenu = activeFeatureInfo?.menuConfig?.items && activeFeatureInfo?.menuConfig?.items.length > 0;
    const isErrorState = streamingState.state === (0, $aU1TP.AudioStreamingState).ERROR;
    const isUninitialized = streamingState.state === (0, $aU1TP.AudioStreamingState).UNINITIALIZED;
    const isUnauthorizedAccess = isErrorState && (0, $a9308afb81463823$export$d48e99c253065d82)(streamingState.error);
    const overflowMenuItems = (activeFeatureInfo?.menuConfig?.items ?? []).map((item)=>{
        return {
            ...item,
            // Disable the manage sources menu item if it exists and there is no content selected
            isDisabled: item.title.id === $302b202115679cb3$export$9df972a8b9862020 && !activeContent?.contentId || item.isDisabled
        };
    });
    (0, $42omo.useEffect)(()=>{
        // Focus the menu button when the expanded audio player opens (only when not showing a panel)
        if (!activeMenu && hasOverflowMenu && menuButtonRef.current) menuButtonRef.current.focus();
        else if (!activeMenu && !hasOverflowMenu && closeButtonRef.current) // Fallback to close button if there's no overflow menu
        closeButtonRef.current.focus();
    }, [
        activeMenu,
        hasOverflowMenu
    ]);
    const onBack = ()=>{
        const interimSupportingContent = (0, $lqUMo.getInterimSupportingContent)() ?? [];
        const sourcesDiverged = (0, $lqUMo.isSourceContentDiverged)(activeContent.supportingContent, interimSupportingContent);
        if (activeMenu?.id === 'manageSources' && sourcesDiverged) {
            if (isUninitialized) (0, $lqUMo.setSupportingContent)(interimSupportingContent);
            else flags?.showFlag({
                appearance: 'info',
                title: formatMessage($302b202115679cb3$var$messages.infoFlagTitle),
                description: formatMessage($302b202115679cb3$var$messages.infoFlagDescription),
                close: 'auto'
            });
        }
        setActiveMenu(undefined);
    };
    const handleClose = ()=>{
        trackAIResultAction('audioClosed', {
            attributes: {
                ...(0, $541af32bf6a57dc8$export$d7261be602ea5ad6)(audioRef, 'closed from expanded audio player')
            }
        });
        closeAudioPlayer();
    };
    if (activeMenu && activeMenu.renderPanel) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $302b202115679cb3$var$styles.expandedAudioPlayerContainer,
        style: $302b202115679cb3$var$dynamicStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b0b498e317860144$export$f537a9b13aef4d02), {
            header: activeMenu.renderPanel.header,
            onBack: onBack,
            children: activeMenu.renderPanel?.body()
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($302b202115679cb3$var$styles.expandedAudioPlayerContainer, $302b202115679cb3$var$styles.audioPlayerMinHeight, pendingContent && !isUninitialized && $302b202115679cb3$var$styles.audioPlayerWithPendingContent),
        style: $302b202115679cb3$var$dynamicStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $b7ab42c5e87f53a1$export$f50a68e3694789ee), {
                leftElement: hasOverflowMenu ? /*#__PURE__*/ (0, $l998X.jsx)((0, $bd1b3d11dfca322d$export$f62801e1786d0b09), {
                    items: overflowMenuItems,
                    buttonRef: menuButtonRef
                }) : undefined,
                onClose: handleClose,
                closeButtonRef: closeButtonRef
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                spread: "space-between",
                xcss: $302b202115679cb3$var$styles.controlsContainer,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.250",
                    alignInline: "center",
                    children: [
                        !isUnauthorizedAccess && /*#__PURE__*/ (0, $l998X.jsx)((0, $be08e60fcd7984c2$export$be8fd49269d8e703), {
                            featureList: audioFeatures,
                            cloudId: cloudId
                        }),
                        isUnauthorizedAccess ? /*#__PURE__*/ (0, $l998X.jsx)((0, $421bfc6ee1d77404$export$fe19aab1a5fc230f), {}) : isErrorState ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7a58e3138507e5bf$export$3c7826ce7b343605), {
                                error: streamingState.error
                            })
                        }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $2ebbeb88b9a023f1$export$94d452cfe99f9aa), {}),
                                !isUninitialized && !pendingContent && /*#__PURE__*/ (0, $l998X.jsx)((0, $ac90fb746780e8b1$export$1ce816177bf69471), {})
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $64432bd829583b79$export$a62c3d0b73e04446), {
                userId: userId,
                displayName: displayName
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f8afa1f53c3baeb9$export$a10c242a3195e585), {
                cloudId: cloudId,
                defaultExpanded: playlistDefaultExpanded
            })
        ]
    });
};









const $877f0dc4917971e9$export$82dee986abd51a32 = (onEscape)=>{
    const { hasOpenDropdownMenu: hasOpenDropdownMenu } = (0, $9s8in.useAudioPlayerStore)();
    (0, $42omo.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (e.code === 'Escape') {
                // If a dropdown menu is open, don't close the player
                // Let the dropdown handle the escape key itself
                if (hasOpenDropdownMenu) return;
                e.preventDefault();
                onEscape();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return ()=>window.removeEventListener('keydown', handleKeyDown);
    }, [
        onEscape,
        hasOpenDropdownMenu
    ]);
};


const $d78377ab2f7b2547$var$i18n = (0, $cgtv4.defineMessages)({
    errorLoadingAudioPreferences: {
        id: "ai-audio.audio-container.error-loading-audio-preferences",
        defaultMessage: "Playback speed error"
    },
    errorDescription: {
        id: "ai-audio.audio-container.error-loading-audio-preferences-description",
        defaultMessage: "Please try again later"
    },
    audioContainerLabel: {
        id: "audio.container.label",
        defaultMessage: "Audio player"
    }
});
const $d78377ab2f7b2547$var$styles = {
    container: "_2rkopb1k _1reo15vq _18m915vq _kqswh2mm _1e0c1o8l _s7n4jp4b"
};
const $d78377ab2f7b2547$var$isFocusInsideContainer = ()=>{
    const containerElement = document.querySelector('[data-testId="audio-container"]');
    if (!containerElement) return false;
     // document.activeElement is the currently focused element in the entire document
    const focusedElement = document.activeElement; // Check if the container itself or any of its descendants has focus
    const isInside = containerElement.contains(focusedElement); // Return the result
    return isInside;
};
const $d78377ab2f7b2547$var$AudioContainerComponent = ({ product: product, cloudId: cloudId, activationId: activationId, audioFeatures: audioFeatures, emojiProvider: emojiProvider, flags: flags, pinToExpandedView: pinToExpandedView = false, closeFn: closeFn, userId: userId, displayName: displayName })=>{
    const { activeAudioContainerMode: activeAudioContainerMode, activeContent: activeContent, activeMenu: activeMenu, isPlaying: isPlaying, pendingContent: pendingContent, playImmediately: playImmediately, resetPlayImmediately: resetPlayImmediately, setCustomization: setCustomization, setActiveAudioContainerMode: setActiveAudioContainerMode, updatePlayerState: updatePlayerState } = (0, $9s8in.useAudioPlayerStore)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleClose = (0, $42omo.useCallback)(()=>{
        if (closeFn && $d78377ab2f7b2547$var$isFocusInsideContainer()) closeFn();
    }, [
        closeFn
    ]); //links escape key to close the dialog, but only when the pop-up has focus
    (0, $877f0dc4917971e9$export$82dee986abd51a32)(handleClose); // Handle blur event when an element inside the container loses focus
    const handleBlur = ()=>{
        handleMouseLeave();
    }; // Handle focus event when an element inside the container receives focus
    const handleFocus = ()=>{
        handleMouseEnter();
    };
    const handleMouseOverChange = (0, $42omo.useCallback)((isHovered)=>{
        if (!isPlaying && activeAudioContainerMode === (0, $61eRd.AUDIO_CONTAINER_MODES).EXPANDED) return;
        setActiveAudioContainerMode(//prevents minification if the popup is hovered or focused
        isHovered || $d78377ab2f7b2547$var$isFocusInsideContainer() ? (0, $61eRd.AUDIO_CONTAINER_MODES).EXPANDED : (0, $61eRd.AUDIO_CONTAINER_MODES).MINIFIED);
    }, [
        setActiveAudioContainerMode,
        isPlaying,
        activeAudioContainerMode
    ]);
    const { handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave } = (0, $afa84e7a69fdc750$export$ea0a8bb4d087b859)({
        delay: 3000,
        initiallyHovered: true,
        resetKey: pendingContent?.contentId,
        isPinned: pinToExpandedView || !!activeMenu,
        onMouseOverChange: handleMouseOverChange
    });
    (0, $42omo.useEffect)(()=>{
        updatePlayerState({
            product: product,
            cloudId: cloudId,
            activationId: activationId
        });
    }, [
        product,
        cloudId,
        activationId,
        updatePlayerState
    ]);
    const { audioRef: audioRef, fetchAudio: fetchAudio } = (0, $eb746a322067b31d$export$ddeb68f842997797)({
        locale: 'en-US',
        format: (0, $08e4a34c7045e030$export$f0c9015bb7804f57).MP3,
        product: product,
        cloudId: cloudId,
        activationId: activationId
    });
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const handleBuffer = (0, $42omo.useCallback)(()=>{
        trackAIResultAction('audioContentBuffer');
    }, [
        trackAIResultAction
    ]);
    (0, $42omo.useEffect)(()=>{
        if (playImmediately) {
            fetchAudio();
            resetPlayImmediately();
        }
    }, [
        playImmediately,
        fetchAudio,
        resetPlayImmediately
    ]);
    (0, $e8c5882c3211aac4$export$682d7e508fc708d7)({
        audioRef: audioRef,
        onBuffer: handleBuffer,
        flags: flags
    });
    const environment = (0, $irOoi.useRelayEnvironment)();
    (0, $42omo.useEffect)(()=>{
        const fetchAudioPreference = async ()=>{
            const data = await (0, $irOoi.fetchQuery)(environment, (0, $6623806f5bfc94bc$export$2e2bcd8739ae039), {
                cloudId: cloudId
            }).toPromise();
            if (data) {
                const tone = data?.confluence_getAudioPreference?.tone;
                const length = data?.confluence_getAudioPreference?.length;
                const playbackSpeed = data?.confluence_getAudioPreference?.playbackSpeed;
                if (tone && length && playbackSpeed) setCustomization({
                    tone: tone,
                    length: length,
                    playbackSpeed: playbackSpeed
                });
                else flags?.showFlag({
                    appearance: 'error',
                    title: formatMessage($d78377ab2f7b2547$var$i18n.errorLoadingAudioPreferences),
                    description: formatMessage($d78377ab2f7b2547$var$i18n.errorDescription),
                    close: 'auto'
                });
            }
        };
        fetchAudioPreference();
    }, [
        audioRef,
        environment,
        cloudId,
        setCustomization,
        flags,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $b80bff0b244fbd50$export$6ec02d48b47f5f51), {
        fetchAudio: fetchAudio,
        audioRef: audioRef,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bfdfc52c2649bf8b$export$180d4a3d7d834091), {
                    cloudId: cloudId
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f43c45a1ab86a258$export$517a124efa5f6d1).Provider, {
                value: {
                    emojiProvider: emojiProvider
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3A9F3.FlagsProviderContext).Provider, {
                    value: {
                        flags: flags
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        xcss: $d78377ab2f7b2547$var$styles.container,
                        style: {
                            width: `${activeAudioContainerMode.width}px`
                        },
                        onMouseEnter: handleMouseEnter,
                        onMouseLeave: handleMouseLeave,
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                        testId: "audio-container",
                        role: "dialog",
                        "aria-modal": "false",
                        "aria-label": formatMessage($d78377ab2f7b2547$var$i18n.audioContainerLabel),
                        children: [
                            activeAudioContainerMode === (0, $61eRd.AUDIO_CONTAINER_MODES).EXPANDED ? /*#__PURE__*/ (0, $l998X.jsx)((0, $302b202115679cb3$export$9547b0db2c4a4264), {
                                audioFeatures: audioFeatures,
                                userId: userId,
                                displayName: displayName
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $8aca57df42a7cd81$export$fd7786f444ea3be1), {
                                title: activeContent.title || 'Untitled',
                                byline: activeContent.author || ''
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("audio", {
                                ref: audioRef
                            })
                        ]
                    })
                })
            })
        ]
    });
};
const $d78377ab2f7b2547$export$6791290ffa0c6398 = (passThroughProps)=>{
    const { activeFeature: activeFeature, closeAudioPlayer: closeAudioPlayer } = (0, $9s8in.useAudioPlayerStore)();
    const aiAnalyticsConfig = {
        product: passThroughProps.product,
        subproduct: 'platform',
        aiFeatureName: (0, $1726f70a3a8c123e$export$8842837476c9062b)(activeFeature),
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        skipAISessionValidation: true
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.AtlassianRelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Rith.AIEventsInstrumentationProvider), {
            config: aiAnalyticsConfig,
            children: /*#__PURE__*/ (0, $l998X.jsx)($d78377ab2f7b2547$var$AudioContainerComponent, {
                ...passThroughProps,
                closeFn: closeAudioPlayer
            })
        })
    });
};

/* DraggableAudio.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $hTKp4 = parcelRequire("hTKp4");





var $bSjaC = parcelRequire("bSjaC");


var $4T4vf = parcelRequire("4T4vf");

parcelRequire("5X6QO");
var $eOL5r = parcelRequire("eOL5r");










const $27d52fddae644c4d$var$initialTopPosition = 104;
const $27d52fddae644c4d$var$initialRightOffset = (0, $61eRd.AUDIO_CONTAINER_MODES).EXPANDED.width + 32; // width + space.400
const $27d52fddae644c4d$var$styles = {
    floatingStyles: "_2rkopb1k _kqsw1n9t _154i1l8a _1xi2xy5q _1pby16oo _16qs130s _y3gn1h6o _8hrz5d63",
    idleStyles: "_80om1qgj",
    draggingStyles: "_80om5szm"
};
// Prevents the miniplayer from being dragged past the boundaries of a given dimension of the window
const $27d52fddae644c4d$var$getBoundedDimension = (proposedDimension, minDimension, maxDimension)=>{
    if (proposedDimension < minDimension || proposedDimension > maxDimension) return proposedDimension < minDimension ? minDimension : maxDimension;
    return proposedDimension;
};
// Prevent clicking from blurring/closing other UI elements like modals/dialogs
const $27d52fddae644c4d$var$stopClickPropagation = (event)=>event.stopPropagation();
// Get actual position without transformation applied so that cursor position does not shift based on element transform (i.e. rotate)
const $27d52fddae644c4d$var$getTransformedCursorPosition = (element, inputLocation)=>{
    const elementTransform = window.getComputedStyle(element).transform;
    // Edge 18 is very dated now and we should not be concerned with its lack of support
    // eslint-disable-next-line compat/compat
    const transformMatrix = new DOMMatrixReadOnly(elementTransform);
    // Calculate cursor position relative to the element's top-left in viewport coords
    const elementBoundingRect = element.getBoundingClientRect();
    const mouseX = inputLocation.clientX - elementBoundingRect.left;
    const mouseY = inputLocation.clientY - elementBoundingRect.top;
    return transformMatrix.inverse().transformPoint({
        x: mouseX,
        y: mouseY
    });
};
// The skew of the transform allows for calculating the difference between the real DOM width/height and that of the rotated
const $27d52fddae644c4d$var$getRotatedDimensionSkew = (element)=>{
    const elementTransform = window.getComputedStyle(element).transform;
    if (![
        '',
        'none'
    ].includes(elementTransform)) {
        const transformMatrixValues = elementTransform.split('(')[1].split(')')[0].split(',');
        return parseFloat(transformMatrixValues[1]);
    }
    return 0;
};
const $27d52fddae644c4d$export$110682900206ff66 = ({ children: children })=>{
    const document = (0, $hTKp4.getDocument)();
    if (!document) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($27d52fddae644c4d$var$DraggableAudioInternal, {
        document: document,
        children: children
    });
};
const $27d52fddae644c4d$var$DraggableAudioInternal = ({ children: children, document: document })=>{
    const draggableRef = (0, $42omo.useRef)(null);
    const [isDragging, setIsDragging] = (0, $42omo.useState)(false);
    const [currentPosition, setCurrentPosition] = (0, $42omo.useState)(()=>({
            top: $27d52fddae644c4d$var$initialTopPosition,
            left: document.body.clientWidth - $27d52fddae644c4d$var$initialRightOffset
        }));
    const { activeAudioContainerMode: activeAudioContainerMode } = (0, $9s8in.useAudioPlayerStore)();
    const setPosition = (0, $42omo.useCallback)((element, location, isDrop = false)=>{
        const initialCursorPoint = $27d52fddae644c4d$var$getTransformedCursorPosition(element, location.initial.input);
        const currentCursorPoint = $27d52fddae644c4d$var$getTransformedCursorPosition(element, location.current.input);
        // Difference between the current cursor position with that of the beginning of the drag
        const clientYDelta = currentCursorPoint.y - initialCursorPoint.y;
        const clientXDelta = currentCursorPoint.x - initialCursorPoint.x;
        const elementBoundingRect = element.getBoundingClientRect();
        // Proposed new top and left of the draggable position
        const newTop = currentPosition.top + clientYDelta;
        const newLeft = currentPosition.left + clientXDelta;
        // Prevent the boundaries of the draggable from being dragged beyond the window boundaries
        const rotatedTopDiff = $27d52fddae644c4d$var$getRotatedDimensionSkew(element) * element.offsetWidth; // TODO: prevent recalculating during drag
        const boundedNewTop = $27d52fddae644c4d$var$getBoundedDimension(newTop, 0, window.innerHeight - elementBoundingRect.height - rotatedTopDiff);
        const rotatedLeftDiff = $27d52fddae644c4d$var$getRotatedDimensionSkew(element) * element.offsetHeight; // TODO: prevent recalculating during drag
        const boundedNewLeft = $27d52fddae644c4d$var$getBoundedDimension(newLeft, rotatedLeftDiff, document.body.clientWidth - elementBoundingRect.width);
        if (isDrop) {
            // Reset transform and physically move element in the DOM
            element.style.setProperty('transform', 'initial');
            element.style.setProperty('top', `${boundedNewTop}px`);
            element.style.setProperty('left', `${boundedNewLeft}px`);
            setCurrentPosition({
                top: boundedNewTop,
                left: boundedNewLeft
            });
        } else {
            const boundedDeltaY = boundedNewTop - currentPosition.top;
            const boundedDeltaX = boundedNewLeft - currentPosition.left;
            // Apply CSS transform to dragged spot without physically moving the element in the DOM
            element.style.setProperty('transform', `rotate(4deg) translate(${boundedDeltaX}px, ${boundedDeltaY}px)`);
        }
    }, [
        currentPosition,
        document
    ]);
    // Setup drag-and-drop
    (0, $42omo.useEffect)(()=>{
        const element = draggableRef.current;
        if (!element) return;
        return (0, $bSjaC.combine)((0, $4T4vf.draggable)({
            element: element,
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage }) {
                // We'll drag the actual element so hide the native drag preview
                (0, $eOL5r.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>{
                setIsDragging(true);
            },
            onDrag: ({ location: location })=>{
                setPosition(element, location);
            },
            onDrop: ({ location: location })=>{
                setPosition(element, location, true);
                setIsDragging(false);
            }
        }), (0, $4T4vf.dropTargetForElements)({
            element: document.body
        }));
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: draggableRef,
        xcss: (0, $1Whri.cx)($27d52fddae644c4d$var$styles.floatingStyles, isDragging ? $27d52fddae644c4d$var$styles.draggingStyles : $27d52fddae644c4d$var$styles.idleStyles),
        style: {
            width: `${activeAudioContainerMode.width}px`
        },
        onClick: $27d52fddae644c4d$var$stopClickPropagation,
        testId: "audio-draggable",
        role: "none",
        children: children({
            isDragging: isDragging
        })
    });
};





var $32x2E = parcelRequire("32x2E");

















var $eznrX = parcelRequire("eznrX");


var $isYda = parcelRequire("isYda");







/**
 * @generated SignedSource<<537ae5c04d1f41cab7d7ddd2a92b022b>>
 * @relayHash 7d6f6442604633db9cad5b7f7d7a2f67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 84469a0d76dc498b9bea3fa90afbc26c6dfbb81e4cbaab08d9021441f3f09ade
const $aed372f169d6288c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceUpdateAudioPreferencePayload",
            "kind": "LinkedField",
            "name": "confluence_updateAudioPreference",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "ConfluenceAudioPreference",
                    "kind": "LinkedField",
                    "name": "preference",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "playbackSpeed"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "length"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tone"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CustomizePanelUpdateAudioPreferenceMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CustomizePanelUpdateAudioPreferenceMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "7d6f6442604633db9cad5b7f7d7a2f67",
            "id": "84469a0d76dc498b9bea3fa90afbc26c6dfbb81e4cbaab08d9021441f3f09ade",
            "metadata": {},
            "name": "CustomizePanelUpdateAudioPreferenceMutation",
            "operationKind": "mutation",
            "text": "mutation CustomizePanelUpdateAudioPreferenceMutation($input:ConfluenceUpdateAudioPreferenceInput!,$cloudId:ID!){confluence_updateAudioPreference(cloudId:$cloudId,input:$input){success,preference{playbackSpeed,length,tone}}}"
        }
    };
}();
$aed372f169d6288c$var$node.hash = "655ac66119013917736398a22f4af9cd";
var $aed372f169d6288c$export$2e2bcd8739ae039 = $aed372f169d6288c$var$node;
















var $fzqvY = parcelRequire("fzqvY");











/**
 * @generated SignedSource<<7b4c9e5a13edaf3cbcc8c0099d328ff3>>
 * @relayHash 83761a27ff4fd472a3b445d17b02d684
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5dbaefb4ba2122864da80840d5b3d0bc60cfcaa6d791e76272e3ac5fccf4da0d
const $976bf76fa52e930d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "mainSource"
    }, v3 = {
        "kind": "ScalarField",
        "name": "supportingSources"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "mainContent",
        "plural": false,
        "selections": [
            v5 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RefetchAudioButtonQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluencePlaylist",
                    "kind": "LinkedField",
                    "name": "confluence_getPlaylist",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluencePaginatedTracks",
                            "kind": "LinkedField",
                            "name": "tracks",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceTrack",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RefetchAudioButtonQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluencePlaylist",
                    "kind": "LinkedField",
                    "name": "confluence_getPlaylist",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluencePaginatedTracks",
                            "kind": "LinkedField",
                            "name": "tracks",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceTrack",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5dbaefb4ba2122864da80840d5b3d0bc60cfcaa6d791e76272e3ac5fccf4da0d",
            "metadata": {},
            "name": "RefetchAudioButtonQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$976bf76fa52e930d$var$node.hash = "e7f77962aa4c63ce3909c96229919cca";
var $976bf76fa52e930d$export$2e2bcd8739ae039 = $976bf76fa52e930d$var$node;






































const $3fa8682747f16925$var$messages = (0, $cgtv4.defineMessages)({
    errorTitle: {
        id: "ai-audio.audio-player.refetch-audio-button.error-title",
        defaultMessage: "Audio player didn't update"
    },
    errorDescription: {
        id: "ai-audio.audio-player.refetch-audio-button.error-description",
        defaultMessage: "Try making the changes again."
    }
});
const $3fa8682747f16925$export$b3d4c0af58555c89 = ({ buttonText: buttonText, shouldRequeue: shouldRequeue = false, supportingContent: supportingContent = [], isDisabled: isDisabled = false, analyticsAttributes: analyticsAttributes })=>{
    const { fetchAudio: fetchAudio, audioRef: audioRef } = (0, $b80bff0b244fbd50$export$2ff13f0ef48683f2)();
    const { state: streamingState } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const { cloudId: cloudId, activeContent: activeContent, setActiveMenu: setActiveMenu, activeFeature: activeFeature } = (0, $9s8in.useAudioPlayerStore)();
    const environment = (0, $irOoi.useRelayEnvironment)();
    const { removeTrack: removeTrack, addTrack: addTrack } = (0, $1WGfE.useContextMenuActions)(cloudId);
    const isLoading = streamingState.state === (0, $aU1TP.AudioStreamingState).LOADING;
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const flags = (0, $3A9F3.useFlags)();
    const { sendUIEvent: sendUIEvent } = (0, $dxfEr.usePlatformInstrumentation)();
    const startNewAudio = (0, $42omo.useCallback)(()=>{
        sendUIEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'audioRegenerate',
            source: 'audioPlayer',
            attributes: {
                version: 'v3',
                audioLocale: locale,
                ...analyticsAttributes
            }
        });
        fetchAudio();
    }, [
        sendUIEvent,
        locale,
        analyticsAttributes,
        fetchAudio
    ]);
    const stopExistingAudio = (0, $42omo.useCallback)(()=>{
        if (audioRef?.current) audioRef.current.pause();
    }, [
        audioRef
    ]);
    /** Handles requeuing the current track with updated supporting content */ const handleRequeueTrack = (0, $42omo.useCallback)(async ()=>{
        try {
            const playlist = await (0, $irOoi.fetchQuery)(environment, (0, $976bf76fa52e930d$export$2e2bcd8739ae039), {
                cloudId: cloudId
            }, {
                fetchPolicy: 'store-or-network'
            }).toPromise();
            if (playlist?.confluence_getPlaylist?.tracks?.nodes) {
                const activeTrackType = activeFeature.toUpperCase();
                const currentTrackIndex = playlist.confluence_getPlaylist.tracks.nodes.findIndex((node)=>node?.mainContent?.id === activeContent.contentId && node?.type === activeTrackType);
                if (currentTrackIndex !== -1) {
                    const currentTrack = playlist.confluence_getPlaylist.tracks.nodes[currentTrackIndex];
                    const trackCopy = {
                        ...currentTrack
                    };
                    // TODO: Create a new mutation that both adds and removes the track
                    // to better guard against scenarios where removal succeeds but addition fails
                    await removeTrack(currentTrack.mainSource, [
                        ...currentTrack.supportingSources ?? []
                    ], currentTrack.type, undefined, {
                        showFlags: false
                    });
                    await addTrack(trackCopy.mainSource, supportingContent.map((resource)=>resource.ari), trackCopy.type, {
                        showFlags: false,
                        top: true
                    });
                }
            }
            // Update global source state only once after successful BE requeue (if applicable),
            // preventing any potential inconsistencies between the BE and local player
            (0, $lqUMo.setSupportingContent)(supportingContent);
            // Reset playback speed to the set value from the customization
            if (audioRef.current) audioRef.current.defaultPlaybackRate = (0, $lqUMo.getCustomization)().playbackSpeed;
            startNewAudio();
        } catch  {
            if (flags) flags.showFlag({
                title: formatMessage($3fa8682747f16925$var$messages.errorTitle),
                description: formatMessage($3fa8682747f16925$var$messages.errorDescription),
                type: 'error',
                close: 'auto'
            });
        }
    }, [
        audioRef,
        cloudId,
        environment,
        removeTrack,
        addTrack,
        activeContent,
        activeFeature,
        supportingContent,
        flags,
        formatMessage,
        startNewAudio
    ]);
    const handleClick = (0, $42omo.useCallback)(async ()=>{
        stopExistingAudio();
        if (shouldRequeue) await handleRequeueTrack();
        else {
            if (supportingContent.length > 0) {
                (0, $lqUMo.setSupportingContent)(supportingContent);
                (0, $lqUMo.setInterimSupportingContent)([]);
            }
            startNewAudio();
            // Return to the audio player home screen
            setActiveMenu(undefined);
        }
    }, [
        startNewAudio,
        stopExistingAudio,
        handleRequeueTrack,
        shouldRequeue,
        supportingContent,
        setActiveMenu
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
        testId: "refetch-audio-button",
        shouldFitContainer: true,
        appearance: "primary",
        onClick: handleClick,
        isLoading: isLoading,
        isDisabled: isDisabled,
        children: formatMessage(buttonText)
    });
};









var $308Wd = parcelRequire("308Wd");




/* DurationSelector.tsx generated by @compiled/babel-plugin v0.36.1 */ 

















var $fb3kw = parcelRequire("fb3kw");


var $epp7s = parcelRequire("epp7s");

const $ec665b16fc7fd07f$var$i18n = (0, $cgtv4.defineMessages)({
    audioDurationLabel: {
        id: "audio.audio-popup.customize-tab.duration-label",
        defaultMessage: "Roughly how long is the audio?"
    },
    shortDurationLabel: {
        id: "audio.audio-popup.customize-tab.duration.short",
        defaultMessage: "Short"
    },
    mediumDurationLabel: {
        id: "audio.audio-popup.customize-tab.duration.medium",
        defaultMessage: "Medium"
    },
    longDurationLabel: {
        id: "audio.audio-popup.customize-tab.duration.long",
        defaultMessage: "Long"
    }
});
const $ec665b16fc7fd07f$var$durationOptions = [
    {
        label: 'shortDurationLabel',
        value: 'SHORT'
    },
    {
        label: 'mediumDurationLabel',
        value: 'MEDIUM'
    },
    {
        label: 'longDurationLabel',
        value: 'LONG'
    }
];
const $ec665b16fc7fd07f$var$styles = {
    durationSliderWrapper: "_19pkx0bf",
    slider: "_y4tiu2gc"
};
const $ec665b16fc7fd07f$var$onDragStart = (e)=>{
    e.stopPropagation();
    e.preventDefault();
};
const $ec665b16fc7fd07f$export$25e3136eb51eb4a3 = ({ onPreferenceUpdate: onPreferenceUpdate, defaultValue: defaultValue })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "length",
        label: formatMessage($ec665b16fc7fd07f$var$i18n.audioDurationLabel),
        id: "audio-duration-field",
        defaultValue: defaultValue
    }, ({ fieldProps: { value: customLength, onChange: onChange } })=>{
        // Use the field value if available, otherwise fall back to defaultValue
        const currentLength = customLength || defaultValue;
        const rangeValue = Math.max(0, $ec665b16fc7fd07f$var$durationOptions.findIndex((option)=>option.value === currentLength));
        const handleRangeChange = (newRangeValue)=>{
            const index = Math.round(newRangeValue);
            const selectedOption = $ec665b16fc7fd07f$var$durationOptions[index].value;
            onChange(selectedOption);
            onPreferenceUpdate({
                length: selectedOption
            });
        };
        const currentOption = $ec665b16fc7fd07f$var$durationOptions[rangeValue];
        const currentValueText = currentOption ? formatMessage($ec665b16fc7fd07f$var$i18n[currentOption.label]) : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $ec665b16fc7fd07f$var$styles.durationSliderWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $ec665b16fc7fd07f$var$styles.slider
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $epp7s.default), {
            type: "range",
            step: 1,
            min: 0,
            max: $ec665b16fc7fd07f$var$durationOptions.length - 1,
            value: rangeValue,
            onChange: handleRangeChange,
            onDragStart: $ec665b16fc7fd07f$var$onDragStart,
            draggable: true // Explicitly make draggable to intercept event and prevent any parent from dragging
            ,
            testId: "duration-range-slider",
            "aria-labelledby": "audio-duration-field-label",
            "aria-valuetext": currentValueText,
            "aria-valuenow": rangeValue
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            spread: "space-between",
            grow: "fill"
        }, $ec665b16fc7fd07f$var$durationOptions.map((option, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                key: option.value,
                size: "small",
                color: rangeValue === index ? 'color.text' : 'color.text.subtlest',
                weight: rangeValue === index ? 'bold' : 'regular'
            }, formatMessage($ec665b16fc7fd07f$var$i18n[option.label]))))));
    });
};


/* ToneSelector.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $3hOY6 = parcelRequire("3hOY6");

var $2gD2K = parcelRequire("2gD2K");




const $22fa3e6c3b0d3dc0$var$i18n = (0, $cgtv4.defineMessages)({
    audioToneLabel: {
        id: "audio.audio-popup.customize-tab.tone-label",
        defaultMessage: "How does the audio sound?"
    },
    professionalToneLabel: {
        id: "audio.audio-popup.customize-tab.tone.professional",
        defaultMessage: "Professional"
    },
    professionalToneDescription: {
        id: "audio.audio-popup.customize-tab.tone.professional.description",
        defaultMessage: "Clear and direct"
    },
    conversationalToneLabel: {
        id: "audio.audio-popup.customize-tab.tone.conversational",
        defaultMessage: "Conversational"
    },
    conversationalToneDescription: {
        id: "audio.audio-popup.customize-tab.tone.conversational.description",
        defaultMessage: "Approachable and informative"
    },
    playfulToneLabel: {
        id: "audio.audio-popup.customize-tab.tone.playful",
        defaultMessage: "Playful"
    },
    playfulToneDescription: {
        id: "audio.audio-popup.customize-tab.tone.playful.description",
        defaultMessage: "Lively and occasionally humorous"
    },
    surpriseToneLabel: {
        id: "audio.audio-popup.customize-tab.tone.surprise",
        defaultMessage: "Surprise me"
    },
    surpriseToneDescription: {
        id: "audio.audio-popup.customize-tab.tone.surprise.description",
        defaultMessage: "Takes on a unique personality"
    }
});
const $22fa3e6c3b0d3dc0$var$styles = {
    wrap: "_o5721btx"
};
const $22fa3e6c3b0d3dc0$var$toneSelectStyles = {
    control: (style)=>({
            ...style,
            borderColor: "var(--ds-border, #0B120E24)",
            borderRadius: "var(--ds-radius-large, 8px)"
        })
}; // Labels are purposely string values rather than Message objects
// This allows us to call formatMessage where needed
const $22fa3e6c3b0d3dc0$var$toneOptions = [
    {
        label: 'professionalToneLabel',
        value: 'PROFESSIONAL',
        description: 'professionalToneDescription'
    },
    {
        label: 'conversationalToneLabel',
        value: 'CONVERSATIONAL',
        description: 'conversationalToneDescription'
    },
    {
        label: 'playfulToneLabel',
        value: 'PLAYFUL',
        description: 'playfulToneDescription'
    },
    {
        label: 'surpriseToneLabel',
        value: 'SURPRISE',
        description: 'surpriseToneDescription'
    }
];
const $22fa3e6c3b0d3dc0$var$ToneOptionComponent = ({ option: option, meta: { context: context }, formatMessage: formatMessage })=>{
    if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle",
        weight: "semibold",
        size: "small"
    }, formatMessage($22fa3e6c3b0d3dc0$var$i18n[option.label])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        size: "small"
    }, formatMessage($22fa3e6c3b0d3dc0$var$i18n[option.description])));
    return formatMessage($22fa3e6c3b0d3dc0$var$i18n[option.label]);
};
const $22fa3e6c3b0d3dc0$var$ToneValue = ({ data: data, ...props })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).SingleValue, {
        data: data,
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlock: "space.050",
        paddingInlineEnd: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle",
        weight: "semibold",
        size: "small"
    }, formatMessage($22fa3e6c3b0d3dc0$var$i18n[data.label]))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $22fa3e6c3b0d3dc0$var$styles.wrap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        size: "small"
    }, formatMessage($22fa3e6c3b0d3dc0$var$i18n[data.description])))));
};
const $22fa3e6c3b0d3dc0$export$e17ece6e64da5462 = ({ onPreferenceUpdate: onPreferenceUpdate, defaultValue: defaultValue })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)(); // Convert ConfluenceTone to ToneOption for Field component
    const defaultToneOption = defaultValue ? $22fa3e6c3b0d3dc0$var$toneOptions.find((option)=>option.value === defaultValue) || null : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "tone",
        label: formatMessage($22fa3e6c3b0d3dc0$var$i18n.audioToneLabel),
        defaultValue: defaultToneOption
    }, ({ fieldProps: { id: id, value: fieldValue, onChange: onChange, ...rest } })=>{
        // Use field value if available, otherwise fall back to defaultToneOption
        const currentSelectedOption = fieldValue || defaultToneOption;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlockStart: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2gD2K.default), {
            inputId: id,
            ...rest,
            value: currentSelectedOption,
            formatOptionLabel: (option, meta)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($22fa3e6c3b0d3dc0$var$ToneOptionComponent, {
                    option: option,
                    meta: meta,
                    formatMessage: formatMessage
                }),
            options: $22fa3e6c3b0d3dc0$var$toneOptions,
            components: {
                SingleValue: $22fa3e6c3b0d3dc0$var$ToneValue
            },
            isSearchable: false,
            menuShouldScrollIntoView: true // Select is a unique case where this is semantically correct
            ,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            styles: $22fa3e6c3b0d3dc0$var$toneSelectStyles,
            menuPosition: "fixed",
            onChange: (selectedOption, _actionMeta)=>{
                if (selectedOption) {
                    onChange(selectedOption);
                    onPreferenceUpdate({
                        tone: selectedOption.value
                    });
                }
            }
        }));
    });
};


const $3eef0dc5ad34d1be$var$i18n = (0, $cgtv4.defineMessages)({
    refetchAudioButtonText: {
        id: "audio.audio-popup.customize-tab.refetch-audio-button",
        defaultMessage: "Re-start briefing"
    },
    errorFlagTitle: {
        id: "audio.audio-popup.customize-tab.error-flag-title",
        defaultMessage: "Error updating audio preference"
    },
    errorFlagDescription: {
        id: "audio.audio-popup.customize-tab.error-flag-description",
        defaultMessage: "Please try again later."
    }
});
const $3eef0dc5ad34d1be$var$styles = {
    formWrapper: "_18zru2gc _y3gn1e5h",
    buttonWrapper: "_19pkutpp"
};
const $3eef0dc5ad34d1be$var$CustomizePanelInner = ()=>{
    const customization = (0, $lqUMo.getCustomization)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const flags = (0, $3A9F3.useFlags)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const defaultValues = {
        length: customization.length,
        tone: customization.tone,
        playbackSpeed: customization.playbackSpeed || 1.0
    };
    const newValuesRef = (0, $42omo.useRef)({
        length: defaultValues.length,
        tone: defaultValues.tone
    });
    const [commitMutation] = (0, $308Wd.useMutationInterop)((0, $aed372f169d6288c$export$2e2bcd8739ae039));
    const handlePreferenceUpdate = (0, $42omo.useCallback)(async (updatedPreferences)=>{
        const currentCustomization = (0, $lqUMo.getCustomization)();
        const newPreferences = {
            ...currentCustomization,
            ...updatedPreferences
        }; // Update ref with new values
        newValuesRef.current = {
            length: newPreferences.length,
            tone: newPreferences.tone
        }; // Optimistic update for immediate UI feedback
        (0, $lqUMo.setCustomization)(newPreferences);
        const optimisticState = {
            ...currentCustomization,
            ...updatedPreferences
        };
        const input = {
            length: newPreferences.length,
            tone: newPreferences.tone,
            playbackSpeed: newPreferences.playbackSpeed ?? 1.0
        };
        (0, $lqUMo.setCustomization)(optimisticState);
        try {
            const result = await commitMutation({
                variables: {
                    input: input,
                    cloudId: cloudId
                }
            });
            if (result.data?.confluence_updateAudioPreference?.success && result.data.confluence_updateAudioPreference.preference) {
                const serverPrefs = result.data.confluence_updateAudioPreference.preference;
                (0, $lqUMo.setCustomization)({
                    length: serverPrefs.length,
                    tone: serverPrefs.tone,
                    playbackSpeed: serverPrefs.playbackSpeed
                });
            } else if (result.data?.confluence_updateAudioPreference?.success === false) {
                // Rollback to previous state on server error
                (0, $lqUMo.setCustomization)(currentCustomization);
                flags?.showFlag({
                    title: formatMessage($3eef0dc5ad34d1be$var$i18n.errorFlagTitle),
                    description: formatMessage($3eef0dc5ad34d1be$var$i18n.errorFlagDescription),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                        color: "var(--ds-icon-danger, #C9372C)",
                        label: ""
                    }),
                    isAutoDismiss: true
                });
            }
        } catch  {
            // Rollback to previous state on network/mutation error
            (0, $lqUMo.setCustomization)(currentCustomization);
            flags?.showFlag({
                title: formatMessage($3eef0dc5ad34d1be$var$i18n.errorFlagTitle),
                description: formatMessage($3eef0dc5ad34d1be$var$i18n.errorFlagDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    label: ""
                }),
                isAutoDismiss: true
            });
        }
    }, [
        commitMutation,
        cloudId,
        flags,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $3eef0dc5ad34d1be$var$styles.formWrapper
    }, (0, $9wGTI.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: ()=>{}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $22fa3e6c3b0d3dc0$export$e17ece6e64da5462), {
        onPreferenceUpdate: handlePreferenceUpdate,
        defaultValue: defaultValues.tone
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ec665b16fc7fd07f$export$25e3136eb51eb4a3), {
        onPreferenceUpdate: handlePreferenceUpdate,
        defaultValue: defaultValues.length
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $3eef0dc5ad34d1be$var$styles.buttonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3fa8682747f16925$export$b3d4c0af58555c89), {
        buttonText: $3eef0dc5ad34d1be$var$i18n.refetchAudioButtonText,
        source: "customizePanel",
        analyticsAttributes: {
            length: newValuesRef.current.length,
            tone: newValuesRef.current.tone
        }
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: ()=>{}
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $22fa3e6c3b0d3dc0$export$e17ece6e64da5462), {
            onPreferenceUpdate: handlePreferenceUpdate,
            defaultValue: defaultValues.tone
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ec665b16fc7fd07f$export$25e3136eb51eb4a3), {
            onPreferenceUpdate: handlePreferenceUpdate,
            defaultValue: defaultValues.length
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $3eef0dc5ad34d1be$var$styles.buttonWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3fa8682747f16925$export$b3d4c0af58555c89), {
            buttonText: $3eef0dc5ad34d1be$var$i18n.refetchAudioButtonText,
            source: "customizePanel"
        }))))));
};
const $3eef0dc5ad34d1be$export$34f57b4c1c4bca9f = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const flagsContextValue = (0, $42omo.useMemo)(()=>{
        return {
            flags: flags
        };
    }, [
        flags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3A9F3.FlagsProviderContext).Provider, {
        value: flagsContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3eef0dc5ad34d1be$var$CustomizePanelInner, null));
});


/* SourcesPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 






















var $hpUsb = parcelRequire("hpUsb");








var $6F6hl = parcelRequire("6F6hl");





var $6M71K = parcelRequire("6M71K");


var $kLzei = parcelRequire("kLzei");


var $3e8bm = parcelRequire("3e8bm");

const $5ed27bb2f6423ca3$var$styles = {
    sourcesContentContainer: "_18zru2gc _y3gn1e5h",
    cardContainer: "_1reo15vq _18m915vq _1tked4y9",
    additionalSourcesList: "_2mzuglyw _bozgidpf _1pfhidpf _6rthutpp",
    smartLinkContainer: "_1reo15vq _18m915vq _c71l1tcg _1pfhidpf",
    buttonContainer: "_18zr1b66"
};
const $5ed27bb2f6423ca3$var$i18n = (0, $cgtv4.defineMessages)({
    sourcesDescription: {
        id: "audio.audio-popup.sources-description",
        defaultMessage: "Customize briefings by adding sources. Hear how all the info works together."
    },
    thisContentHeader: {
        id: "audio.audio-popup.sources-this-content-header",
        defaultMessage: "This content"
    },
    additionalSourcesHeader: {
        id: "audio.audio-popup.sources-additional-sources-header",
        defaultMessage: "Additional sources"
    },
    refetchAudioButtonText: {
        id: "audio.audio-popup.sources-tab.refetch-audio-button",
        defaultMessage: "Re-start briefing"
    },
    sourceAddedAnnouncement: {
        id: "audio.audio-popup.sources-tab.source-added-announcement",
        defaultMessage: "Source added successfully"
    },
    sourceRemovedAnnouncement: {
        id: "audio.audio-popup.sources-tab.source-removed-announcement",
        defaultMessage: "Source removed successfully"
    }
});
const $5ed27bb2f6423ca3$export$2c62bf432071778d = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const smartCardProviderProps = (0, $kLzei.getSmartCardRenderers)();
    const activeContent = (0, $lqUMo.getActiveContent)();
    const activeContentUrl = activeContent.mainContentLink;
    const latestAdditionalSources = (0, $lqUMo.getInterimSupportingContent)() ?? activeContent.supportingContent;
    const [localAdditionalResources, setLocalAdditionalResources] = (0, $42omo.useState)(()=>latestAdditionalSources.map((resource)=>({
                link: resource.link,
                ari: resource.ari
            }))); // State for ARIA live region announcements
    const [announcement, setAnnouncement] = (0, $42omo.useState)(''); // Sync local changes to interim supporting content for onBack functionality
    (0, $42omo.useEffect)(()=>{
        (0, $lqUMo.setInterimSupportingContent)(localAdditionalResources);
    }, [
        localAdditionalResources
    ]);
    const addAdditionalResource = (0, $42omo.useCallback)((newResource)=>{
        setLocalAdditionalResources((prev)=>[
                ...prev,
                newResource
            ]);
        setAnnouncement(formatMessage($5ed27bb2f6423ca3$var$i18n.sourceAddedAnnouncement));
    }, [
        formatMessage
    ]);
    const removeAdditionalResource = (0, $42omo.useCallback)((ariToRemove)=>{
        setLocalAdditionalResources((prev)=>prev.filter((resource)=>resource.ari !== ariToRemove));
        setAnnouncement(formatMessage($5ed27bb2f6423ca3$var$i18n.sourceRemovedAnnouncement));
    }, [
        formatMessage
    ]);
    const sourcesHaveDiverged = (0, $lqUMo.isSourceContentDiverged)(activeContent.supportingContent, latestAdditionalSources);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), smartCardProviderProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "status",
        "aria-live": "polite",
        "aria-atomic": "true"
    }, announcement)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $5ed27bb2f6423ca3$var$styles.sourcesContentContainer,
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage($5ed27bb2f6423ca3$var$i18n.sourcesDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xxsmall"
    }, formatMessage($5ed27bb2f6423ca3$var$i18n.thisContentHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $5ed27bb2f6423ca3$var$styles.cardContainer,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
        url: activeContentUrl,
        appearance: "inline",
        truncateInline: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xxsmall"
    }, formatMessage($5ed27bb2f6423ca3$var$i18n.additionalSourcesHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.075",
        as: "ul",
        xcss: $5ed27bb2f6423ca3$var$styles.additionalSourcesList
    }, localAdditionalResources.map((resource)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            key: resource.ari,
            spread: "space-between",
            xcss: $5ed27bb2f6423ca3$var$styles.smartLinkContainer,
            as: "li"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
            url: resource.link,
            appearance: "inline",
            truncateInline: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5ed27bb2f6423ca3$var$styles.buttonContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            label: "remove-audio-resource",
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
            spacing: "compact",
            onClick: ()=>removeAdditionalResource(resource.ari)
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3e8bm.SourcesInput), {
        additionalResources: localAdditionalResources,
        addAdditionalResource: addAdditionalResource,
        activeContent: activeContent
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3fa8682747f16925$export$b3d4c0af58555c89), {
        buttonText: $5ed27bb2f6423ca3$var$i18n.refetchAudioButtonText,
        source: "sourcesPanel",
        shouldRequeue: true,
        supportingContent: localAdditionalResources,
        isDisabled: !sourcesHaveDiverged,
        analyticsAttributes: {
            areSourcesDiverged: sourcesHaveDiverged
        }
    }))));
};


const $8e358b0e699a1ab1$var$i18n = (0, $cgtv4.defineMessages)({
    narrationLabel: {
        id: "audio.audio-features.narration-label",
        defaultMessage: "Narration"
    },
    briefingLabel: {
        id: "audio.audio-features.briefing-label",
        defaultMessage: "Briefing"
    },
    narrationAccessibleLabel: {
        id: "audio.audio-features.narration-accessible-label",
        defaultMessage: "audio narration"
    },
    briefingAccessibleLabel: {
        id: "audio.audio-features.briefing-accessible-label",
        defaultMessage: "audio briefing"
    },
    customizeLabel: {
        id: "audio.audio-features.customize-menu-item-label",
        defaultMessage: "Customize"
    },
    manageSourcesLabel: {
        id: "audio.audio-features.manage-sources-menu-item-label",
        defaultMessage: "Manage sources"
    },
    manageSourcesPanelHeader: {
        id: "audio.audio-features.manage-sources-panel-header",
        defaultMessage: "Sources"
    }
});
const $8e358b0e699a1ab1$export$5d6e5eb56242f9e9 = [
    {
        name: (0, $CAM5Y.AudioFeatureType).BRIEFING,
        translationString: $8e358b0e699a1ab1$var$i18n.briefingLabel,
        accessibleLabel: $8e358b0e699a1ab1$var$i18n.briefingAccessibleLabel,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($afBrg))),
        menuConfig: {
            items: [
                {
                    id: 'customize',
                    onClick: ()=>{},
                    title: $8e358b0e699a1ab1$var$i18n.customizeLabel,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($isYda)))({
                        label: ''
                    }),
                    renderPanel: {
                        header: $8e358b0e699a1ab1$var$i18n.customizeLabel,
                        body: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eef0dc5ad34d1be$export$34f57b4c1c4bca9f), null)
                    }
                },
                {
                    id: 'manageSources',
                    onClick: ()=>{},
                    title: $8e358b0e699a1ab1$var$i18n.manageSourcesLabel,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o)))({
                        label: ''
                    }),
                    renderPanel: {
                        header: $8e358b0e699a1ab1$var$i18n.manageSourcesPanelHeader,
                        body: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ed27bb2f6423ca3$export$2c62bf432071778d), null)
                    }
                }
            ]
        }
    },
    {
        name: (0, $CAM5Y.AudioFeatureType).NARRATION,
        translationString: $8e358b0e699a1ab1$var$i18n.narrationLabel,
        accessibleLabel: $8e358b0e699a1ab1$var$i18n.narrationAccessibleLabel,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eznrX)))
    }
];


const $3dcdb07ca5337b62$export$d559f44428716fef = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const { isOpen: isOpen } = (0, $9s8in.useAudioPlayerStore)();
    const { activationId: activationId, userId: userId, cloudId: cloudId, displayName: displayName } = (0, $bQm3c.useSessionData)();
    const [emojiProvider, setEmojiProvider] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        //getEmojiProvider returns a promise, but getEmojiProvider requires it to be resolved. This middle step ensures the promise has returned before the value is passed
        (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
            cloudId: cloudId,
            userId: userId
        }).then(setEmojiProvider).catch(()=>{});
    }, [
        cloudId,
        userId
    ]);
    return isOpen && emojiProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $27d52fddae644c4d$export$110682900206ff66), null, ({ isDragging: isDragging })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d78377ab2f7b2547$export$6791290ffa0c6398), {
            product: "confluence",
            cloudId: cloudId,
            activationId: activationId,
            emojiProvider: emojiProvider,
            audioFeatures: (0, $8e358b0e699a1ab1$export$5d6e5eb56242f9e9),
            flags: flags,
            pinToExpandedView: isDragging,
            userId: userId ?? undefined,
            displayName: displayName ?? undefined
        })) : null;
});




// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $8AKrx = parcelRequire("8AKrx");


var $4S8ti = parcelRequire("4S8ti");










const $09eeca995b457ca5$export$efd8e9a23eed920f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "psJZK",
    name: "UpgradeFreePoolExperimentModalPostUpgradeModalLoadable",
    loader: async ()=>(await (parcelRequire("hZ7et"))).UpgradeFreePoolExperimentModalPostUpgradeModalBaseComponent
});






const $d8e3aca11cb56cc3$export$3dedce674c098c16 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IOfS7",
    name: "UpgradeFreePoolExperimentModalPreUpgradeModalLoadable",
    loader: async ()=>(await (parcelRequire("aMFlV"))).UpgradeFreePoolExperimentModalPreUpgradeModalBaseComponent
});






const $115e4f8cc2211b97$export$1b00dbfc05a9ac4b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KjI9E",
    name: "EndOfTrialModalContainerWithErrorBoundaryLoadable",
    loader: async ()=>(await (parcelRequire("gbvKD"))).EndOfTrialModalContainerWithErrorBoundary
});



























var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $f7MuR = parcelRequire("f7MuR");








var $8Lx5S = parcelRequire("8Lx5S");


var $JCGnt = parcelRequire("JCGnt");

const $9551f5972adb6029$export$be51a88de4a31ef5 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const basicEligibilityMet = isRovoLLMEnabled && isLicensed && (0, $9wGTI.fg)('aifc_onboarding_ga_enabled');
    const { isNewUser: isNewUser, loading: isLoadingNewUser, error: errorNewUser } = (0, $JCGnt.useIsNewUser)({}, !basicEligibilityMet);
    if (isLoadingNewUser) return {
        isEligible: false,
        loading: true
    };
    if (errorNewUser) return {
        isEligible: false,
        loading: false,
        error: errorNewUser
    };
    return {
        isEligible: basicEligibilityMet && !isNewUser,
        loading: false
    };
};


const $6bee3b19aa029c55$var$TRAIT_HAS_USED_CREATE_WITH_ROVO = 'confluence_has_used_create_with_rovo';
const $6bee3b19aa029c55$var$ANALYTICS_SOURCE = 'createWithRovoAnnouncementSplashModal';
const $6bee3b19aa029c55$export$afc82bec3a547983 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { isEligible: isEligible, loading: isLoadingEligibility, error: eligibilityError } = (0, $9551f5972adb6029$export$be51a88de4a31ef5)();
    const { data: dataTraits, loading: isLoadingTraits, error: errorTraits } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: !isEligible
    });
    const hasUsedCreateWithRovo = dataTraits?.attributes?.find(({ name: name })=>name === $6bee3b19aa029c55$var$TRAIT_HAS_USED_CREATE_WITH_ROVO)?.value === 'true';
    const { data: data, loading: isLoadingHasSeenModal, error: errorHasSeenModal } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $dBcar.CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH)), !isEligible);
    const { hasSeenSplashModal: hasSeenSplashModal } = (0, $ivb8S.deserializeState)(data);
    const loading = isLoadingEligibility || isLoadingTraits || (isEligible ? isLoadingHasSeenModal : false);
    const error = eligibilityError || errorTraits || (isEligible ? errorHasSeenModal : undefined);
    const isModalVisible = (0, $42omo.useMemo)(()=>isEligible && !hasUsedCreateWithRovo && !hasSeenSplashModal && !loading && !error, [
        isEligible,
        hasUsedCreateWithRovo,
        hasSeenSplashModal,
        loading,
        error
    ]);
    const onModalShown = (0, $42omo.useCallback)((dismissSource)=>{
        if (isModalVisible) {
            setOnboardingState({
                key: (0, $dBcar.CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH).HAS_SEEN_SPLASH_MODAL,
                value: 'true'
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'dismiss',
                    attributes: {
                        dismissSource: dismissSource
                    },
                    source: $6bee3b19aa029c55$var$ANALYTICS_SOURCE
                }
            }).fire();
        }
    }, [
        isModalVisible,
        createAnalyticsEvent,
        setOnboardingState
    ]);
    return {
        isModalVisible: isModalVisible,
        onModalShown: onModalShown,
        loading: loading,
        error: error
    };
};


const $aa0f5309ecb985e1$export$74d9720ef7c5b47 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).FLYWHEEL_FEATURE_DISCOVERY
})(()=>{
    const { isModalVisible: isModalVisible, onModalShown: onModalShown, loading: loading, error: error } = (0, $6bee3b19aa029c55$export$afc82bec3a547983)();
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    if (loading || !isModalVisible) return null;
    if (isModalVisible && (0, $6mKj3.expValEquals)('cc-aifc-databases-experiment', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($aa0f5309ecb985e1$var$Modal, {
        onModalShown: onModalShown
    });
});

const $aa0f5309ecb985e1$var$Modal = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "E2fZV",
    name: "Modal",
    loader: async ()=>(await (parcelRequire("6OFcd"))).RovoAnnouncementSplashContainer
});


const $21316eb17a577fc6$export$461c2ed3163c74ff = ()=>{
    const isNav4DisplayedToUser = (0, $gz8ZY.useIsNav4Enabled)();
    (0, $560a905f50f30e05$export$209ba536680f5b50)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Disco'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $60b070effa9833b5$export$8b3b261467ad7423), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d903e4dac8e596de$export$40ad526e6a3cd784), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Smarts'
        }
    }, (0, $9wGTI.fg)('aifc_create_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7DERG.ConfluenceSmartCreationModalLoader), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CC_IMPORTER,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Importer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8AFM.ConditionalImportContentModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cQbTj.ConditionalImportContentDrawer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Ecosystem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $053fc94f5ddb8d12$export$d15e21537dfa6cb0), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE,
        attributes: {
            errorBoundaryId: 'GlobalComponents-AdminExperience'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ac3d7089b8f08ca$export$5bf713f6291006b2), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
        attributes: {
            errorBoundaryId: 'GlobalComponents-GrowthLuna'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8e4a487f1ccf39b0$export$7699251dbf86d265), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5zvz.StandardToPremiumModalMountComponent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7a2cd2323bccfe9$export$c108f21945b8b79), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hAnPj.LazyRestrictionsDialogMountPoint), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ACTIVATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0cafdf8f81e44cdc$export$51c4358102159001), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63d46b1fc54f0401$export$11a38f66cbb85629), null)), (0, $9wGTI.fg)('aifc_onboarding_ga_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_FEATURE_DISCOVERY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aa0f5309ecb985e1$export$74d9720ef7c5b47), null)), isNav4DisplayedToUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i5Ioa.ProgressBar), {
        isNav4: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_PUMA,
        attributes: {
            errorBoundaryId: 'GlobalComponents-GrowthPuma'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4S8ti.CrossJoinNudgesWithFlags), null)), (0, $9wGTI.fg)('loom_ai_meeting_notes_in_confluence_killswitch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_MULTIPLIERS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a899a35998a2f0d5$export$65c1757b89fecfeb), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
        attributes: {
            errorBoundaryId: 'GlobalComponents-GrowthArtemis'
        }
    }, (0, $9wGTI.fg)('twcg-206_confluence_upgrade_permanent_free_fg') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8e3aca11cb56cc3$export$3dedce674c098c16), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $09eeca995b457ca5$export$efd8e9a23eed920f), null)), (0, $9wGTI.fg)('twcg-530_confluence_ai_in_editor_eot_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $115e4f8cc2211b97$export$1b00dbfc05a9ac4b), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Audio'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dcdb07ca5337b62$export$d559f44428716fef), null)));
};
module.exports["GlobalComponents"] = $21316eb17a577fc6$export$461c2ed3163c74ff;

});

parcelRegister("bAyaS", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $8eabddf4fe78ba91$var$initialState = {
    showCreateSpaceDrawer: false,
    shouldRenderDrawer: false,
    createSpaceButtonRef: {
        current: null
    },
    createSpaceButtonLocation: undefined
};
const $8eabddf4fe78ba91$export$e324594224ef24da = {
    openDrawer: (value, createSpaceButtonLocation)=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: true,
                shouldRenderDrawer: true,
                createSpaceButtonRef: value,
                createSpaceButtonLocation: createSpaceButtonLocation
            });
        },
    closeDrawer: ()=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: false,
                createSpaceButtonLocation: undefined
            });
        }
};
const $8eabddf4fe78ba91$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $8eabddf4fe78ba91$var$initialState,
    actions: $8eabddf4fe78ba91$export$e324594224ef24da,
    name: 'createSpaceStore'
});
const $8eabddf4fe78ba91$export$5642c413017336a4 = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
const $8eabddf4fe78ba91$var$getShouldRenderDrawer = (state)=>{
    return state.shouldRenderDrawer;
};
const $8eabddf4fe78ba91$export$34596812152477bc = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getShouldRenderDrawer
});
const $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing = (state)=>{
    return state.showCreateSpaceDrawer;
};
const $8eabddf4fe78ba91$export$5ff6e7335b182a8e = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing
});
const $8eabddf4fe78ba91$export$ad3d638eaaafd693 = (0, $9zUhf.createActionsHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
module.exports["useCreateSpaceStore"] = $8eabddf4fe78ba91$export$5642c413017336a4;
module.exports["useShouldRenderDrawer"] = $8eabddf4fe78ba91$export$34596812152477bc;
module.exports["useCreateSpaceStoreActions"] = $8eabddf4fe78ba91$export$ad3d638eaaafd693;

});

parcelRegister("kjDYe", function(module, exports) {

let $eca4964a9e4403a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eca4964a9e4403a6$var$load("ht6hk"),
    $eca4964a9e4403a6$var$load("f35QR"),
    $eca4964a9e4403a6$var$load("eVYW1"),
    $eca4964a9e4403a6$var$load("ls0Um"),
    $eca4964a9e4403a6$var$load("020xd"),
    $eca4964a9e4403a6$var$load("eTBsW"),
    $eca4964a9e4403a6$var$load("bYxCZ"),
    $eca4964a9e4403a6$var$load("6HBYC"),
    $eca4964a9e4403a6$var$load("eDqo1"),
    $eca4964a9e4403a6$var$load("lxiFd"),
    $eca4964a9e4403a6$var$load("1oiJ6"),
    $eca4964a9e4403a6$var$load("huUvS"),
    $eca4964a9e4403a6$var$load("6wr18"),
    $eca4964a9e4403a6$var$load("4o7bO"),
    $eca4964a9e4403a6$var$load("QcHuP"),
    $eca4964a9e4403a6$var$load("19uFC"),
    $eca4964a9e4403a6$var$load("a3Uq6"),
    $eca4964a9e4403a6$var$load("8UKe0"),
    $eca4964a9e4403a6$var$load("fD0v8"),
    $eca4964a9e4403a6$var$load("6XCf4"),
    $eca4964a9e4403a6$var$load("1qlDN"),
    $eca4964a9e4403a6$var$load("1yVM6"),
    $eca4964a9e4403a6$var$load("Wowvf"),
    $eca4964a9e4403a6$var$load("fsikk"),
    $eca4964a9e4403a6$var$load("5pvpJ"),
    $eca4964a9e4403a6$var$load("6vhrJ"),
    $eca4964a9e4403a6$var$load("ffEVr"),
    $eca4964a9e4403a6$var$load("hhss7"),
    $eca4964a9e4403a6$var$load("atyNV")
]).then(()=>parcelRequire('1tDKi'));

});

parcelRegister("h3wYQ", function(module, exports) {
$parcel$export(module.exports, "ConditionalImportContentDrawer", () => (parcelRequire("cQbTj")).ConditionalImportContentDrawer);
$parcel$export(module.exports, "ConditionalImportContentModal", () => (parcelRequire("f8AFM")).ConditionalImportContentModal);
$parcel$export(module.exports, "ImportContentButton", () => (parcelRequire("gKGjM")).ImportContentButton);

var $cQbTj = parcelRequire("cQbTj");


var $f8AFM = parcelRequire("f8AFM");


var $gKGjM = parcelRequire("gKGjM");


});

parcelRegister("cQbTj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $5IN3L = parcelRequire("5IN3L");


const $8584efcc44eb8061$var$ImportContentDrawerLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "R258E",
    name: "ImportContentDrawerLoader",
    loader: async ()=>(await (parcelRequire("6jOqx"))).ImportContentDrawer
});
const $8584efcc44eb8061$export$5aeeed7cf265bb36 = ()=>{
    const [importContentState, importContentActions] = (0, $5IN3L.useImportContentStore)();
    return importContentState.shouldRenderDrawer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8584efcc44eb8061$var$ImportContentDrawerLoader, {
        isImportingContent: importContentState.showImportContentDrawer,
        setIsImportingContent: importContentActions.setShowImportContentDrawer,
        contentType: importContentState.contentType
    }) : null;
};
module.exports["ConditionalImportContentDrawer"] = $8584efcc44eb8061$export$5aeeed7cf265bb36;

});

parcelRegister("5IN3L", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $8uc8a = parcelRequire("8uc8a");


var $27ffu = parcelRequire("27ffu");


var $dzqet = parcelRequire("dzqet");

const $c73c161a517b87e3$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: {
        showImportContentDrawer: false,
        shouldRenderDrawer: false,
        showImportContentModal: false,
        shouldRenderModal: false,
        shouldRenderMiroTokenModal: false,
        contentType: (0, $dzqet.ContentType).NOTION
    },
    actions: {
        setShowImportContentDrawer: (value)=>({ setState: setState })=>{
                setState({
                    showImportContentDrawer: value
                });
            },
        setShouldRenderDrawer: (value)=>({ setState: setState })=>{
                setState({
                    shouldRenderDrawer: value
                });
            },
        setShowImportContentModal: (value)=>({ setState: setState })=>{
                setState({
                    showImportContentModal: value
                });
            },
        setShouldRenderModal: (value)=>({ setState: setState })=>{
                setState({
                    shouldRenderModal: value
                });
            },
        setShouldRenderMiroTokenModal: (value)=>({ setState: setState })=>{
                setState({
                    shouldRenderMiroTokenModal: value
                });
            },
        setContentType: (value)=>({ setState: setState })=>{
                setState({
                    contentType: value
                });
            }
    },
    name: 'importContentStore'
});
const $c73c161a517b87e3$export$7805c3dc7bda328d = /*#__PURE__*/ (0, $42omo.createContext)({
    authProviderError: '',
    setAuthProviderError: ()=>{},
    hasSubpages: false,
    setHasSubpages: ()=>{},
    dropzoneCancelFnRef: {
        current: null
    },
    browserCancelFnRef: {
        current: null
    },
    isUploadingFile: false,
    setIsUploadingFile: ()=>{},
    isStartingImport: false,
    setIsStartingImport: ()=>{},
    fileNameDisplay: '',
    setFileNameDisplay: ()=>{},
    fileSizeBytes: 0,
    setFileSizeBytes: ()=>{},
    filestoreId: '',
    setFilestoreId: ()=>{},
    migrationScopeId: '',
    setMigrationScopeId: ()=>{},
    migrationId: '',
    setMigrationId: ()=>{},
    collectionId: '',
    setCollectionId: ()=>{},
    shouldMapNotionMembers: true,
    setShouldMapNotionMembers: ()=>{},
    shouldRenderCloseDrawerModal: false,
    setShouldRenderCloseDrawerModal: ()=>{},
    shouldRenderIntegrationTokenModal: false,
    setShouldRenderIntegrationTokenModal: ()=>{},
    integrationToken: '',
    setIntegrationToken: ()=>{},
    shouldAddRemainingMembers: false,
    setShouldAddRemainingMembers: ()=>{},
    shouldCopyPagePermissions: false,
    setShouldCopyPagePermissions: ()=>{},
    shouldRenderAccessTokenModal: false,
    setShouldRenderAccessTokenModal: ()=>{},
    shouldExportEntities: true,
    setShouldExportEntities: ()=>{},
    accessToken: '',
    setAccessToken: ()=>{},
    refreshToken: '',
    setRefreshToken: ()=>{},
    tokenExpireAt: '',
    setTokenExpireAt: ()=>{},
    newSpaceName: '',
    setNewSpaceName: ()=>{},
    setExistingSpace: ()=>{},
    setParentPageId: ()=>{},
    selectedPermissions: (0, $8uc8a.PermissionOptions).DEFAULT,
    setSelectedPermissions: ()=>{},
    miroAuthToken: '',
    setMiroAuthToken: ()=>{},
    miroTeamId: '',
    setMiroTeamId: ()=>{},
    miroProjectId: null,
    setMiroProjectId: ()=>{},
    clearAllMiroBulkImportTokens: ()=>{},
    didReceiveMiroBulkApiTokens: false,
    setDidReceiveMiroBulkApiTokens: ()=>{},
    isNotionWorkspaceImportDisabled: false,
    setIsNotionWorkspaceImportDisabled: ()=>{},
    isValidatingZip: false,
    setIsValidatingZip: ()=>{}
});
const $c73c161a517b87e3$export$4261666d8e0efef2 = (props)=>{
    const [authProviderError, setAuthProviderError] = (0, $42omo.useState)('');
    const [hasSubpages, setHasSubpages] = (0, $42omo.useState)(false);
    const dropzoneCancelFnRef = (0, $42omo.useRef)(null);
    const browserCancelFnRef = (0, $42omo.useRef)(null);
    const [isUploadingFile, setIsUploadingFile] = (0, $42omo.useState)(false);
    const [isStartingImport, setIsStartingImport] = (0, $42omo.useState)(false);
    const [fileNameDisplay, setFileNameDisplay] = (0, $42omo.useState)('');
    const [fileSizeBytes, setFileSizeBytes] = (0, $42omo.useState)(0);
    const [filestoreId, setFilestoreId] = (0, $42omo.useState)('');
    const [migrationScopeId, setMigrationScopeId] = (0, $42omo.useState)('');
    const [migrationId, setMigrationId] = (0, $42omo.useState)('');
    const [collectionId, setCollectionId] = (0, $42omo.useState)('');
    const [shouldMapNotionMembers, setShouldMapNotionMembers] = (0, $42omo.useState)(true);
    const [shouldRenderIntegrationTokenModal, setShouldRenderIntegrationTokenModal] = (0, $42omo.useState)(false);
    const [shouldRenderCloseDrawerModal, setShouldRenderCloseDrawerModal] = (0, $42omo.useState)(false);
    const [integrationToken, setIntegrationToken] = (0, $42omo.useState)('');
    const [shouldAddRemainingMembers, setShouldAddRemainingMembers] = (0, $42omo.useState)(true);
    const [shouldCopyPagePermissions, setShouldCopyPagePermissions] = (0, $42omo.useState)(false);
    const [shouldRenderAccessTokenModal, setShouldRenderAccessTokenModal] = (0, $42omo.useState)(false);
    const [shouldExportEntities, setShouldExportEntities] = (0, $42omo.useState)(false);
    const [accessToken, setAccessToken] = (0, $42omo.useState)('');
    const [refreshToken, setRefreshToken] = (0, $42omo.useState)('');
    const [tokenExpireAt, setTokenExpireAt] = (0, $42omo.useState)('');
    const [newSpaceName, setNewSpaceName] = (0, $42omo.useState)('');
    const [existingSpace, setExistingSpace] = (0, $42omo.useState)();
    const [parentPageId, setParentPageId] = (0, $42omo.useState)();
    const [miroAuthToken, setMiroAuthToken] = (0, $42omo.useState)('');
    const [miroTeamId, setMiroTeamId] = (0, $42omo.useState)('');
    const [miroProjectId, setMiroProjectId] = (0, $42omo.useState)(null);
    const [didReceiveMiroBulkApiTokens, setDidReceiveMiroBulkApiTokens] = (0, $42omo.useState)(false);
    const [selectedPermissions, setSelectedPermissions] = (0, $42omo.useState)((0, $8uc8a.PermissionOptions).DEFAULT);
    const [isNotionWorkspaceImportDisabled, setIsNotionWorkspaceImportDisabled] = (0, $42omo.useState)(false);
    const [isValidatingZip, setIsValidatingZip] = (0, $42omo.useState)(false);
    const clearAllMiroBulkImportTokens = ()=>{
        setMiroAuthToken('');
        setMiroTeamId('');
        setMiroProjectId(null);
    };
    const setParentPageIdWithValidation = (rawParentPageId)=>{
        if (rawParentPageId === 'no-page-selection') setParentPageId(undefined);
        else setParentPageId(rawParentPageId);
    };
    const setMiroProjectIdWithValidation = (rawMiroProjectId)=>{
        if (rawMiroProjectId === '' || rawMiroProjectId === null) setMiroProjectId(null);
        else setMiroProjectId(rawMiroProjectId);
    };
    (0, $27ffu.useBeforeUnload)('Changes may not be saved', isUploadingFile || isStartingImport);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c73c161a517b87e3$export$7805c3dc7bda328d.Provider, {
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value: {
            authProviderError: authProviderError,
            setAuthProviderError: setAuthProviderError,
            hasSubpages: hasSubpages,
            setHasSubpages: setHasSubpages,
            dropzoneCancelFnRef: dropzoneCancelFnRef,
            browserCancelFnRef: browserCancelFnRef,
            isUploadingFile: isUploadingFile,
            setIsUploadingFile: setIsUploadingFile,
            isStartingImport: isStartingImport,
            setIsStartingImport: setIsStartingImport,
            fileNameDisplay: fileNameDisplay,
            setFileNameDisplay: setFileNameDisplay,
            fileSizeBytes: fileSizeBytes,
            setFileSizeBytes: setFileSizeBytes,
            filestoreId: filestoreId,
            setFilestoreId: setFilestoreId,
            migrationScopeId: migrationScopeId,
            setMigrationScopeId: setMigrationScopeId,
            migrationId: migrationId,
            setMigrationId: setMigrationId,
            collectionId: collectionId,
            setCollectionId: setCollectionId,
            shouldMapNotionMembers: shouldMapNotionMembers,
            setShouldMapNotionMembers: setShouldMapNotionMembers,
            shouldRenderCloseDrawerModal: shouldRenderCloseDrawerModal,
            setShouldRenderCloseDrawerModal: setShouldRenderCloseDrawerModal,
            shouldRenderIntegrationTokenModal: shouldRenderIntegrationTokenModal,
            setShouldRenderIntegrationTokenModal: setShouldRenderIntegrationTokenModal,
            shouldExportEntities: shouldExportEntities,
            setShouldExportEntities: setShouldExportEntities,
            integrationToken: integrationToken,
            setIntegrationToken: setIntegrationToken,
            shouldAddRemainingMembers: shouldAddRemainingMembers,
            setShouldAddRemainingMembers: setShouldAddRemainingMembers,
            shouldCopyPagePermissions: shouldCopyPagePermissions,
            setShouldCopyPagePermissions: setShouldCopyPagePermissions,
            shouldRenderAccessTokenModal: shouldRenderAccessTokenModal,
            setShouldRenderAccessTokenModal: setShouldRenderAccessTokenModal,
            accessToken: accessToken,
            setAccessToken: setAccessToken,
            refreshToken: refreshToken,
            setRefreshToken: setRefreshToken,
            tokenExpireAt: tokenExpireAt,
            setTokenExpireAt: setTokenExpireAt,
            newSpaceName: newSpaceName,
            setNewSpaceName: setNewSpaceName,
            existingSpace: existingSpace,
            parentPageId: parentPageId,
            setParentPageId: setParentPageIdWithValidation,
            setExistingSpace: setExistingSpace,
            selectedPermissions: selectedPermissions,
            setSelectedPermissions: setSelectedPermissions,
            miroAuthToken: miroAuthToken,
            setMiroAuthToken: setMiroAuthToken,
            miroTeamId: miroTeamId,
            setMiroTeamId: setMiroTeamId,
            miroProjectId: miroProjectId,
            setMiroProjectId: setMiroProjectIdWithValidation,
            clearAllMiroBulkImportTokens: clearAllMiroBulkImportTokens,
            didReceiveMiroBulkApiTokens: didReceiveMiroBulkApiTokens,
            setDidReceiveMiroBulkApiTokens: setDidReceiveMiroBulkApiTokens,
            isNotionWorkspaceImportDisabled: isNotionWorkspaceImportDisabled,
            setIsNotionWorkspaceImportDisabled: setIsNotionWorkspaceImportDisabled,
            isValidatingZip: isValidatingZip,
            setIsValidatingZip: setIsValidatingZip
        }
    }, props.children);
};
const $c73c161a517b87e3$export$316a7de2e8141cc8 = (0, $9zUhf.createHook)($c73c161a517b87e3$export$390f32400eaf98c9);
const $c73c161a517b87e3$export$21ba04a22063ba7c = (0, $9zUhf.createActionsHook)($c73c161a517b87e3$export$390f32400eaf98c9);
module.exports["ImportContentWorkflowContext"] = $c73c161a517b87e3$export$7805c3dc7bda328d;
module.exports["ImportContentWorkflowContextProvider"] = $c73c161a517b87e3$export$4261666d8e0efef2;
module.exports["useImportContentStore"] = $c73c161a517b87e3$export$316a7de2e8141cc8;
module.exports["useImportContentStoreActions"] = $c73c161a517b87e3$export$21ba04a22063ba7c;

});

parcelRegister("8uc8a", function(module, exports) {
var $9db47457289923c5$export$e64befb57ff51d2d = /*#__PURE__*/ function(PermissionOptions) {
    PermissionOptions["RESTRICTED"] = "RESTRICTED";
    PermissionOptions["NOTION"] = "NOTION";
    PermissionOptions["DEFAULT"] = "DEFAULT";
    return PermissionOptions;
}({});
module.exports["PermissionOptions"] = $9db47457289923c5$export$e64befb57ff51d2d;

});

parcelRegister("27ffu", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $0a41942d2e8255bf$export$c0a586b329cae57d = (message, isUploadingFile)=>{
    (0, $42omo.useEffect)(()=>{
        if (isUploadingFile) {
            const handleBeforeUnload = (event)=>{
                event.preventDefault(); // Required to trigger the dialog in some browsers
                event.returnValue = message;
            };
            window.addEventListener('beforeunload', handleBeforeUnload);
            return ()=>{
                window.removeEventListener('beforeunload', handleBeforeUnload);
            };
        }
    }, [
        message,
        isUploadingFile
    ]);
};
module.exports["useBeforeUnload"] = $0a41942d2e8255bf$export$c0a586b329cae57d;

});

parcelRegister("dzqet", function(module, exports) {
var $b9ba7ab256cbc974$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["NOTION"] = "NOTION";
    ContentType["MIRO"] = "MIRO";
    ContentType["HTML"] = "HTML";
    ContentType["MURAL"] = "MURAL";
    return ContentType;
}({});
module.exports["ContentType"] = $b9ba7ab256cbc974$export$e2e108cbe2e4f865;

});

parcelRegister("6jOqx", function(module, exports) {

let $499ba22dcecfbd30$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $499ba22dcecfbd30$var$load("lYvov"),
    $499ba22dcecfbd30$var$load("9hfvd"),
    $499ba22dcecfbd30$var$load("34i5i"),
    $499ba22dcecfbd30$var$load("3ySTn"),
    $499ba22dcecfbd30$var$load("c2rHL"),
    $499ba22dcecfbd30$var$load("1hmnv"),
    $499ba22dcecfbd30$var$load("1faui"),
    $499ba22dcecfbd30$var$load("6wr18"),
    $499ba22dcecfbd30$var$load("7WcBh"),
    $499ba22dcecfbd30$var$load("5uN9h"),
    $499ba22dcecfbd30$var$load("7MlKm"),
    $499ba22dcecfbd30$var$load("Wowvf"),
    $499ba22dcecfbd30$var$load("ffEVr"),
    $499ba22dcecfbd30$var$load("kHOMt"),
    $499ba22dcecfbd30$var$load("hhss7"),
    $499ba22dcecfbd30$var$load("7EorR"),
    $499ba22dcecfbd30$var$load("kUbUu"),
    $499ba22dcecfbd30$var$load("9JWXo")
]).then(()=>parcelRequire('hSRPs'));

});

parcelRegister("f8AFM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jmjWc = parcelRequire("jmjWc");


var $5IN3L = parcelRequire("5IN3L");


var $dzqet = parcelRequire("dzqet");


const $123d8cc31f005f3d$var$ImportContentModalLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "CsuHF",
    name: "ImportContentModalLoader",
    loader: async ()=>(await (parcelRequire("iSGhg"))).ImportContentModal
});
const $123d8cc31f005f3d$export$cf1f5228a529b27e = ()=>{
    const [importContentState, importContentActions] = (0, $5IN3L.useImportContentStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const makeCardClickHandler = (contentType)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'importContentCard',
                    source: 'importContentModal',
                    attributes: {
                        contentType: contentType
                    }
                }
            }).fire();
            importContentActions.setShowImportContentModal(false);
            importContentActions.setContentType(contentType);
            importContentActions.setShouldRenderDrawer(true);
            importContentActions.setShowImportContentDrawer(true);
        };
    return importContentState.shouldRenderModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($123d8cc31f005f3d$var$ImportContentModalLoader, {
        shouldRender: importContentState.showImportContentModal,
        onClose: ()=>importContentActions.setShowImportContentModal(false),
        onMiroClick: makeCardClickHandler((0, $dzqet.ContentType).MIRO),
        onNotionClick: makeCardClickHandler((0, $dzqet.ContentType).NOTION),
        onFileImportClick: makeCardClickHandler((0, $dzqet.ContentType).HTML),
        onMuralClick: makeCardClickHandler((0, $dzqet.ContentType).MURAL)
    }) : null;
};
module.exports["ConditionalImportContentModal"] = $123d8cc31f005f3d$export$cf1f5228a529b27e;

});

parcelRegister("iSGhg", function(module, exports) {

let $dbee108b1367905f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dbee108b1367905f$var$load("6wr18"),
    $dbee108b1367905f$var$load("ffEVr"),
    $dbee108b1367905f$var$load("hhss7"),
    $dbee108b1367905f$var$load("hX5aL")
]).then(()=>parcelRequire('c6LMF'));

});

parcelRegister("gKGjM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $56M4r = parcelRequire("56M4r");


var $inPa6 = parcelRequire("inPa6");


var $fNJG8 = parcelRequire("fNJG8");


var $iI2ST = parcelRequire("iI2ST");


var $ccHMk = parcelRequire("ccHMk");


var $5IN3L = parcelRequire("5IN3L");

const $02de2c54d3c44def$var$i18n = (0, $cgtv4.defineMessages)({
    buttonText: {
        id: "import-content.button.text",
        defaultMessage: "Import from other tools"
    }
});
const $02de2c54d3c44def$export$b0d230bf69c0838c = ({ isNav4Enabled: isNav4Enabled, isMenuButton: isMenuButton = true, closePopup: closePopup })=>{
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, importContentActions] = (0, $5IN3L.useImportContentStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                source: 'importContentButton'
            }
        }).fire();
        importContentActions.setShouldRenderModal(true);
        importContentActions.setShowImportContentModal(true);
        closePopup?.('import content clicked');
    };
    return isMenuButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isNav4Enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iI2ST.ButtonMenuItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fNJG8))), {
            label: "",
            color: "currentColor"
        }),
        onClick: handleClick,
        testId: "import-content-menu-button-nav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $02de2c54d3c44def$var$i18n.buttonText)), !isNav4Enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
        onClick: handleClick,
        testId: "import-content-menu-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $02de2c54d3c44def$var$i18n.buttonText))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: handleClick,
        appearance: "primary",
        testId: "import-content-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $02de2c54d3c44def$var$i18n.buttonText));
};
module.exports["ImportContentButton"] = $02de2c54d3c44def$export$b0d230bf69c0838c;

});

parcelRegister("iI2ST", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $5ujhR = parcelRequire("5ujhR");


var $jjpBv = parcelRequire("jjpBv");

const $d3e054ddee411308$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jjpBv.MenuListItem), {
        ref: listItemRef,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5ujhR.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            /**
					 * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
					 * so they aren't rendered in the disabled state.
					 */ actions: isDisabled ? undefined : actions,
            actionsOnHover: isDisabled ? undefined : actionsOnHover,
            onClick: onClick,
            ariaControls: (0, $dh538.fg)('platform-dst-buttonmenuitem-selected-state-support') ? ariaControls : undefined,
            ariaExpanded: (0, $dh538.fg)('platform-dst-buttonmenuitem-selected-state-support') ? ariaExpanded : undefined,
            ariaHasPopup: (0, $dh538.fg)('platform-dst-buttonmenuitem-selected-state-support') ? ariaHasPopup : undefined,
            isSelected: (0, $dh538.fg)('platform-dst-buttonmenuitem-selected-state-support') ? isSelected : undefined,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});
module.exports["ButtonMenuItem"] = $d3e054ddee411308$export$6dc09b7c0ec1dfcd;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("kxN5Y"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("kxN5Y", function(module, exports) {

let $ef4cf9036132d263$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef4cf9036132d263$var$load("2PePB"),
    $ef4cf9036132d263$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("4vC63", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("fQP2E", function(module, exports) {

let $b8a34e2c7f685c8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b8a34e2c7f685c8a$var$load("7WaUI"),
    $b8a34e2c7f685c8a$var$load("dIKKx")
]).then(()=>parcelRequire('eYRFW'));

});

parcelRegister("aOp12", function(module, exports) {

let $7df1fa848f3b84e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7df1fa848f3b84e9$var$load("52dqm").then(()=>parcelRequire('3zSMJ'));

});

parcelRegister("gsyUw", function(module, exports) {

let $bfba57616104aae4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bfba57616104aae4$var$load("7WaUI"),
    $bfba57616104aae4$var$load("gIOIL")
]).then(()=>parcelRequire('gLUng'));

});

parcelRegister("4R3wx", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {

var $dHiKK = parcelRequire("dHiKK");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $i8Ofl = parcelRequire("i8Ofl");

const $45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery = (0, $dHiKK.default);
const $45094daeb894a50e$export$5d821a9fc4b7faa = ()=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        variables: {
            cloudId: cloudId
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<b0fb41d42738db4128917afea956b213>>
 * @relayHash 255e1eee858b61b7fb061e8b9eb8fbc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceLoomEntryPoints",
            "kind": "LinkedField",
            "name": "confluence_loomEntryPoints",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLoomEntryPointsEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "255e1eee858b61b7fb061e8b9eb8fbc9",
            "id": "52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "767e6480b08dd1cf6643fe7ca065c357";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("cYe4v", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId,
        environment
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("5CUwy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cbc8g = parcelRequire("cbc8g");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");



var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default)
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    retryWait: 500
                });
                (0, $cbc8g.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $1P1Tu.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $9zUhf.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $9zUhf.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserPermissionStatus"] = $9633e2f0bea217d1$export$85de6c803181afa9;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;
module.exports["useLoomEntryPointVariantActions"] = $9633e2f0bea217d1$export$fd0650c7a15c6ef2;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<e139440afb86fce20d0d7fdd22b96ac3>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
            "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "21c387cdafea215b61e4183319580a69";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("eNjW4", function(module, exports) {

var $5spQU = parcelRequire("5spQU");


var $lzcvT = parcelRequire("lzcvT");


var $9wGTI = parcelRequire("9wGTI");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = ()=>{
    const isInFedRamp = (0, $lzcvT.isFedRamp)();
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    // When the gate is ON, we use the feature-encoding SDK to check if the feature is enabled in the current environment
    const isLoomFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-loom-integration') : !isInFedRamp;
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("5GjsS", function(module, exports) {
const $fb693db220d77333$export$f8ada5a979213a3d = 'lamnic-user-clicked-on-meeting-notes';
module.exports["USER_HAS_CLICKED_ON_MEETING_NOTES_TEMPLATE_KEY"] = $fb693db220d77333$export$f8ada5a979213a3d;

});

parcelRegister("j8xJB", function(module, exports) {

let $dee8eea50999a089$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dee8eea50999a089$var$load("1hmnv"),
    $dee8eea50999a089$var$load("1faui"),
    $dee8eea50999a089$var$load("jfplD"),
    $dee8eea50999a089$var$load("9ET5T"),
    $dee8eea50999a089$var$load("lkOIY"),
    $dee8eea50999a089$var$load("7WaUI"),
    $dee8eea50999a089$var$load("jXx9i"),
    $dee8eea50999a089$var$load("ktyyJ")
]).then(()=>parcelRequire('1VYG6'));

});

parcelRegister("i5Ioa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $9wGTI = parcelRequire("9wGTI");


var $kmyZQ = parcelRequire("kmyZQ");


var $2TpIg = parcelRequire("2TpIg");

const $2a2fcb666bddc8b3$export$c17561cb55d4db30 = /*#__PURE__*/ (0, $42omo.memo)(({ theme: theme, isNav4: isNav4 })=>{
    if ((0, $9wGTI.fg)('confluence_hide_loading_bar_all_types')) return null;
    const highlightColor = theme && theme.mode.productHome.backgroundColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kmyZQ.ProgressBarContainer)
        ]
    }, (progressBar)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2TpIg.WrappedProgressBar), {
            highlightColor: highlightColor,
            status: progressBar.getStatus(),
            progressBar: progressBar,
            duration: progressBar.getDuration(),
            isNav4: isNav4
        }));
});
module.exports["ProgressBar"] = $2a2fcb666bddc8b3$export$c17561cb55d4db30;

});

parcelRegister("2TpIg", function(module, exports) {
/* eslint react/no-danger: 0 */ /* eslint @atlaskit/ui-styling-standard/no-global-styles: 0 */ 
var $42omo = parcelRequire("42omo");


var $1ps47 = parcelRequire("1ps47");


var $ec2MS = parcelRequire("ec2MS");


var $76b2E = parcelRequire("76b2E");

const $c75afe39495ae8f4$var$getStyledAttributes = (status, duration, ssrProgressBarDuration, ssrProgressBarLoadPercent)=>{
    switch(status){
        case 'START':
            return {
                transform: 'scaleX(0.99)',
                transitionDuration: `${duration}ms`
            };
        case 'FINISH':
            return {
                transform: 'scaleX(1)',
                transitionDuration: `${0, $1ps47.EXIT_ANIMATION_SPEED}ms`
            };
        case 'DELAYED':
            return {
                animation: 'shimmer 1200ms infinite',
                isDelayed: true,
                transform: 'scaleX(1)',
                transitionDuration: '0ms'
            };
        case 'SSR':
            // When browser is rendering the static HTML progress from 0 to 1/3
            // Then when SPA loads proceed from 33.33% to 99%, then 100% when apdex ends
            return {
                // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                animation: 'none',
                transform: `scaleX(${ssrProgressBarLoadPercent / 100})`,
                transitionDuration: '0ms'
            };
        case 'RESET':
        default:
            return {
                animation: 'none',
                transform: `scaleX(0)`,
                transitionDuration: '0ms'
            };
    }
};
//start Nav 4 styles
const $c75afe39495ae8f4$var$generateLoadingBarStyles = ({ animation: animation = 'none', background: background, isDelayed: isDelayed, transform: transform, isNav4: isNav4, transitionDuration: transitionDuration })=>{
    return `
	body::before{
    content: '';
    display: block;
    animation: ${animation};
	  background: ${// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    background};
    height: 2px;
    z-index: 999;
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
	transform: ${transform};
	transition-duration: ${transitionDuration};
    transform-origin: 0 0;
    will-change: transform;
  }
  ${''}
	${isDelayed ? ` @keyframes shimmer { from { left: -15%; width: 15%; } to { left: 115%; width: 15%; } }` : ''}
	${isNav4 ? `opacity: '0.6',
	position: 'absolute',
	transformOrigin: '0 0',
	width: '100%',
	willChange: 'transform'` : ''}
	${// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    isNav4 && isDelayed && true ? `@keyframes shimmer {
			from: { left: '-15%', width: '15%' },
			to: { left: '115%', width: '15%' }
		}` : ''}
	${''}
	${''}
`;
};
const $c75afe39495ae8f4$export$fa6e04c8cb414d0e = ({ highlightColor: highlightColor = (0, $1ps47.DEFAULT_LOADING_BAR_COLOR), status: status, duration: duration, progressBar: progressBar, isNav4: isNav4 })=>{
    const ssrAttributes = $c75afe39495ae8f4$var$getStyledAttributes('SSR', 0, 6000, 80);
    // Initially, set progress bar to 0%, this ensures that progress bar does not start with 99% on the first load
    const initialAttributes = $c75afe39495ae8f4$var$getStyledAttributes('RESET', duration, 6000, 80);
    const [attributes, setAttributes] = (0, $42omo.useState)(// If the page is currently rendering on the server-side or was rendered on server-side
    // We need to set the start point synchronously
    status === 'SSR' ? ssrAttributes : initialAttributes);
    (0, $ec2MS.useProgressBarController)(progressBar);
    (0, $76b2E.useProgressBarListenerController)(progressBar);
    /**
	 * this logic (useEffect -> setTimeout -> setState) is necessary to fix a
	 * rendering issue where the progress bar animation starts loading at 99%.
	 * this should be investigated more and solved in a future ticket.
	 */ (0, $42omo.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            setAttributes($c75afe39495ae8f4$var$getStyledAttributes(status, duration, 6000, 80));
        }, 0);
        return ()=>clearTimeout(timeout);
    }, [
        duration,
        status
    ]);
    const dynamicLoadingStyles = $c75afe39495ae8f4$var$generateLoadingBarStyles({
        ...attributes,
        background: highlightColor
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", {
        "data-testid": isNav4 ? (0, $1ps47.NAV4_ID) : (0, $1ps47.NAV3_ID),
        dangerouslySetInnerHTML: {
            __html: dynamicLoadingStyles
        },
        "data-vc": `global-progress-bar-nav${isNav4 ? '4' : '3'}`
    });
};
module.exports["WrappedProgressBar"] = $c75afe39495ae8f4$export$fa6e04c8cb414d0e;

});

parcelRegister("ec2MS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7zgzO = parcelRequire("7zgzO");


var $lSOAM = parcelRequire("lSOAM");


var $9wGTI = parcelRequire("9wGTI");


var $9sGCn = parcelRequire("9sGCn");


var $98zed = parcelRequire("98zed");

/**
 * "contentSlug" is changable due to url encode, content title contains special charactor, changed title, etc.
 * If "contentSlug" changed, URL will be redirected, but the page content won't rerender.
 * In this case, the progress bar should not show up.
 * To handle that, use "contentId" as screen's identity, instead of pathname.
 * Assuming if a URL contains "contentSlug" param, then it much contains "contentId" as well.
 * The above assumption is valid according to: next/packages/named-routes/src/index.ts
 *
 * Another circumstance that progress bar should not show up is, when blog post url changed from pattern VIEW_BLOG_DATE_LEGACY to VIEW_BLOG or conversely.
 */ function $953a05b2dab9a5d3$var$isPreviousPage(match, prevMatch) {
    if (match && match.params && match.name && prevMatch && prevMatch.params && prevMatch.name && (match.name === prevMatch.name || match.name.startsWith('VIEW_BLOG') && prevMatch.name.startsWith('VIEW_BLOG') && 'contentSlug' in match.params && 'contentSlug' in prevMatch.params || match.name === 'HOME' && prevMatch.name === 'WIKI')) return prevMatch.params.contentId === match.params.contentId;
    return false;
}
const $953a05b2dab9a5d3$export$724ea2b284503598 = (progressBar)=>{
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const livePageSSRStatus = (0, $98zed.useIsLivePageWithSSR)();
    (0, $42omo.useEffect)(()=>{
        const shouldHideProgressBar = ()=>{
            const conditions = [
                ()=>{
                    // Hide the progress bar for all live pages.
                    if (!(0, $9wGTI.fg)('confluence_perceived_perf_hide_loading_bar')) return false;
                    // Check for SSR'd live page. If it is, hide the progress bar.
                    if (livePageSSRStatus?.isTypeKnown && livePageSSRStatus?.isLive) return true;
                    // Check for non-SSR'd live data from live pages fast loading. If it is, hide the progress bar.
                    const { subType: subType, isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(match?.params.contentId);
                    const isLivePage = subType === 'live' && isArchived === false;
                    return isLivePage && match?.name === 'VIEW_PAGE';
                }
            ];
            return conditions.some((condition)=>condition());
        };
        if (!$953a05b2dab9a5d3$var$isPreviousPage(match, progressBar.prevMatch)) {
            // These are special conditions where we hide the progress bar for perceived performance experiments.
            if (shouldHideProgressBar()) progressBar.reset();
            else if ((0, $lSOAM.isBMPageLoad)(match) && (0, $lSOAM.hasBMPageLoadStarted)()) progressBar.start();
            else progressBar.reset();
        }
        progressBar.prevMatch = match;
        return ()=>{
            progressBar.reset();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        match && match.pathname
    ]);
};
module.exports["useProgressBarController"] = $953a05b2dab9a5d3$export$724ea2b284503598;

});

parcelRegister("9sGCn", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $hp2SH = parcelRequire("hp2SH");


var $gKr8t = parcelRequire("gKr8t");


var $ge2sX = parcelRequire("ge2sX");


var $9p0fU = parcelRequire("9p0fU");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $9p0fU.ContentSubTypeAndStatusFragment)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $9p0fU.ContentSubTypeFragment)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $9p0fU.PTPageSubTypeFragment)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $9p0fU.SearchConfluencePageBlogAttachmentSubTypeFragment)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $2XqLN.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    const ccGqlClient = (0, $hp2SH.getApolloClient)();
    const aggGqlClient = (0, $gKr8t.getAGGClient)();
    const clientMap = {
        ["Cc graphql client"]: ccGqlClient,
        ["Agg graphql client"]: aggGqlClient
    };
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            // This approach is duplicated in /confluence/next/packages/editor-features/src/utils/getCachedPageTitle.ts
            // and should be migrated to readFragmentInterop.
            const fragmentData = clientMap[client].readFragment({
                id: id,
                fragment: fragment
            });
            if (fragmentData?.subType) {
                subType = fragmentData.subType;
                isArchived = fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData?.confluenceEntity?.subtype) {
                // In search graphql query's response, subtype exists in the confluenceEntity object
                subType = fragmentData.confluenceEntity.subtype.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("9p0fU", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $f3357fc24ccca23a$export$6345dfb10a0b6cbe = (0, $eSUdr.default)`fragment SubTypeAndStatusContentFragment on Content{id subType status}`;
const $f3357fc24ccca23a$export$4121dd5434380612 = (0, $eSUdr.default)`fragment SubTypeContentFragment on Content{id subType}`;
const $f3357fc24ccca23a$export$e7df79006c7c4a55 = (0, $eSUdr.default)`fragment SubTypePageTreeFragment on PTPage{id subType}`;
const $f3357fc24ccca23a$export$e77fa03b04da6df0 = (0, $eSUdr.default)`fragment SubTypeFragment on SearchConfluencePageBlogAttachment{id confluenceEntity{subtype}}`;
module.exports["ContentSubTypeAndStatusFragment"] = $f3357fc24ccca23a$export$6345dfb10a0b6cbe;
module.exports["ContentSubTypeFragment"] = $f3357fc24ccca23a$export$4121dd5434380612;
module.exports["PTPageSubTypeFragment"] = $f3357fc24ccca23a$export$e7df79006c7c4a55;
module.exports["SearchConfluencePageBlogAttachmentSubTypeFragment"] = $f3357fc24ccca23a$export$e77fa03b04da6df0;

});

parcelRegister("98zed", function(module, exports) {

var $dPJCf = parcelRequire("dPJCf");


var $eNbbn = parcelRequire("eNbbn");

const $91141199ce9a5735$export$899773b8bcad4fc7 = ()=>{
    const isTransition = (0, $dPJCf.useIsTransition)();
    const ssrStatus = (0, $eNbbn.useLivePageSSRStatus)();
    if (!ssrStatus.isTypeKnown && isTransition) return {
        isLive: undefined,
        isTypeKnown: false
    };
    return ssrStatus;
};
module.exports["useIsLivePageWithSSR"] = $91141199ce9a5735$export$899773b8bcad4fc7;

});

parcelRegister("76b2E", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ew3Dj = parcelRequire("ew3Dj");

const $fb45058d7703419b$export$70df3474f6d5549 = (progressBar)=>{
    const { start: start, finish: finish } = progressBar;
    const postMessageHandler = (0, $42omo.useCallback)((event)=>{
        if (event.data && event.data.eventType == (0, $ew3Dj.START_MESSAGE_TYPE)) start(event.data.startDuration, event.data.delayDuration);
        if (event.data && event.data.eventType == (0, $ew3Dj.FINISH_MESSAGE_TYPE)) finish();
    }, [
        start,
        finish
    ]);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener('message', postMessageHandler);
        return ()=>{
            window.removeEventListener('message', postMessageHandler);
        };
    }, [
        postMessageHandler
    ]);
};
module.exports["useProgressBarListenerController"] = $fb45058d7703419b$export$70df3474f6d5549;

});

parcelRegister("ew3Dj", function(module, exports) {
const $d8f8f2e6d4b52281$export$2613057e8390a95c = 'start_progress_bar';
const $d8f8f2e6d4b52281$export$87f9c116a4a9abb1 = 'finish_progress_bar';
module.exports["START_MESSAGE_TYPE"] = $d8f8f2e6d4b52281$export$2613057e8390a95c;
module.exports["FINISH_MESSAGE_TYPE"] = $d8f8f2e6d4b52281$export$87f9c116a4a9abb1;

});

parcelRegister("2cEww", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b04916d9a8148b2$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $9x4nt = parcelRequire("9x4nt");


var $feexy = parcelRequire("feexy");


var $4u5NT = parcelRequire("4u5NT");

function $5b04916d9a8148b2$export$2e2bcd8739ae039({ dataKey: dataKey, value: value }) {
    const interactionContext = (0, $42omo.useContext)((0, $9x4nt.default));
    (0, $42omo.useMemo)(()=>{
        if (!interactionContext) return;
        const interactionId = (0, $feexy.getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        (0, $4u5NT.addCohortingCustomData)(currentInteractionId, dataKey, value);
    }, [
        dataKey,
        value,
        interactionContext
    ]);
    return null;
}
function $5b04916d9a8148b2$export$f9c6890b323d326b(key, value) {
    const interactionId = (0, $feexy.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $4u5NT.addCohortingCustomData)(currentInteractionId, key, value);
}
module.exports["addUFOCustomCohortData"] = $5b04916d9a8148b2$export$f9c6890b323d326b;

});

parcelRegister("fQudG", function(module, exports) {

let $b8932758dfb3687a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8932758dfb3687a$var$load("dj3mE").then(()=>parcelRequire('2pYxO'));

});

parcelRegister("jZl47", function(module, exports) {

let $e8d40df7924f1192$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e8d40df7924f1192$var$load("li9sm"),
    $e8d40df7924f1192$var$load("hhss7"),
    $e8d40df7924f1192$var$load("jXx9i"),
    $e8d40df7924f1192$var$load("gmwfN")
]).then(()=>parcelRequire('53kS0'));

});

parcelRegister("2qwfL", function(module, exports) {

let $1c47074bd9799721$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c47074bd9799721$var$load("bP6pn").then(()=>parcelRequire('iII7v'));

});

parcelRegister("7DERG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b0c65948d0a153f5$export$92e41deae5b713d0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "c07Cp",
    name: 'ConfluenceSmartCreationModalLoader',
    loader: async ()=>(await (parcelRequire("gXz7g"))).ConfluenceSmartCreationModalManager
});
module.exports["ConfluenceSmartCreationModalLoader"] = $b0c65948d0a153f5$export$92e41deae5b713d0;

});

parcelRegister("gXz7g", function(module, exports) {

let $c58d65637ab6e9ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c58d65637ab6e9ee$var$load("gs8si").then(()=>parcelRequire('iaA9H'));

});

parcelRegister("2Rith", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $j4EkW = parcelRequire("j4EkW");

const $0f73dde994861ed0$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $0f73dde994861ed0$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $j4EkW.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $42omo.useMemo)(()=>{
        $0f73dde994861ed0$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ifW2H.AIEventsInstrumentationContext).Provider, {
        value: contextValue,
        children: children
    });
};
module.exports["AIEventsInstrumentationProvider"] = $0f73dde994861ed0$export$b5d4bc85dfbaa4f8;

});

parcelRegister("gWF6I", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $JyXl5 = parcelRequire("JyXl5");

function $8122506f239babd4$export$6c22afad970ad5ac({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $irOoi.RelayEnvironmentProvider), {
        environment: (0, $JyXl5.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__),
        children: children
    });
}
const $8122506f239babd4$export$43b1f3e917d65526 = $8122506f239babd4$export$6c22afad970ad5ac;
const $8122506f239babd4$export$2f6292af3d34630d = ({ children: children })=>{
    const isRelayPresent = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, $l998X.jsx)($8122506f239babd4$export$6c22afad970ad5ac, {
        children: children
    });
};
function $8122506f239babd4$export$e237a628f59c9f4e() {
    const environment = (0, $irOoi.useRelayEnvironment)();
    return (0, $42omo.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}
module.exports["AtlassianRelayEnvironmentProvider"] = $8122506f239babd4$export$6c22afad970ad5ac;
module.exports["RelayEnvironmentProvider"] = $8122506f239babd4$export$43b1f3e917d65526;
module.exports["ConditionalRelayEnvironmentProvider"] = $8122506f239babd4$export$2f6292af3d34630d;
module.exports["useRelayEnvironmentProvider"] = $8122506f239babd4$export$e237a628f59c9f4e;

});

parcelRegister("JyXl5", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $aPmQM = parcelRequire("aPmQM");


var $hvWxm = parcelRequire("hvWxm");


var $kzjMJ = parcelRequire("kzjMJ");

const $e443eef90c98bdab$var$getLoggingAndMetricsHelper = ()=>{
    return {
        logNonBreakingErrors: ()=>{},
        logError: ()=>{},
        logErrorRetry: ()=>{},
        logQueryFallbackToPost: ()=>{}
    };
};
const $e443eef90c98bdab$export$4a639ebead870a0c = new (0, $kzjMJ.SSRQueryResponseCache)({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $e443eef90c98bdab$export$df54517d175e6d6b = (0, $aPmQM.createRelayEnvironment)({
    networkOptions: {
        getLoggingAndMetricsHelper: $e443eef90c98bdab$var$getLoggingAndMetricsHelper,
        withErrorHandling: (source)=>source,
        validateResponse: (request, response)=>{
            const errors = 'errors' in response ? response.errors : undefined;
            if (errors != null) {
                const requestId = response?.extensions?.gateway?.request_id;
                (0, $hvWxm.captureErrors)(errors, {
                    operationName: request.name,
                    requestId: requestId
                });
                if ((0, $dh538.fg)('platform_relay_redirect_on_step_up_auth_studio')) {
                    const { hasStepUpAuthError: hasStepUpAuthError, stepUpUrl: stepUpUrl } = (0, $hvWxm.isStepUpAuthError)(errors);
                    if (hasStepUpAuthError && stepUpUrl) window.location.href = stepUpUrl;
                }
            }
            return true;
        },
        onInvalidResponse: ()=>{},
        queryResponseCache: $e443eef90c98bdab$export$4a639ebead870a0c,
        isServer: globalThis.__SERVER__
    }
});
module.exports["__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__"] = $e443eef90c98bdab$export$df54517d175e6d6b;

});

parcelRegister("aPmQM", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");


var $3tMMZ = parcelRequire("3tMMZ");

function $e57f333731aa23ab$export$7afaa9c867644497(environmentOptions) {
    const options = (0, $3tMMZ.getSharedRelayEnvironmentConfig)(environmentOptions);
    return new (0, $3e6Uc.Environment)(options);
}
module.exports["createRelayEnvironment"] = $e57f333731aa23ab$export$7afaa9c867644497;

});

parcelRegister("kzjMJ", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");

function $55e864d84c99338e$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $3e6Uc.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $55e864d84c99338e$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $55e864d84c99338e$export$be21c283b097d175 extends (0, $3e6Uc.QueryResponseCache) {
    /**
   * @deprecated only sets a single response; does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
   * Stores a GraphQLRepsonse along with metadata about the call.
   * If called multiple times (such as when incremental payloads are received),
   * will update the stored response to be an array of GraphQLSingularResponse objects,
   * which Relay is happy to handle.
   * @deprecated works, but does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
   * Deletes a request from the store, if found.
   *
   * IMPORTANT: Make sure DELETE method always has tests that include get/set
   * to ensure our `getCacheKey` matches Relay's.
   *
   * @returns {boolean} indicating if an entry in the cache was deleted
   */ delete(queryID, variables) {
        const cacheKey = $55e864d84c99338e$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
    constructor({ cacheName: cacheName, size: size, ttl: ttl, timeoutCallback: timeoutCallback }){
        super({
            size: size,
            ttl: ttl
        });
        this.cacheName = void 0;
        this.requestMetadata = void 0;
        const isServer = typeof window === 'undefined';
        const cachedData = isServer ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!isServer) setTimeout(()=>{
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            timeoutCallback?.(this._responses, this.requestMetadata);
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
}
module.exports["SSRQueryResponseCache"] = $55e864d84c99338e$export$be21c283b097d175;

});

parcelRegister("aU1TP", function(module, exports) {

var $9TRAA = parcelRequire("9TRAA");

var $ae4e7949267550f2$export$eb3237121301a5e5 = /*#__PURE__*/ function(AudioStreamingState) {
    AudioStreamingState["UNINITIALIZED"] = "uninitialized";
    AudioStreamingState["LOADING"] = "loading";
    AudioStreamingState["ERROR"] = "error";
    AudioStreamingState["STREAM_STARTED"] = "stream_started";
    AudioStreamingState["STREAM_DISPOSED"] = "stream_disposed";
    return AudioStreamingState;
}({});
const $ae4e7949267550f2$export$a0ed58682f50d27c = (0, $9TRAA.e)({
    state: "uninitialized"
});
const $ae4e7949267550f2$export$218145c33c4aee2e = (action)=>{
    switch(action.type){
        case "uninitialized":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "uninitialized"
            });
            break;
        case "loading":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "loading"
            });
            break;
        case "error":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "error",
                error: action.error
            });
            break;
        case "stream_started":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "stream_started",
                response: action.response
            });
            break;
        case "stream_disposed":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "stream_disposed"
            });
            break;
    }
};
module.exports["AudioStreamingState"] = $ae4e7949267550f2$export$eb3237121301a5e5;
module.exports["audioPlayerStreamingStore"] = $ae4e7949267550f2$export$a0ed58682f50d27c;
module.exports["setAudioPlayerStreamingStore"] = $ae4e7949267550f2$export$218145c33c4aee2e;

});

parcelRegister("4wsPv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lbhE8 = parcelRequire("lbhE8");


var $aU1TP = parcelRequire("aU1TP");

const $441d910c6d0db13d$export$9ea8ebe6968f73b1 = ()=>{
    const state = (0, $lbhE8.useAtom)((0, $aU1TP.audioPlayerStreamingStore));
    const updateAudioPlayerStreamingStore = (0, $42omo.useCallback)((action)=>{
        (0, $aU1TP.setAudioPlayerStreamingStore)(action);
    }, []);
    return {
        state: state,
        updateAudioPlayerStreamingStore: updateAudioPlayerStreamingStore
    };
};
module.exports["useAudioPlayerStreamingStore"] = $441d910c6d0db13d$export$9ea8ebe6968f73b1;

});

parcelRegister("dxfEr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");

const $28fbd8955423911a$export$26781781bc6ae697 = ({ channel: channel } = {
    channel: (0, $3pfAb.FabricChannel).atlaskit
})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendUIEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire(channel);
    }, [
        channel,
        createAnalyticsEvent
    ]);
    const sendTrackEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire(channel);
    }, [
        channel,
        createAnalyticsEvent
    ]);
    const sendOperationalEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire(channel);
    }, [
        channel,
        createAnalyticsEvent
    ]);
    const sendScreenEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire(channel);
    }, [
        channel,
        createAnalyticsEvent
    ]);
    return {
        sendUIEvent: sendUIEvent,
        sendTrackEvent: sendTrackEvent,
        sendOperationalEvent: sendOperationalEvent,
        sendScreenEvent: sendScreenEvent
    };
};
module.exports["usePlatformInstrumentation"] = $28fbd8955423911a$export$26781781bc6ae697;

});

parcelRegister("lAJUP", function(module, exports) {

var $42omo = parcelRequire("42omo");

'use client';
const $fb8093ab2fb0a0e7$export$b16d9fb1a22de840 = (0, $42omo.createContext)(null);
const $fb8093ab2fb0a0e7$var$initialState = {
    didCatch: false,
    error: null
};
class $fb8093ab2fb0a0e7$export$e926676385687eaf extends (0, $42omo.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $fb8093ab2fb0a0e7$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $42omo.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $42omo.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $42omo.createElement)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $fb8093ab2fb0a0e7$var$initialState;
    }
}
function $fb8093ab2fb0a0e7$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $fb8093ab2fb0a0e7$export$c052f6604b7d51fe() {
    const context = (0, $42omo.useContext)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840);
    $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $42omo.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $42omo.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $42omo.forwardRef)((props, ref)=>(0, $42omo.createElement)($fb8093ab2fb0a0e7$export$e926676385687eaf, errorBoundaryProps, (0, $42omo.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}
module.exports["ErrorBoundary"] = $fb8093ab2fb0a0e7$export$e926676385687eaf;
module.exports["withErrorBoundary"] = $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7;

});

parcelRegister("4Gau4", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7hpmn = parcelRequire("7hpmn");


var $ig6yX = parcelRequire("ig6yX");


var $4c48T = parcelRequire("4c48T");


var $jtTDB = parcelRequire("jtTDB");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $4QtAs = parcelRequire("4QtAs");

const $c747837ed372cb4a$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $4c48T.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $ig6yX.easeInOut) } = {})=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $jtTDB.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $jtTDB.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $c747837ed372cb4a$export$204d7b6d1491a2d3 = ({ children: children, ...props })=>{
    const resizing = $c747837ed372cb4a$export$da99457d6430d83(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: children(resizing)
    });
};
module.exports["useResizingHeight"] = $c747837ed372cb4a$export$da99457d6430d83;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("4QtAs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dclyF = parcelRequire("dclyF");

const $0136602141ebd577$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $42omo.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dclyF.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $0136602141ebd577$export$9e95200239cd148b;

});

parcelRegister("bXYW5", function(module, exports) {

let $8b64790162012713$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8b64790162012713$var$load("kiGNy"),
    $8b64790162012713$var$load("aLGWB")
]).then(()=>parcelRequire('bcsjp'));

});

parcelRegister("CQuUR", function(module, exports) {

let $074c45a9dcbabc63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $074c45a9dcbabc63$var$load("kiGNy"),
    $074c45a9dcbabc63$var$load("ivNGg")
]).then(()=>parcelRequire('6gH5T'));

});

parcelRegister("afBrg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28e818db41afcf6fce742cecb9d4361e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $776858abadb4b212$var$_react = $776858abadb4b212$var$_interopRequireDefault((parcelRequire("42omo")));

var $776858abadb4b212$var$_baseNew = $776858abadb4b212$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $776858abadb4b212$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeAudioBriefing".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Audio Briefings, a new feature launching within Confluence to help people develop an expanded awareness on a topic by generating AI-powered podcasts about their work.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $776858abadb4b212$var$AiGenerativeAudioBriefingIcon = (props)=>/*#__PURE__*/ $776858abadb4b212$var$_react.default.createElement($776858abadb4b212$var$_baseNew.default, Object.assign({
        name: "AiGenerativeAudioBriefingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0c.97 0 1.88.2 2.72.55l-.24.09c-.52.19-.93.56-1.19 1.02A5.5 5.5 0 0 0 2.5 7v.71A2.5 2.5 0 0 1 6 10v3.08A1.92 1.92 0 0 1 4.08 15 3.08 3.08 0 0 1 1 12V7a7 7 0 0 1 7-7M3.5 9a1 1 0 0 0-1 1v1.92c0 .87.71 1.58 1.58 1.58.23 0 .42-.19.42-.42V10a1 1 0 0 0-1-1m11.46-2.78Q15 6.6 15 7v5a3.08 3.08 0 0 1-3.08 3A1.92 1.92 0 0 1 10 13.08V10a2.5 2.5 0 0 1 3.5-2.29v-.73a2.25 2.25 0 0 0 1.46-.77M12.5 9a1 1 0 0 0-1 1v3.08c0 .23.19.42.42.42.87 0 1.58-.71 1.58-1.58V10a1 1 0 0 0-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M13.365.009a.75.75 0 0 1 .541.378l.05.106.334.92a.5.5 0 0 0 .298.297l.919.335a.75.75 0 0 1 0 1.41l-.92.335a.5.5 0 0 0-.297.298l-.335.919a.75.75 0 0 1-1.41 0l-.335-.92a.5.5 0 0 0-.298-.297l-.919-.335a.75.75 0 0 1-.484-.589L10.5 2.75l.009-.116a.75.75 0 0 1 .484-.59l.92-.334a.5.5 0 0 0 .297-.298l.335-.919A.75.75 0 0 1 13.249 0z"/>`
    }, props));
$776858abadb4b212$var$AiGenerativeAudioBriefingIcon.displayName = 'AiGenerativeAudioBriefingIcon';
var $776858abadb4b212$var$_default = module.exports.default = $776858abadb4b212$var$AiGenerativeAudioBriefingIcon;

});

parcelRegister("eq3pJ", function(module, exports) {

var $6otn0 = parcelRequire("6otn0");


var $CAM5Y = parcelRequire("CAM5Y");


var $5vJ4Q = parcelRequire("5vJ4Q");


var $iA9co = parcelRequire("iA9co");

var $93a7a8b84b793666$require$Buffer = $iA9co.Buffer;
const $93a7a8b84b793666$var$generateAudioSharePayload = (feature, supportingContent)=>{
    if (feature === (0, $CAM5Y.AudioFeatureType).BRIEFING) return supportingContent.map((content)=>`${content.ari},${content.link}`).join(',');
    return '';
};
const $93a7a8b84b793666$var$generateCompressedAndEncodedAudioShareValue = (feature, supportingContent)=>{
    const payload = $93a7a8b84b793666$var$generateAudioSharePayload(feature, supportingContent);
    const audioShareValue = `feature=${feature};type=${(0, $5vJ4Q.AudioSharingVersion).V1};payload=${payload}`;
    const compressedAudioShareValue = (0, $6otn0.gzipSync)(new TextEncoder().encode(audioShareValue));
    return $93a7a8b84b793666$require$Buffer.from(compressedAudioShareValue).toString('base64');
};
const $93a7a8b84b793666$export$74cf488b6935d40f = (mainSourceUrl, feature, supportingContent)=>{
    const url = new URL(mainSourceUrl);
    const audioShareValue = $93a7a8b84b793666$var$generateCompressedAndEncodedAudioShareValue(feature, supportingContent);
    url.searchParams.set('audioShare', audioShareValue);
    return url.toString();
};
const $93a7a8b84b793666$var$parseAudioSharePayload = (payload)=>{
    const combinedSources = payload.split(',').filter(Boolean);
    if (combinedSources.length % 2 !== 0) return [];
    const supportingContent = [];
    for(let i = 0; i < combinedSources.length; i += 2)supportingContent.push({
        ari: combinedSources[i],
        link: combinedSources[i + 1]
    });
    return supportingContent;
};
const $93a7a8b84b793666$var$decompressAudioShareValue = (encodedValue)=>{
    try {
        const compressedArray = Uint8Array.from($93a7a8b84b793666$require$Buffer.from(encodedValue, 'base64'));
        const decompressedArray = (0, $6otn0.gunzipSync)(compressedArray);
        const audioShareValue = new TextDecoder().decode(decompressedArray);
        const entries = audioShareValue.split(';').map((part)=>part.split('='));
        const data = Object.fromEntries(entries);
        return {
            feature: data.feature || '',
            type: data.type || '',
            payload: data.payload || ''
        };
    } catch  {
        return null;
    }
};
const $93a7a8b84b793666$export$74d89d4e604f8429 = (audioShareLink)=>{
    const defaultResult = {
        feature: (0, $CAM5Y.AudioFeatureType).BRIEFING,
        supportingContent: []
    };
    try {
        const url = new URL(audioShareLink);
        const encodedValue = url.searchParams.get('audioShare');
        if (!encodedValue) return defaultResult;
        const parsedData = $93a7a8b84b793666$var$decompressAudioShareValue(encodedValue);
        if (!parsedData) return defaultResult;
        if (parsedData.type !== (0, $5vJ4Q.AudioSharingVersion).V1) return {
            feature: parsedData.feature || (0, $CAM5Y.AudioFeatureType).BRIEFING,
            supportingContent: []
        };
        return {
            feature: parsedData.feature || (0, $CAM5Y.AudioFeatureType).BRIEFING,
            supportingContent: $93a7a8b84b793666$var$parseAudioSharePayload(parsedData.payload)
        };
    } catch  {
        return defaultResult;
    }
};
module.exports["generateAudioShareLink"] = $93a7a8b84b793666$export$74cf488b6935d40f;
module.exports["parseAudioShareLink"] = $93a7a8b84b793666$export$74d89d4e604f8429;

});

parcelRegister("5vJ4Q", function(module, exports) {
const $506afddc853935f8$export$c944456865027afe = {
    V1: '1'
};
module.exports["AudioSharingVersion"] = $506afddc853935f8$export$c944456865027afe;

});

parcelRegister("jY68A", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::840e9064aa0761adacec2a7ce2dee628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03c064ac252dc790$var$_react = $03c064ac252dc790$var$_interopRequireDefault((parcelRequire("42omo")));

var $03c064ac252dc790$var$_baseNew = $03c064ac252dc790$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $03c064ac252dc790$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $03c064ac252dc790$var$SyncIcon = (props)=>/*#__PURE__*/ $03c064ac252dc790$var$_react.default.createElement($03c064ac252dc790$var$_baseNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$03c064ac252dc790$var$SyncIcon.displayName = 'SyncIcon';
var $03c064ac252dc790$var$_default = module.exports.default = $03c064ac252dc790$var$SyncIcon;

});

parcelRegister("9pS9R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bacc7e4688824042b7c7acb7148b6a10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6db0757f75190298$var$_react = $6db0757f75190298$var$_interopRequireDefault((parcelRequire("42omo")));

var $6db0757f75190298$var$_baseNew = $6db0757f75190298$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6db0757f75190298$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6db0757f75190298$var$RefreshIcon = (props)=>/*#__PURE__*/ $6db0757f75190298$var$_react.default.createElement($6db0757f75190298$var$_baseNew.default, Object.assign({
        name: "RefreshIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$6db0757f75190298$var$RefreshIcon.displayName = 'RefreshIcon';
var $6db0757f75190298$var$_default = module.exports.default = $6db0757f75190298$var$RefreshIcon;

});

parcelRegister("5X6QO", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("eOL5r")).disableNativeDragPreview);

var $eOL5r = parcelRequire("eOL5r");


});

parcelRegister("eOL5r", function(module, exports) {
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $20c6df176d77bef6$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $20c6df176d77bef6$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $20c6df176d77bef6$var$tinyTransparentImage) nativeSetDragImage($20c6df176d77bef6$var$tinyTransparentImage, 0, 0);
}
module.exports["disableNativeDragPreview"] = $20c6df176d77bef6$export$c588cb30ff3b876e;

});

parcelRegister("3e8bm", function(module, exports) {
/* SourcesInput.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");


var $4noo5 = parcelRequire("4noo5");


var $g5gZt = parcelRequire("g5gZt");


var $fzqvY = parcelRequire("fzqvY");

var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");


var $9hlns = parcelRequire("9hlns");


var $1qfLF = parcelRequire("1qfLF");


var $cvXh8 = parcelRequire("cvXh8");


var $hmuev = parcelRequire("hmuev");

parcelRequire("ayS0g");
var $laZ2J = parcelRequire("laZ2J");


var $bQm3c = parcelRequire("bQm3c");


var $3OX6q = parcelRequire("3OX6q");


var $f6lSf = parcelRequire("f6lSf");


var $ajLjS = parcelRequire("ajLjS");

const $94f6234ad4b372c8$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    focusedPlaceholder: {
        id: "audio.audio-popup.sources-tab.focused-placeholder",
        defaultMessage: "Paste a Confluence link..."
    },
    unfocusedPlaceholder: {
        id: "audio.audio-popup.sources-tab.unfocused-placeholder",
        defaultMessage: "Add a link..."
    },
    submitButtonLabel: {
        id: "audio.audio-popup.sources-tab.submit-button-label",
        defaultMessage: "Add Link"
    },
    clearButtonLabel: {
        id: "audio.audio-popup.sources-tab.clear-button-label",
        defaultMessage: "Clear"
    },
    [(0, $3OX6q.SourceErrors).UNSUPPORTED_URL]: {
        id: "audio.audio-popup.sources-tab.validation-error.unsupported-url",
        defaultMessage: "This source is currently not supported."
    },
    [(0, $3OX6q.SourceErrors).DUPLICATE]: {
        id: "audio.audio-popup.sources-tab.validation-error.duplicate",
        defaultMessage: "This link is already present!"
    },
    [(0, $3OX6q.SourceErrors).INVALID_URL]: {
        id: "audio.audio-popup.sources-tab.validation-error.invalid-url",
        defaultMessage: "Please paste a valid link"
    },
    [(0, $3OX6q.SourceErrors).CURRENT_CONTENT]: {
        id: "audio.audio-popup.sources-tab.validation-error.current-content",
        defaultMessage: "The active content is already included."
    },
    [(0, $3OX6q.SourceErrors).NO_ACCESS]: {
        id: "audio.audio-popup.sources-tab.validation-error.no-access",
        defaultMessage: "This content is restricted."
    }
});
const $94f6234ad4b372c8$var$styles = {
    container: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    inputContainer: "_1rjcv77o _kqswh2mm",
    addIcon: "_2rkofajl _189ee4h9 _1dqonqa1 _1h6d1l7x _4t3if6fq _ahbqv77o",
    textFieldContainer: "_1rjcukr8 _16jlkb7n",
    buttonsContainer: "_kqswstnw _rjxpidpf _1pfh12x7 _1pby1kze",
    buttonWrapper: "_2rko12b0 _bfhk1bhr _16qs130s"
};
const $94f6234ad4b372c8$var$MAX_RESOURCES = 4;
const $94f6234ad4b372c8$var$InputAddIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
    xcss: $94f6234ad4b372c8$var$styles.addIcon
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
    label: "",
    size: "small",
    spacing: "compact"
}));
const $94f6234ad4b372c8$export$8dbace620c159c96 = ({ additionalResources: additionalResources, addAdditionalResource: addAdditionalResource, activeContent: activeContent })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { fetchEmbedData: fetchEmbedData } = (0, $laZ2J.useFetchDataFromORS)();
    const [inputError, setInputError] = (0, $42omo.useState)();
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    const isMaxReached = additionalResources.length === $94f6234ad4b372c8$var$MAX_RESOURCES;
    const [placeholder, setPlaceholder] = (0, $42omo.useState)(formatMessage($94f6234ad4b372c8$export$a7357cdd1f0b0168.unfocusedPlaceholder));
    const inputRef = (0, $42omo.useRef)(null);
    const validateUrl = (url)=>{
        try {
            new URL(url);
            return null;
        } catch  {
            return (0, $3OX6q.SourceErrors).INVALID_URL;
        }
    };
    const validateResourceSupport = (resolvedLink)=>{
        return (0, $ajLjS.isSupportedResource)(resolvedLink) ? null : (0, $3OX6q.SourceErrors).UNSUPPORTED_URL;
    };
    const validateDuplicate = (newResource)=>{
        const isDuplicate = additionalResources.some((existingResource)=>existingResource.ari === newResource.ari);
        return isDuplicate ? (0, $3OX6q.SourceErrors).DUPLICATE : null;
    };
    const validateAccess = (resolvedLink)=>{
        return resolvedLink?.access !== 'granted' ? (0, $3OX6q.SourceErrors).NO_ACCESS : null;
    };
    const validateNotCurrentContent = (newResource)=>{
        // activeContent should really be there and have these fields
        // this is just a best effort check anyways
        const { contentType: contentType = '', contentId: contentId = '' } = activeContent || {};
        const currentAri = (0, $f6lSf.getConfluenceContentAri)(cloudId, contentId, contentType);
        const submissionMatchesActiveContent = currentAri?.toString() === newResource.ari;
        return submissionMatchesActiveContent ? (0, $3OX6q.SourceErrors).CURRENT_CONTENT : null;
    };
    const resetFormWithError = (form, error)=>{
        form.reset();
        setInputError(error);
        setTimeout(()=>{
            inputRef.current?.focus();
        }, 0);
    };
    const resetFormSuccessfully = (form)=>{
        form.reset(); // Submission doesn't trigger the onBlur handler
        setPlaceholder(formatMessage($94f6234ad4b372c8$export$a7357cdd1f0b0168.unfocusedPlaceholder));
        setIsFocused(false);
    };
    const createNewResource = (link, resolvedLink)=>({
            link: link,
            // we know that ari is not undefined because isSupportedResource would have returned false
            // if we didn't have Confluence as the product or page as the resource type
            ari: resolvedLink.ari
        });
    const handleNewResourceSubmit = async (values, form)=>{
        setInputError(undefined);
        const { resourceUrl: resourceUrl } = values;
        const urlError = validateUrl(resourceUrl);
        if (urlError) {
            resetFormWithError(form, urlError);
            return;
        }
        try {
            const resolvedLink = await resolveLink(resourceUrl);
            const supportError = validateResourceSupport(resolvedLink);
            if (supportError) {
                resetFormWithError(form, supportError);
                return;
            }
            const accessError = validateAccess(resolvedLink);
            if (accessError) {
                resetFormWithError(form, accessError);
                return;
            }
            const newResource = createNewResource(resourceUrl, resolvedLink);
            const duplicateError = validateDuplicate(newResource);
            if (duplicateError) {
                resetFormWithError(form, duplicateError);
                return;
            }
            const currentContentError = validateNotCurrentContent(newResource);
            if (currentContentError) {
                resetFormWithError(form, currentContentError);
                return;
            }
            resetFormSuccessfully(form);
            addAdditionalResource(newResource);
        } catch  {
            // Handle any unexpected errors during link resolution
            resetFormWithError(form, (0, $3OX6q.SourceErrors).INVALID_URL);
        }
    }; // Only returns resolved Atlassian links
    // Loom will make this a bit complicated down the line
    const resolveLink = async (value)=>{
        const linkData = await fetchEmbedData({
            embedUrl: value
        });
        const resolvedAccess = linkData.meta?.access;
        const resolvedAri = linkData.data?.['atlassian:ari'];
        const resolvedProduct = linkData.meta?.product;
        const resolvedResourceType = linkData.meta?.resourceType;
        return {
            access: resolvedAccess,
            ari: resolvedAri,
            product: resolvedProduct,
            resourceType: resolvedResourceType
        };
    };
    const handleOnFocus = ()=>{
        setPlaceholder(formatMessage($94f6234ad4b372c8$export$a7357cdd1f0b0168.focusedPlaceholder));
    };
    const handleOnBlur = (event)=>{
        // Only blur if focus is not moving to our action buttons
        const relatedTarget = event.relatedTarget;
        const isMovingToActionButton = relatedTarget?.closest('[data-testid*="action-button"]');
        if (!isMovingToActionButton) {
            setPlaceholder(formatMessage($94f6234ad4b372c8$export$a7357cdd1f0b0168.unfocusedPlaceholder));
            setInputError(undefined);
            setIsFocused(false);
        }
    };
    const handleClear = (reset)=>{
        reset();
        setInputError(undefined);
        setPlaceholder(formatMessage($94f6234ad4b372c8$export$a7357cdd1f0b0168.unfocusedPlaceholder));
        setIsFocused(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: handleNewResourceSubmit
    }, ({ formProps: formProps, submitting: submitting, reset: reset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: "resourceUrl",
            defaultValue: "",
            isDisabled: isMaxReached || submitting
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $94f6234ad4b372c8$var$styles.inputContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
                ...fieldProps,
                ref: inputRef,
                testId: "audio-sources-textfield",
                elemAfterInput: submitting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
                    size: "small"
                }),
                appearance: "subtle",
                elemBeforeInput: $94f6234ad4b372c8$var$InputAddIcon,
                "aria-label": formatMessage($94f6234ad4b372c8$export$a7357cdd1f0b0168.focusedPlaceholder),
                isInvalid: !!inputError,
                placeholder: placeholder,
                isCompact: true,
                onFocus: handleOnFocus,
                onBlur: handleOnBlur
            }), inputError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $94f6234ad4b372c8$export$a7357cdd1f0b0168[inputError])), isFocused && !inputError && !submitting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                xcss: $94f6234ad4b372c8$var$styles.buttonsContainer,
                gap: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $94f6234ad4b372c8$var$styles.buttonWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                type: "submit",
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: formatMessage($94f6234ad4b372c8$export$a7357cdd1f0b0168.submitButtonLabel),
                isDisabled: !fieldProps.value,
                testId: "action-button-submit"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $94f6234ad4b372c8$var$styles.buttonWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: formatMessage($94f6234ad4b372c8$export$a7357cdd1f0b0168.clearButtonLabel),
                isDisabled: !fieldProps.value,
                onClick: ()=>handleClear(reset),
                testId: "action-button-clear"
            })))))));
};
module.exports["i18n"] = $94f6234ad4b372c8$export$a7357cdd1f0b0168;
module.exports["SourcesInput"] = $94f6234ad4b372c8$export$8dbace620c159c96;

});

parcelRegister("ayS0g", function(module, exports) {
$parcel$export(module.exports, "PERMISSIONS_INFO_BANNER_QUERY_PARAM_KEY", () => (parcelRequire("5y1g5")).PERMISSIONS_INFO_BANNER_QUERY_PARAM_KEY);
$parcel$export(module.exports, "IS_NEW_EMBED_QUERY_PARAM_KEY", () => (parcelRequire("5y1g5")).IS_NEW_EMBED_QUERY_PARAM_KEY);
$parcel$export(module.exports, "DotGridBackground", () => (parcelRequire("fnyki")).DotGridBackground);
$parcel$export(module.exports, "normalizeAndValidateUrl", () => (parcelRequire("aVk5V")).normalizeAndValidateUrl);
$parcel$export(module.exports, "fetchDataFromORS", () => (parcelRequire("laZ2J")).fetchDataFromORS);
$parcel$export(module.exports, "useFetchDataFromORS", () => (parcelRequire("laZ2J")).useFetchDataFromORS);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $5y1g5 = parcelRequire("5y1g5");


var $fnyki = parcelRequire("fnyki");


var $l01bG = parcelRequire("l01bG");


var $9QoCS = parcelRequire("9QoCS");


var $aVk5V = parcelRequire("aVk5V");


var $laZ2J = parcelRequire("laZ2J");


var $eaBPu = parcelRequire("eaBPu");


});

parcelRegister("5y1g5", function(module, exports) {
const $a7a321c00b90eef4$export$387a295dc04f5f90 = 'showPermissionsBanner';
const $a7a321c00b90eef4$export$3738b9a85a6948a6 = 'isNewBlankEmbed';
module.exports["PERMISSIONS_INFO_BANNER_QUERY_PARAM_KEY"] = $a7a321c00b90eef4$export$387a295dc04f5f90;
module.exports["IS_NEW_EMBED_QUERY_PARAM_KEY"] = $a7a321c00b90eef4$export$3738b9a85a6948a6;

});

parcelRegister("fnyki", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");

const $f37f7bd9b125a5e3$var$fullHeightContainer = (0, $ecnYn.xcss)({
    height: 'calc(100vh - var(--bannerHeight, 0px) - var(--topNavigationHeight, 0px))'
});
const $f37f7bd9b125a5e3$var$dotGridBackground = (0, $ecnYn.xcss)({
    backgroundImage: `radial-gradient(circle at 2px 2px, ${"var(--ds-surface-overlay-hovered, #F0F1F2)"} 2px, transparent 0)`,
    backgroundSize: '20px 20px'
});
const $f37f7bd9b125a5e3$export$b520b551d14c6a6e = ({ showDottedBackground: showDottedBackground, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "column",
        xcss: [
            $f37f7bd9b125a5e3$var$fullHeightContainer,
            showDottedBackground && $f37f7bd9b125a5e3$var$dotGridBackground
        ]
    }, children);
};
module.exports["DotGridBackground"] = $f37f7bd9b125a5e3$export$b520b551d14c6a6e;

});

parcelRegister("l01bG", function(module, exports) {

var $8hlRK = parcelRequire("8hlRK");

const $f493076f7b61f977$export$b8af48de83cf2008 = (url)=>{
    const httpPattern = /^https?:\/\/[^\s]*$/im;
    return httpPattern.test(url);
};
const $f493076f7b61f977$export$285f8e8582d94002 = (data)=>{
    /*
	 * data.generator.icon.url is where provider icon is and
	 * data.icon.url is where the link icon usually is. In most cases,
	 * they are the same thing but some providers have specific icons
	 * for specific links. For example, a Google Sheet link from
	 * google-object-provider would return Google Drive icon as a provider
	 * icon (data.generator.icon.url) but would return Google Sheets icon
	 * as link icon (data.icon.url).
	 */ const generatorIconObj = data.generator?.icon;
    const iconObj = data.icon;
    const generatorIcon = generatorIconObj && (0, $8hlRK.extractUrlFromIconJsonLd)(generatorIconObj) || '';
    const icon = iconObj && (0, $8hlRK.extractUrlFromIconJsonLd)(iconObj) || '';
    // TEMP: calling isValidScheme here is a workaround to
    // ensure data URIs for favicons don't make it through
    // (BE fails as it expects a http(s) scheme). Long term,
    // we should support inlined data URI favicons.
    // https://hello.jira.atlassian.cloud/browse/CTIA-1918
    return $f493076f7b61f977$export$b8af48de83cf2008(icon) && icon || $f493076f7b61f977$export$b8af48de83cf2008(generatorIcon) && generatorIcon || '';
};
module.exports["extractIconUrl"] = $f493076f7b61f977$export$285f8e8582d94002;

});

parcelRegister("9QoCS", function(module, exports) {

var $ccQw1 = parcelRequire("ccQw1");

// Gets a more specific product for the URL if we know that a provider can cover
// multiple products
const $9b10c9a9aeeff07b$var$getSpecificProduct = (hostname, providerName)=>{
    if (providerName === 'OneDrive' && hostname.includes('sharepoint')) return 'SharePoint';
    else return providerName;
};
const $9b10c9a9aeeff07b$export$a6859be1cfc01481 = (embedUrl, data)=>{
    const url = new URL(embedUrl);
    const urlHostname = url.hostname;
    // we want to remove the "www." at the beginning of the URL if it exists
    // so that the analytics are receiving domains in a consistent format
    const parsedHostname = urlHostname.replace(/^www\./, '');
    if (!data) return parsedHostname;
    const provider = (0, $ccQw1.extractProvider)(data);
    const providerName = provider?.text;
    const embedProduct = $9b10c9a9aeeff07b$var$getSpecificProduct(urlHostname, providerName);
    const providerIsHostname = embedProduct !== undefined && embedProduct.includes(parsedHostname);
    // ORS will sometimes return the urlHostname as the provider so use
    // the parsedHostname is there is no providerName or if the provider
    // contains the hostname
    if (!embedProduct || providerIsHostname) return parsedHostname;
    return embedProduct;
};
module.exports["extractProduct"] = $9b10c9a9aeeff07b$export$a6859be1cfc01481;

});

parcelRegister("aVk5V", function(module, exports) {

var $l3dur = parcelRequire("l3dur");

// regex to check that the url entered is at least of this format "://example.com"
const $9509ca2c76fbd4db$var$REGEX = /:\/\/(.*\.)?.+\..+/;
const $9509ca2c76fbd4db$export$53289a1e3dd02563 = (url)=>{
    const normalizedUrl = (0, $l3dur.normalizeUrl)(url.trim());
    // `isSafeUrl()` treats a string with just the protocol (e.g. "http://") as a valid url so we need additional check
    const isValid = !!normalizedUrl && (0, $l3dur.isSafeUrl)(normalizedUrl) && $9509ca2c76fbd4db$var$REGEX.test(normalizedUrl);
    return isValid ? normalizedUrl : null;
};
module.exports["normalizeAndValidateUrl"] = $9509ca2c76fbd4db$export$53289a1e3dd02563;

});

parcelRegister("laZ2J", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");


var $l6lJr = parcelRequire("l6lJr");

var $hUifo = parcelRequire("hUifo");


var $inPa6 = parcelRequire("inPa6");


var $l01bG = parcelRequire("l01bG");


var $aUoHg = parcelRequire("aUoHg");


var $eaBPu = parcelRequire("eaBPu");

const $07e4518f8509fec5$var$extractEmbedData = ({ createAnalyticsEvent: createAnalyticsEvent, data: data, embedUrl: embedUrl })=>{
    return {
        iconURL: data ? (0, $l01bG.extractIconUrl)(data) : undefined,
        product: (0, $eaBPu.extractEmbedProduct)({
            createAnalyticsEvent: createAnalyticsEvent,
            embedUrl: embedUrl,
            data: data
        }),
        title: data ? (0, $hUifo.extractTitle)(data) : undefined,
        url: data ? (0, $l6lJr.extractLink)(data) : undefined
    };
};
const $07e4518f8509fec5$export$7053598ec03d6366 = async ({ cardClient: cardClient, createAnalyticsEvent: createAnalyticsEvent, embedUrl: embedUrl, includeAuthHandling: includeAuthHandling })=>{
    try {
        const details = await cardClient.fetchData(embedUrl);
        let data = details && details.data;
        let meta = details && details.meta;
        if (includeAuthHandling) {
            const authURL = meta.auth?.[0]?.url;
            if (meta.access === 'unauthorized' && authURL) {
                try {
                    await (0, $aUoHg.handleEmbedAuthentication)({
                        authURL: authURL
                    });
                } catch (error) {
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'failed',
                            actionSubject: 'outboundAuthFlow',
                            source: 'smartLinkEmbedAuthentication',
                            attributes: {
                                error: error.type || 'unknown',
                                extensionKey: meta?.key ?? null,
                                destinationObjectType: meta?.resourceType ?? null,
                                contentType: 'embed'
                            },
                            nonPrivacySafeAttributes: {
                                linkDomain: (0, $eaBPu.extractEmbedProduct)({
                                    createAnalyticsEvent: createAnalyticsEvent,
                                    data: data,
                                    embedUrl: embedUrl
                                })
                            }
                        }
                    }).fire();
                    return {
                        data: data,
                        meta: meta,
                        parsedEmbedData: $07e4518f8509fec5$var$extractEmbedData({
                            createAnalyticsEvent: createAnalyticsEvent,
                            data: data,
                            embedUrl: embedUrl
                        }),
                        error: null
                    };
                }
                // We have successfully authenticated with the URL, so lets refetch to get all the
                // proper data.
                const refetchedDetails = await cardClient.fetchData(embedUrl);
                meta = refetchedDetails && refetchedDetails.meta;
                if (refetchedDetails && refetchedDetails.data) data = refetchedDetails.data;
            }
        }
        return {
            data: data,
            meta: meta,
            parsedEmbedData: $07e4518f8509fec5$var$extractEmbedData({
                createAnalyticsEvent: createAnalyticsEvent,
                data: data,
                embedUrl: embedUrl
            }),
            error: null
        };
    } catch (error) {
        return {
            data: undefined,
            meta: undefined,
            parsedEmbedData: $07e4518f8509fec5$var$extractEmbedData({
                createAnalyticsEvent: createAnalyticsEvent,
                data: undefined,
                embedUrl: embedUrl
            }),
            error: error
        };
    }
};
const $07e4518f8509fec5$export$22fdc6a4626c032 = ()=>{
    const { connections: connections } = (0, $eIleF.useSmartLinkContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fetchEmbedData = (0, $42omo.useCallback)(async ({ embedUrl: embedUrl, includeAuthHandling: includeAuthHandling })=>{
        return $07e4518f8509fec5$export$7053598ec03d6366({
            cardClient: connections.client,
            createAnalyticsEvent: createAnalyticsEvent,
            embedUrl: embedUrl,
            includeAuthHandling: includeAuthHandling
        });
    }, [
        connections.client,
        createAnalyticsEvent
    ]);
    return {
        fetchEmbedData: fetchEmbedData
    };
};
module.exports["fetchDataFromORS"] = $07e4518f8509fec5$export$7053598ec03d6366;
module.exports["useFetchDataFromORS"] = $07e4518f8509fec5$export$22fdc6a4626c032;

});

parcelRegister("aUoHg", function(module, exports) {

var $3uVVG = parcelRequire("3uVVG");

const $1d0cc37ef4affcea$export$2b381fecab5b3691 = async ({ authURL: authURL })=>{
    const POPUP_HEIGHT = 600;
    const POPUP_WIDTH = 720;
    const BROWSER_SIZE_THRESHOLD = 48;
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    // Center the popup window
    const left = (vw - POPUP_WIDTH) / 2;
    const top = (vh - POPUP_HEIGHT) / 2;
    // Open a popup if there's enough space in the viewport
    // Otherwise, fall back to the default behavior (opening in a new tab)
    const windowFeatures = vw > POPUP_WIDTH + BROWSER_SIZE_THRESHOLD && vh > POPUP_HEIGHT + BROWSER_SIZE_THRESHOLD ? `width=${POPUP_WIDTH},height=${POPUP_HEIGHT}},left=${left},top=${top}` : undefined;
    await (0, $3uVVG.auth)(authURL, windowFeatures);
};
module.exports["handleEmbedAuthentication"] = $1d0cc37ef4affcea$export$2b381fecab5b3691;

});

parcelRegister("eaBPu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9QoCS = parcelRequire("9QoCS");

const $86c9e03e9bf37880$export$c6a11f4b62c81749 = ({ createAnalyticsEvent: createAnalyticsEvent, data: data, embedUrl: embedUrl })=>{
    try {
        return (0, $9QoCS.extractProduct)(embedUrl, data || undefined);
    } catch (error) {
        createAnalyticsEvent?.({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'embedProductExtraction',
                source: 'smartLinkEmbedProductExtraction',
                attributes: {
                    contentType: 'embed'
                }
            }
        }).fire();
        return null;
    }
};
const $86c9e03e9bf37880$export$fe632efa34893174 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const _extractEmbedProduct = (0, $42omo.useCallback)(({ data: data, embedUrl: embedUrl })=>{
        return $86c9e03e9bf37880$export$c6a11f4b62c81749({
            createAnalyticsEvent: createAnalyticsEvent,
            data: data,
            embedUrl: embedUrl
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        extractEmbedProduct: _extractEmbedProduct
    };
};
module.exports["extractEmbedProduct"] = $86c9e03e9bf37880$export$c6a11f4b62c81749;

});

parcelRegister("3OX6q", function(module, exports) {
const $40a313a71580821a$export$79488106e350fce7 = {
    DUPLICATE: 'duplicate',
    INVALID_URL: 'invalid-url',
    UNSUPPORTED_URL: 'unsupported-url',
    CURRENT_CONTENT: 'current-content',
    NO_ACCESS: 'no-access'
};
module.exports["SourceErrors"] = $40a313a71580821a$export$79488106e350fce7;

});

parcelRegister("f6lSf", function(module, exports) {

var $eB56w = parcelRequire("eB56w");

var $a2xFu = parcelRequire("a2xFu");

var $a5Dk4 = parcelRequire("a5Dk4");

const $f16877b6875ebf37$export$6a2f2c83863e9bfe = (siteId, contentId, contentType)=>{
    try {
        switch(contentType){
            case 'page':
                return (0, $a2xFu.ConfluencePageAri).create({
                    siteId: siteId,
                    pageId: contentId
                });
            case 'blogpost':
                return (0, $eB56w.ConfluenceBlogpostAri).create({
                    siteId: siteId,
                    blogpostId: contentId
                });
            case 'whiteboard':
                return (0, $a5Dk4.ConfluenceWhiteboardAri).create({
                    siteId: siteId,
                    whiteboardId: contentId
                });
        }
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["getConfluenceContentAri"] = $f16877b6875ebf37$export$6a2f2c83863e9bfe;

});

parcelRegister("eB56w", function(module, exports) {

var $fOAkx = parcelRequire("fOAkx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/blogpost/manifest.ts
var $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $fOAkx.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $fOAkx.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $aa087af90d1c8aca$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $aa087af90d1c8aca$export$8602a2c2f6ac09bc;

});

parcelRegister("fOAkx", function(module, exports) {
// src/confluence/blogpost/types.ts
var $b837b4f269c93ee4$export$9389f06bd1d0765c = "confluence", $b837b4f269c93ee4$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $b837b4f269c93ee4$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $b837b4f269c93ee4$export$fb777a2d645a4129;

});

parcelRegister("a2xFu", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $74f4351b9cae92fc$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $74f4351b9cae92fc$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $74f4351b9cae92fc$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("a5Dk4", function(module, exports) {

var $aOBEU = parcelRequire("aOBEU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/whiteboard/manifest.ts
var $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $aOBEU.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $aOBEU.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $7588dfadc8876fc5$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $7588dfadc8876fc5$export$ba3d25b6768ddb10;

});

parcelRegister("aOBEU", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $7dfbc92767b8c664$export$6130ea1abbb885ef = "confluence", $7dfbc92767b8c664$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $7dfbc92767b8c664$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $7dfbc92767b8c664$export$d3070d1568a10e2d;

});

parcelRegister("ajLjS", function(module, exports) {
const $5d4f5325ccb48e05$var$SupportedProducts = {
    Confluence: 'confluence'
};
const $5d4f5325ccb48e05$var$SupportedResourceTypes = {
    Page: 'page',
    Blog: 'blog'
};
const $5d4f5325ccb48e05$export$748bd4722e404459 = {
    confluence: [
        'page',
        'blog'
    ]
};
const $5d4f5325ccb48e05$var$isValidProduct = (value)=>{
    return !!value && Object.values($5d4f5325ccb48e05$var$SupportedProducts).includes(value);
};
const $5d4f5325ccb48e05$var$isValidResourceType = (value)=>{
    return !!value && Object.values($5d4f5325ccb48e05$var$SupportedResourceTypes).includes(value);
};
const $5d4f5325ccb48e05$export$ffe6e4c15ebb740f = (resolvedLink)=>{
    const { product: product, resourceType: resourceType } = resolvedLink;
    if (!$5d4f5325ccb48e05$var$isValidProduct(product) || !$5d4f5325ccb48e05$var$isValidResourceType(resourceType)) return false;
    return $5d4f5325ccb48e05$export$748bd4722e404459[product].includes(resourceType);
};
module.exports["isSupportedResource"] = $5d4f5325ccb48e05$export$ffe6e4c15ebb740f;

});

parcelRegister("8AKrx", function(module, exports) {

var $69QGC = parcelRequire("69QGC");

var $fOoLf = parcelRequire("fOoLf");


var $6mKj3 = parcelRequire("6mKj3");


var $dIgcq = parcelRequire("dIgcq");


var $biOtS = parcelRequire("biOtS");


var $iuZ4N = parcelRequire("iuZ4N");





var $2RNw9 = parcelRequire("2RNw9");

var $150tu = parcelRequire("150tu");

var $lRCxi = parcelRequire("lRCxi");

var $aHsHn = parcelRequire("aHsHn");





var $hYAxW = parcelRequire("hYAxW");


var $1Hbkf = parcelRequire("1Hbkf");

const $54349ac24c29d21a$var$MAX_FEATURE_VISIT_COUNT = 3;
const $54349ac24c29d21a$export$da8724bcb6526688 = 'crossJoinNudgesV3';
const $54349ac24c29d21a$export$49a8cf368338c69c = async ({ userId: userId, cloudId: cloudId, getMSRNudgeRecommendations: getMSRNudgeRecommendations })=>{
    const cachedUserIsTooNew = (0, $hYAxW.withEligibilityCache)('user_is_too_new', (0, $aHsHn.isUserTooNew), 1);
    if ((0, $1Hbkf.getFeatureVisitedCount)($54349ac24c29d21a$export$da8724bcb6526688) >= $54349ac24c29d21a$var$MAX_FEATURE_VISIT_COUNT) return {
        ineligibilityReason: 'FEATURE_VISITED_COUNT_MAXED_OUT'
    };
    if ((0, $1Hbkf.isUserOptedOut)($54349ac24c29d21a$export$da8724bcb6526688)) return {
        ineligibilityReason: 'USER_HAS_OPTED_OUT'
    };
    if (await (0, $lRCxi.isSiteOptedOut)(cloudId)) return {
        ineligibilityReason: 'SITE_OPTED_OUT'
    };
    if (await (0, $2RNw9.hasAccessToProduct)('jira-software', cloudId)) return {
        ineligibilityReason: 'ALREADY_HAVE_ACCESS'
    };
    if (await cachedUserIsTooNew(cloudId, userId, 'confluence_first_active')) return {
        ineligibilityReason: 'USER_IS_TOO_NEW'
    };
    const collaborators = await (0, $69QGC.getUsersFromCollaborationGraph)('crossJoinNudgesV3', cloudId, userId);
    if (collaborators === undefined || collaborators.length === 0) return {
        ineligibilityReason: 'NO_COLLABORATORS_FOUND'
    };
    const collaboratorsWithJiraAccess = await (0, $fOoLf.getCollaboratorsWithJiraAccess)(cloudId, collaborators);
    if (collaboratorsWithJiraAccess.length === 0) return {
        ineligibilityReason: 'COLLABORATORS_HAVE_NO_ACCESS'
    };
    if (!await (0, $iuZ4N.canUserRequestAccess)('jira-software', cloudId)) return {
        ineligibilityReason: 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
    };
    if (!await (0, $150tu.isSite7DaysOld)('jira-software', cloudId)) return {
        ineligibilityReason: 'NEW_SITE_LESS_THAN_7_DAYS_OLD'
    };
    if ((0, $6mKj3.expValEquals)('twcg-1237-msr-cjn-m2', 'isEnabled', true)) {
        const recommendations = await getMSRNudgeRecommendations();
        if (!recommendations.includes('cjn-conf-jira-v3')) return {
            ineligibilityReason: 'MSR_NUDGE_NOT_RECOMMENDED'
        };
    }
    return {
        ineligibilityReason: null,
        collaborators: collaboratorsWithJiraAccess
    };
};

























const $15b4e34a7ce1da70$var$MAX_FEATURE_VISIT_COUNT = 3;
const $15b4e34a7ce1da70$export$6353fe5db4bd7dca = 'crossJoinNudgesConfluenceToJpd';
const $15b4e34a7ce1da70$export$8916d0e9bd8973b7 = async (cloudId, userId)=>{
    const cachedUserIsTooNew = (0, $hYAxW.withEligibilityCache)('user_is_too_new', (0, $aHsHn.isUserTooNew), 1);
    if ((0, $1Hbkf.getFeatureVisitedCount)($15b4e34a7ce1da70$export$6353fe5db4bd7dca) >= $15b4e34a7ce1da70$var$MAX_FEATURE_VISIT_COUNT) return {
        eligible: false,
        ineligibilityReason: 'FEATURE_VISITED_COUNT_MAXED_OUT'
    };
    if ((0, $1Hbkf.isUserOptedOut)($15b4e34a7ce1da70$export$6353fe5db4bd7dca)) return {
        eligible: false,
        ineligibilityReason: 'USER_HAS_OPTED_OUT'
    };
    if (await (0, $lRCxi.isSiteOptedOut)(cloudId)) return {
        eligible: false,
        ineligibilityReason: 'SITE_OPTED_OUT'
    };
    if (await (0, $2RNw9.hasAccessToProduct)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'ALREADY_HAVE_ACCESS'
    };
    if (await cachedUserIsTooNew(cloudId, userId, 'confluence_first_active')) return {
        eligible: false,
        ineligibilityReason: 'USER_IS_TOO_NEW'
    };
    if (!await (0, $150tu.isSite7DaysOld)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'NEW_SITE_LESS_THAN_7_DAYS_OLD'
    };
    if (!await (0, $iuZ4N.canUserRequestAccess)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
    };
    return {
        eligible: true
    };
};


const $3e82bea0d95824c0$export$9d305ebad2a9218a = async ({ cloudId: cloudId, userId: userId, displayName: displayName, flags: flags, createAnalyticsEvent: createAnalyticsEvent, push: push, formatMessage: formatMessage, getMSRNudgeRecommendations: getMSRNudgeRecommendations })=>{
    const analytics = (0, $biOtS.getExperimentAnalytics)((0, $54349ac24c29d21a$export$da8724bcb6526688), createAnalyticsEvent);
    try {
        if (!userId || await (0, $1Hbkf.isFeatureVisited)((0, $54349ac24c29d21a$export$da8724bcb6526688))) return;
        const response = await (0, $54349ac24c29d21a$export$49a8cf368338c69c)({
            userId: userId,
            cloudId: cloudId,
            getMSRNudgeRecommendations: getMSRNudgeRecommendations
        });
        if (response.ineligibilityReason === null) {
            await (0, $dIgcq.showNudgeFlag)({
                product: 'jira-software',
                integration: (0, $54349ac24c29d21a$export$da8724bcb6526688),
                userId: userId,
                displayName: displayName,
                cloudId: cloudId,
                collaborators: response.collaborators,
                createAnalyticsEvent: createAnalyticsEvent,
                flags: flags,
                pushRoute: push,
                formatMessage: formatMessage
            });
            (0, $1Hbkf.increaseFeatureVisitedCount)((0, $54349ac24c29d21a$export$da8724bcb6526688));
            // this is used in the eligibility check for loom nudge
            await (0, $hYAxW.setHasSeenNudgeInLast7Days)();
        } else if (response.ineligibilityReason === 'SITE_OPTED_OUT') (0, $biOtS.fireSiteOptedOutAnalytics)(analytics);
        else if (response.ineligibilityReason === 'MSR_NUDGE_NOT_RECOMMENDED') (0, $biOtS.fireMsrNotRecommendedAnalytics)(analytics, 'cjn-conf-jira-v3');
    } catch (error) {
        (0, $biOtS.fireExperimentError)(analytics, error);
    }
};
const $3e82bea0d95824c0$export$db3bc6af881f6bd0 = async ({ cloudId: cloudId, userId: userId, createAnalyticsEvent: createAnalyticsEvent, getMSRNudgeRecommendations: getMSRNudgeRecommendations })=>{
    const analytics = (0, $biOtS.getExperimentAnalytics)((0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca), createAnalyticsEvent);
    try {
        if (!userId) return false;
        if (await (0, $1Hbkf.isFeatureVisited)((0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca))) return false;
        const eligibilityResponse = await (0, $15b4e34a7ce1da70$export$8916d0e9bd8973b7)(cloudId, userId);
        if (!eligibilityResponse.eligible) {
            if (eligibilityResponse.ineligibilityReason === 'SITE_OPTED_OUT') (0, $biOtS.fireSiteOptedOutAnalytics)(analytics);
            return false;
        }
        if ((0, $6mKj3.expValEquals)('twcg-1237-msr-cjn-m2', 'isEnabled', true)) {
            const recommendations = await getMSRNudgeRecommendations();
            if (!recommendations.includes('cjn-conf-jpd')) {
                (0, $biOtS.fireMsrNotRecommendedAnalytics)(analytics, 'cjn-conf-jpd');
                return false;
            }
        }
        return true;
    } catch (error) {
        (0, $biOtS.fireExperimentError)(analytics, error);
        return false;
    }
};
const $3e82bea0d95824c0$export$2cec488374560b5c = async ({ cloudId: cloudId, userId: userId, displayName: displayName, flags: flags, createAnalyticsEvent: createAnalyticsEvent, push: push, formatMessage: formatMessage })=>{
    const analytics = (0, $biOtS.getExperimentAnalytics)((0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca), createAnalyticsEvent);
    try {
        if (!userId) return;
        const collaborators = await (0, $69QGC.getUsersFromCollaborationGraph)((0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca), cloudId, userId);
        const collaboratorsOnJpd = await (0, $fOoLf.getUsersWithProductAccess)('jira-product-discovery', cloudId, collaborators);
        await (0, $dIgcq.showNudgeFlag)({
            product: 'jira-product-discovery',
            integration: (0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca),
            userId: userId,
            displayName: displayName,
            cloudId: cloudId,
            collaborators: collaboratorsOnJpd,
            createAnalyticsEvent: createAnalyticsEvent,
            flags: flags,
            pushRoute: push,
            formatMessage: formatMessage
        });
        (0, $1Hbkf.increaseFeatureVisitedCount)((0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca));
        // this is used in the eligibility check for loom nudge
        await (0, $hYAxW.setHasSeenNudgeInLast7Days)();
    } catch (error) {
        (0, $biOtS.fireExperimentError)(analytics, error);
    }
};
module.exports["triggerJiraCrossJoinNudge"] = $3e82bea0d95824c0$export$9d305ebad2a9218a;
module.exports["checkJpdCrossJoinNudgeEligibility"] = $3e82bea0d95824c0$export$db3bc6af881f6bd0;
module.exports["showJpdCrossJoinNudge"] = $3e82bea0d95824c0$export$2cec488374560b5c;

});

parcelRegister("69QGC", function(module, exports) {
const $49e5b045f74dcd7a$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $49e5b045f74dcd7a$export$f757fae6e9facd6f = async (integration, cloudId, userId)=>{
    const payload = {
        context: {
            contextType: integration,
            principalId: userId,
            siteId: cloudId
        },
        modelRequestParams: {
            experience: 'CgUserNearbyUser'
        },
        expanded: true,
        maxNumberOfResults: $49e5b045f74dcd7a$var$COLLABORATION_GRAPH_MAX_RESULTS,
        userId: userId
    };
    const response = await fetch('/gateway/api/collaboration/v1/collaborationgraph/user/user', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
    const result = (await response.json())?.collaborationGraphEntities?.filter((en)=>en?.userProfile !== undefined && en?.userProfile?.account_type !== 'app' && en?.userProfile?.account_status !== 'deactivated' && en?.userProfile?.account_status !== 'deleted').map(({ userProfile: { account_id: account_id, name: name, picture: picture } })=>({
            id: account_id,
            name: name,
            avatar: picture
        }));
    return result;
};
module.exports["getUsersFromCollaborationGraph"] = $49e5b045f74dcd7a$export$f757fae6e9facd6f;

});

parcelRegister("fOoLf", function(module, exports) {
const $237583ee60417350$export$8db0f1e8ecc00a3f = async (cloudId, collaborators)=>{
    const accountIds = collaborators.map((c)=>c.id);
    const response = await fetch('/gateway/api/growth/cross-join-nudges-v3/get-permitted-jira-users', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            cloudId: cloudId,
            accountIds: accountIds
        })
    });
    const returnedAccountIds = await response.json();
    return collaborators.filter((c)=>returnedAccountIds.includes(c.id));
};
const $237583ee60417350$export$a68fadaa3a8b5e25 = async (product, cloudId, collaborators)=>{
    const response = await fetch('/gateway/api/growth/invite-on-link-insert/get-invitees', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            cloudId: cloudId,
            product: product,
            accountIds: collaborators.map((c)=>c.id)
        })
    });
    const returnedAccountIds = await response.json();
    return collaborators.filter((c)=>!returnedAccountIds.includes(c.id));
};
module.exports["getCollaboratorsWithJiraAccess"] = $237583ee60417350$export$8db0f1e8ecc00a3f;
module.exports["getUsersWithProductAccess"] = $237583ee60417350$export$a68fadaa3a8b5e25;

});

parcelRegister("dIgcq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $4QLH5 = parcelRequire("4QLH5");

var $8YEMg = parcelRequire("8YEMg");

var $6go91 = parcelRequire("6go91");

var $3Cc3L = parcelRequire("3Cc3L");

var $9Luz9 = parcelRequire("9Luz9");


var $lsxnT = parcelRequire("lsxnT");


var $1Hbkf = parcelRequire("1Hbkf");


var $biOtS = parcelRequire("biOtS");

const $5ef7c2e23b8af61a$var$crossJoinRoutes = {
    crossJoinNudgesV3: '/jira',
    crossJoinNudgesConfluenceToJpd: '/jira/projects',
    crossJoinNudgesConfluenceToJiraMsr: '/jira',
    crossJoinNudgesConfluenceToJpdMsr: '/jira/projects'
};
const $5ef7c2e23b8af61a$export$e55a23675aaa8cd1 = async ({ product: product, integration: integration, userId: userId, displayName: displayName, cloudId: cloudId, collaborators: collaborators, createAnalyticsEvent: createAnalyticsEvent, flags: flags, pushRoute: pushRoute, formatMessage: formatMessage })=>{
    const featureVisitedCount = (0, $1Hbkf.getFeatureVisitedCount)(integration);
    const attributes = {
        collaborators: collaborators.length,
        userId: userId,
        featureVisitedCount: featureVisitedCount
    };
    const analytics = (0, $biOtS.getExperimentAnalytics)(integration, createAnalyticsEvent, {
        attributes: attributes
    });
    const dismiss = async (id, flags)=>{
        (0, $biOtS.fireFlagDismissed)(analytics);
        await flags.hideFlag(id);
    };
    const dismissAndSnooze = async (id, flags)=>{
        await dismiss(id, flags);
        (0, $biOtS.fireFlagSnoozed)(analytics);
        (0, $1Hbkf.snoozeFeatureFor30Days)(integration);
    };
    const dismissAndOptout = async (id, flags)=>{
        await dismiss(id, flags);
        (0, $biOtS.fireUserOptedOut)(analytics);
        (0, $1Hbkf.setUserOptedOut)(integration);
    };
    await flags.showFlag({
        customComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5ef7c2e23b8af61a$export$ef75ccc59458e1ea, {
                id: props.id,
                integration: integration,
                collaborators: collaborators,
                targetProduct: product,
                viewCount: featureVisitedCount,
                onDismiss: ()=>dismiss(props.id, flags),
                onSnoozeAndDismiss: ()=>dismissAndSnooze(props.id, flags),
                onOptoutAndDismiss: ()=>dismissAndOptout(props.id, flags),
                onSubmit: async ()=>{
                    try {
                        const nonContextualNote = (0, $dh538.fg)('twcg-1402-non-contextual-ra-note') ? (0, $4QLH5.buildNonContextualNote)({
                            displayName: displayName ?? null,
                            userId: userId,
                            targetProduct: product,
                            formatMessage: formatMessage
                        }) : undefined;
                        const accessStatus = await (0, $8YEMg.requestAccess)(product, 'confluence', integration, userId, cloudId, createAnalyticsEvent, nonContextualNote);
                        if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') pushRoute($5ef7c2e23b8af61a$var$crossJoinRoutes[integration]);
                        else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') {
                            await flags.hideFlag(props.id);
                            await $5ef7c2e23b8af61a$export$fef8478a2c810f18(flags);
                        } else {
                            await flags.hideFlag(props.id);
                            await $5ef7c2e23b8af61a$export$dfa2148cdb92917d(flags, product);
                        }
                    } catch  {
                        await flags.hideFlag(props.id);
                        await $5ef7c2e23b8af61a$export$dfa2148cdb92917d(flags, product);
                    }
                    (0, $biOtS.fireJoinButtonClicked)(analytics);
                }
            })
    });
    (0, $biOtS.fireFlagShown)(analytics);
};
const $5ef7c2e23b8af61a$export$fef8478a2c810f18 = async (flags)=>{
    await flags.showFlag({
        customComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Luz9.RequestAccessSuccessFlag), {
                id: props.id,
                onDismiss: ()=>flags.hideFlag(props.id)
            })
    });
};
const $5ef7c2e23b8af61a$export$dfa2148cdb92917d = async (flags, product)=>{
    await flags.showFlag({
        customComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6go91.RequestAccessErrorFlag), {
                id: props.id,
                targetProduct: product,
                onDismiss: ()=>flags.hideFlag(props.id)
            })
    });
};
function $5ef7c2e23b8af61a$export$ef75ccc59458e1ea({ ...passThrough }) {
    const { useChoreographedRender: useChoreographedRender } = (0, $lsxnT.useChoreographerAssets)();
    const canShow = useChoreographedRender({
        messageId: 'cc-cross-join-nudge'
    });
    return canShow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Cc3L.RequestAccessPromptFlag), passThrough) : null;
}
module.exports["showNudgeFlag"] = $5ef7c2e23b8af61a$export$e55a23675aaa8cd1;
module.exports["ChoreographerRequestAccessPromptFlag"] = $5ef7c2e23b8af61a$export$ef75ccc59458e1ea;
module.exports["showSuccessFlag"] = $5ef7c2e23b8af61a$export$fef8478a2c810f18;
module.exports["showErrorFlag"] = $5ef7c2e23b8af61a$export$dfa2148cdb92917d;

});

parcelRegister("4QLH5", function(module, exports) {

var $2IyA1 = parcelRequire("2IyA1");

const $d747d41c113c6170$export$ccdf4a6c54ceeae4 = ({ displayName: displayName, userEmail: userEmail, userId: userId, targetProduct: targetProduct, formatMessage: formatMessage })=>{
    const valuePropMessage = $d747d41c113c6170$export$363a81b0818153d1(targetProduct);
    if (!valuePropMessage) return undefined;
    const requestingUser = displayName || userEmail || userId;
    const requestingApp = $d747d41c113c6170$export$aa3f36fe5dd1f237(targetProduct);
    const valueProp = formatMessage(valuePropMessage);
    const noteText = formatMessage((0, $2IyA1.nonContextualNoteMessages).CJNNonContextualNote, {
        requestingUser: requestingUser,
        requestingApp: requestingApp,
        valueProp: valueProp
    });
    return noteText;
};
const $d747d41c113c6170$export$aa3f36fe5dd1f237 = (targetProduct)=>{
    switch(targetProduct){
        case 'jira-product-discovery':
            return 'Jira Product Discovery';
        case 'jira-software':
            return 'Jira';
        case 'loom':
            return 'Loom';
        case 'confluence':
            return 'Confluence';
        default:
            return targetProduct;
    }
};
const $d747d41c113c6170$export$363a81b0818153d1 = (targetProduct)=>{
    switch(targetProduct){
        case 'jira-product-discovery':
            return (0, $2IyA1.nonContextualNoteMessages).jpdValueProp;
        case 'jira-software':
            return (0, $2IyA1.nonContextualNoteMessages).jiraValueProp;
        case 'loom':
            return (0, $2IyA1.nonContextualNoteMessages).loomValueProp;
        case 'confluence':
            return (0, $2IyA1.nonContextualNoteMessages).confluenceValueProp;
        default:
            return undefined;
    }
};
module.exports["buildNonContextualNote"] = $d747d41c113c6170$export$ccdf4a6c54ceeae4;

});

parcelRegister("8YEMg", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $368e3dac27509b32$export$cd9e5995821603e1 = async (product, sourceProduct, integration, userId, cloudId, createAnalyticsEvent, nonContextualNote)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    const shouldIncludeNonContextualNote = nonContextualNote && (0, $dh538.fg)('twcg-1402-non-contextual-ra-note');
    try {
        const response = await fetch('/gateway/api/invitations/v1/access-requests/request', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource,
                ...shouldIncludeNonContextualNote && {
                    nonContextualNote: nonContextualNote
                },
                metadata: {
                    touchpoint: 'Crossjoin Nudge',
                    sourceProduct: sourceProduct
                }
            })
        });
        const accessRequestResponse = await response.json();
        const { results: results } = accessRequestResponse;
        const result = results[resource];
        const analyticsAttributes = {
            userId: userId,
            products: [
                product
            ],
            inviteResult: [
                {
                    resourceAri: resource,
                    status: result
                }
            ],
            integration: integration
        };
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'requested',
                actionSubject: 'productAccess',
                source: integration,
                attributes: analyticsAttributes
            }
        }).fire();
        return result;
    } catch (error) {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'requestAccess',
                source: integration,
                attributes: {
                    message: String(error),
                    details: {
                        ...error || {}
                    }
                }
            }
        }).fire();
        throw error;
    }
};
module.exports["requestAccess"] = $368e3dac27509b32$export$cd9e5995821603e1;

});

parcelRegister("6go91", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $eCEXz = parcelRequire("eCEXz");


var $a3fRD = parcelRequire("a3fRD");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $6fnsQ = parcelRequire("6fnsQ");


var $6LPtl = parcelRequire("6LPtl");


var $51kba = parcelRequire("51kba");


var $cgtv4 = parcelRequire("cgtv4");

const $b4eade39954d5e85$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    title: {
        id: "cross-join-nudges.request-access-error-flag.title",
        defaultMessage: "We couldn't add you to {product}"
    },
    description: {
        id: "cross-join-nudges.request-access-error-flag.description-support-link",
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, <a>contact support</a>."
    }
});


const $972d0d1a08d63dad$var$SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $972d0d1a08d63dad$export$e1d0d64874873c8b = (0, $51kba.withLocalIntl)(({ onDismiss: onDismiss, targetProduct: targetProduct, flagComponent: FlagComponent = (0, $eCEXz.default), ...props })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)(FlagComponent, {
        ...props,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
            spacing: "spacious",
            label: "Error",
            color: `var(--ds-icon-danger, ${(0, $6fnsQ.R300)})`
        }),
        onDismissed: onDismiss,
        title: formatMessage((0, $b4eade39954d5e85$export$defe85febe8b728c).title, {
            product: (0, $6LPtl.getProductDisplayName)(targetProduct)
        }),
        description: formatMessage((0, $b4eade39954d5e85$export$defe85febe8b728c).description, {
            a: (chunks)=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__growth-groot') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                    href: $972d0d1a08d63dad$var$SUPPORT_LINK,
                    children: chunks
                }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, $l998X.jsx)("a", {
                    href: $972d0d1a08d63dad$var$SUPPORT_LINK,
                    children: chunks
                })
        })
    });
});
module.exports["RequestAccessErrorFlag"] = $972d0d1a08d63dad$export$e1d0d64874873c8b;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the context and pass them downstream
   * This prevents the missing messages error
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    (0, $42omo.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
        return undefined;
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $fI8ba = parcelRequire("fI8ba");

var $gmMgo = parcelRequire("gmMgo");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $fI8ba.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $gmMgo.Context));
    if (!context) return (0, $1e2E5.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("4yBJM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $898892faf0a0a598$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $898892faf0a0a598$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': 'All sites',
    'navigation.global-shortcuts.apps.align': 'Align',
    'navigation.global-shortcuts.apps.analytics': 'Analytics',
    'navigation.global-shortcuts.apps.assets': 'Assets',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': 'Company Hub',
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': 'Goals',
    'navigation.global-shortcuts.apps.home': 'Home',
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': 'Projects',
    'navigation.global-shortcuts.apps.projects-galaxia': 'Spaces',
    'navigation.global-shortcuts.apps.studio': 'Studio',
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': 'Teams',
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Close',
    'navigation.global-shortcuts.menu-expand-item.site-aria-label': '{name} site',
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(currently unavailable)',
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Open external link icon',
    'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(loading)',
    'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(loading)',
    'navigation.global-shortcuts.shortcut-action.open-menu-label': 'open menu',
    'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
    'navigation.global-shortcuts.sites': '{productName} sites'
};

});

parcelRegister("4opcN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2f37d5078b127d0b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $4a63a3b5bacb8bda$export$2e2bcd8739ae039 = {
    'cross-join-nudges.common.request-access-prompt-flag.description-jira-confluence-msr-nudge-no-collaborators': 'Create project pages to build a shared understanding for better decision-making.',
    'cross-join-nudges.common.request-access-prompt-flag.description-jira-confluence-msr-nudge-with-collaborators': 'Organize team knowledge, capture ideas, and share requirements for your Jira projects.',
    'cross-join-nudges.common.request-access-prompt-flag.title-jira-confluence-msr-nudge': 'Join your team in using Confluence',
    'cross-join-nudges.request-access-error-flag.description-support-link': "Try again in a few minutes. If you still aren't able to join, <a>contact support</a>.",
    'cross-join-nudges.request-access-error-flag.title': "We couldn't add you to {product}",
    'cross-join-nudges.request-access-prompt-flag.description-jira': 'Stay on top of your tasks, unify your project workflow and track your team progress in Jira.',
    'cross-join-nudges.request-access-prompt-flag.description-jira-galaxia': 'Stay on top of your tasks, unify your space workflow and track your team progress in Jira.',
    'cross-join-nudges.request-access-prompt-flag.description-jpd-nudge': 'Prioritize ideas, share custom roadmaps, and unify your workflow from discovery to delivery.',
    'cross-join-nudges.request-access-prompt-flag.description-loom-nudge': 'Use Loom videos to summarize pages and share information.',
    'cross-join-nudges.request-access-prompt-flag.do-not-show-again-button': "Don't show again",
    'cross-join-nudges.request-access-prompt-flag.get-started-button': 'Get started',
    'cross-join-nudges.request-access-prompt-flag.join-button': 'Join your team',
    'cross-join-nudges.request-access-prompt-flag.not-interested-button': 'Not interested',
    'cross-join-nudges.request-access-prompt-flag.remind-me-later-button': 'Remind me later',
    'cross-join-nudges.request-access-prompt-flag.title': 'Your team is now using {product}',
    'cross-join-nudges.request-access-prompt-flag.title-jira-nudge': 'Join your team in using Jira',
    'cross-join-nudges.request-access-prompt-flag.title-jpd-nudge': 'Join your team in using Jira Product Discovery',
    'cross-join-nudges.request-access-prompt-flag.title-loom-nudge': 'Join your team on Loom',
    'cross-join-nudges.request-access-prompt-flag.title-not-interested': 'Your team is waiting for you in {product}',
    'cross-join-nudges.request-access-prompt-flag.title-reminder': 'Your team is working in {product}',
    'cross-join-nudges.request-access-success-flag.description': "You'll receive an email once they've reviewed it.",
    'cross-join-nudges.request-access-success-flag.title': 'A request was sent to your admins'
};


var $2f37d5078b127d0b$export$2e2bcd8739ae039 = (0, $4a63a3b5bacb8bda$export$2e2bcd8739ae039);

});

parcelRegister("kVIRg", function(module, exports) {

let $f3cbed6d618b220c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3cbed6d618b220c$var$load("aIwO0").then(()=>parcelRequire('kJXhH'));

});

parcelRegister("49i1r", function(module, exports) {

let $3055fb8d838d35a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3055fb8d838d35a1$var$load("iwseV").then(()=>parcelRequire('e9Wyv'));

});

parcelRegister("dasEj", function(module, exports) {

let $99626eace46d7bc5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99626eace46d7bc5$var$load("eh9w8").then(()=>parcelRequire('bcTDG'));

});

parcelRegister("lC97I", function(module, exports) {

let $fbc43951974296c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fbc43951974296c9$var$load("3eWGu").then(()=>parcelRequire('5UXdT'));

});

parcelRegister("3KIQf", function(module, exports) {

let $2bb87398117f81ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2bb87398117f81ac$var$load("8jVst").then(()=>parcelRequire('kaCr9'));

});

parcelRegister("gzQK5", function(module, exports) {

let $c118d3c33f76afeb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c118d3c33f76afeb$var$load("hNk7k").then(()=>parcelRequire('guYPm'));

});

parcelRegister("ePDTL", function(module, exports) {

let $acc4c71d953145e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $acc4c71d953145e3$var$load("arXo9").then(()=>parcelRequire('e65rL'));

});

parcelRegister("jl7HU", function(module, exports) {

let $e145f4faabedcc3c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e145f4faabedcc3c$var$load("yuLnu").then(()=>parcelRequire('e1RZ8'));

});

parcelRegister("c585o", function(module, exports) {

let $8cbc396421eb872f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8cbc396421eb872f$var$load("2pQv8").then(()=>parcelRequire('an7BE'));

});

parcelRegister("jAnnr", function(module, exports) {

let $e4238353f237f732$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4238353f237f732$var$load("jGBo1").then(()=>parcelRequire('hPdO5'));

});

parcelRegister("4HVkJ", function(module, exports) {

let $36d7a6cea6c2dbcc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $36d7a6cea6c2dbcc$var$load("eUrwV").then(()=>parcelRequire('9zs6n'));

});

parcelRegister("dcU0x", function(module, exports) {

let $99d7d752e5b33e72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99d7d752e5b33e72$var$load("2zgDh").then(()=>parcelRequire('7Xwbr'));

});

parcelRegister("iO7I3", function(module, exports) {

let $db12e072c5a651c7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db12e072c5a651c7$var$load("bETPT").then(()=>parcelRequire('hdK8A'));

});

parcelRegister("jat2x", function(module, exports) {

let $df457a364dd20276$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df457a364dd20276$var$load("ceBZg").then(()=>parcelRequire('2VxMN'));

});

parcelRegister("cekPs", function(module, exports) {

let $8e76f30f559a62ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8e76f30f559a62ae$var$load("5STWe").then(()=>parcelRequire('4Wh4F'));

});

parcelRegister("6U9LK", function(module, exports) {

let $506f8cfb12b55347$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $506f8cfb12b55347$var$load("EfE3i").then(()=>parcelRequire('8O7Z4'));

});

parcelRegister("gVZfP", function(module, exports) {

let $c5417c0dfc0e79ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c5417c0dfc0e79ed$var$load("hFqXA").then(()=>parcelRequire('kLJGE'));

});

parcelRegister("emNuY", function(module, exports) {

let $a7598426696e9c94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7598426696e9c94$var$load("4ArgV").then(()=>parcelRequire('13H9y'));

});

parcelRegister("17t4T", function(module, exports) {

let $0d0d002bb24934cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d0d002bb24934cc$var$load("28EDH").then(()=>parcelRequire('Uq9Kn'));

});

parcelRegister("hOImN", function(module, exports) {

let $cf89857e786325fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cf89857e786325fd$var$load("k3mTs").then(()=>parcelRequire('d55ia'));

});

parcelRegister("1Kgrq", function(module, exports) {

let $1456d73be4a91d07$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1456d73be4a91d07$var$load("jJdZ4").then(()=>parcelRequire('KN7Dc'));

});

parcelRegister("bybL2", function(module, exports) {

let $868bfd8110ab5362$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $868bfd8110ab5362$var$load("eZRzs").then(()=>parcelRequire('iF5yO'));

});

parcelRegister("hzFW1", function(module, exports) {

let $ccb63becee365084$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ccb63becee365084$var$load("bLQZ9").then(()=>parcelRequire('6QVDr'));

});

parcelRegister("kjxkN", function(module, exports) {

let $ec9f7080d5dc28ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec9f7080d5dc28ee$var$load("e0E8p").then(()=>parcelRequire('1N8wK'));

});

parcelRegister("7ttEc", function(module, exports) {

let $57123d31064ec9b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57123d31064ec9b4$var$load("4DYJ5").then(()=>parcelRequire('htQvj'));

});

parcelRegister("7OHuB", function(module, exports) {

let $5b0ef0a32cdfebe6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5b0ef0a32cdfebe6$var$load("hfFxJ").then(()=>parcelRequire('j0WBL'));

});

parcelRegister("jpB0s", function(module, exports) {

let $e21d0ed459cba5b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e21d0ed459cba5b6$var$load("gofGr").then(()=>parcelRequire('3MhJQ'));

});

parcelRegister("jCWwP", function(module, exports) {

let $e49ef77cd11b5ed2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e49ef77cd11b5ed2$var$load("aSjrK").then(()=>parcelRequire('2w1Sp'));

});

parcelRegister("lHMT3", function(module, exports) {

let $fcd38911f3085033$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fcd38911f3085033$var$load("7NpX8").then(()=>parcelRequire('h8y2B'));

});

parcelRegister("hJ9kV", function(module, exports) {

let $ce7de1afcb9ee695$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ce7de1afcb9ee695$var$load("bFU3Y").then(()=>parcelRequire('aqqCI'));

});

parcelRegister("5rwHI", function(module, exports) {

let $3f68d7b9efbcb761$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3f68d7b9efbcb761$var$load("exaJ2").then(()=>parcelRequire('3xPJL'));

});

parcelRegister("9qEKd", function(module, exports) {

let $6dd625be6f9625ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6dd625be6f9625ed$var$load("hcCcg").then(()=>parcelRequire('7MFNR'));

});

parcelRegister("a7JZv", function(module, exports) {

let $75ee3bb49917093a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $75ee3bb49917093a$var$load("j9KTb").then(()=>parcelRequire('5DyPd'));

});

parcelRegister("aD7ie", function(module, exports) {

let $7bd3342a3bf6e560$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7bd3342a3bf6e560$var$load("3hjAq").then(()=>parcelRequire('l8XHM'));

});

parcelRegister("bKGp5", function(module, exports) {

let $88e4e2124b30625d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $88e4e2124b30625d$var$load("2bCHJ").then(()=>parcelRequire('c3dIt'));

});

parcelRegister("c4Nwk", function(module, exports) {

let $8cac457f92dcad07$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8cac457f92dcad07$var$load("fdXnq").then(()=>parcelRequire('ekqU6'));

});

parcelRegister("6ZdFN", function(module, exports) {

let $51630bc246f641d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $51630bc246f641d7$var$load("cItJR").then(()=>parcelRequire('3JMfw'));

});

parcelRegister("kbvK1", function(module, exports) {

let $eb1d74e392bb15b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb1d74e392bb15b1$var$load("SctKm").then(()=>parcelRequire('kNuBD'));

});

parcelRegister("cRhRj", function(module, exports) {

let $95c849b0683abf74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $95c849b0683abf74$var$load("1fJz1").then(()=>parcelRequire('8WL5R'));

});

parcelRegister("ij8LW", function(module, exports) {

let $d540ce52c5131954$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d540ce52c5131954$var$load("9yA8o").then(()=>parcelRequire('hWeMa'));

});

parcelRegister("4AdNi", function(module, exports) {

let $356539744143d49b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $356539744143d49b$var$load("448N7").then(()=>parcelRequire('fyjTp'));

});

parcelRegister("46LQR", function(module, exports) {

let $2fdcd74f4ecb8583$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2fdcd74f4ecb8583$var$load("gBDdh").then(()=>parcelRequire('3DOrU'));

});

parcelRegister("fcybv", function(module, exports) {

let $b1127e5727eafd30$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1127e5727eafd30$var$load("epkdv").then(()=>parcelRequire('fwHlL'));

});

parcelRegister("clAdA", function(module, exports) {

let $8fd38a640f84ba43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8fd38a640f84ba43$var$load("fdczG").then(()=>parcelRequire('lpvU6'));

});

parcelRegister("1Ixw1", function(module, exports) {

let $1403e5f58898b361$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1403e5f58898b361$var$load("3MGOs").then(()=>parcelRequire('eefyR'));

});

parcelRegister("f6Mq7", function(module, exports) {

let $affcf9cbe0876a42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $affcf9cbe0876a42$var$load("innCz").then(()=>parcelRequire('eBv13'));

});

parcelRegister("ak97t", function(module, exports) {

let $7842d892d0e608ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7842d892d0e608ad$var$load("ebljE").then(()=>parcelRequire('8LR5Q'));

});

parcelRegister("glFbo", function(module, exports) {

let $be6e8d8875d506fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be6e8d8875d506fe$var$load("j4dSZ").then(()=>parcelRequire('5tR4J'));

});

parcelRegister("3Cc3L", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hQNhB = parcelRequire("hQNhB");


var $8C5kA = parcelRequire("8C5kA");


var $c6GJD = parcelRequire("c6GJD");


var $eCEXz = parcelRequire("eCEXz");


var $eXmBZ = parcelRequire("eXmBZ");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");











var $2Pg7f = parcelRequire("2Pg7f");


var $3gadb = parcelRequire("3gadb");

const $83a48c2a9ee27fa2$var$MAX_AVATARS_FEATURED_BOTTOM = 4;
const $83a48c2a9ee27fa2$var$MAX_AVATARS_FEATURED_TOP = 2;
const $83a48c2a9ee27fa2$export$29beada2d5f93289 = ({ position: position = 'bottom', data: data, ...props })=>{
    const maxAvatarCount = position === 'top' ? $83a48c2a9ee27fa2$var$MAX_AVATARS_FEATURED_TOP : $83a48c2a9ee27fa2$var$MAX_AVATARS_FEATURED_BOTTOM;
    const tooltipPosition = position;
    const { data: customData, overrides: customOverrides } = (0, $42omo.useMemo)(()=>$83a48c2a9ee27fa2$export$bc55c1ff86d63c4d({
            data: data,
            maxAvatarCount: maxAvatarCount
        }), [
        data,
        maxAvatarCount
    ]);
    const avatarGroup = /*#__PURE__*/ (0, $l998X.jsx)((0, $2Pg7f.default), {
        maxCount: maxAvatarCount,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        tooltipPosition: tooltipPosition,
        onMoreClick: (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB))),
        ...props
    });
    return avatarGroup;
};
const $83a48c2a9ee27fa2$export$bc55c1ff86d63c4d = ({ data: users, maxAvatarCount: maxAvatarCount = $83a48c2a9ee27fa2$var$MAX_AVATARS_FEATURED_BOTTOM })=>{
    const lastFeaturedUser = maxAvatarCount - 1;
    const overflowUsers = users.slice(lastFeaturedUser);
    const overrides = {
        MoreIndicator: {
            render: (Component, componentProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: overflowUsers.map((u)=>u.name).join(', '),
                    position: "top",
                    children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                        ...componentProps,
                        borderColor: "none",
                        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB)))
                    })
                })
        }
    };
    return {
        overrides: overrides,
        data: users
    };
};



var $6LPtl = parcelRequire("6LPtl");


var $51kba = parcelRequire("51kba");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $fVUfS = parcelRequire("fVUfS");

const $2ab564100a8568f0$var$styles = {
    button: "_11c8fhey _1reo15vq _18m915vq _1rjcze3t _18zrze3t _bfhksm61 _syaz13af _k48p1wq8 _p12f1w81 _9oik1r31 _1bnx8stv _jf4cnqa1"
};
const $2ab564100a8568f0$export$29d11c0fe2fc51d8 = ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        onClick: onClick,
        xcss: $2ab564100a8568f0$var$styles.button,
        children: children
    });
};



var $cgtv4 = parcelRequire("cgtv4");

const $5299b9331331d488$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    title: {
        id: "cross-join-nudges.request-access-prompt-flag.title",
        defaultMessage: "Your team is now using {product}"
    },
    titleReminder: {
        id: "cross-join-nudges.request-access-prompt-flag.title-reminder",
        defaultMessage: "Your team is working in {product}"
    },
    titleNotInterested: {
        id: "cross-join-nudges.request-access-prompt-flag.title-not-interested",
        defaultMessage: "Your team is waiting for you in {product}"
    },
    descriptionJira: {
        id: "cross-join-nudges.request-access-prompt-flag.description-jira",
        defaultMessage: "Stay on top of your tasks, unify your project workflow and track your team progress in Jira."
    },
    joinButton: {
        id: "cross-join-nudges.request-access-prompt-flag.join-button",
        defaultMessage: "Join your team"
    },
    remindMeLaterButton: {
        id: "cross-join-nudges.request-access-prompt-flag.remind-me-later-button",
        defaultMessage: "Remind me later"
    },
    notInterestedButton: {
        id: "cross-join-nudges.request-access-prompt-flag.not-interested-button",
        defaultMessage: "Not interested"
    },
    titleJpdNudge: {
        id: "cross-join-nudges.request-access-prompt-flag.title-jpd-nudge",
        defaultMessage: "Join your team in using Jira Product Discovery"
    },
    titleJiraNudgeMsr: {
        id: "cross-join-nudges.request-access-prompt-flag.title-jira-nudge",
        defaultMessage: "Join your team in using Jira"
    },
    descriptionJpdNudge: {
        id: "cross-join-nudges.request-access-prompt-flag.description-jpd-nudge",
        defaultMessage: "Prioritize ideas, share custom roadmaps, and unify your workflow from discovery to delivery."
    },
    getStartedButton: {
        id: "cross-join-nudges.request-access-prompt-flag.get-started-button",
        defaultMessage: "Get started"
    },
    doNotShowAgainButton: {
        id: "cross-join-nudges.request-access-prompt-flag.do-not-show-again-button",
        defaultMessage: "Don't show again"
    },
    descriptionJiraGalaxia: {
        id: "cross-join-nudges.request-access-prompt-flag.description-jira-galaxia",
        defaultMessage: "Stay on top of your tasks, unify your space workflow and track your team progress in Jira."
    },
    titleJiraConfluenceMsrNudge: {
        id: "cross-join-nudges.common.request-access-prompt-flag.title-jira-confluence-msr-nudge",
        defaultMessage: "Join your team in using Confluence"
    },
    descriptionJiraConfluenceMsrNudgeNoCollaborators: {
        id: "cross-join-nudges.common.request-access-prompt-flag.description-jira-confluence-msr-nudge-no-collaborators",
        defaultMessage: "Create project pages to build a shared understanding for better decision-making."
    },
    descriptionJiraConfluenceMsrNudgeWithCollaborators: {
        id: "cross-join-nudges.common.request-access-prompt-flag.description-jira-confluence-msr-nudge-with-collaborators",
        defaultMessage: "Organize team knowledge, capture ideas, and share requirements for your Jira projects. "
    },
    titleLoomNudge: {
        id: "cross-join-nudges.request-access-prompt-flag.title-loom-nudge",
        defaultMessage: "Join your team on Loom"
    },
    descriptionLoomNudge: {
        id: "cross-join-nudges.request-access-prompt-flag.description-loom-nudge",
        defaultMessage: "Use Loom videos to summarize pages and share information."
    }
});


const $ea34d206000e8fcb$var$messageLibrary = (()=>({
        crossJoinNudgesV3: {
            ctaButton: (0, $5299b9331331d488$export$defe85febe8b728c).joinButton,
            remindMeLaterButton: (0, $5299b9331331d488$export$defe85febe8b728c).remindMeLaterButton,
            optOutButton: (0, $5299b9331331d488$export$defe85febe8b728c).notInterestedButton,
            descriptionWithCollaborators: (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJiraGalaxia : (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJira,
            descriptionWithoutCollaborators: (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJiraGalaxia : (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJira,
            title: (0, $5299b9331331d488$export$defe85febe8b728c).title,
            titleReminder: (0, $5299b9331331d488$export$defe85febe8b728c).titleReminder,
            titleNotInterested: (0, $5299b9331331d488$export$defe85febe8b728c).titleNotInterested
        },
        crossJoinNudgesConfluenceToJpd: {
            ctaButton: (0, $5299b9331331d488$export$defe85febe8b728c).getStartedButton,
            remindMeLaterButton: (0, $5299b9331331d488$export$defe85febe8b728c).remindMeLaterButton,
            optOutButton: (0, $5299b9331331d488$export$defe85febe8b728c).doNotShowAgainButton,
            descriptionWithCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJpdNudge,
            descriptionWithoutCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJpdNudge,
            title: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge,
            titleReminder: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge,
            titleNotInterested: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge
        },
        crossJoinNudgesJiraToConfluence: {
            ctaButton: (0, $5299b9331331d488$export$defe85febe8b728c).getStartedButton,
            optOutButton: (0, $5299b9331331d488$export$defe85febe8b728c).remindMeLaterButton,
            descriptionWithCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJiraConfluenceMsrNudgeWithCollaborators,
            descriptionWithoutCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJiraConfluenceMsrNudgeNoCollaborators,
            title: (0, $5299b9331331d488$export$defe85febe8b728c).titleJiraConfluenceMsrNudge,
            titleReminder: (0, $5299b9331331d488$export$defe85febe8b728c).titleJiraConfluenceMsrNudge,
            titleNotInterested: (0, $5299b9331331d488$export$defe85febe8b728c).titleJiraConfluenceMsrNudge
        },
        crossJoinNudgesJiraToJpd: {
            ctaButton: (0, $5299b9331331d488$export$defe85febe8b728c).getStartedButton,
            optOutButton: (0, $5299b9331331d488$export$defe85febe8b728c).remindMeLaterButton,
            descriptionWithCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJpdNudge,
            descriptionWithoutCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJpdNudge,
            title: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge,
            titleReminder: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge,
            titleNotInterested: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge
        },
        crossJoinNudgesConfluenceToJiraMsr: {
            ctaButton: (0, $5299b9331331d488$export$defe85febe8b728c).getStartedButton,
            optOutButton: (0, $5299b9331331d488$export$defe85febe8b728c).remindMeLaterButton,
            descriptionWithCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJira,
            descriptionWithoutCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJira,
            title: (0, $5299b9331331d488$export$defe85febe8b728c).titleJiraNudgeMsr,
            titleReminder: (0, $5299b9331331d488$export$defe85febe8b728c).titleJiraNudgeMsr,
            titleNotInterested: (0, $5299b9331331d488$export$defe85febe8b728c).titleJiraNudgeMsr
        },
        crossJoinNudgesConfluenceToJpdMsr: {
            ctaButton: (0, $5299b9331331d488$export$defe85febe8b728c).getStartedButton,
            optOutButton: (0, $5299b9331331d488$export$defe85febe8b728c).doNotShowAgainButton,
            descriptionWithCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJpdNudge,
            descriptionWithoutCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJpdNudge,
            title: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge,
            titleReminder: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge,
            titleNotInterested: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge
        },
        crossJoinNudgesConfluenceToLoom: {
            ctaButton: (0, $5299b9331331d488$export$defe85febe8b728c).getStartedButton,
            remindMeLaterButton: (0, $5299b9331331d488$export$defe85febe8b728c).remindMeLaterButton,
            optOutButton: (0, $5299b9331331d488$export$defe85febe8b728c).notInterestedButton,
            descriptionWithCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionLoomNudge,
            descriptionWithoutCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionLoomNudge,
            title: (0, $5299b9331331d488$export$defe85febe8b728c).titleLoomNudge,
            titleReminder: (0, $5299b9331331d488$export$defe85febe8b728c).titleLoomNudge,
            titleNotInterested: (0, $5299b9331331d488$export$defe85febe8b728c).titleLoomNudge
        }
    }))();
const $ea34d206000e8fcb$var$MAX_NUMBER_OF_COLLABORATORS = 10;
const $ea34d206000e8fcb$var$styles = {
    descriptionWrapper: "_1reoewfl _18m9ewfl _195gze3t _19pkze3t _otyru2gc"
};
const $ea34d206000e8fcb$export$5a4ad4945410eb2c = ({ integration: integration, collaborators: collaborators, descriptionWithCollaborators: descriptionWithCollaborators = null, targetProduct: // Can be supplied to override the description when there are multiple collaborators
targetProduct, viewCount: viewCount, onSubmit: onSubmit, onDismiss: onDismiss, onSnoozeAndDismiss: onSnoozeAndDismiss, onOptoutAndDismiss: onOptoutAndDismiss, flagComponent: FlagComponent = (0, $eCEXz.default), ...props })=>{
    const handleOnSubmit = (0, $42omo.useCallback)(async ()=>{
        await onSubmit();
    }, [
        onSubmit
    ]);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const messages = $ea34d206000e8fcb$var$messageLibrary[integration];
    const customFlagFooterProps = (0, $42omo.useMemo)(()=>({
            // Workaround to achieve primary button + avatars in the footer.
            //
            // How this works:
            // We pass a dummy `action` that gets displayed in the Flag's footer
            // by the custom `linkComponent`. The component displays our actual footer.
            // This way, we don't occupy the limited space inside `description`.
            //
            // Why not use `actions` normally?
            // Because our Avatar Group is not an action, and even our Submit button
            // should be bold & blue (appearance="primary") which is not supported
            // by the AK Flag.
            //
            // Why not put this in `description`?
            // Because that one has a max height equivalent to 5 lines of text,
            // and our footer is taller than 2, causing an unwanted scrollbar
            // to show.
            actions: [
                {
                    content: '',
                    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB)))
                }
            ],
            linkComponent: ()=>{
                let secondCTA = null;
                if (viewCount === 1 && messages['remindMeLaterButton']) secondCTA = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ab564100a8568f0$export$29d11c0fe2fc51d8), {
                    onClick: onSnoozeAndDismiss,
                    children: formatMessage(messages['remindMeLaterButton'])
                });
                else if (viewCount > 1) secondCTA = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ab564100a8568f0$export$29d11c0fe2fc51d8), {
                    onClick: onOptoutAndDismiss,
                    children: formatMessage(messages['optOutButton'])
                });
                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignInline: "start",
                    grow: "fill",
                    alignBlock: "center",
                    separator: "\xb7",
                    space: "space.150",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2ab564100a8568f0$export$29d11c0fe2fc51d8), {
                            onClick: handleOnSubmit,
                            children: formatMessage(messages['ctaButton'])
                        }),
                        secondCTA
                    ]
                });
            }
        }), [
        viewCount,
        handleOnSubmit,
        formatMessage,
        messages,
        onSnoozeAndDismiss,
        onOptoutAndDismiss
    ]);
    const customIcon = (0, $42omo.useMemo)(()=>{
        return collaborators.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $83a48c2a9ee27fa2$export$29beada2d5f93289), {
            position: "top",
            data: collaborators.slice(0, $ea34d206000e8fcb$var$MAX_NUMBER_OF_COLLABORATORS).map((user)=>({
                    name: user.name,
                    src: user.avatar,
                    appearance: 'circle'
                })),
            boundariesElement: "scrollParent",
            size: "small"
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
            color: "var(--ds-icon-information, #357DE8)",
            label: ""
        });
    }, [
        collaborators
    ]);
    const title = viewCount === 0 ? messages['title'] : viewCount === 1 ? messages['titleReminder'] : messages['titleNotInterested'];
    const infoFlagTitle = formatMessage(title, {
        product: (0, $6LPtl.getProductDisplayName)(targetProduct)
    });
    const description = collaborators.length === 0 ? formatMessage(messages['descriptionWithoutCollaborators']) : descriptionWithCollaborators || formatMessage(messages['descriptionWithCollaborators']);
    return /*#__PURE__*/ (0, $l998X.jsx)(FlagComponent, {
        ...props,
        ...customFlagFooterProps,
        onDismissed: viewCount === 0 ? onDismiss : onSnoozeAndDismiss,
        title: infoFlagTitle,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $ea34d206000e8fcb$var$styles.descriptionWrapper,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                as: "p",
                maxLines: 3,
                children: description
            })
        }),
        icon: customIcon
    });
};
const $ea34d206000e8fcb$export$9b8813c3601640da = (0, $51kba.withLocalIntl)($ea34d206000e8fcb$export$5a4ad4945410eb2c);
module.exports["RequestAccessPromptFlag"] = $ea34d206000e8fcb$export$9b8813c3601640da;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("9Luz9", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $eCEXz = parcelRequire("eCEXz");


var $3sFtD = parcelRequire("3sFtD");


var $51kba = parcelRequire("51kba");


var $cgtv4 = parcelRequire("cgtv4");

const $c15a75c32a878fff$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    title: {
        id: "cross-join-nudges.request-access-success-flag.title",
        defaultMessage: "A request was sent to your admins"
    },
    description: {
        id: "cross-join-nudges.request-access-success-flag.description",
        defaultMessage: "You'll receive an email once they've reviewed it."
    }
});


const $eccd6d357c9d913e$export$567128fc1024c9cf = (0, $51kba.withLocalIntl)(({ onDismiss: onDismiss, flagComponent: FlagComponent = (0, $eCEXz.default), ...props })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)(FlagComponent, {
        ...props,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            spacing: "spacious",
            label: "Success",
            color: "var(--ds-icon-success, #6A9A23)"
        }),
        onDismissed: onDismiss,
        title: formatMessage((0, $c15a75c32a878fff$export$defe85febe8b728c).title),
        description: formatMessage((0, $c15a75c32a878fff$export$defe85febe8b728c).description)
    });
});
module.exports["RequestAccessSuccessFlag"] = $eccd6d357c9d913e$export$567128fc1024c9cf;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");


const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    if ((0, $4VJDS.default).isKillSwitchOn('cc_e2e_stable_ui')) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.location.search.includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
    return false;
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedToggle: $d24b02c281555a47$var$ChoreographerComponentStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("1Hbkf", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $fe3e94e79d9de90d$var$EXPIRY_IN_7_DAYS = 604800;
const $fe3e94e79d9de90d$var$EXPIRY_IN_30_DAYS = 2592000;
const $fe3e94e79d9de90d$export$262c003deb93a450 = async (integration)=>{
    try {
        if ($fe3e94e79d9de90d$export$ee4ac5fe77f8084a(integration)) return true;
        $fe3e94e79d9de90d$export$7a91674e4b755c4b(integration);
        if (!$fe3e94e79d9de90d$export$ee4ac5fe77f8084a(integration)) return true;
        return false;
    } catch  {
        return true;
    }
};
const $fe3e94e79d9de90d$export$64c6861c3bbd89a2 = (integration)=>{
    const value = (0, $17wUi.confluenceLocalStorageInstance).getItem($fe3e94e79d9de90d$var$getVisitedCountStorageKey(integration));
    return parseInt(value, 10) || 0;
};
const $fe3e94e79d9de90d$export$41554dcbb74e65ef = (integration)=>{
    const currentCount = $fe3e94e79d9de90d$export$64c6861c3bbd89a2(integration);
    (0, $17wUi.confluenceLocalStorageInstance).setItem($fe3e94e79d9de90d$var$getVisitedCountStorageKey(integration), currentCount + 1);
};
const $fe3e94e79d9de90d$export$7a91674e4b755c4b = (integration)=>{
    $fe3e94e79d9de90d$var$setFeatureVisited(integration, $fe3e94e79d9de90d$var$EXPIRY_IN_7_DAYS);
};
const $fe3e94e79d9de90d$export$788659dbff920e5f = (integration)=>{
    $fe3e94e79d9de90d$var$setFeatureVisited(integration, $fe3e94e79d9de90d$var$EXPIRY_IN_30_DAYS);
};
const $fe3e94e79d9de90d$var$setFeatureVisited = (integration, expire)=>{
    (0, $17wUi.confluenceLocalStorageInstance).setItem($fe3e94e79d9de90d$var$getVisitedStorageKey(integration), true, expire);
};
const $fe3e94e79d9de90d$export$ee4ac5fe77f8084a = (integration)=>(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean($fe3e94e79d9de90d$var$getVisitedStorageKey(integration));
const $fe3e94e79d9de90d$export$4ceb2f7d0e405037 = (integration)=>{
    (0, $17wUi.confluenceLocalStorageInstance).setItem($fe3e94e79d9de90d$var$getOptOutStorageKey(integration), true);
};
const $fe3e94e79d9de90d$export$c74d1fb7a364edae = (integration)=>(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean($fe3e94e79d9de90d$var$getOptOutStorageKey(integration));
function $fe3e94e79d9de90d$var$getOptOutStorageKey(integration) {
    switch(integration){
        case 'crossJoinNudgesV3':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_V3_USER_OPT_OUT;
        case 'crossJoinNudgesConfluenceToJpd':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_JPD_USER_OPT_OUT;
        case 'crossJoinNudgesConfluenceToJpdMsr':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_MSR_USER_OPT_OUT;
        case 'crossJoinNudgesConfluenceToJiraMsr':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_MSR_USER_OPT_OUT;
        case 'crossJoinNudgesConfluenceToLoom':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_OPT_OUT;
        default:
            return '';
    }
}
function $fe3e94e79d9de90d$var$getVisitedStorageKey(integration) {
    switch(integration){
        case 'crossJoinNudgesV3':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_V3_VISITED_KEY;
        case 'crossJoinNudgesConfluenceToJpd':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_JPD_VISITED_KEY;
        case 'crossJoinNudgesConfluenceToLoom':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_VISITED_KEY;
        default:
            return '';
    }
}
function $fe3e94e79d9de90d$var$getVisitedCountStorageKey(integration) {
    switch(integration){
        case 'crossJoinNudgesV3':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_V3_VISITED_COUNT;
        case 'crossJoinNudgesConfluenceToJpd':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_JPD_VISITED_COUNT;
        case 'crossJoinNudgesConfluenceToJpdMsr':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_MSR_VISITED_COUNT;
        case 'crossJoinNudgesConfluenceToJiraMsr':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_MSR_VISITED_COUNT;
        case 'crossJoinNudgesConfluenceToLoom':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_VISITED_COUNT;
        default:
            return '';
    }
}
module.exports["isFeatureVisited"] = $fe3e94e79d9de90d$export$262c003deb93a450;
module.exports["getFeatureVisited"] = $fe3e94e79d9de90d$export$ee4ac5fe77f8084a;
module.exports["snoozeFeatureFor7Days"] = $fe3e94e79d9de90d$export$7a91674e4b755c4b;
module.exports["getFeatureVisitedCount"] = $fe3e94e79d9de90d$export$64c6861c3bbd89a2;
module.exports["increaseFeatureVisitedCount"] = $fe3e94e79d9de90d$export$41554dcbb74e65ef;
module.exports["snoozeFeatureFor30Days"] = $fe3e94e79d9de90d$export$788659dbff920e5f;
module.exports["setUserOptedOut"] = $fe3e94e79d9de90d$export$4ceb2f7d0e405037;
module.exports["isUserOptedOut"] = $fe3e94e79d9de90d$export$c74d1fb7a364edae;

});

parcelRegister("biOtS", function(module, exports) {
const $5ce0e61a84ffab65$export$459d2a90e25243eb = 'cross_join_nudges_confluence_to_jpd_experiment';
const $5ce0e61a84ffab65$export$ff0d532025d54d77 = (integration, createAnalyticsEvent, { attributes: commonAttributes = {} } = {})=>(type, actionSubject, action, actionSubjectId, attributes)=>createAnalyticsEvent({
            type: type,
            data: {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                source: integration,
                attributes: {
                    ...commonAttributes,
                    ...attributes
                }
            }
        }).fire();
const $5ce0e61a84ffab65$export$ed26b312f8fb3da = (analytics, error)=>analytics('sendOperationalEvent', 'showCrossJoinNudges', 'failed', undefined, {
        message: String(error),
        details: {
            ...error || {}
        }
    });
const $5ce0e61a84ffab65$export$926c49ee4cec3927 = (analytics)=>analytics('sendUIEvent', 'flag', 'dismissed', 'requestAccessFlag');
const $5ce0e61a84ffab65$export$dfd781a069757128 = (analytics)=>analytics('sendUIEvent', 'flag', 'snoozed', 'requestAccessFlag');
const $5ce0e61a84ffab65$export$b02e37e6448a2f = (analytics)=>analytics('sendUIEvent', 'user', 'optedOut', 'requestAccessFlag');
const $5ce0e61a84ffab65$export$9ca55cf6ee7ca489 = (analytics)=>analytics('sendUIEvent', 'flag', 'shown', 'requestAccessFlag');
const $5ce0e61a84ffab65$export$951f0a85c06c95e8 = (analytics)=>analytics('sendUIEvent', 'joinButton', 'clicked', 'requestAccessFlag');
const $5ce0e61a84ffab65$export$b6a30d1aef42926f = (analytics)=>{
    analytics('sendTrackEvent', 'eligibility', 'checked', undefined, {
        flagKey: 'NON_CONTEXTUAL_CROSS_JOIN_NUDGES',
        ineligibilityReason: 'SITE_OPTED_OUT'
    });
};
const $5ce0e61a84ffab65$export$e19a7f6320c04dee = (analytics, nudgeId)=>{
    analytics('sendTrackEvent', 'eligibility', 'checked', undefined, {
        flagKey: 'NON_CONTEXTUAL_CROSS_JOIN_NUDGES',
        ineligibilityReason: 'MSR_NOT_RECOMMENDED',
        nudgeId: nudgeId
    });
};
const $5ce0e61a84ffab65$export$a303df7e5393c39c = (source, createAnalyticsEvent, { attributes: commonAttributes = {} } = {})=>(type, actionSubject, action, actionSubjectId, attributes)=>createAnalyticsEvent({
            type: type,
            data: {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...commonAttributes,
                    ...attributes
                }
            }
        }).fire();
const $5ce0e61a84ffab65$export$946cc509d91a25c0 = (analytics, error, actionSubject, action, analyticsAttributes)=>analytics('sendOperationalEvent', actionSubject, action, undefined, {
        message: String(error),
        details: {
            ...error || {}
        },
        ...analyticsAttributes
    });
const $5ce0e61a84ffab65$export$94f7de6ee481ded5 = (analytics, reason)=>analytics('sendTrackEvent', 'msrCjnEligibility', 'blocked', undefined, {
        reason: reason
    });
const $5ce0e61a84ffab65$export$5213517542ffdea7 = (analytics, attributes)=>analytics('sendTrackEvent', 'msrCjnEligibility', 'checked', undefined, attributes);
const $5ce0e61a84ffab65$export$ef76abaf7a2fcf22 = (analytics, attributes)=>analytics('sendTrackEvent', 'loomCjnEligibility', 'checked', undefined, attributes);
module.exports["getExperimentAnalytics"] = $5ce0e61a84ffab65$export$ff0d532025d54d77;
module.exports["fireExperimentError"] = $5ce0e61a84ffab65$export$ed26b312f8fb3da;
module.exports["fireFlagDismissed"] = $5ce0e61a84ffab65$export$926c49ee4cec3927;
module.exports["fireFlagSnoozed"] = $5ce0e61a84ffab65$export$dfd781a069757128;
module.exports["fireUserOptedOut"] = $5ce0e61a84ffab65$export$b02e37e6448a2f;
module.exports["fireFlagShown"] = $5ce0e61a84ffab65$export$9ca55cf6ee7ca489;
module.exports["fireJoinButtonClicked"] = $5ce0e61a84ffab65$export$951f0a85c06c95e8;
module.exports["fireSiteOptedOutAnalytics"] = $5ce0e61a84ffab65$export$b6a30d1aef42926f;
module.exports["fireMsrNotRecommendedAnalytics"] = $5ce0e61a84ffab65$export$e19a7f6320c04dee;
module.exports["getCustomExperimentAnalytics"] = $5ce0e61a84ffab65$export$a303df7e5393c39c;
module.exports["fireCustomExperimentError"] = $5ce0e61a84ffab65$export$946cc509d91a25c0;
module.exports["fireMsrCjnEligibilityBlocked"] = $5ce0e61a84ffab65$export$94f7de6ee481ded5;
module.exports["fireMsrCjnEligibilityChecked"] = $5ce0e61a84ffab65$export$5213517542ffdea7;
module.exports["fireLoomCjnEligibilityChecked"] = $5ce0e61a84ffab65$export$ef76abaf7a2fcf22;

});

parcelRegister("iuZ4N", function(module, exports) {
const $f476e317aa81769f$export$7663eef720c16d28 = async (product, cloudId, createAnalyticsEvent, source)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    const params = new URLSearchParams({
        resource: resource
    });
    try {
        const response = await fetch(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) {
            // 400 response means the user is not licensed for the product and we want to handle this case so it still caches the result.
            // For other error codes we still want to throw an error so the result is not cached.
            if (response.status === 400) return false;
            else throw new Error(`Unexpected response status: ${response.status}`);
        }
        const capabilities = (await response.json())?.results[resource];
        return capabilities === 'DIRECT_ACCESS' || capabilities === 'REQUEST_ACCESS';
    } catch (err) {
        // Source is required for operational events otherwise it won't fire
        if (createAnalyticsEvent && source) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'fetchError',
                actionSubject: 'capabilitiesCheck',
                source: source,
                attributes: {
                    message: String(err)
                }
            }
        }).fire();
        throw err;
    }
};
module.exports["canUserRequestAccess"] = $f476e317aa81769f$export$7663eef720c16d28;

});

parcelRegister("2RNw9", function(module, exports) {
const $88bc59deeed3fb0a$export$780c542cf1b3e229 = async (product, cloudId)=>{
    const data = {
        permissionId: 'write',
        resourceId: `ari:cloud:${product}::site/${cloudId}`
    };
    const response = await fetch('/gateway/api/permissions/permitted', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    return (await response.json()).permitted;
};
module.exports["hasAccessToProduct"] = $88bc59deeed3fb0a$export$780c542cf1b3e229;

});

parcelRegister("150tu", function(module, exports) {
const $fa075ae88637f89d$export$23b7746c9e6ae406 = async (product, cloudId)=>{
    const traitName = $fa075ae88637f89d$var$ACTIVATION_TRAITS[product] || undefined;
    if (!traitName) throw Error(`Unknown activation trait key for site product ${product}`);
    const siteTraits = await $fa075ae88637f89d$var$fetchSitePersonalization(cloudId);
    const productActivation = siteTraits.find((trait)=>trait.name === traitName);
    if (productActivation?.value) {
        const oneWeekLaterActivation = new Date(productActivation?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return false;
};
const $fa075ae88637f89d$export$e7b898c6b427cf14 = async (cloudId)=>{
    const traitName = $fa075ae88637f89d$var$ACTIVATION_TRAITS['loom'] || undefined;
    if (!traitName) throw Error(`Unknown activation trait key for site product Loom}`);
    const siteTraits = await $fa075ae88637f89d$var$fetchSitePersonalization(cloudId);
    const productActivation = siteTraits.find((trait)=>trait.name === traitName);
    if (productActivation?.value) {
        const oneWeekLaterActivation = new Date(productActivation?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return true;
};
const $fa075ae88637f89d$var$ACTIVATION_TRAITS = {
    'jira-software': 'jira-software.ondemand.activationDate',
    'jira-product-discovery': 'jira-product-discovery.activationDate',
    confluence: 'confluence.ondemand.activationDate',
    loom: 'loom.activationDate'
};
const $fa075ae88637f89d$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $fa075ae88637f89d$var$fetchSitePersonalization = async (cloudId)=>{
    const response = await fetch($fa075ae88637f89d$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    const { attributes: attributes } = await response.json();
    return attributes;
};
module.exports["isSite7DaysOld"] = $fa075ae88637f89d$export$23b7746c9e6ae406;
module.exports["isLoomSite7DaysOld"] = $fa075ae88637f89d$export$e7b898c6b427cf14;

});

parcelRegister("lRCxi", function(module, exports) {
const $6d3a2f07b0875b27$export$3475487c10c1ac17 = async (cloudId)=>{
    const siteTraits = await $6d3a2f07b0875b27$var$fetchSitePersonalization(cloudId);
    const optoutTraitValue = siteTraits.find((trait)=>trait.name === 'optout_all_messages')?.value;
    return typeof optoutTraitValue === 'boolean' && optoutTraitValue;
};
const $6d3a2f07b0875b27$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $6d3a2f07b0875b27$var$fetchSitePersonalization = async (cloudId)=>{
    const response = await fetch($6d3a2f07b0875b27$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const { attributes: attributes } = await response.json();
    return attributes;
};
module.exports["isSiteOptedOut"] = $6d3a2f07b0875b27$export$3475487c10c1ac17;

});

parcelRegister("aHsHn", function(module, exports) {
const $7fb0822596b2feb3$export$9641ccd51cea648b = async (cloudId, userId, trait)=>{
    const requiredDaysActive = 14;
    const userTraits = await $7fb0822596b2feb3$var$fetchUserPersonalization(cloudId, userId);
    const activationDateTrait = userTraits.find((t)=>t.name === trait);
    if (!activationDateTrait || typeof activationDateTrait.value !== 'string') return true;
    const activationDate = new Date(activationDateTrait.value);
    return $7fb0822596b2feb3$export$9b2c7fafd3ba5799(activationDate, requiredDaysActive);
};
const $7fb0822596b2feb3$export$9b2c7fafd3ba5799 = (startDate, thresholdDays)=>{
    const today = new Date();
    const dateAfterThreshold = new Date(startDate);
    dateAfterThreshold.setDate(startDate.getDate() + thresholdDays);
    return today <= dateAfterThreshold;
};
const $7fb0822596b2feb3$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $7fb0822596b2feb3$var$fetchUserPersonalization = async (cloudId, userId)=>{
    const response = await fetch($7fb0822596b2feb3$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    const { attributes: attributes } = await response.json();
    return attributes;
};
module.exports["isUserTooNew"] = $7fb0822596b2feb3$export$9641ccd51cea648b;

});

parcelRegister("hYAxW", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $b7194d4ca9996ac0$var$ONE_DAY_IN_MILLISECONDS = 86400000;
function $b7194d4ca9996ac0$export$6cca8a222d1193d7() {
    let queue = [];
    let locked = false;
    const acquireLock = ()=>{
        return new Promise((resolve)=>{
            const releaseLock = ()=>{
                locked = false;
                processQueue();
            };
            const grantLock = ()=>{
                locked = true;
                resolve(releaseLock);
            };
            if (locked) queue.push(()=>{
                grantLock();
            });
            else grantLock();
        });
    };
    const processQueue = ()=>{
        if (queue.length > 0) {
            const resolveNextItem = queue.shift();
            if (resolveNextItem) resolveNextItem();
        }
    };
    return {
        acquireLock: acquireLock
    };
}
function $b7194d4ca9996ac0$export$61c308f36d3fce82(control) {
    const mutex = $b7194d4ca9996ac0$export$6cca8a222d1193d7();
    function getControlCache() {
        const possibleObject = control.get();
        if (possibleObject === undefined || possibleObject === null || possibleObject === '') return {};
        return possibleObject;
    }
    return {
        get: async (key)=>{
            const releaseLock = await mutex.acquireLock();
            const storedValues = getControlCache();
            const storedCheck = storedValues[key];
            if (storedCheck !== null && storedCheck !== undefined) {
                const { value: { value: value, ttl: ttl } } = storedCheck;
                const pastTtl = ttl ? ttl < Date.now() : false;
                if (pastTtl) {
                    releaseLock();
                    return undefined;
                }
                releaseLock();
                return value;
            }
            releaseLock();
            return undefined;
        },
        set: async (key, value, daysToLive)=>{
            const releaseLock = await mutex.acquireLock();
            const storedValues = getControlCache();
            const keyValue = {
                value: {
                    value: value,
                    ...daysToLive ? {
                        ttl: new Date().getTime() + $b7194d4ca9996ac0$var$ONE_DAY_IN_MILLISECONDS * daysToLive
                    } : {}
                },
                timestamp: Date.now()
            };
            storedValues[key] = keyValue;
            control.set(storedValues);
            releaseLock();
        },
        delete: async (key)=>{
            const releaseLock = await mutex.acquireLock();
            const object = control.get();
            delete object[key];
            control.set(object);
            releaseLock();
        },
        deleteAll: async ()=>{
            const releaseLock = await mutex.acquireLock();
            control.delete();
            releaseLock();
        }
    };
}
function $b7194d4ca9996ac0$export$d932b194d241af5e(cache) {
    function withEligibilityCache(key, eligibilityCheck, daysToLive) {
        return async (...args)=>{
            try {
                const cachedValue = await cache.get(key);
                if (cachedValue !== undefined && cachedValue !== null) return cachedValue;
            } catch (e) {
            // cache get fail, do nothing
            }
            const result = await eligibilityCheck(...args);
            try {
                await cache.set(key, result, daysToLive);
            } catch (e) {
            // cache set fail, do nothing
            }
            return result;
        };
    }
    return withEligibilityCache;
}


const $0ca9c4cacb4d1123$var$cjnEligibilityCacheController = {
    get: ()=>(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_ELIGIBILITY_KEY),
    set: (value)=>(0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_ELIGIBILITY_KEY, value),
    delete: ()=>(0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_ELIGIBILITY_KEY)
};
const $0ca9c4cacb4d1123$export$beb12117dd89482e = (0, $b7194d4ca9996ac0$export$61c308f36d3fce82)($0ca9c4cacb4d1123$var$cjnEligibilityCacheController);
const $0ca9c4cacb4d1123$export$86938f072bd79cac = (0, $b7194d4ca9996ac0$export$d932b194d241af5e)($0ca9c4cacb4d1123$export$beb12117dd89482e);
const $0ca9c4cacb4d1123$export$29c2c598e956ca9c = {
    get: (key)=>{
        const storedValue = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_EVENT_CACHE_KEY);
        if (!storedValue) return undefined;
        const storedValueObject = JSON.parse(storedValue);
        return storedValueObject[key];
    },
    set: (key, value)=>{
        const storedValue = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_EVENT_CACHE_KEY) ?? '{}');
        storedValue[key] = value;
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_EVENT_CACHE_KEY, JSON.stringify(storedValue));
    },
    delete: (key)=>{
        const storedValue = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_EVENT_CACHE_KEY) ?? {};
        delete storedValue[key];
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_EVENT_CACHE_KEY, JSON.stringify(storedValue));
    }
};
const $0ca9c4cacb4d1123$export$9fafd3f54ebb3132 = {
    get: (key)=>{
        const storedValue = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY);
        if (!storedValue) return undefined;
        const storedValueObject = JSON.parse(storedValue);
        return storedValueObject[key];
    },
    set: (key, value)=>{
        const storedValue = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY) ?? '{}');
        storedValue[key] = value;
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY, JSON.stringify(storedValue));
    },
    delete: (key)=>{
        const storedValue = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY) ?? {};
        delete storedValue[key];
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_EVENT_CACHE_KEY, JSON.stringify(storedValue));
    }
};
const $0ca9c4cacb4d1123$export$2a72056994381bc4 = async ()=>{
    await $0ca9c4cacb4d1123$export$beb12117dd89482e.set('local_storage_enabled', true);
    const value = await $0ca9c4cacb4d1123$export$beb12117dd89482e.get('local_storage_enabled');
    return value === true;
};
const $0ca9c4cacb4d1123$export$d172f6d49154a44b = async ()=>{
    try {
        // overwrite the key even if it exists
        await $0ca9c4cacb4d1123$export$beb12117dd89482e.set('has_seen_nudge_in_last_7_days', true);
    } catch (e) {
    // cache set fail, do nothing
    }
};
const $0ca9c4cacb4d1123$export$f03b4069dddacff6 = async ()=>{
    try {
        return !!await $0ca9c4cacb4d1123$export$beb12117dd89482e.get('has_seen_nudge_in_last_7_days');
    } catch (e) {
    // cache get fail, return false
    }
    return false;
};
module.exports["cjnEligibilityCacheHandler"] = $0ca9c4cacb4d1123$export$beb12117dd89482e;
module.exports["withEligibilityCache"] = $0ca9c4cacb4d1123$export$86938f072bd79cac;
module.exports["cjnEventCacheController"] = $0ca9c4cacb4d1123$export$29c2c598e956ca9c;
module.exports["cjnLoomEventCacheController"] = $0ca9c4cacb4d1123$export$9fafd3f54ebb3132;
module.exports["isCacheEnabled"] = $0ca9c4cacb4d1123$export$2a72056994381bc4;
module.exports["setHasSeenNudgeInLast7Days"] = $0ca9c4cacb4d1123$export$d172f6d49154a44b;
module.exports["getHasSeenNudgeInLast7Days"] = $0ca9c4cacb4d1123$export$f03b4069dddacff6;

});

parcelRegister("dy62u", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $93599b1913d46edb$export$583909077c804932(overrides) {
    return (key, val)=>{
        if (Object.prototype.hasOwnProperty.call(overrides, key)) {
            const overrideVal = overrides[key];
            if (typeof overrideVal === 'boolean') return overrideVal;
        }
        return val;
    };
}


var $aV1pt = parcelRequire("aV1pt");




var $dQl1W = parcelRequire("dQl1W");





const $d21587c9a96cbb66$export$1ae8ed46ebb1741f = ({ cloudId: cloudId, product: product, subProduct: subProduct, onNoMsrResultsReturned: onNoMsrResultsReturned, onEligibilityReturned: onEligibilityReturned, onError: onError, getFeatureVisited: getFeatureVisited, setFeatureVisited: setFeatureVisited, getFeatureVisitedCount: getFeatureVisitedCount, setFeatureVisitedCount: setFeatureVisitedCount, overrides: overrides })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const sessionId = (0, $42omo.useRef)((0, $dQl1W.v4)());
    const getMSRNudgeRecommendations = (0, $aV1pt.useMSRNudgeRecommendations)({
        product: product,
        sessionId: sessionId.current,
        cloudId: cloudId,
        subProduct: subProduct
    });
    const { blockEligibilityUntilTomorrow: blockEligibilityUntilTomorrow, blockEligibilityToPreventRace: blockEligibilityToPreventRace, snooze: snooze } = (0, $aV1pt.useMsrSnoozeHandler)({
        setFeatureVisited: setFeatureVisited,
        setFeatureVisitedCount: setFeatureVisitedCount,
        getFeatureVisitedCount: getFeatureVisitedCount
    });
    const withOverrides = (0, $93599b1913d46edb$export$583909077c804932)(overrides);
    return (0, $42omo.useCallback)(async ({ nudges: nudges })=>{
        try {
            if (withOverrides('feature_visited_too_recently', getFeatureVisited())) return;
            blockEligibilityToPreventRace();
            const eligibilityResults = await Promise.all(nudges.map(async (nudge)=>{
                const eligibilityResult = await nudge.nudgeEligibility();
                onEligibilityReturned({
                    eligibilityResult: eligibilityResult,
                    key: nudge.nudgeKey
                });
                return {
                    ...nudge,
                    ...eligibilityResult
                };
            }));
            const eligibleNudges = eligibilityResults.filter((result)=>result.isEligible);
            if (eligibleNudges.length <= 0) return;
            const recommendations = await getMSRNudgeRecommendations();
            const nudgeKeys = nudges.map(({ nudgeKey: nudgeKey })=>nudgeKey);
            if (recommendations.filter((rec)=>nudgeKeys.includes(rec)).length <= 0) {
                blockEligibilityUntilTomorrow();
                onNoMsrResultsReturned();
                return;
            }
            for (const recommendation of recommendations){
                const nudge = eligibleNudges.find((nudge)=>nudge.nudgeKey === recommendation);
                if (nudge) {
                    snooze();
                    return nudge.showNudge({
                        sessionId: sessionId.current,
                        recommendedNudges: recommendations
                    });
                }
            }
        } catch (error) {
            blockEligibilityUntilTomorrow();
            onError(error);
        }
    }, [
        getFeatureVisited,
        getMSRNudgeRecommendations,
        blockEligibilityUntilTomorrow,
        blockEligibilityToPreventRace,
        withOverrides,
        snooze,
        onError,
        onNoMsrResultsReturned,
        onEligibilityReturned
    ]);
};



var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");





var $inPa6 = parcelRequire("inPa6");


var $biOtS = parcelRequire("biOtS");


var $hYAxW = parcelRequire("hYAxW");

const $f4d0e1e41d90bf5b$export$ca11b55c5a624a26 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const customAnalytics = (0, $biOtS.getCustomExperimentAnalytics)('crossJoinNudges', createAnalyticsEvent);
    /**
	 * Fire event only in case the event value has not been cached or cached value is different
	 * to prevent excessive number of analytics calls.
	 */ return (0, $42omo.useCallback)(({ value: value, key: key })=>{
        try {
            const cachedValue = (0, $hYAxW.cjnEventCacheController).get(key);
            if (!cachedValue || cachedValue.isEligible !== value.isEligible || cachedValue.reason !== value.reason) {
                (0, $biOtS.fireMsrCjnEligibilityChecked)(customAnalytics, {
                    ...value,
                    key: key
                });
                (0, $hYAxW.cjnEventCacheController).set(key, value);
            }
        } catch (e) {
        // cache get fail, do nothing
        }
    }, [
        customAnalytics
    ]);
};






var $4smS9 = parcelRequire("4smS9");


var $QU6QS = parcelRequire("QU6QS");

const $6316a449963c23a0$export$ab0d8295b09da679 = (queryKey)=>{
    const location = (0, $QU6QS.useLocation)();
    const queryParams = new URLSearchParams(location.search);
    const value = queryParams.get(queryKey);
    const overrides = {};
    if (value) value.split(',').forEach((key)=>{
        overrides[key.trim()] = false;
    });
    return overrides;
};





const $eb07c8986906989a$export$a03fea1e8104a2a4 = ()=>{
    const cachedHasEnrolledMsr = (0, $hYAxW.withEligibilityCache)('has_enrolled_msr_v1', async ()=>{
        // The first time this is accessed without being set, it will be set false
        return false;
    });
    return cachedHasEnrolledMsr();
};
const $eb07c8986906989a$export$31ce9592444f963b = ()=>{
    return (0, $hYAxW.cjnEligibilityCacheHandler).set('has_enrolled_msr_v1', true);
};
const $eb07c8986906989a$export$8681007d4029d94f = async ()=>{
    // MSR relies too heavily on localstorage to allow any users who have it disabled
    if (!await (0, $hYAxW.isCacheEnabled)()) return false;
    // Existing users of MSR variant/control
    if (await $eb07c8986906989a$export$a03fea1e8104a2a4()) return true;
    // Users who should be put into MSR variant/control
    if (!(0, $4smS9.hasSeenAnyNudgeExceptMsr)()) return true;
    return false;
};
function $eb07c8986906989a$export$7ec6e762c673df9() {
    return (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).CROSS_JOIN_NUDGES_MSR_VISITED_KEY) || false;
}
function $eb07c8986906989a$export$dcf8f0cd962f7c8f(daysExpiry) {
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_MSR_VISITED_KEY, true, daysExpiry * 86400);
}
function $eb07c8986906989a$export$f2efafc0691e783() {
    const val = Number((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_MSR_VISITED_COUNT));
    if (Number.isNaN(val)) return 0;
    return val;
}
function $eb07c8986906989a$export$a8c9fb94d252072d(count) {
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_MSR_VISITED_COUNT, count);
}

const $eb07c8986906989a$export$682826b64e5ea722 = ({ cloudId: cloudId, userId: userId, displayName: displayName, flags: flags, createAnalyticsEvent: createAnalyticsEvent, push: push, formatMessage: formatMessage })=>{
    const overrides = (0, $6316a449963c23a0$export$ab0d8295b09da679)('cjn_msr_overrides');
    const withOverrides = (0, $93599b1913d46edb$export$583909077c804932)(overrides);
    const customAnalytics = (0, $biOtS.getCustomExperimentAnalytics)('crossJoinNudges', createAnalyticsEvent);
    const fireOnlyNewEvent = (0, $f4d0e1e41d90bf5b$export$ca11b55c5a624a26)();
    const executeNudge = (0, $d21587c9a96cbb66$export$1ae8ed46ebb1741f)({
        cloudId: cloudId,
        getFeatureVisited: $eb07c8986906989a$export$7ec6e762c673df9,
        getFeatureVisitedCount: $eb07c8986906989a$export$f2efafc0691e783,
        onEligibilityReturned: ({ eligibilityResult: eligibilityResult, key: key })=>{
            fireOnlyNewEvent({
                value: eligibilityResult,
                key: key
            });
        },
        onNoMsrResultsReturned: ()=>{
            (0, $biOtS.fireMsrCjnEligibilityBlocked)(customAnalytics, 'no recommendations');
        },
        onError: (err)=>{
            if (err instanceof (0, $aV1pt.RecommendationError)) (0, $biOtS.fireCustomExperimentError)(customAnalytics, err.options.cause, 'msrCjnFetchRecommendation', 'failed', {
                cloudId: cloudId
            });
            else (0, $biOtS.fireCustomExperimentError)(customAnalytics, err, 'executeMSRNudge', 'failed', {
                cloudId: cloudId
            });
            (0, $biOtS.fireMsrCjnEligibilityBlocked)(customAnalytics, 'unexpected error');
        },
        overrides: overrides,
        product: 'confluence',
        subProduct: '',
        setFeatureVisited: $eb07c8986906989a$export$dcf8f0cd962f7c8f,
        setFeatureVisitedCount: $eb07c8986906989a$export$a8c9fb94d252072d
    });
    return (0, $42omo.useCallback)(async ()=>{
        const { getNudges: getNudges } = await (parcelRequire("3Ismv"));
        const nudges = getNudges({
            cloudId: cloudId,
            userId: userId,
            displayName: displayName,
            createAnalyticsEvent: createAnalyticsEvent,
            flags: flags,
            push: push,
            formatMessage: formatMessage,
            withOverrides: withOverrides
        });
        return executeNudge({
            nudges: nudges
        });
    }, [
        cloudId,
        userId,
        displayName,
        createAnalyticsEvent,
        flags,
        push,
        formatMessage,
        executeNudge,
        withOverrides
    ]);
};
module.exports["setEnrolledInMsr"] = $eb07c8986906989a$export$31ce9592444f963b;
module.exports["checkMsrCrossJoinNudgeEligibility"] = $eb07c8986906989a$export$8681007d4029d94f;
module.exports["getMsrFeatureVisitedCount"] = $eb07c8986906989a$export$f2efafc0691e783;
module.exports["useRunMsrNudges"] = $eb07c8986906989a$export$682826b64e5ea722;

});

parcelRegister("4smS9", function(module, exports) {

var $1Hbkf = parcelRequire("1Hbkf");

const $12100d07bed27d78$export$6e23d5af59907eac = ()=>{
    if ($12100d07bed27d78$export$51e43b8519b9ffae()) return true;
    if ($12100d07bed27d78$export$75241b993cf1b7e4()) return true;
    if ($12100d07bed27d78$export$f27ac85949171228()) return true;
    return false;
};
const $12100d07bed27d78$export$51e43b8519b9ffae = ()=>{
    if ((0, $1Hbkf.getFeatureVisitedCount)('crossJoinNudgesConfluenceToJpd') > 0) return true;
    return false;
};
const $12100d07bed27d78$export$75241b993cf1b7e4 = ()=>{
    if ((0, $1Hbkf.getFeatureVisitedCount)('crossJoinNudgesV3') > 0) return true;
    return false;
};
const $12100d07bed27d78$export$f27ac85949171228 = ()=>{
    if ((0, $1Hbkf.getFeatureVisitedCount)('crossJoinNudgesConfluenceToLoom') > 0) return true;
    return false;
};
module.exports["hasSeenAnyNudgeExceptMsr"] = $12100d07bed27d78$export$6e23d5af59907eac;

});

parcelRegister("3Ismv", function(module, exports) {

let $2b4b7b455107d3c7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2b4b7b455107d3c7$var$load("7rE1n").then(()=>parcelRequire('dkj8B'));

});

parcelRegister("fg10r", function(module, exports) {

let $b1b92168f648ab1a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1b92168f648ab1a$var$load("b2zon").then(()=>parcelRequire('3hjAC'));

});

parcelRegister("hZ7et", function(module, exports) {

let $d17dbe6607d3c721$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d17dbe6607d3c721$var$load("6wr18"),
    $d17dbe6607d3c721$var$load("lAzPQ"),
    $d17dbe6607d3c721$var$load("jle6Z"),
    $d17dbe6607d3c721$var$load("ffEVr"),
    $d17dbe6607d3c721$var$load("iAqyW"),
    $d17dbe6607d3c721$var$load("hhss7"),
    $d17dbe6607d3c721$var$load("878st")
]).then(()=>parcelRequire('iVuad'));

});

parcelRegister("aMFlV", function(module, exports) {

let $7d9e76db1aca47ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7d9e76db1aca47ff$var$load("6wr18"),
    $7d9e76db1aca47ff$var$load("lAzPQ"),
    $7d9e76db1aca47ff$var$load("ffEVr"),
    $7d9e76db1aca47ff$var$load("iAqyW"),
    $7d9e76db1aca47ff$var$load("hhss7"),
    $7d9e76db1aca47ff$var$load("6xJuR")
]).then(()=>parcelRequire('6fYhs'));

});

parcelRegister("gbvKD", function(module, exports) {

let $bc864d89a05a2cdc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bc864d89a05a2cdc$var$load("6wr18"),
    $bc864d89a05a2cdc$var$load("fjOTL"),
    $bc864d89a05a2cdc$var$load("8UKe0"),
    $bc864d89a05a2cdc$var$load("ffEVr"),
    $bc864d89a05a2cdc$var$load("hhss7"),
    $bc864d89a05a2cdc$var$load("ehu5c")
]).then(()=>parcelRequire('kfmcq'));

});

parcelRegister("f7MuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $1P1Tu.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $9zUhf.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $9zUhf.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($26d702ce000cc6e9$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId || !userId) return;
        $26d702ce000cc6e9$var$hasFetched = true;
        storeActions.start();
        $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser ?? false,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $922yL = parcelRequire("922yL");

var $e0SBo = parcelRequire("e0SBo");

var $cFEpk = parcelRequire("cFEpk");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, fallback to excluding the user
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: false,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $e0SBo.default)((0, $922yL.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $cFEpk.default)(cutoffDate) ? (0, $e0SBo.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("922yL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6936494635ea8bcb$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6936494635ea8bcb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("e0SBo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33b6ba3d9a58f3b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $a33b6ba3d9a58f3b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("6OFcd", function(module, exports) {

let $4f675e40131be4d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f675e40131be4d0$var$load("6aY84"),
    $4f675e40131be4d0$var$load("5CaYW"),
    $4f675e40131be4d0$var$load("jhQhN")
]).then(()=>parcelRequire('dYN4E'));

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("1o4fX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hqNcO = parcelRequire("hqNcO");

function $560b1fdf6e9d95bc$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $hqNcO.MILLISECONDS_IN_A_DAY));
}
function $560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $560b1fdf6e9d95bc$export$954628993bf3188e(trialEndTime - Date.now());
}
function $560b1fdf6e9d95bc$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $560b1fdf6e9d95bc$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $560b1fdf6e9d95bc$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $560b1fdf6e9d95bc$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndTime"] = $560b1fdf6e9d95bc$export$165abb069513be0e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $560b1fdf6e9d95bc$export$ee6c4faab08346c;

});

parcelRegister("hqNcO", function(module, exports) {
const $f5358d62f394b358$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $f5358d62f394b358$export$98a7370239de6730;

});

parcelRegister("e3X7L", function(module, exports) {
/**
 * @generated SignedSource<<018f680a41f998d85b2f3329e18a2d4f>>
 * @relayHash 6ea58338105a015fd443972b8fa8bd85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c621ba09ccc6f35017033687da8b71cefb7d4fe258097148bd0d767f32870c64
const $05607cbb6652fe1b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GrantAccessDialogLoaderQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GrantAccessDialogLoaderQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6ea58338105a015fd443972b8fa8bd85",
            "id": "c621ba09ccc6f35017033687da8b71cefb7d4fe258097148bd0d767f32870c64",
            "metadata": {},
            "name": "GrantAccessDialogLoaderQuery",
            "operationKind": "query",
            "text": "query GrantAccessDialogLoaderQuery($contentId:ID!,$accountId:ID!){singleContent(id:$contentId){id,title},user:confluence_atlassianUser(id:$accountId){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$05607cbb6652fe1b$var$node.hash = "65e9fca072feda54403e4da52299bc66";
var $05607cbb6652fe1b$export$2e2bcd8739ae039 = $05607cbb6652fe1b$var$node;
module.exports["default"] = $05607cbb6652fe1b$export$2e2bcd8739ae039;

});

parcelRegister("cOrQJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8z9j5 = parcelRequire("8z9j5");


var $60yhz = parcelRequire("60yhz");

/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $3ebd34920f1cc52c$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $42omo.useState)((0, $8z9j5.default)());
    (0, $42omo.useEffect)(()=>{
        const observer = new (0, $60yhz.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $3ebd34920f1cc52c$export$2e2bcd8739ae039 = $3ebd34920f1cc52c$var$useThemeObserver;
module.exports["default"] = $3ebd34920f1cc52c$export$2e2bcd8739ae039;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<634d8ca034d2498a989d5a4ffee872da>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");

var $9wgn8 = parcelRequire("9wgn8");

var $cVrnQ = parcelRequire("cVrnQ");

var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzgdfik _1dk7dfik _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $9wgn8.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $gMc0m.default)([
                    $1f9fb6b4b3bc4020$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6MlG5.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $l998X.jsxs)((0, $cVrnQ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $hcDON.default), {})
                ]
            })
        ]
    });
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $71feb0a29953fded$var$svgStyles = null;
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: 'var(--checkbox-background-color)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: 'var(--checkbox-tick-color)'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }),
                icon
            ]
        })
    });
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null;
const $edf27753e59bf881$var$disabledStyles = null;
const $edf27753e59bf881$var$labelStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _syazi7uo _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1gmx _80om13gf",
            "_h5e31j9a _1nzsr01l _1eszjmqp _yp0j1q28 _ay2wby5v _d51ul4ek _phftrsbi _1g1f1l7x _l6wkjmqp _1dik1q28 _1sfg1bqt _fpdjby5v _1yjc1v1w _oaj1rsbi _1j3h1bqt _eawb5w2r _1rda5w2r _18q02sac _13hr1j28",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("fBMbo", function(module, exports) {

var $dNGPK = parcelRequire("dNGPK");


var $7qH1e = parcelRequire("7qH1e");

function $b5cfafc926496f98$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $dNGPK.Context)._currentRenderer2 && (0, $dNGPK.Context)._currentValue2 || // grab value from default renderer
    (0, $dNGPK.Context)._currentValue || (0, $7qH1e.globalDi);
    return getDependencies(deps, target);
}
module.exports["di"] = $b5cfafc926496f98$export$479d1ccc5f2ab701;

});

parcelRegister("dNGPK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7qH1e = parcelRequire("7qH1e");

const $a0c113d1cdcf525c$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getDependencies: (0, $7qH1e.globalDi).getDependencies
});
module.exports["Context"] = $a0c113d1cdcf525c$export$841858b892ce1f4c;

});

parcelRegister("7qH1e", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $b1tX2 = parcelRequire("b1tX2");

const $568c54c2a75aa99b$var$replacementMap = new Map();
const $568c54c2a75aa99b$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($568c54c2a75aa99b$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $b1tX2.findInjectable)($568c54c2a75aa99b$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($568c54c2a75aa99b$var$replacementMap.size) throw new Error(`${(0, $ipvr6.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj));
    },
    clear () {
        $568c54c2a75aa99b$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $ipvr6.diRegistry).get(inj).global) (0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $b1tX2.removeInjectableFromMap)($568c54c2a75aa99b$var$replacementMap, inj));
    }
};
function $568c54c2a75aa99b$export$b887ce09d70113f9(thunk, deps) {
    $568c54c2a75aa99b$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function' && typeof result.finally === 'function') result.finally($568c54c2a75aa99b$export$a775919ebd7dd28a.clear);
        else $568c54c2a75aa99b$export$a775919ebd7dd28a.clear();
    }
}
module.exports["globalDi"] = $568c54c2a75aa99b$export$a775919ebd7dd28a;

});

parcelRegister("ipvr6", function(module, exports) {
const $d672f259068efdcd$export$4203fb010fad9bf0 = new WeakMap();
const $d672f259068efdcd$export$b8b9d90f9e5bd72b = 'react-magnetic-di';
module.exports["diRegistry"] = $d672f259068efdcd$export$4203fb010fad9bf0;
module.exports["PACKAGE_NAME"] = $d672f259068efdcd$export$b8b9d90f9e5bd72b;

});

parcelRegister("b1tX2", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $aqxLC = parcelRequire("aqxLC");

let $80670563c880fcd1$var$hasWarned = false;
function $80670563c880fcd1$export$5b28268982f175ba(message) {
    if (!$80670563c880fcd1$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $80670563c880fcd1$var$hasWarned = true;
    }
}
function $80670563c880fcd1$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $aqxLC.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $80670563c880fcd1$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $80670563c880fcd1$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $80670563c880fcd1$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $80670563c880fcd1$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $aqxLC.stats).track(candidate);
    return candidate;
}
module.exports["addInjectableToMap"] = $80670563c880fcd1$export$7a7134bdd2f9ae2e;
module.exports["removeInjectableFromMap"] = $80670563c880fcd1$export$8057a2244a849b7b;
module.exports["findInjectable"] = $80670563c880fcd1$export$7c436e151c3ee289;

});

parcelRegister("aqxLC", function(module, exports) {
const $79768685dc5c2f62$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $79768685dc5c2f62$export$7804429c45dff272 = {
    state: $79768685dc5c2f62$var$createState(),
    set (injObj) {
        var _injObj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === injObj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(injObj, new Error(`Unused "di" injectable: ${((_injObj$value = injObj.value) == null ? void 0 : _injObj$value.displayName) || injObj.value}.`, {
            cause: injObj.cause
        }));
        // reset to avoid potential memory leaks via stack traces
        injObj.cause = null;
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
    },
    reset () {
        this.state = $79768685dc5c2f62$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};
module.exports["stats"] = $79768685dc5c2f62$export$7804429c45dff272;

});

parcelRegister("5mB97", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3e7bd247c2a15a57$var$_react = $3e7bd247c2a15a57$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $3e7bd247c2a15a57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e7bd247c2a15a57$var$Document16Icon = (props)=>/*#__PURE__*/ $3e7bd247c2a15a57$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$3e7bd247c2a15a57$var$Document16Icon.displayName = 'Document16Icon';
var $3e7bd247c2a15a57$var$_default = module.exports.default = $3e7bd247c2a15a57$var$Document16Icon;

});

parcelRegister("i9cac", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36280b20a14c4f7$var$_react = $d36280b20a14c4f7$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d36280b20a14c4f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36280b20a14c4f7$var$Document24Icon = (props)=>/*#__PURE__*/ $d36280b20a14c4f7$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36280b20a14c4f7$var$Document24Icon.displayName = 'Document24Icon';
var $d36280b20a14c4f7$var$_default = module.exports.default = $d36280b20a14c4f7$var$Document24Icon;

});

parcelRegister("j6GAe", function(module, exports) {
$parcel$export(module.exports, "default", () => $90028f2cad692a01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $fP78j = parcelRequire("fP78j");

function $90028f2cad692a01$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("fP78j", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce53c8d1c9f5417$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

function $fce53c8d1c9f5417$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
}

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ]),
        children: children
    });
}

});

parcelRegister("66dpz", function(module, exports) {
$parcel$export(module.exports, "default", () => $893c7e3925139b9a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

function $893c7e3925139b9a$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});

parcelRegister("kXb3C", function(module, exports) {
$parcel$export(module.exports, "default", () => $5412502140f64e3a$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $5412502140f64e3a$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});

parcelRegister("fAGae", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f3b40ffeda05888$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a95f50e5543417b936016ac441fe40a9>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $fP78j = parcelRequire("fP78j");

function $0f3b40ffeda05888$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
}

});

parcelRegister("6Eovk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d797c8c4e4c6494$export$2e2bcd8739ae039);
/* eslint-disable import/no-default-export */ /* eslint-disable react/prop-types */ 
var $42omo = parcelRequire("42omo");


var $cMypa = parcelRequire("cMypa");

function $4d797c8c4e4c6494$export$2e2bcd8739ae039(props) {
    // Produce the image tag as is because there is no onLoad event in SSR
    // Also render image tag directly if the page was SSRed because react-render-image always render placeholder first.
    // This will make image flicker
    return props.src && (0, window.__SSR_RENDERED__) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.loaded) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMypa))), props);
}

});

parcelRegister("cMypa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $94e4a7d853f8088a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $94e4a7d853f8088a$var$React = $94e4a7d853f8088a$var$_interopRequireWildcard($42omo);
function $94e4a7d853f8088a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $94e4a7d853f8088a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $94e4a7d853f8088a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $94e4a7d853f8088a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $94e4a7d853f8088a$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $94e4a7d853f8088a$var$loaded() {
    return {
        isLoaded: true
    };
}
function $94e4a7d853f8088a$var$errored() {
    return {
        isErrored: true
    };
}
function $94e4a7d853f8088a$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $94e4a7d853f8088a$var$ImageRenderer = function(_React$Component) {
    $94e4a7d853f8088a$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $94e4a7d853f8088a$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $94e4a7d853f8088a$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $94e4a7d853f8088a$var$_possibleConstructorReturn(_this, _ret);
    }
    $94e4a7d853f8088a$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(this.props, nextProps)) this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($94e4a7d853f8088a$var$React.Component);
module.exports.default = $94e4a7d853f8088a$var$ImageRenderer;

});

parcelRegister("1Okf1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDhJe = parcelRequire("dDhJe");

const $6833d9101ef67c08$export$d08617a365fbe694 = (cardClient)=>(0, $42omo.useMemo)(()=>(0, $dDhJe.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $6833d9101ef67c08$export$d08617a365fbe694;

});

parcelRegister("6iY4P", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e9f22edb5bbb2a5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $kXb3C = parcelRequire("kXb3C");

function $0e9f22edb5bbb2a5$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("gZctg", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("ihBqS")).preventUnhandled);

var $ihBqS = parcelRequire("ihBqS");


});

parcelRegister("ihBqS", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $cmcCB = parcelRequire("cmcCB");

function $713d889559578e2f$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $713d889559578e2f$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $713d889559578e2f$var$start() {
    $713d889559578e2f$var$cleanup();
    $713d889559578e2f$var$unbindEvents = (0, $fFa3V.bindAll)(window, [
        {
            type: 'dragover',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $713d889559578e2f$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $713d889559578e2f$var$cleanup
        },
        ...(0, $cmcCB.getBindingsForBrokenDrags)({
            onDragEnd: $713d889559578e2f$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $713d889559578e2f$var$cleanup() {
    $713d889559578e2f$var$unbindEvents?.();
    $713d889559578e2f$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $713d889559578e2f$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $713d889559578e2f$var$cleanup();
}
const $713d889559578e2f$export$453c0582481cc59d = {
    start: $713d889559578e2f$var$start,
    stop: $713d889559578e2f$var$stop
};
module.exports["preventUnhandled"] = $713d889559578e2f$export$453c0582481cc59d;

});

parcelRegister("8DMug", function(module, exports) {

var $4c48T = parcelRequire("4c48T");


var $jtTDB = parcelRequire("jtTDB");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $g9Srd = parcelRequire("g9Srd");

/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $7a0922b43eeb26f0$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const exiting = (0, $g9Srd.useExitingPersistence)();
    const requestAnimationFrame = (0, $jtTDB.useRequestAnimationFrame)();
    const setTimeout = (0, $jtTDB.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $dclyF.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $4c48T.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $4c48T.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $7a0922b43eeb26f0$export$2e2bcd8739ae039 = $7a0922b43eeb26f0$var$ShrinkOut;
module.exports["default"] = $7a0922b43eeb26f0$export$2e2bcd8739ae039;

});

parcelRegister("5izcQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $QiYCb = parcelRequire("QiYCb");


var $6cnUO = parcelRequire("6cnUO");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $f788f1551fff696f$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $QiYCb.default), {
                name: name,
                hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$f788f1551fff696f$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $f788f1551fff696f$export$2e2bcd8739ae039 = $f788f1551fff696f$var$SpotlightTarget;
module.exports["default"] = $f788f1551fff696f$export$2e2bcd8739ae039;

});

parcelRegister("QiYCb", function(module, exports) {
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $e8Hkv = parcelRequire("e8Hkv");

const $9a3edd35791f2369$var$spanStyles = null; /**
                          * A wrapper component that conditionally applies a NodeResolver to its children.
                          *
                          * Note: NodeResolver should not be used in React 18 concurrent mode. This component
                          * is intended to be removed once the feature flag  is removed.
                          * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
                          * @param {ReactElement} props.children - The child elements to be wrapped.
                          * @param {string} props.name - The name to reference from Spotlight.
                          * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
                          * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
                          */ 
const $9a3edd35791f2369$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8Hkv))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: divRef,
        className: (0, $gMc0m.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
$9a3edd35791f2369$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $9a3edd35791f2369$export$2e2bcd8739ae039 = $9a3edd35791f2369$var$NodeResolverSpotlightTarget;
module.exports["default"] = $9a3edd35791f2369$export$2e2bcd8739ae039;

});

parcelRegister("bVAxT", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");

class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $T1bCI.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}
module.exports["RestrictionsDialogStateContainer"] = $20c3e8ab10e63e24$export$f91385b453474810;

});

parcelRegister("fXbFR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PxT5 = parcelRequire("4PxT5");

const $d2d9cd8fe7c899bb$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $4PxT5.useOnScreen)(ref);
    const dwellTimeRef = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $d2d9cd8fe7c899bb$export$15dda63faa44a0df;

});

parcelRegister("4PxT5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $944e21aa736984a5$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $944e21aa736984a5$export$edb9b52ab3f1abbb;

});

parcelRegister("eMqrF", function(module, exports) {

var $02AY0 = parcelRequire("02AY0");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/team/manifest.ts
var $ac2a0fd84662e75e$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $02AY0.IdentityTeamAriResourceOwner),
    resourceType: (0, $02AY0.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $ac2a0fd84662e75e$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $3NXcb.RegisteredAri) {
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $ac2a0fd84662e75e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $ac2a0fd84662e75e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
    constructor(opts){
        super(opts), this._teamId = opts.resourceIdSegmentValues.teamId;
    }
};
module.exports["IdentityTeamAri"] = $ac2a0fd84662e75e$export$33bbb2d79e520118;

});

parcelRegister("02AY0", function(module, exports) {
// src/identity/team/types.ts
var $007cdcdc857abd84$export$49beddf48ffb3f35 = "identity", $007cdcdc857abd84$export$b2079a2a841afe32 = "team";
module.exports["IdentityTeamAriResourceOwner"] = $007cdcdc857abd84$export$49beddf48ffb3f35;
module.exports["IdentityTeamAriResourceType"] = $007cdcdc857abd84$export$b2079a2a841afe32;

});

parcelRegister("b8JCF", function(module, exports) {

var $1VjMI = parcelRequire("1VjMI");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/jira/issue/manifest.ts
var $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1VjMI.JiraIssueAriResourceOwner),
    resourceType: (0, $1VjMI.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $81c3d4c7dce903d7$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
};
module.exports["JiraIssueAri"] = $81c3d4c7dce903d7$export$1da6808e89ee03e;

});

parcelRegister("1VjMI", function(module, exports) {
// src/jira/issue/types.ts
var $166a76280cbc11fa$export$665a39f1b4e29e0a = "jira", $166a76280cbc11fa$export$76beb4d0da177ad4 = "issue";
module.exports["JiraIssueAriResourceOwner"] = $166a76280cbc11fa$export$665a39f1b4e29e0a;
module.exports["JiraIssueAriResourceType"] = $166a76280cbc11fa$export$76beb4d0da177ad4;

});

parcelRegister("5JRMI", function(module, exports) {

var $ehowZ = parcelRequire("ehowZ");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/townsquare/project/manifest.ts
var $01140be010796b0a$var$townsquareProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $ehowZ.TownsquareProjectAriResourceOwner),
    resourceType: (0, $ehowZ.TownsquareProjectAriResourceType),
    resourceIdSlug: "{projectUuid}",
    resourceIdSegmentFormats: {
        projectUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/project/index.ts
var $01140be010796b0a$export$41215e8d01921e7d = class _TownsquareProjectAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectUuid() {
        return this._projectUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $01140be010796b0a$var$townsquareProjectAriStaticOpts.qualifier,
            platformQualifier: $01140be010796b0a$var$townsquareProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $01140be010796b0a$var$townsquareProjectAriStaticOpts.resourceOwner,
            resourceType: $01140be010796b0a$var$townsquareProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectUuid}`,
            resourceIdSegmentValues: {
                projectUuid: opts.projectUuid
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $01140be010796b0a$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $01140be010796b0a$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectUuid: this.projectUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectUuid = opts.resourceIdSegmentValues.projectUuid;
    }
};
module.exports["TownsquareProjectAri"] = $01140be010796b0a$export$41215e8d01921e7d;

});

parcelRegister("ehowZ", function(module, exports) {
// src/townsquare/project/types.ts
var $a655ae9218632ad3$export$a258bc824c789b17 = "townsquare", $a655ae9218632ad3$export$aa8900dadffaa32a = "project";
module.exports["TownsquareProjectAriResourceOwner"] = $a655ae9218632ad3$export$a258bc824c789b17;
module.exports["TownsquareProjectAriResourceType"] = $a655ae9218632ad3$export$aa8900dadffaa32a;

});

parcelRegister("fwXBL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edc088c8e1dff28f4540e843bee097cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4e8151e15b50def$var$_react = $b4e8151e15b50def$var$_interopRequireDefault((parcelRequire("42omo")));

var $b4e8151e15b50def$var$_baseNew = $b4e8151e15b50def$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b4e8151e15b50def$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObject".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing objects in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4e8151e15b50def$var$AssetsObjectIcon = (props)=>/*#__PURE__*/ $b4e8151e15b50def$var$_react.default.createElement($b4e8151e15b50def$var$_baseNew.default, Object.assign({
        name: "AssetsObjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.5v3.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V2.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM7 5.5h2v-3H7zm8 7.5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$b4e8151e15b50def$var$AssetsObjectIcon.displayName = 'AssetsObjectIcon';
var $b4e8151e15b50def$var$_default = module.exports.default = $b4e8151e15b50def$var$AssetsObjectIcon;

});

parcelRegister("e4o8D", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $2679ebd914f0a083$export$96e8e9e8e57310bb = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    return renderServerPlaceholder;
} : (renderServerPlaceholderOnNonHydrate = false)=>{
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    !isTransition || Boolean(undefined) : // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    (0, $42omo.useEffect)(()=>{
        setRenderServerPlaceholder(false);
    }, []);
    return renderServerPlaceholder;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["VIEW_AI_PRESENTATION_INTERACTION"] = $4fa41f80373a2ebe$export$af1eb8557193d022;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("etJRk", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $7W8i8 = parcelRequire("7W8i8");


var $17wUi = parcelRequire("17wUi");


var $5GjsS = parcelRequire("5GjsS");

const $4b46d4dc3abd42c4$var$logger = (0, $7W8i8.getLogger)('useLoomAiMeetingNotesSideNavCardListener');
const $4b46d4dc3abd42c4$var$ACCEPTED_MEETING_NOTES_TEMPLATE_IDS = [
    'com.atlassian.confluence.plugins.confluence-business-blueprints:1-on-1-meeting-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:all-hands-meeting-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:page-led-meetings-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:remote-team-meeting-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-blueprint',
    'com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-blueprint'
];
const $4b46d4dc3abd42c4$var$isAcceptedTemplateId = (templateId)=>{
    return $4b46d4dc3abd42c4$var$ACCEPTED_MEETING_NOTES_TEMPLATE_IDS.includes(templateId);
};
const $4b46d4dc3abd42c4$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        isSideNavCardEligible: false
    },
    actions: {
        showLoomAiMeetingNotesSideNavCardIfMeetingNotesTemplate: (templateId, onLocalStorageFail)=>({ setState: setState })=>{
                if ($4b46d4dc3abd42c4$var$isAcceptedTemplateId(templateId)) {
                    try {
                        /**
						 * Reason we are using local storage:
						 * - it persists across browser sessions and tab closures, ensuring the user's interaction is remembered
						 * - This is important for the "create from template" macro which opens the template in a new tab (instead of same page)
						 */ (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $5GjsS.USER_HAS_CLICKED_ON_MEETING_NOTES_TEMPLATE_KEY), true);
                    } catch (setError) {
                        /**
						 * this is here to avoid uncaught storage errors
						 */ $4b46d4dc3abd42c4$var$logger.error`An error occurred while setting local storage: ${setError}`;
                        onLocalStorageFail?.();
                    }
                    setState({
                        isSideNavCardEligible: true
                    });
                }
            }
    }
});
const $4b46d4dc3abd42c4$export$b24c0c9f7b270c76 = (0, $9zUhf.createStateHook)($4b46d4dc3abd42c4$var$store);
const $4b46d4dc3abd42c4$export$3608a4533235df3f = (0, $9zUhf.createActionsHook)($4b46d4dc3abd42c4$var$store);
module.exports["useLoomAiMeetingNotesSideNavCardState"] = $4b46d4dc3abd42c4$export$b24c0c9f7b270c76;
module.exports["useLoomAiMeetingNotesSideNavCardActions"] = $4b46d4dc3abd42c4$export$3608a4533235df3f;

});

parcelRegister("1KBSi", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $fEhQK = parcelRequire("fEhQK");

const $15029de520f1b9e8$export$cadd7e072478f5e = ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: canCreateData } = (0, $jMyy4.useQueryInterop)(// Due to circular dependency issues we are using the PreloadCreateSpaceQuery from create-space-preload package
    (0, $fEhQK.default), {
        skip: !isLicensed
    });
    const canCreateSpace = Boolean(canCreateData?.user?.confluence?.operations.some((obj)=>obj?.operation === 'create_space'));
    return {
        canCreateSpace: canCreateSpace
    };
};
module.exports["useCanCreateSpace"] = $15029de520f1b9e8$export$cadd7e072478f5e;

});

parcelRegister("14SPd", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

var $jIOyV = parcelRequire("jIOyV");

const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
const $8ab24ab9418ac89d$export$2ba38536ff91e2a7 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.RESTRICTIONS_DIALOG_INTERACTION)
});
module.exports["RESTRICTIONS_BUTTON_METRIC"] = $8ab24ab9418ac89d$export$34cc51d2a4e5cf67;
module.exports["RESTRICTIONS_DIALOG_METRIC"] = $8ab24ab9418ac89d$export$2ba38536ff91e2a7;

});

parcelRegister("eznrX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6dad959d4748daed02c67a782b9b76e4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9b6863a6285bd23$var$_react = $a9b6863a6285bd23$var$_interopRequireDefault((parcelRequire("42omo")));

var $a9b6863a6285bd23$var$_baseNew = $a9b6863a6285bd23$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a9b6863a6285bd23$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextAudioTranscript".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for viewing transcript in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9b6863a6285bd23$var$TextAudioTranscriptIcon = (props)=>/*#__PURE__*/ $a9b6863a6285bd23$var$_react.default.createElement($a9b6863a6285bd23$var$_baseNew.default, Object.assign({
        name: "TextAudioTranscriptIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 0H2v1.5h14zM6 5.105C6 4.315 5.418 3.5 4.5 3.5S3 4.314 3 5.105v3.29C3 9.185 3.582 10 4.5 10S6 9.186 6 8.395zm10-.939H8.959v1.5H16zm0 4.167h-5v1.5h5zm-8.5.062v.073c0 1.699-1.328 3.052-3 3.052s-3-1.353-3-3.052v-.073H0v.073c0 2.247 1.593 4.131 3.75 4.49V14.5H1.5V16h6v-1.5H5.25v-1.542C7.407 12.6 9 10.715 9 8.468v-.073zm8.5 4.104h-5v1.5h5z" clip-rule="evenodd"/>`
    }, props));
$a9b6863a6285bd23$var$TextAudioTranscriptIcon.displayName = 'TextAudioTranscriptIcon';
var $a9b6863a6285bd23$var$_default = module.exports.default = $a9b6863a6285bd23$var$TextAudioTranscriptIcon;

});

parcelRegister("4S8ti", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $9HkI0 = parcelRequire("9HkI0");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $dPJCf = parcelRequire("dPJCf");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $aV1pt = parcelRequire("aV1pt");




const $1ae11c45c0b3d6dc$export$8e19800337f63156 = ()=>{
    const hasFired = (0, $42omo.useRef)(false);
    return (0, $42omo.useCallback)((event)=>{
        if (hasFired.current) return;
        hasFired.current = true;
        event.fire();
    }, []);
};



var $dy62u = parcelRequire("dy62u");








var $biOtS = parcelRequire("biOtS");


var $hYAxW = parcelRequire("hYAxW");

const $3f1df2e5e7061ec6$export$57ede52633f7b520 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const customAnalytics = (0, $biOtS.getCustomExperimentAnalytics)('crossJoinNudges', createAnalyticsEvent);
    /**
	 * Fire event only in case the event value has not been cached or cached value is different
	 * to prevent excessive number of analytics calls.
	 */ return (0, $42omo.useCallback)(({ value: value, key: key })=>{
        try {
            const cachedValue = (0, $hYAxW.cjnLoomEventCacheController).get(key);
            if (!cachedValue || cachedValue.eligible !== value.eligible || cachedValue.ineligibilityReason !== value.ineligibilityReason) {
                (0, $biOtS.fireLoomCjnEligibilityChecked)(customAnalytics, {
                    ...value,
                    key: key
                });
                (0, $hYAxW.cjnLoomEventCacheController).set(key, value);
            }
        } catch (e) {
        // cache get fail, do nothing
        }
    }, [
        customAnalytics
    ]);
};





const $40e69e7df4e12fd0$export$b73ba4b3997f9abe = ({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { cloudId: cloudId, userId: userId, displayName: displayName, locale: locale } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticEventOnceForMsr = (0, $1ae11c45c0b3d6dc$export$8e19800337f63156)();
    const fireAnalyticEventOnceForLoom = (0, $1ae11c45c0b3d6dc$export$8e19800337f63156)();
    const fireOnlyNewLoomEvent = (0, $3f1df2e5e7061ec6$export$57ede52633f7b520)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const runMsrNudges = (0, $dy62u.useRunMsrNudges)({
        cloudId: cloudId,
        userId: userId,
        displayName: displayName,
        flags: flags,
        createAnalyticsEvent: createAnalyticsEvent,
        push: push,
        formatMessage: formatMessage
    });
    const getMSRNudgeRecommendations = (0, $aV1pt.useMSRNudgeRecommendations)({
        product: 'confluence',
        sessionId: (0, $9HkI0.v4)(),
        cloudId: cloudId,
        subProduct: ''
    });
    (0, $42omo.useEffect)(()=>{
        const execNudges = async ()=>{
            const { checkJpdCrossJoinNudgeEligibility: checkJpdCrossJoinNudgeEligibility, showJpdCrossJoinNudge: showJpdCrossJoinNudge, triggerJiraCrossJoinNudge: triggerJiraCrossJoinNudge } = await Promise.resolve((parcelRequire("8AKrx")));
            const isJpdCrossJoinNudgesEligible = await checkJpdCrossJoinNudgeEligibility({
                cloudId: cloudId,
                userId: userId,
                createAnalyticsEvent: createAnalyticsEvent,
                getMSRNudgeRecommendations: getMSRNudgeRecommendations
            });
            isJpdCrossJoinNudgesEligible ? await showJpdCrossJoinNudge({
                cloudId: cloudId,
                userId: userId,
                displayName: displayName,
                flags: flags,
                createAnalyticsEvent: createAnalyticsEvent,
                push: push,
                formatMessage: formatMessage
            }) : await triggerJiraCrossJoinNudge({
                cloudId: cloudId,
                userId: userId,
                displayName: displayName,
                flags: flags,
                createAnalyticsEvent: createAnalyticsEvent,
                push: push,
                formatMessage: formatMessage,
                getMSRNudgeRecommendations: getMSRNudgeRecommendations
            });
        };
        const execNudgesWithLoom = async ()=>{
            if (!userId || !(locale || '').toLowerCase().startsWith('en') || !(0, $9wGTI.fg)('twcg-443-cjn-confluence-loom-killswitch')) {
                await execNudges();
                return;
            }
            const { checkLoomCrossJoinNudgeEligibility: checkLoomCrossJoinNudgeEligibility, showLoomCrossJoinNudge: showLoomCrossJoinNudge } = await (parcelRequire("fg10r"));
            const isLoomCrossJoinNudgesEligible = await checkLoomCrossJoinNudgeEligibility({
                cloudId: cloudId,
                userId: userId,
                createAnalyticsEvent: createAnalyticsEvent
            });
            if (isLoomCrossJoinNudgesEligible.eligible) {
                if ((0, $6mKj3.expVal)('twcg-443-cjn-confluence-loom', 'cohort', 'not-enrolled') !== 'not-enrolled') fireAnalyticEventOnceForLoom(createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'exposed',
                        actionSubject: 'confluenceToLoomNudgeFeature',
                        source: 'crossJoinNudges',
                        attributes: {
                            flagKey: 'twcg-443-cjn-confluence-loom',
                            cohort: (0, $6mKj3.expVal)('twcg-443-cjn-confluence-loom', 'cohort', 'not-enrolled')
                        }
                    }
                }));
                await showLoomCrossJoinNudge({
                    cloudId: cloudId,
                    userId: userId,
                    displayName: displayName,
                    flags: flags,
                    createAnalyticsEvent: createAnalyticsEvent,
                    formatMessage: formatMessage
                });
            } else {
                // Track eligibility failure reasons
                fireOnlyNewLoomEvent({
                    value: isLoomCrossJoinNudgesEligible,
                    key: 'cjn-conf-loom'
                });
                await execNudges();
            }
        };
        const orchestrateNudges = async ()=>{
            const { checkMsrCrossJoinNudgeEligibility: checkMsrCrossJoinNudgeEligibility, setEnrolledInMsr: setEnrolledInMsr } = await Promise.resolve((parcelRequire("dy62u")));
            if (await checkMsrCrossJoinNudgeEligibility()) {
                if ((0, $6mKj3.expValEquals)('twcg-437-cjn-msr-m1', 'cohort', 'variation')) {
                    fireAnalyticEventOnceForMsr(createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'exposed',
                            actionSubject: 'msrCjnExperiment',
                            source: 'crossJoinNudges',
                            attributes: {
                                flagKey: 'twcg-437-cjn-msr-m1',
                                value: 'variation'
                            }
                        }
                    }));
                    setEnrolledInMsr();
                    await runMsrNudges();
                } else if ((0, $6mKj3.expValEquals)('twcg-437-cjn-msr-m1', 'cohort', 'control')) {
                    fireAnalyticEventOnceForMsr(createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'exposed',
                            actionSubject: 'msrCjnExperiment',
                            source: 'crossJoinNudges',
                            attributes: {
                                flagKey: 'twcg-437-cjn-msr-m1',
                                value: 'control'
                            }
                        }
                    }));
                    setEnrolledInMsr();
                    await execNudges();
                } else await execNudges();
            } else await execNudgesWithLoom();
        };
        const init = async ()=>{
            await orchestrateNudges();
        };
        init();
    // Disabling as we only want this to execute based on `execNudge` or if `flags` gets updated.
    // This prevents edge cases where flags might be shown twice due to
    // Complex dependency arrays of children components/dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        flags
    ]);
};
const $40e69e7df4e12fd0$export$6e567f651a10d419 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    $40e69e7df4e12fd0$export$b73ba4b3997f9abe({
        flags: flags
    });
    return null;
});
module.exports["CrossJoinNudgesWithFlags"] = $40e69e7df4e12fd0$export$6e567f651a10d419;

});

parcelRegister("2IyA1", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $b7ebdacf1aaf3f09$export$c1e568f41a04bfb1 = (0, $cgtv4.defineMessages)({
    CJNNonContextualNote: {
        id: "cross-join-nudges.contextual-note.generic",
        defaultMessage: "{requestingUser} needs {requestingApp} access {valueProp}."
    },
    jpdValueProp: {
        id: "cross-join-nudges.non-contextual-note.jpd-value-prop",
        defaultMessage: "to prioritize ideas and create roadmaps"
    },
    jiraValueProp: {
        id: "cross-join-nudges.non-contextual-note.jira-value-prop",
        defaultMessage: "to plan and track work"
    },
    loomValueProp: {
        id: "cross-join-nudges.non-contextual-note.loom-value-prop",
        defaultMessage: "to create and edit videos"
    },
    confluenceValueProp: {
        id: "cross-join-nudges.non-contextual-note.confluence-value-prop",
        defaultMessage: "to collaborate on pages and whiteboards"
    }
});
module.exports["nonContextualNoteMessages"] = $b7ebdacf1aaf3f09$export$c1e568f41a04bfb1;

});

parcelRegister("6LPtl", function(module, exports) {
const $5bc94f32b32b3a52$export$2a1baa97ca79d572 = {
    confluence: 'Confluence',
    jira: 'Jira',
    'jira-software': 'Jira',
    'jira-product-discovery': 'Jira Product Discovery',
    loom: 'Loom'
};
const $5bc94f32b32b3a52$export$44fea6589b7ddc92 = (product)=>$5bc94f32b32b3a52$export$2a1baa97ca79d572[product];
module.exports["getProductDisplayName"] = $5bc94f32b32b3a52$export$44fea6589b7ddc92;

});

parcelRegister("51kba", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $4yBJM = parcelRequire("4yBJM");


var $4opcN = parcelRequire("4opcN");


var $h2Pgl = parcelRequire("h2Pgl");

// Merge default English messages at module level to avoid missing translation errors
const $a785c260fdcc781d$var$DEFAULT_MERGED_MESSAGES = {
    ...(0, $4yBJM.default),
    ...(0, $4opcN.default)
};
const $a785c260fdcc781d$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        // Normalize locale - Intl.Locale doesn't like underscores
        const normalizedLocale = locale.replace('_', '-');
        const finalLocale = new Intl.Locale(normalizedLocale).toString();
        // Fetch messages from both packages in parallel
        const [crossJoinNudgesModule, globalShortcutsModule] = await Promise.all([
            (0, $h2Pgl.fetchLanguageFile)(finalLocale).catch(()=>({
                    default: {}
                })),
            (0, $h2Pgl.fetchGlobalShortcutsLanguageFile)(finalLocale).catch(()=>({
                    default: {}
                }))
        ]);
        const crossJoinNudgesMessages = crossJoinNudgesModule.default || crossJoinNudgesModule;
        const globalShortcutsMessages = globalShortcutsModule.default || globalShortcutsModule;
        // Merge messages: cross-join-nudges messages take precedence over global-shortcuts
        // Start with defaults, then override with locale-specific messages
        const mergedMessages = {
            ...$a785c260fdcc781d$var$DEFAULT_MERGED_MESSAGES,
            ...globalShortcutsMessages,
            ...crossJoinNudgesMessages
        };
        return mergedMessages;
    } catch (// eslint-disable-next-line no-unused-vars
    e) {
        // If loading fails, return default messages
        return $a785c260fdcc781d$var$DEFAULT_MERGED_MESSAGES;
    }
};
const $a785c260fdcc781d$export$c5d7da1d3dca7da2 = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        defaultMessages: $a785c260fdcc781d$var$DEFAULT_MERGED_MESSAGES,
        loaderFn: $a785c260fdcc781d$export$2b153a2030b0feb2,
        children: children
    });
function $a785c260fdcc781d$export$2a4cd3780f93f2ef(Component) {
    return function WithLocalIntlComponent(props) {
        return /*#__PURE__*/ (0, $l998X.jsx)($a785c260fdcc781d$export$c5d7da1d3dca7da2, {
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...props
            })
        });
    };
}
module.exports["withLocalIntl"] = $a785c260fdcc781d$export$2a4cd3780f93f2ef;

});

parcelRegister("aV1pt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $83WWS = parcelRequire("83WWS");

const $72eddac512bc7ced$var$SNOOZE_INTERVALS = {
    0: 7,
    1: 14,
    2: 30,
    3: 90
};
const $72eddac512bc7ced$export$929578679169c83e = ({ setFeatureVisited: setFeatureVisited, getFeatureVisitedCount: getFeatureVisitedCount, setFeatureVisitedCount: setFeatureVisitedCount })=>{
    const blockEligibilityToPreventRace = (0, $42omo.useCallback)(()=>{
        setFeatureVisited(0.1);
    }, [
        setFeatureVisited
    ]);
    const blockEligibilityUntilTomorrow = (0, $42omo.useCallback)(()=>{
        setFeatureVisited(1);
    }, [
        setFeatureVisited
    ]);
    const snooze = (0, $42omo.useCallback)(()=>{
        const visitedCount = getFeatureVisitedCount();
        // We are going to loop the last nudge indefinitely
        const loopedVisitedCount = Math.min(visitedCount, Object.keys($72eddac512bc7ced$var$SNOOZE_INTERVALS).length - 1);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const snoozeInterval = $72eddac512bc7ced$var$SNOOZE_INTERVALS[loopedVisitedCount];
        setFeatureVisited(snoozeInterval);
        setFeatureVisitedCount(visitedCount + 1);
    }, [
        setFeatureVisited,
        setFeatureVisitedCount,
        getFeatureVisitedCount
    ]);
    return {
        snooze: snooze,
        blockEligibilityUntilTomorrow: blockEligibilityUntilTomorrow,
        blockEligibilityToPreventRace: blockEligibilityToPreventRace
    };
};
const $72eddac512bc7ced$var$MSR_CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE = 'crossJoinNudgeFlags';
class $72eddac512bc7ced$export$f6f4711ce6617505 extends Error {
    constructor(message, options){
        super(message);
        this.options = void 0;
        this.name = 'RecommendationError';
        this.options = options;
    }
}
function $72eddac512bc7ced$export$e87e269d0f71e3a3({ product: product, sessionId: sessionId, cloudId: cloudId, subProduct: subProduct }) {
    const contextResolver = (0, $42omo.useCallback)(()=>({
            product: product,
            useCase: $72eddac512bc7ced$var$MSR_CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE,
            tenantId: cloudId,
            subproduct: subProduct,
            sessionId: sessionId
        }), [
        cloudId,
        product,
        subProduct,
        sessionId
    ]);
    const { getRecommendations: getRecommendations } = (0, $83WWS.default)({
        contextResolver: contextResolver
    });
    return (0, $42omo.useCallback)(async ()=>{
        try {
            const result = await getRecommendations({
                first: 4,
                config: {
                    cacheConfig: {
                        ttl: 86400 // cache for 1 day in seconds
                    }
                }
            });
            const { response: { data: data } = {} } = result;
            const recommendedEntities = (data ?? []).map((e)=>e.entityId);
            return recommendedEntities;
        } catch (error) {
            let cause;
            if (error instanceof Error) cause = error;
            else if (error && error.reason) cause = new Error(error.reason);
            else cause = new Error(String(error));
            throw new $72eddac512bc7ced$export$f6f4711ce6617505('Get MSR nudge recommendations error', {
                cause: cause
            });
        }
    }, [
        getRecommendations
    ]);
}
module.exports["useMsrSnoozeHandler"] = $72eddac512bc7ced$export$929578679169c83e;
module.exports["RecommendationError"] = $72eddac512bc7ced$export$f6f4711ce6617505;
module.exports["useMSRNudgeRecommendations"] = $72eddac512bc7ced$export$e87e269d0f71e3a3;

});

parcelRegister("h2Pgl", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $88141116575c9211$export$5ac26fa9b941854e(locale) {
    const [messages, setMessages] = (0, $42omo.useState)({});
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        let isMounted = true;
        async function startToFetchMessagesByLocale() {
            // Intl.Locale doesn't like underscores
            const finalLocale = new Intl.Locale(locale.replace('_', '-')).toString();
            try {
                setIsLoading(true);
                const module = await $88141116575c9211$export$c08b58fa4727b0d2(finalLocale);
                const newMessages = module.default || module;
                if (isMounted) setMessages(newMessages);
            } catch (// eslint-disable-next-line no-unused-vars
            e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                if (isMounted) setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
        return ()=>{
            isMounted = false;
        };
    }, [
        locale
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}


























function $88141116575c9211$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("kVIRg"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("49i1r"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("dasEj"));
        case 'en-GB':
            return (parcelRequire("lC97I"));
        case 'en-AU':
        case 'en-US':
        case 'en':
            return Promise.resolve((parcelRequire("4opcN")));
        case 'en-ZZ':
            return (parcelRequire("3KIQf"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("gzQK5"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("ePDTL"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("jl7HU"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("c585o"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("jAnnr"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("4HVkJ"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("dcU0x"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("iO7I3"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("jat2x"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("cekPs"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("6U9LK"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("gVZfP"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("emNuY"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("17t4T"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("hOImN"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("1Kgrq"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("bybL2"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("hzFW1"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("kjxkN"));
        default:
            return Promise.resolve((parcelRequire("4opcN")));
    }
}


























function $88141116575c9211$export$65a15453632bd60b(locale) {
    // Normalize locale to match global-shortcuts format
    const normalizedLocale = locale.replace('_', '-');
    const languageLocale = normalizedLocale.split(/[-_]/)[0] || 'en';
    switch(normalizedLocale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("7ttEc"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("7OHuB"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("jpB0s"));
        case 'en-GB':
            return (parcelRequire("jCWwP"));
        case 'en-AU':
        case 'en-US':
        case 'en':
            return Promise.resolve((parcelRequire("4yBJM")));
        case 'en-ZZ':
            return (parcelRequire("lHMT3"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("hJ9kV"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("5rwHI"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("9qEKd"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("a7JZv"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("aD7ie"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("bKGp5"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("c4Nwk"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("6ZdFN"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("kbvK1"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("cRhRj"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("ij8LW"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("4AdNi"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("46LQR"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("fcybv"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("clAdA"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("1Ixw1"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("f6Mq7"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("ak97t"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("glFbo"));
        default:
            // Fallback to language code if specific locale not found
            if (languageLocale === 'en') return Promise.resolve((parcelRequire("4yBJM")));
    }
    return Promise.resolve({
        default: {}
    });
}
module.exports["fetchLanguageFile"] = $88141116575c9211$export$c08b58fa4727b0d2;
module.exports["fetchGlobalShortcutsLanguageFile"] = $88141116575c9211$export$65a15453632bd60b;

});

parcelRegister("83WWS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lADxa = parcelRequire("lADxa");


var $12DlI = parcelRequire("12DlI");


var $kDMnZ = parcelRequire("kDMnZ");


var $8JRIT = parcelRequire("8JRIT");


var $egpDV = parcelRequire("egpDV");

const $2bd3878531988bc1$var$useRecommendations = ({ endpoint: endpoint = '/gateway/api/graphql', contextResolver: contextResolver })=>{
    /**
	 * Fetch recommendations for a given context
	 */ const getRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((args, deprecatedRerank = [])=>{
        // Deconstruct the args object with deprecated arguments to make it backwards compatible
        const { first: first, rerank: rerank, config: { cacheConfig: cacheConfig } = {
            cacheConfig: undefined
        } } = typeof args === 'number' ? {
            first: args,
            rerank: deprecatedRerank
        } : args;
        const recommendationRequestMaker = new (0, $kDMnZ.default)(endpoint);
        const requester = new (0, $egpDV.default)(new (0, $8JRIT.RecommendationsRequestBroker)());
        const context = (0, $12DlI.getContext)(contextResolver);
        return requester.fetch(recommendationRequestMaker.makeRequest({
            contextResolver: contextResolver,
            first: first,
            rerank: rerank
        }), {
            cacheConfig: cacheConfig ? {
                ...cacheConfig,
                cacheName: (0, $lADxa.CACHE_NAME),
                useCase: context.useCase
            } : undefined
        });
    }, [
        contextResolver,
        endpoint
    ]);
    return {
        getRecommendations: getRecommendations
    };
};
var $2bd3878531988bc1$export$2e2bcd8739ae039 = $2bd3878531988bc1$var$useRecommendations;
module.exports["default"] = $2bd3878531988bc1$export$2e2bcd8739ae039;

});

parcelRegister("lADxa", function(module, exports) {
// Events
const $ced3a33160abceeb$export$38f20466f22f45f0 = 'CLICK_PRIVACY_POLICY_LINK';
const $ced3a33160abceeb$export$836f30b3a88d4259 = 'UNDO_DISMISSAL_STARTED';
const $ced3a33160abceeb$export$5ee3f53555c01a95 = 'UNDO_DISMISSAL_SUCCEEDED';
const $ced3a33160abceeb$export$eebf6a2671000e28 = 'UNDO_DISMISSAL_FAILED';
const $ced3a33160abceeb$export$14b7e2c312f27acd = 'atlassian-growth-recos';
module.exports["CACHE_NAME"] = $ced3a33160abceeb$export$14b7e2c312f27acd;

});

parcelRegister("12DlI", function(module, exports) {
function $046cb65f983803a0$export$a079a83b07f794bf(value) {
    if (value === null || value === undefined || value === '') return false;
    if (Array.isArray(value) && value.length === 0) return false;
    if (typeof value === 'object' && Object.keys(value).length === 0) return false;
    return true;
}
function $046cb65f983803a0$export$31553aaa555c1514(contextResolver, checkUseCase = true) {
    const context = typeof contextResolver === 'function' ? contextResolver() : contextResolver;
    if (checkUseCase && (typeof context?.useCase !== 'string' || context?.useCase.trim().length === 0)) throw new Error('useCase is required');
    return context;
}
module.exports["getContext"] = $046cb65f983803a0$export$31553aaa555c1514;

});

parcelRegister("kDMnZ", function(module, exports) {

var $gBcV5 = parcelRequire("gBcV5");

class $5e1f700bb1e33e2f$export$2e2bcd8739ae039 extends (0, $gBcV5.default) {
    makeRequest(makeRequestParams) {
        const { contextResolver: contextResolver, first: first, rerank: rerank } = makeRequestParams;
        return new Request(this.endpoint, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: this.getHeaders(),
            body: JSON.stringify({
                query: $5e1f700bb1e33e2f$var$recommendationsQuery,
                variables: {
                    first: first,
                    context: this.getContext(contextResolver),
                    rerank: rerank
                }
            })
        });
    }
}
const $5e1f700bb1e33e2f$var$recommendationsQuery = `
query GrowthRecQuery($context: GrowthRecContext!, $first: Int!, $rerank: [GrowthRecRerankCandidate!]) {
  growthRecommendations {
    recommendations(context: $context, first: $first, rerank: $rerank) {
      ... on GrowthRecRecommendations {
        __typename
        data {
          __typename
          entityId
          reasons
        }
      }
      ... on QueryError {
        __typename
        identifier
        message
        extensions {
          __typename
          statusCode
          errorType
        }
      }
    }
  }
}
`;
module.exports["default"] = $5e1f700bb1e33e2f$export$2e2bcd8739ae039;

});

parcelRegister("8JRIT", function(module, exports) {

var $hvgsK = parcelRequire("hvgsK");

class $2dbfb4e6f44d9269$export$7f19312509e0d2c0 {
    extract(response) {
        return response?.recommendations?.data ?? [];
    }
    getSuccessResultCreator(response, result) {
        return new (0, $hvgsK.RecommendationSuccessResultCreator)(response, result);
    }
}
module.exports["RecommendationsRequestBroker"] = $2dbfb4e6f44d9269$export$7f19312509e0d2c0;

});

parcelRegister("egpDV", function(module, exports) {

var $beCuV = parcelRequire("beCuV");


var $aU6a4 = parcelRequire("aU6a4");

class $01e78e6aa98b5954$export$2e2bcd8739ae039 {
    /**
   * Fetches the response by the given request from the cache or the API
   * the cache config is optional, if not provided, the response will not be cached
   *
   * @param request The request to fetch the response from
   * @param cacheConfig The cache configuration to use
   * @returns The query result
   */ fetch(request, { cacheConfig: cacheConfig } = {}) {
        return new Promise(async (resolve, reject)=>{
            const response = await this.getResponse(request, cacheConfig);
            if (!response.ok) return reject(new (0, $beCuV.NonOkQueryResultCreator)(response).makeQueryResult());
            const json = await response.json();
            if (json.errors) return reject(new (0, $beCuV.GeneralQueryErrorResultCreator)(json.errors).makeQueryResult());
            const schemaResponse = json?.data?.growthRecommendations;
            const queryRes = this.broker.extract(schemaResponse);
            // Undefined is not expected as a valid response from GraphQL
            if (queryRes === undefined) return reject(new (0, $beCuV.MissingQueryDataResultCreator)(response).makeQueryResult());
            return resolve(this.broker.getSuccessResultCreator(response, queryRes).makeQueryResult());
        });
    }
    /**
   * Fetches the response by tha given request from the cache or the API
   * the cache config is optional, if not provided, the response will not be cached
   *
   * @param request The request to fetch the response from
   * @param cacheConfig The cache configuration to use
   * @returns The response from the request
   */ async getResponse(request, cacheConfig) {
        const cacheProvider = (0, $aU6a4.default).resolve(cacheConfig);
        const cachedResponse = await cacheProvider.get(request);
        // If the response is cached, return it
        if (cachedResponse) return cachedResponse;
        // Clone the request before it being used to be able to use it multiple times
        const clonedRequest = request.clone();
        return fetch(request).then((response)=>{
            // Cache response only if the response is ok
            if (response.ok) cacheProvider.set(clonedRequest, response.clone());
            return response;
        });
    }
    constructor(broker){
        this.broker = broker;
    }
}
module.exports["default"] = $01e78e6aa98b5954$export$2e2bcd8739ae039;

});

parcelRegister("gBcV5", function(module, exports) {

var $12DlI = parcelRequire("12DlI");

class $33d16fd926db52d3$export$2e2bcd8739ae039 {
    getHeaders() {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return headers;
    }
    getContext(contextResolver) {
        return (0, $12DlI.getContext)(contextResolver);
    }
    constructor(endpoint){
        this.endpoint = endpoint;
    }
}
module.exports["default"] = $33d16fd926db52d3$export$2e2bcd8739ae039;

});

parcelRegister("hvgsK", function(module, exports) {

var $beCuV = parcelRequire("beCuV");

class $0480229b9a520ecb$export$c02f0b31b3b527a3 extends (0, $beCuV.QuerySuccessResultCreator) {
    makeQueryResult() {
        return new (0, $beCuV.GraphQlQueryResult)(this.response.status, this.response.statusText, {
            data: this.data
        });
    }
    constructor(response, data){
        super(response, data), this.response = response;
    }
}
module.exports["RecommendationSuccessResultCreator"] = $0480229b9a520ecb$export$c02f0b31b3b527a3;

});

parcelRegister("beCuV", function(module, exports) {
class $f32b9853811025b6$export$d0a1abfd57dc5018 {
    constructor(code, reason, response){
        this.code = code;
        this.reason = reason;
        this.response = response;
    }
}
class $f32b9853811025b6$var$QueryResultCreator {
}
class $f32b9853811025b6$export$ad7cb7f4450dd7c4 extends $f32b9853811025b6$var$QueryResultCreator {
    makeQueryResult() {
        return new $f32b9853811025b6$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText);
    }
    constructor(fetchResponse){
        super(), this.fetchResponse = fetchResponse;
    }
}
class $f32b9853811025b6$export$553722ecbbe27276 extends $f32b9853811025b6$var$QueryResultCreator {
    makeQueryResult() {
        const [{ extensions: extensions }] = this.errors;
        const [{ statusCode: statusCode, errorType: errorType }] = Array.isArray(extensions) ? extensions : [
            extensions
        ];
        return new $f32b9853811025b6$export$d0a1abfd57dc5018(statusCode, errorType, {
            errors: this.errors.map((error)=>error.message)
        });
    }
    constructor(errors){
        super(), this.errors = errors;
    }
}
class $f32b9853811025b6$export$ff264bfdc9a404eb extends $f32b9853811025b6$var$QueryResultCreator {
    makeQueryResult() {
        return new $f32b9853811025b6$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText, {
            errors: [
                'Received data has missing attributes'
            ]
        });
    }
    constructor(fetchResponse){
        super(), this.fetchResponse = fetchResponse;
    }
}
class $f32b9853811025b6$export$6b16771e962990ff extends $f32b9853811025b6$var$QueryResultCreator {
    constructor(response, data){
        super(), this.response = response, this.data = data;
    }
}
module.exports["GraphQlQueryResult"] = $f32b9853811025b6$export$d0a1abfd57dc5018;
module.exports["NonOkQueryResultCreator"] = $f32b9853811025b6$export$ad7cb7f4450dd7c4;
module.exports["GeneralQueryErrorResultCreator"] = $f32b9853811025b6$export$553722ecbbe27276;
module.exports["MissingQueryDataResultCreator"] = $f32b9853811025b6$export$ff264bfdc9a404eb;
module.exports["QuerySuccessResultCreator"] = $f32b9853811025b6$export$6b16771e962990ff;

});

parcelRegister("aU6a4", function(module, exports) {

var $iUvbb = parcelRequire("iUvbb");


var $3dIYp = parcelRequire("3dIYp");

class $7ab716f7d2388209$export$2e2bcd8739ae039 {
    /**
   * Returns the cache provider based on the given cache configuration
   *
   * @param cacheConfig The cache configuration to use
   * @returns The cache provider
   */ static resolve(cacheConfig) {
        if (cacheConfig) return new (0, $3dIYp.default)(cacheConfig);
        return new (0, $iUvbb.default)();
    }
}
module.exports["default"] = $7ab716f7d2388209$export$2e2bcd8739ae039;

});

parcelRegister("iUvbb", function(module, exports) {
class $9f8e6801fd127c12$export$2e2bcd8739ae039 {
    async get(request) {
        return undefined;
    }
    async set(request, response) {
        return;
    }
    async delete(request) {
        return true;
    }
}
module.exports["default"] = $9f8e6801fd127c12$export$2e2bcd8739ae039;

});

parcelRegister("3dIYp", function(module, exports) {

var $795OW = parcelRequire("795OW");


var $ke6Vx = parcelRequire("ke6Vx");

class $ad3f63563cb22b21$export$2e2bcd8739ae039 {
    /**
   * Get cached response
   */ async get(request) {
        if (!this.supported) return undefined;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expired = await this.isExpired(request);
            if (expired) {
                await this.delete(request);
                return undefined;
            }
            return cache.match(this.getCacheKey(request));
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
   * Put response in cache
   */ async set(request, response) {
        if (!this.supported) return;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expiryDate = Date.now() + this.cacheConfig.ttl * 1000;
            await this.expiryStorage.setExpiry(this.getStoreKey(request), expiryDate);
            await cache.put(this.getCacheKey(request), response);
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
   * Delete cached response
   */ async delete(request) {
        if (!this.supported) return true;
        try {
            return caches.open(this.cacheConfig.cacheName).then(async (cache)=>{
                await cache.delete(this.getCacheKey(request));
                await this.expiryStorage.deleteExpiry(this.getStoreKey(request));
                return true;
            });
        } catch (e) {
            this.cacheConfig.onError(e);
            return false;
        }
    }
    /**
   * Check if the cached response is expired
   */ async isExpired(request) {
        try {
            const key = this.getStoreKey(request);
            const expiry = await this.expiryStorage.getExpiry(key);
            return Date.now() > (expiry ?? 0);
        } catch (error) {
            this.cacheConfig.onError(error instanceof Error ? error : new Error('Error checking expiry'));
            return true;
        }
    }
    /**
   * Compose the URL and the use case as the search params to cache the response
   */ getCacheKey(request) {
        const url = new URL(request.url);
        url.searchParams.set('useCase', this.cacheConfig.useCase);
        return url;
    }
    /**
   * Get the key to store the response
   * Interally, it hashes the request body to get a unique key
   */ getStoreKey(request) {
        return this.getCacheKey(request).toString();
    }
    /**
   * Initialise the WebCacheStorage
   * @param cacheName The name of the cache to use. See {@link https://developer.mozilla.org/en-US/docs/Web/API/CacheStorage/open}
   * @param onError a callback when any error occurs
   */ constructor(cacheProviderConfig){
        /**
     * Whether the Cache API is supported
     */ this.supported = void 0;
        /**
     * Expiry storage
     */ this.expiryStorage = void 0;
        this.cacheConfig = void 0;
        this.supported = typeof caches === 'object' && typeof caches.open === 'function';
        this.cacheConfig = new (0, $795OW.default)(cacheProviderConfig);
        this.expiryStorage = new (0, $ke6Vx.default)(this.cacheConfig);
    }
}
module.exports["default"] = $ad3f63563cb22b21$export$2e2bcd8739ae039;

});

parcelRegister("795OW", function(module, exports) {
const $306861b3dd4a3a29$var$DEFAULT_TTL = 60;
class $306861b3dd4a3a29$export$2e2bcd8739ae039 {
    get cacheName() {
        return this.cacheProviderConfig.cacheName;
    }
    get useCase() {
        return this.cacheProviderConfig.useCase;
    }
    get ttl() {
        return this.cacheProviderConfig.ttl ?? $306861b3dd4a3a29$var$DEFAULT_TTL;
    }
    get onError() {
        return this.cacheProviderConfig.onError ?? (()=>{});
    }
    constructor(cacheProviderConfig){
        this.cacheProviderConfig = cacheProviderConfig;
    }
}
module.exports["default"] = $306861b3dd4a3a29$export$2e2bcd8739ae039;

});

parcelRegister("ke6Vx", function(module, exports) {
class $28285a544c090e2e$export$2e2bcd8739ae039 {
    /**
   * Set the expiry date of the cached response
   */ async setExpiry(key, expireAt) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.put(expireAt, key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
   * Get the expiry date of the cached response
   */ async getExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readonly');
                const storeRequest = store.get(key);
                storeRequest.onsuccess = ()=>{
                    resolve(Number(storeRequest.result ?? 0));
                };
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    async deleteExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.delete(key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
   * Initialise the IndexedDB
   */ initDb() {
        const dbRequest = indexedDB.open(`${this.cacheConfig.cacheName}-expiry`);
        dbRequest.onupgradeneeded = ()=>{
            const db = dbRequest.result;
            db.createObjectStore(this.expiryStoreName);
        };
        return dbRequest;
    }
    /**
   * Get the object store from the IndexedDB
   */ getObjectStore(dbRequest, mode = 'readwrite') {
        const db = dbRequest.result;
        return db.transaction(this.expiryStoreName, mode).objectStore(this.expiryStoreName);
    }
    /**
   * Initialise the ExpiryStorage
   */ constructor(cacheConfig){
        this.cacheConfig = cacheConfig;
        this.expiryStoreName = 'expiries';
    }
}
module.exports["default"] = $28285a544c090e2e$export$2e2bcd8739ae039;

});


//# sourceMappingURL=GlobalComponents.392a3d24.js.map
